import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _text: any;
  float8: any;
  geography: any;
  geometry: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  timetz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type ClassEntityType = {
  __typename?: 'ClassEntity';
  id: Scalars['String'];
  image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreatePaymentIntentResponseType = {
  __typename?: 'CreatePaymentIntentResponse';
  customer_id: Scalars['String'];
  ephemeral_key: Scalars['String'];
  payment_intent: Scalars['String'];
};

export type CreateStripeUserResponseType = {
  __typename?: 'CreateStripeUserResponse';
  url: Scalars['String'];
};

export type CreatedByType = {
  __typename?: 'CreatedBy';
  image_url: Scalars['String'];
  name: Scalars['String'];
  teacher_profile?: Maybe<TeacherProfileType>;
};

export type DeleteAccountResponseType = {
  __typename?: 'DeleteAccountResponse';
  success: Scalars['Boolean'];
};

export type EventEntityType = {
  __typename?: 'EventEntity';
  id: Scalars['String'];
  main_image_url?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ImageType = {
  __typename?: 'Image';
  id: Scalars['String'];
  url: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InviteType = {
  __typename?: 'Invite';
  class?: Maybe<ClassEntityType>;
  confirmation_status: Scalars['String'];
  created_at: Scalars['String'];
  created_by: CreatedByType;
  created_by_id: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  entity?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['String']>;
  event?: Maybe<EventEntityType>;
  id: Scalars['String'];
  updated_at: Scalars['String'];
};

export type LoginInputType = {
  email: Scalars['String'];
  inviteId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type LoginResponseType = {
  __typename?: 'LoginResponse';
  refreshToken: Scalars['String'];
  token: Scalars['String'];
  user: UserResponseType;
};

export type LoginWithRefreshTokenInputType = {
  refreshToken: Scalars['String'];
};

export type MatchedSubstringType = {
  __typename?: 'MatchedSubstring';
  length: Scalars['Float'];
  offset: Scalars['Float'];
};

export type PlaceType = {
  __typename?: 'Place';
  description: Scalars['String'];
  id: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type PlaceSuggestionType = {
  __typename?: 'PlaceSuggestion';
  description: Scalars['String'];
  id: Scalars['String'];
  matched_substrings: Array<MatchedSubstringType>;
};

export type RegisterInputType = {
  email: Scalars['String'];
  inviteId?: InputMaybe<Scalars['String']>;
  isNewsletterEnabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  password: Scalars['String'];
};

export type RegisterResponseType = {
  __typename?: 'RegisterResponse';
  refreshToken: Scalars['String'];
  token: Scalars['String'];
  user: RegisterUserResponseType;
};

export type RegisterUserResponseType = {
  __typename?: 'RegisterUserResponse';
  id: Scalars['String'];
  image_url: Scalars['String'];
  name: Scalars['String'];
};

export type ResetPasswordInputType = {
  email: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SuccessOutputType = {
  __typename?: 'SuccessOutput';
  success: Scalars['Boolean'];
};

export type TeacherImageType = {
  __typename?: 'TeacherImage';
  image: ImageType;
  is_profile_picture: Scalars['Boolean'];
};

export type TeacherProfileType = {
  __typename?: 'TeacherProfile';
  images: Array<TeacherImageType>;
  name: Scalars['String'];
};

export type UserResponseType = {
  __typename?: 'UserResponse';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['_text']>;
  _gt?: InputMaybe<Scalars['_text']>;
  _gte?: InputMaybe<Scalars['_text']>;
  _in?: InputMaybe<Array<Scalars['_text']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_text']>;
  _lte?: InputMaybe<Scalars['_text']>;
  _neq?: InputMaybe<Scalars['_text']>;
  _nin?: InputMaybe<Array<Scalars['_text']>>;
};

/** columns and relationships of "acro_roles" */
export type Acro_RolesType = {
  __typename?: 'acro_roles';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  user?: Maybe<UsersType>;
};

/** aggregated selection of "acro_roles" */
export type Acro_Roles_AggregateType = {
  __typename?: 'acro_roles_aggregate';
  aggregate?: Maybe<Acro_Roles_Aggregate_FieldsType>;
  nodes: Array<Acro_RolesType>;
};

/** aggregate fields of "acro_roles" */
export type Acro_Roles_Aggregate_FieldsType = {
  __typename?: 'acro_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Acro_Roles_Max_FieldsType>;
  min?: Maybe<Acro_Roles_Min_FieldsType>;
};


/** aggregate fields of "acro_roles" */
export type Acro_Roles_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Acro_Roles_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "acro_roles". All fields are combined with a logical 'AND'. */
export type Acro_Roles_Bool_ExpType = {
  _and?: InputMaybe<Array<Acro_Roles_Bool_ExpType>>;
  _not?: InputMaybe<Acro_Roles_Bool_ExpType>;
  _or?: InputMaybe<Array<Acro_Roles_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
};

/** unique or primary key constraints on table "acro_roles" */
export enum Acro_Roles_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  AcroRolesPkeyType = 'acro_roles_pkey'
}

/** input type for inserting data into table "acro_roles" */
export type Acro_Roles_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Acro_Roles_Max_FieldsType = {
  __typename?: 'acro_roles_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Acro_Roles_Min_FieldsType = {
  __typename?: 'acro_roles_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "acro_roles" */
export type Acro_Roles_Mutation_ResponseType = {
  __typename?: 'acro_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Acro_RolesType>;
};

/** input type for inserting object relation for remote table "acro_roles" */
export type Acro_Roles_Obj_Rel_Insert_InputType = {
  data: Acro_Roles_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Acro_Roles_On_ConflictType>;
};

/** on_conflict condition type for table "acro_roles" */
export type Acro_Roles_On_ConflictType = {
  constraint: Acro_Roles_ConstraintType;
  update_columns?: Array<Acro_Roles_Update_ColumnType>;
  where?: InputMaybe<Acro_Roles_Bool_ExpType>;
};

/** Ordering options when selecting data from "acro_roles". */
export type Acro_Roles_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
};

/** primary key columns input for table: acro_roles */
export type Acro_Roles_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "acro_roles" */
export enum Acro_Roles_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  NameType = 'name'
}

/** input type for updating data in table "acro_roles" */
export type Acro_Roles_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "acro_roles" */
export type Acro_Roles_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Acro_Roles_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Acro_Roles_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "acro_roles" */
export enum Acro_Roles_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  NameType = 'name'
}

export type Acro_Roles_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Acro_Roles_Set_InputType>;
  where: Acro_Roles_Bool_ExpType;
};

/** columns and relationships of "booking_option" */
export type Booking_OptionType = {
  __typename?: 'booking_option';
  /** An array relationship */
  class_booking_options: Array<Class_Booking_OptionType>;
  /** An aggregate relationship */
  class_booking_options_aggregate: Class_Booking_Option_AggregateType;
  commission?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency: Scalars['String'];
  discount: Scalars['numeric'];
  id: Scalars['uuid'];
  price: Scalars['numeric'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "booking_option" */
export type Booking_OptionClass_Booking_OptionsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


/** columns and relationships of "booking_option" */
export type Booking_OptionClass_Booking_Options_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};

/** aggregated selection of "booking_option" */
export type Booking_Option_AggregateType = {
  __typename?: 'booking_option_aggregate';
  aggregate?: Maybe<Booking_Option_Aggregate_FieldsType>;
  nodes: Array<Booking_OptionType>;
};

/** aggregate fields of "booking_option" */
export type Booking_Option_Aggregate_FieldsType = {
  __typename?: 'booking_option_aggregate_fields';
  avg?: Maybe<Booking_Option_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Booking_Option_Max_FieldsType>;
  min?: Maybe<Booking_Option_Min_FieldsType>;
  stddev?: Maybe<Booking_Option_Stddev_FieldsType>;
  stddev_pop?: Maybe<Booking_Option_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Booking_Option_Stddev_Samp_FieldsType>;
  sum?: Maybe<Booking_Option_Sum_FieldsType>;
  var_pop?: Maybe<Booking_Option_Var_Pop_FieldsType>;
  var_samp?: Maybe<Booking_Option_Var_Samp_FieldsType>;
  variance?: Maybe<Booking_Option_Variance_FieldsType>;
};


/** aggregate fields of "booking_option" */
export type Booking_Option_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Booking_Option_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Booking_Option_Avg_FieldsType = {
  __typename?: 'booking_option_avg_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "booking_option". All fields are combined with a logical 'AND'. */
export type Booking_Option_Bool_ExpType = {
  _and?: InputMaybe<Array<Booking_Option_Bool_ExpType>>;
  _not?: InputMaybe<Booking_Option_Bool_ExpType>;
  _or?: InputMaybe<Array<Booking_Option_Bool_ExpType>>;
  class_booking_options?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
  class_booking_options_aggregate?: InputMaybe<Class_Booking_Option_Aggregate_Bool_ExpType>;
  commission?: InputMaybe<Numeric_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  currency?: InputMaybe<String_Comparison_ExpType>;
  discount?: InputMaybe<Numeric_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  price?: InputMaybe<Numeric_Comparison_ExpType>;
  subtitle?: InputMaybe<String_Comparison_ExpType>;
  title?: InputMaybe<String_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

/** unique or primary key constraints on table "booking_option" */
export enum Booking_Option_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  BookingOptionPkeyType = 'booking_option_pkey'
}

/** input type for incrementing numeric columns in table "booking_option" */
export type Booking_Option_Inc_InputType = {
  commission?: InputMaybe<Scalars['numeric']>;
  discount?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "booking_option" */
export type Booking_Option_Insert_InputType = {
  class_booking_options?: InputMaybe<Class_Booking_Option_Arr_Rel_Insert_InputType>;
  commission?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Booking_Option_Max_FieldsType = {
  __typename?: 'booking_option_max_fields';
  commission?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Booking_Option_Min_FieldsType = {
  __typename?: 'booking_option_min_fields';
  commission?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "booking_option" */
export type Booking_Option_Mutation_ResponseType = {
  __typename?: 'booking_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Booking_OptionType>;
};

/** input type for inserting object relation for remote table "booking_option" */
export type Booking_Option_Obj_Rel_Insert_InputType = {
  data: Booking_Option_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Booking_Option_On_ConflictType>;
};

/** on_conflict condition type for table "booking_option" */
export type Booking_Option_On_ConflictType = {
  constraint: Booking_Option_ConstraintType;
  update_columns?: Array<Booking_Option_Update_ColumnType>;
  where?: InputMaybe<Booking_Option_Bool_ExpType>;
};

/** Ordering options when selecting data from "booking_option". */
export type Booking_Option_Order_ByType = {
  class_booking_options_aggregate?: InputMaybe<Class_Booking_Option_Aggregate_Order_ByType>;
  commission?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  currency?: InputMaybe<Order_ByType>;
  discount?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  price?: InputMaybe<Order_ByType>;
  subtitle?: InputMaybe<Order_ByType>;
  title?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: booking_option */
export type Booking_Option_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "booking_option" */
export enum Booking_Option_Select_ColumnType {
  /** column name */
  CommissionType = 'commission',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CurrencyType = 'currency',
  /** column name */
  DiscountType = 'discount',
  /** column name */
  IdType = 'id',
  /** column name */
  PriceType = 'price',
  /** column name */
  SubtitleType = 'subtitle',
  /** column name */
  TitleType = 'title',
  /** column name */
  UpdatedAtType = 'updated_at'
}

/** input type for updating data in table "booking_option" */
export type Booking_Option_Set_InputType = {
  commission?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Booking_Option_Stddev_FieldsType = {
  __typename?: 'booking_option_stddev_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Booking_Option_Stddev_Pop_FieldsType = {
  __typename?: 'booking_option_stddev_pop_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Booking_Option_Stddev_Samp_FieldsType = {
  __typename?: 'booking_option_stddev_samp_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "booking_option" */
export type Booking_Option_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Booking_Option_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Booking_Option_Stream_Cursor_Value_InputType = {
  commission?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Booking_Option_Sum_FieldsType = {
  __typename?: 'booking_option_sum_fields';
  commission?: Maybe<Scalars['numeric']>;
  discount?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "booking_option" */
export enum Booking_Option_Update_ColumnType {
  /** column name */
  CommissionType = 'commission',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CurrencyType = 'currency',
  /** column name */
  DiscountType = 'discount',
  /** column name */
  IdType = 'id',
  /** column name */
  PriceType = 'price',
  /** column name */
  SubtitleType = 'subtitle',
  /** column name */
  TitleType = 'title',
  /** column name */
  UpdatedAtType = 'updated_at'
}

export type Booking_Option_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Booking_Option_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Booking_Option_Set_InputType>;
  where: Booking_Option_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Booking_Option_Var_Pop_FieldsType = {
  __typename?: 'booking_option_var_pop_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Booking_Option_Var_Samp_FieldsType = {
  __typename?: 'booking_option_var_samp_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Booking_Option_Variance_FieldsType = {
  __typename?: 'booking_option_variance_fields';
  commission?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "class_booking_option" */
export type Class_Booking_OptionType = {
  __typename?: 'class_booking_option';
  /** An object relationship */
  booking_option?: Maybe<Booking_OptionType>;
  booking_option_id: Scalars['uuid'];
  class_id: Scalars['uuid'];
  /** An object relationship */
  classes?: Maybe<ClassesType>;
  id: Scalars['uuid'];
};

/** aggregated selection of "class_booking_option" */
export type Class_Booking_Option_AggregateType = {
  __typename?: 'class_booking_option_aggregate';
  aggregate?: Maybe<Class_Booking_Option_Aggregate_FieldsType>;
  nodes: Array<Class_Booking_OptionType>;
};

export type Class_Booking_Option_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Class_Booking_Option_Aggregate_Bool_Exp_CountType>;
};

export type Class_Booking_Option_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_booking_option" */
export type Class_Booking_Option_Aggregate_FieldsType = {
  __typename?: 'class_booking_option_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Booking_Option_Max_FieldsType>;
  min?: Maybe<Class_Booking_Option_Min_FieldsType>;
};


/** aggregate fields of "class_booking_option" */
export type Class_Booking_Option_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_booking_option" */
export type Class_Booking_Option_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Booking_Option_Max_Order_ByType>;
  min?: InputMaybe<Class_Booking_Option_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_booking_option" */
export type Class_Booking_Option_Arr_Rel_Insert_InputType = {
  data: Array<Class_Booking_Option_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Booking_Option_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_booking_option". All fields are combined with a logical 'AND'. */
export type Class_Booking_Option_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Booking_Option_Bool_ExpType>>;
  _not?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Booking_Option_Bool_ExpType>>;
  booking_option?: InputMaybe<Booking_Option_Bool_ExpType>;
  booking_option_id?: InputMaybe<Uuid_Comparison_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  classes?: InputMaybe<Classes_Bool_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_booking_option" */
export enum Class_Booking_Option_ConstraintType {
  /** unique or primary key constraint on columns "booking_option_id", "class_id" */
  ClassBookingOptionClassIdBookingOptionIdKeyType = 'class_booking_option_class_id_booking_option_id_key',
  /** unique or primary key constraint on columns "id" */
  ClassBookingOptionPkeyType = 'class_booking_option_pkey'
}

/** input type for inserting data into table "class_booking_option" */
export type Class_Booking_Option_Insert_InputType = {
  booking_option?: InputMaybe<Booking_Option_Obj_Rel_Insert_InputType>;
  booking_option_id?: InputMaybe<Scalars['uuid']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  classes?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Booking_Option_Max_FieldsType = {
  __typename?: 'class_booking_option_max_fields';
  booking_option_id?: Maybe<Scalars['uuid']>;
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_booking_option" */
export type Class_Booking_Option_Max_Order_ByType = {
  booking_option_id?: InputMaybe<Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Booking_Option_Min_FieldsType = {
  __typename?: 'class_booking_option_min_fields';
  booking_option_id?: Maybe<Scalars['uuid']>;
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_booking_option" */
export type Class_Booking_Option_Min_Order_ByType = {
  booking_option_id?: InputMaybe<Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_booking_option" */
export type Class_Booking_Option_Mutation_ResponseType = {
  __typename?: 'class_booking_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Booking_OptionType>;
};

/** on_conflict condition type for table "class_booking_option" */
export type Class_Booking_Option_On_ConflictType = {
  constraint: Class_Booking_Option_ConstraintType;
  update_columns?: Array<Class_Booking_Option_Update_ColumnType>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_booking_option". */
export type Class_Booking_Option_Order_ByType = {
  booking_option?: InputMaybe<Booking_Option_Order_ByType>;
  booking_option_id?: InputMaybe<Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  classes?: InputMaybe<Classes_Order_ByType>;
  id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_booking_option */
export type Class_Booking_Option_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_booking_option" */
export enum Class_Booking_Option_Select_ColumnType {
  /** column name */
  BookingOptionIdType = 'booking_option_id',
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id'
}

/** input type for updating data in table "class_booking_option" */
export type Class_Booking_Option_Set_InputType = {
  booking_option_id?: InputMaybe<Scalars['uuid']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_booking_option" */
export type Class_Booking_Option_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Booking_Option_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Booking_Option_Stream_Cursor_Value_InputType = {
  booking_option_id?: InputMaybe<Scalars['uuid']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_booking_option" */
export enum Class_Booking_Option_Update_ColumnType {
  /** column name */
  BookingOptionIdType = 'booking_option_id',
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id'
}

export type Class_Booking_Option_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Booking_Option_Set_InputType>;
  where: Class_Booking_Option_Bool_ExpType;
};

/** columns and relationships of "class_event_bookings" */
export type Class_Event_BookingsType = {
  __typename?: 'class_event_bookings';
  amount: Scalars['numeric'];
  /** An object relationship */
  booking_option?: Maybe<Booking_OptionType>;
  booking_option_id: Scalars['uuid'];
  /** An object relationship */
  class_event?: Maybe<Class_EventsType>;
  class_event_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  currency: Scalars['String'];
  id: Scalars['uuid'];
  payment_intent_id?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<UsersType>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "class_event_bookings" */
export type Class_Event_Bookings_AggregateType = {
  __typename?: 'class_event_bookings_aggregate';
  aggregate?: Maybe<Class_Event_Bookings_Aggregate_FieldsType>;
  nodes: Array<Class_Event_BookingsType>;
};

export type Class_Event_Bookings_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Class_Event_Bookings_Aggregate_Bool_Exp_CountType>;
};

export type Class_Event_Bookings_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_event_bookings" */
export type Class_Event_Bookings_Aggregate_FieldsType = {
  __typename?: 'class_event_bookings_aggregate_fields';
  avg?: Maybe<Class_Event_Bookings_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Class_Event_Bookings_Max_FieldsType>;
  min?: Maybe<Class_Event_Bookings_Min_FieldsType>;
  stddev?: Maybe<Class_Event_Bookings_Stddev_FieldsType>;
  stddev_pop?: Maybe<Class_Event_Bookings_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Class_Event_Bookings_Stddev_Samp_FieldsType>;
  sum?: Maybe<Class_Event_Bookings_Sum_FieldsType>;
  var_pop?: Maybe<Class_Event_Bookings_Var_Pop_FieldsType>;
  var_samp?: Maybe<Class_Event_Bookings_Var_Samp_FieldsType>;
  variance?: Maybe<Class_Event_Bookings_Variance_FieldsType>;
};


/** aggregate fields of "class_event_bookings" */
export type Class_Event_Bookings_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_event_bookings" */
export type Class_Event_Bookings_Aggregate_Order_ByType = {
  avg?: InputMaybe<Class_Event_Bookings_Avg_Order_ByType>;
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Event_Bookings_Max_Order_ByType>;
  min?: InputMaybe<Class_Event_Bookings_Min_Order_ByType>;
  stddev?: InputMaybe<Class_Event_Bookings_Stddev_Order_ByType>;
  stddev_pop?: InputMaybe<Class_Event_Bookings_Stddev_Pop_Order_ByType>;
  stddev_samp?: InputMaybe<Class_Event_Bookings_Stddev_Samp_Order_ByType>;
  sum?: InputMaybe<Class_Event_Bookings_Sum_Order_ByType>;
  var_pop?: InputMaybe<Class_Event_Bookings_Var_Pop_Order_ByType>;
  var_samp?: InputMaybe<Class_Event_Bookings_Var_Samp_Order_ByType>;
  variance?: InputMaybe<Class_Event_Bookings_Variance_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_event_bookings" */
export type Class_Event_Bookings_Arr_Rel_Insert_InputType = {
  data: Array<Class_Event_Bookings_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Event_Bookings_On_ConflictType>;
};

/** aggregate avg on columns */
export type Class_Event_Bookings_Avg_FieldsType = {
  __typename?: 'class_event_bookings_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Avg_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** Boolean expression to filter rows from the table "class_event_bookings". All fields are combined with a logical 'AND'. */
export type Class_Event_Bookings_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Event_Bookings_Bool_ExpType>>;
  _not?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Event_Bookings_Bool_ExpType>>;
  amount?: InputMaybe<Numeric_Comparison_ExpType>;
  booking_option?: InputMaybe<Booking_Option_Bool_ExpType>;
  booking_option_id?: InputMaybe<Uuid_Comparison_ExpType>;
  class_event?: InputMaybe<Class_Events_Bool_ExpType>;
  class_event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  currency?: InputMaybe<String_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  payment_intent_id?: InputMaybe<String_Comparison_ExpType>;
  status?: InputMaybe<String_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_event_bookings" */
export enum Class_Event_Bookings_ConstraintType {
  /** unique or primary key constraint on columns "payment_intent_id" */
  ClassEventBookingPaymentIntentKeyType = 'class_event_booking_payment_intent_key',
  /** unique or primary key constraint on columns "id" */
  ClassEventBookingPkeyType = 'class_event_booking_pkey'
}

/** input type for incrementing numeric columns in table "class_event_bookings" */
export type Class_Event_Bookings_Inc_InputType = {
  amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "class_event_bookings" */
export type Class_Event_Bookings_Insert_InputType = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking_option?: InputMaybe<Booking_Option_Obj_Rel_Insert_InputType>;
  booking_option_id?: InputMaybe<Scalars['uuid']>;
  class_event?: InputMaybe<Class_Events_Obj_Rel_Insert_InputType>;
  class_event_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Event_Bookings_Max_FieldsType = {
  __typename?: 'class_event_bookings_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  booking_option_id?: Maybe<Scalars['uuid']>;
  class_event_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  payment_intent_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Max_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
  booking_option_id?: InputMaybe<Order_ByType>;
  class_event_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  currency?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  payment_intent_id?: InputMaybe<Order_ByType>;
  status?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Event_Bookings_Min_FieldsType = {
  __typename?: 'class_event_bookings_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  booking_option_id?: Maybe<Scalars['uuid']>;
  class_event_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  payment_intent_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Min_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
  booking_option_id?: InputMaybe<Order_ByType>;
  class_event_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  currency?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  payment_intent_id?: InputMaybe<Order_ByType>;
  status?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_event_bookings" */
export type Class_Event_Bookings_Mutation_ResponseType = {
  __typename?: 'class_event_bookings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Event_BookingsType>;
};

/** on_conflict condition type for table "class_event_bookings" */
export type Class_Event_Bookings_On_ConflictType = {
  constraint: Class_Event_Bookings_ConstraintType;
  update_columns?: Array<Class_Event_Bookings_Update_ColumnType>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_event_bookings". */
export type Class_Event_Bookings_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
  booking_option?: InputMaybe<Booking_Option_Order_ByType>;
  booking_option_id?: InputMaybe<Order_ByType>;
  class_event?: InputMaybe<Class_Events_Order_ByType>;
  class_event_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  currency?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  payment_intent_id?: InputMaybe<Order_ByType>;
  status?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_event_bookings */
export type Class_Event_Bookings_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_event_bookings" */
export enum Class_Event_Bookings_Select_ColumnType {
  /** column name */
  AmountType = 'amount',
  /** column name */
  BookingOptionIdType = 'booking_option_id',
  /** column name */
  ClassEventIdType = 'class_event_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CurrencyType = 'currency',
  /** column name */
  IdType = 'id',
  /** column name */
  PaymentIntentIdType = 'payment_intent_id',
  /** column name */
  StatusType = 'status',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "class_event_bookings" */
export type Class_Event_Bookings_Set_InputType = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking_option_id?: InputMaybe<Scalars['uuid']>;
  class_event_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Class_Event_Bookings_Stddev_FieldsType = {
  __typename?: 'class_event_bookings_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Stddev_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_pop on columns */
export type Class_Event_Bookings_Stddev_Pop_FieldsType = {
  __typename?: 'class_event_bookings_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Stddev_Pop_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_samp on columns */
export type Class_Event_Bookings_Stddev_Samp_FieldsType = {
  __typename?: 'class_event_bookings_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Stddev_Samp_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** Streaming cursor of the table "class_event_bookings" */
export type Class_Event_Bookings_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Event_Bookings_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Event_Bookings_Stream_Cursor_Value_InputType = {
  amount?: InputMaybe<Scalars['numeric']>;
  booking_option_id?: InputMaybe<Scalars['uuid']>;
  class_event_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  payment_intent_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Class_Event_Bookings_Sum_FieldsType = {
  __typename?: 'class_event_bookings_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Sum_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** update columns of table "class_event_bookings" */
export enum Class_Event_Bookings_Update_ColumnType {
  /** column name */
  AmountType = 'amount',
  /** column name */
  BookingOptionIdType = 'booking_option_id',
  /** column name */
  ClassEventIdType = 'class_event_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CurrencyType = 'currency',
  /** column name */
  IdType = 'id',
  /** column name */
  PaymentIntentIdType = 'payment_intent_id',
  /** column name */
  StatusType = 'status',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UserIdType = 'user_id'
}

export type Class_Event_Bookings_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Class_Event_Bookings_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Event_Bookings_Set_InputType>;
  where: Class_Event_Bookings_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Class_Event_Bookings_Var_Pop_FieldsType = {
  __typename?: 'class_event_bookings_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Var_Pop_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** aggregate var_samp on columns */
export type Class_Event_Bookings_Var_Samp_FieldsType = {
  __typename?: 'class_event_bookings_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Var_Samp_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** aggregate variance on columns */
export type Class_Event_Bookings_Variance_FieldsType = {
  __typename?: 'class_event_bookings_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "class_event_bookings" */
export type Class_Event_Bookings_Variance_Order_ByType = {
  amount?: InputMaybe<Order_ByType>;
};

/** columns and relationships of "class_event_bookmarks" */
export type Class_Event_BookmarksType = {
  __typename?: 'class_event_bookmarks';
  /** An object relationship */
  class_event: Class_EventsType;
  class_event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "class_event_bookmarks" */
export type Class_Event_Bookmarks_AggregateType = {
  __typename?: 'class_event_bookmarks_aggregate';
  aggregate?: Maybe<Class_Event_Bookmarks_Aggregate_FieldsType>;
  nodes: Array<Class_Event_BookmarksType>;
};

export type Class_Event_Bookmarks_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Class_Event_Bookmarks_Aggregate_Bool_Exp_CountType>;
};

export type Class_Event_Bookmarks_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_event_bookmarks" */
export type Class_Event_Bookmarks_Aggregate_FieldsType = {
  __typename?: 'class_event_bookmarks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Event_Bookmarks_Max_FieldsType>;
  min?: Maybe<Class_Event_Bookmarks_Min_FieldsType>;
};


/** aggregate fields of "class_event_bookmarks" */
export type Class_Event_Bookmarks_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Event_Bookmarks_Max_Order_ByType>;
  min?: InputMaybe<Class_Event_Bookmarks_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Arr_Rel_Insert_InputType = {
  data: Array<Class_Event_Bookmarks_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Event_Bookmarks_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_event_bookmarks". All fields are combined with a logical 'AND'. */
export type Class_Event_Bookmarks_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Event_Bookmarks_Bool_ExpType>>;
  _not?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Event_Bookmarks_Bool_ExpType>>;
  class_event?: InputMaybe<Class_Events_Bool_ExpType>;
  class_event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_event_bookmarks" */
export enum Class_Event_Bookmarks_ConstraintType {
  /** unique or primary key constraint on columns "user_id", "class_event_id" */
  ClassEventBookmarksClassEventIdUserIdKeyType = 'class_event_bookmarks_class_event_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  ClassEventBookmarksPkeyType = 'class_event_bookmarks_pkey'
}

/** input type for inserting data into table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Insert_InputType = {
  class_event?: InputMaybe<Class_Events_Obj_Rel_Insert_InputType>;
  class_event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Event_Bookmarks_Max_FieldsType = {
  __typename?: 'class_event_bookmarks_max_fields';
  class_event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Max_Order_ByType = {
  class_event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Event_Bookmarks_Min_FieldsType = {
  __typename?: 'class_event_bookmarks_min_fields';
  class_event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Min_Order_ByType = {
  class_event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Mutation_ResponseType = {
  __typename?: 'class_event_bookmarks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Event_BookmarksType>;
};

/** on_conflict condition type for table "class_event_bookmarks" */
export type Class_Event_Bookmarks_On_ConflictType = {
  constraint: Class_Event_Bookmarks_ConstraintType;
  update_columns?: Array<Class_Event_Bookmarks_Update_ColumnType>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_event_bookmarks". */
export type Class_Event_Bookmarks_Order_ByType = {
  class_event?: InputMaybe<Class_Events_Order_ByType>;
  class_event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_event_bookmarks */
export type Class_Event_Bookmarks_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_event_bookmarks" */
export enum Class_Event_Bookmarks_Select_ColumnType {
  /** column name */
  ClassEventIdType = 'class_event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Set_InputType = {
  class_event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_event_bookmarks" */
export type Class_Event_Bookmarks_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Event_Bookmarks_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Event_Bookmarks_Stream_Cursor_Value_InputType = {
  class_event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_event_bookmarks" */
export enum Class_Event_Bookmarks_Update_ColumnType {
  /** column name */
  ClassEventIdType = 'class_event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

export type Class_Event_Bookmarks_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Event_Bookmarks_Set_InputType>;
  where: Class_Event_Bookmarks_Bool_ExpType;
};

/** columns and relationships of "class_events" */
export type Class_EventsType = {
  __typename?: 'class_events';
  available_booking_slots: Scalars['Int'];
  /** An object relationship */
  class?: Maybe<ClassesType>;
  /** An array relationship */
  class_bookings: Array<Class_Event_BookingsType>;
  /** An aggregate relationship */
  class_bookings_aggregate: Class_Event_Bookings_AggregateType;
  class_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_cancelled: Scalars['Boolean'];
  is_highlighted?: Maybe<Scalars['Boolean']>;
  max_booking_slots: Scalars['Int'];
  /** An array relationship */
  participants: Array<Class_Events_ParticipantsType>;
  /** An aggregate relationship */
  participants_aggregate: Class_Events_Participants_AggregateType;
  /** An object relationship */
  recurring_pattern?: Maybe<Recurring_PatternsType>;
  recurring_pattern_id: Scalars['uuid'];
  start_date: Scalars['timestamptz'];
};


/** columns and relationships of "class_events" */
export type Class_EventsClass_BookingsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


/** columns and relationships of "class_events" */
export type Class_EventsClass_Bookings_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


/** columns and relationships of "class_events" */
export type Class_EventsParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


/** columns and relationships of "class_events" */
export type Class_EventsParticipants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};

/** aggregated selection of "class_events" */
export type Class_Events_AggregateType = {
  __typename?: 'class_events_aggregate';
  aggregate?: Maybe<Class_Events_Aggregate_FieldsType>;
  nodes: Array<Class_EventsType>;
};

export type Class_Events_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Class_Events_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Class_Events_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Class_Events_Aggregate_Bool_Exp_CountType>;
};

export type Class_Events_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Class_Events_Select_Column_Class_Events_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Events_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Events_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Class_Events_Select_Column_Class_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Events_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Events_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Events_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_events" */
export type Class_Events_Aggregate_FieldsType = {
  __typename?: 'class_events_aggregate_fields';
  avg?: Maybe<Class_Events_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Class_Events_Max_FieldsType>;
  min?: Maybe<Class_Events_Min_FieldsType>;
  stddev?: Maybe<Class_Events_Stddev_FieldsType>;
  stddev_pop?: Maybe<Class_Events_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Class_Events_Stddev_Samp_FieldsType>;
  sum?: Maybe<Class_Events_Sum_FieldsType>;
  var_pop?: Maybe<Class_Events_Var_Pop_FieldsType>;
  var_samp?: Maybe<Class_Events_Var_Samp_FieldsType>;
  variance?: Maybe<Class_Events_Variance_FieldsType>;
};


/** aggregate fields of "class_events" */
export type Class_Events_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_events" */
export type Class_Events_Aggregate_Order_ByType = {
  avg?: InputMaybe<Class_Events_Avg_Order_ByType>;
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Events_Max_Order_ByType>;
  min?: InputMaybe<Class_Events_Min_Order_ByType>;
  stddev?: InputMaybe<Class_Events_Stddev_Order_ByType>;
  stddev_pop?: InputMaybe<Class_Events_Stddev_Pop_Order_ByType>;
  stddev_samp?: InputMaybe<Class_Events_Stddev_Samp_Order_ByType>;
  sum?: InputMaybe<Class_Events_Sum_Order_ByType>;
  var_pop?: InputMaybe<Class_Events_Var_Pop_Order_ByType>;
  var_samp?: InputMaybe<Class_Events_Var_Samp_Order_ByType>;
  variance?: InputMaybe<Class_Events_Variance_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_events" */
export type Class_Events_Arr_Rel_Insert_InputType = {
  data: Array<Class_Events_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Events_On_ConflictType>;
};

/** aggregate avg on columns */
export type Class_Events_Avg_FieldsType = {
  __typename?: 'class_events_avg_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "class_events" */
export type Class_Events_Avg_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** Boolean expression to filter rows from the table "class_events". All fields are combined with a logical 'AND'. */
export type Class_Events_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Events_Bool_ExpType>>;
  _not?: InputMaybe<Class_Events_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Events_Bool_ExpType>>;
  available_booking_slots?: InputMaybe<Int_Comparison_ExpType>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_bookings?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
  class_bookings_aggregate?: InputMaybe<Class_Event_Bookings_Aggregate_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  end_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_cancelled?: InputMaybe<Boolean_Comparison_ExpType>;
  is_highlighted?: InputMaybe<Boolean_Comparison_ExpType>;
  max_booking_slots?: InputMaybe<Int_Comparison_ExpType>;
  participants?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
  participants_aggregate?: InputMaybe<Class_Events_Participants_Aggregate_Bool_ExpType>;
  recurring_pattern?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
  recurring_pattern_id?: InputMaybe<Uuid_Comparison_ExpType>;
  start_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

export type Class_Events_By_Location_V1_ArgsType = {
  lat?: InputMaybe<Scalars['numeric']>;
  lng?: InputMaybe<Scalars['numeric']>;
};

/** unique or primary key constraints on table "class_events" */
export enum Class_Events_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassEventsPkeyType = 'class_events_pkey',
  /** unique or primary key constraint on columns "end_date", "start_date", "recurring_pattern_id" */
  ClassEventsStartDateEndDateRecurringPatternIdKeyType = 'class_events_start_date_end_date_recurring_pattern_id_key'
}

/** input type for incrementing numeric columns in table "class_events" */
export type Class_Events_Inc_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "class_events" */
export type Class_Events_Insert_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_bookings?: InputMaybe<Class_Event_Bookings_Arr_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<Class_Events_Participants_Arr_Rel_Insert_InputType>;
  recurring_pattern?: InputMaybe<Recurring_Patterns_Obj_Rel_Insert_InputType>;
  recurring_pattern_id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Class_Events_Max_FieldsType = {
  __typename?: 'class_events_max_fields';
  available_booking_slots?: Maybe<Scalars['Int']>;
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  recurring_pattern_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "class_events" */
export type Class_Events_Max_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  recurring_pattern_id?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Events_Min_FieldsType = {
  __typename?: 'class_events_min_fields';
  available_booking_slots?: Maybe<Scalars['Int']>;
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  recurring_pattern_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "class_events" */
export type Class_Events_Min_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  recurring_pattern_id?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_events" */
export type Class_Events_Mutation_ResponseType = {
  __typename?: 'class_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_EventsType>;
};

/** input type for inserting object relation for remote table "class_events" */
export type Class_Events_Obj_Rel_Insert_InputType = {
  data: Class_Events_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Events_On_ConflictType>;
};

/** on_conflict condition type for table "class_events" */
export type Class_Events_On_ConflictType = {
  constraint: Class_Events_ConstraintType;
  update_columns?: Array<Class_Events_Update_ColumnType>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_events". */
export type Class_Events_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  class?: InputMaybe<Classes_Order_ByType>;
  class_bookings_aggregate?: InputMaybe<Class_Event_Bookings_Aggregate_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  is_cancelled?: InputMaybe<Order_ByType>;
  is_highlighted?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  participants_aggregate?: InputMaybe<Class_Events_Participants_Aggregate_Order_ByType>;
  recurring_pattern?: InputMaybe<Recurring_Patterns_Order_ByType>;
  recurring_pattern_id?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
};

/** columns and relationships of "class_events_participants" */
export type Class_Events_ParticipantsType = {
  __typename?: 'class_events_participants';
  /** An object relationship */
  class_event: Class_EventsType;
  class_event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "class_events_participants" */
export type Class_Events_Participants_AggregateType = {
  __typename?: 'class_events_participants_aggregate';
  aggregate?: Maybe<Class_Events_Participants_Aggregate_FieldsType>;
  nodes: Array<Class_Events_ParticipantsType>;
};

export type Class_Events_Participants_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Class_Events_Participants_Aggregate_Bool_Exp_CountType>;
};

export type Class_Events_Participants_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_events_participants" */
export type Class_Events_Participants_Aggregate_FieldsType = {
  __typename?: 'class_events_participants_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Events_Participants_Max_FieldsType>;
  min?: Maybe<Class_Events_Participants_Min_FieldsType>;
};


/** aggregate fields of "class_events_participants" */
export type Class_Events_Participants_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_events_participants" */
export type Class_Events_Participants_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Events_Participants_Max_Order_ByType>;
  min?: InputMaybe<Class_Events_Participants_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_events_participants" */
export type Class_Events_Participants_Arr_Rel_Insert_InputType = {
  data: Array<Class_Events_Participants_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Events_Participants_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_events_participants". All fields are combined with a logical 'AND'. */
export type Class_Events_Participants_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Events_Participants_Bool_ExpType>>;
  _not?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Events_Participants_Bool_ExpType>>;
  class_event?: InputMaybe<Class_Events_Bool_ExpType>;
  class_event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_events_participants" */
export enum Class_Events_Participants_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassEventsParticipantsPkeyType = 'class_events_participants_pkey',
  /** unique or primary key constraint on columns "user_id", "class_event_id" */
  ClassEventsParticipantsUserIdClassEventIdKeyType = 'class_events_participants_user_id_class_event_id_key'
}

/** input type for inserting data into table "class_events_participants" */
export type Class_Events_Participants_Insert_InputType = {
  class_event?: InputMaybe<Class_Events_Obj_Rel_Insert_InputType>;
  class_event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Events_Participants_Max_FieldsType = {
  __typename?: 'class_events_participants_max_fields';
  class_event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_events_participants" */
export type Class_Events_Participants_Max_Order_ByType = {
  class_event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Events_Participants_Min_FieldsType = {
  __typename?: 'class_events_participants_min_fields';
  class_event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_events_participants" */
export type Class_Events_Participants_Min_Order_ByType = {
  class_event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_events_participants" */
export type Class_Events_Participants_Mutation_ResponseType = {
  __typename?: 'class_events_participants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_Events_ParticipantsType>;
};

/** on_conflict condition type for table "class_events_participants" */
export type Class_Events_Participants_On_ConflictType = {
  constraint: Class_Events_Participants_ConstraintType;
  update_columns?: Array<Class_Events_Participants_Update_ColumnType>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_events_participants". */
export type Class_Events_Participants_Order_ByType = {
  class_event?: InputMaybe<Class_Events_Order_ByType>;
  class_event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_events_participants */
export type Class_Events_Participants_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_events_participants" */
export enum Class_Events_Participants_Select_ColumnType {
  /** column name */
  ClassEventIdType = 'class_event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "class_events_participants" */
export type Class_Events_Participants_Set_InputType = {
  class_event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_events_participants" */
export type Class_Events_Participants_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Events_Participants_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Events_Participants_Stream_Cursor_Value_InputType = {
  class_event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_events_participants" */
export enum Class_Events_Participants_Update_ColumnType {
  /** column name */
  ClassEventIdType = 'class_event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

export type Class_Events_Participants_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Events_Participants_Set_InputType>;
  where: Class_Events_Participants_Bool_ExpType;
};

/** primary key columns input for table: class_events */
export type Class_Events_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_events" */
export enum Class_Events_Select_ColumnType {
  /** column name */
  AvailableBookingSlotsType = 'available_booking_slots',
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  IdType = 'id',
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  IsHighlightedType = 'is_highlighted',
  /** column name */
  MaxBookingSlotsType = 'max_booking_slots',
  /** column name */
  RecurringPatternIdType = 'recurring_pattern_id',
  /** column name */
  StartDateType = 'start_date'
}

/** select "class_events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_events" */
export enum Class_Events_Select_Column_Class_Events_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  IsHighlightedType = 'is_highlighted'
}

/** select "class_events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_events" */
export enum Class_Events_Select_Column_Class_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  IsHighlightedType = 'is_highlighted'
}

/** input type for updating data in table "class_events" */
export type Class_Events_Set_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  recurring_pattern_id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Class_Events_Stddev_FieldsType = {
  __typename?: 'class_events_stddev_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "class_events" */
export type Class_Events_Stddev_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_pop on columns */
export type Class_Events_Stddev_Pop_FieldsType = {
  __typename?: 'class_events_stddev_pop_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "class_events" */
export type Class_Events_Stddev_Pop_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_samp on columns */
export type Class_Events_Stddev_Samp_FieldsType = {
  __typename?: 'class_events_stddev_samp_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "class_events" */
export type Class_Events_Stddev_Samp_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** Streaming cursor of the table "class_events" */
export type Class_Events_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Events_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Events_Stream_Cursor_Value_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  recurring_pattern_id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Class_Events_Sum_FieldsType = {
  __typename?: 'class_events_sum_fields';
  available_booking_slots?: Maybe<Scalars['Int']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "class_events" */
export type Class_Events_Sum_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** update columns of table "class_events" */
export enum Class_Events_Update_ColumnType {
  /** column name */
  AvailableBookingSlotsType = 'available_booking_slots',
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  IdType = 'id',
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  IsHighlightedType = 'is_highlighted',
  /** column name */
  MaxBookingSlotsType = 'max_booking_slots',
  /** column name */
  RecurringPatternIdType = 'recurring_pattern_id',
  /** column name */
  StartDateType = 'start_date'
}

export type Class_Events_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Class_Events_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Events_Set_InputType>;
  where: Class_Events_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Class_Events_Var_Pop_FieldsType = {
  __typename?: 'class_events_var_pop_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "class_events" */
export type Class_Events_Var_Pop_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate var_samp on columns */
export type Class_Events_Var_Samp_FieldsType = {
  __typename?: 'class_events_var_samp_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "class_events" */
export type Class_Events_Var_Samp_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate variance on columns */
export type Class_Events_Variance_FieldsType = {
  __typename?: 'class_events_variance_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "class_events" */
export type Class_Events_Variance_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** columns and relationships of "class_favorites" */
export type Class_FavoritesType = {
  __typename?: 'class_favorites';
  class_id: Scalars['uuid'];
  /** An object relationship */
  classes?: Maybe<ClassesType>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<UsersType>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "class_favorites" */
export type Class_Favorites_AggregateType = {
  __typename?: 'class_favorites_aggregate';
  aggregate?: Maybe<Class_Favorites_Aggregate_FieldsType>;
  nodes: Array<Class_FavoritesType>;
};

export type Class_Favorites_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Class_Favorites_Aggregate_Bool_Exp_CountType>;
};

export type Class_Favorites_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Favorites_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_favorites" */
export type Class_Favorites_Aggregate_FieldsType = {
  __typename?: 'class_favorites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Favorites_Max_FieldsType>;
  min?: Maybe<Class_Favorites_Min_FieldsType>;
};


/** aggregate fields of "class_favorites" */
export type Class_Favorites_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_favorites" */
export type Class_Favorites_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Favorites_Max_Order_ByType>;
  min?: InputMaybe<Class_Favorites_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_favorites" */
export type Class_Favorites_Arr_Rel_Insert_InputType = {
  data: Array<Class_Favorites_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Favorites_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_favorites". All fields are combined with a logical 'AND'. */
export type Class_Favorites_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Favorites_Bool_ExpType>>;
  _not?: InputMaybe<Class_Favorites_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Favorites_Bool_ExpType>>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  classes?: InputMaybe<Classes_Bool_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_favorites" */
export enum Class_Favorites_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassFavoritesPkeyType = 'class_favorites_pkey',
  /** unique or primary key constraint on columns "user_id", "class_id" */
  ClassFavoritesUserIdClassIdKeyType = 'class_favorites_user_id_class_id_key'
}

/** input type for inserting data into table "class_favorites" */
export type Class_Favorites_Insert_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  classes?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Favorites_Max_FieldsType = {
  __typename?: 'class_favorites_max_fields';
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_favorites" */
export type Class_Favorites_Max_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Favorites_Min_FieldsType = {
  __typename?: 'class_favorites_min_fields';
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_favorites" */
export type Class_Favorites_Min_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_favorites" */
export type Class_Favorites_Mutation_ResponseType = {
  __typename?: 'class_favorites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_FavoritesType>;
};

/** on_conflict condition type for table "class_favorites" */
export type Class_Favorites_On_ConflictType = {
  constraint: Class_Favorites_ConstraintType;
  update_columns?: Array<Class_Favorites_Update_ColumnType>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_favorites". */
export type Class_Favorites_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  classes?: InputMaybe<Classes_Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_favorites */
export type Class_Favorites_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_favorites" */
export enum Class_Favorites_Select_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "class_favorites" */
export type Class_Favorites_Set_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_favorites" */
export type Class_Favorites_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Favorites_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Favorites_Stream_Cursor_Value_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_favorites" */
export enum Class_Favorites_Update_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

export type Class_Favorites_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Favorites_Set_InputType>;
  where: Class_Favorites_Bool_ExpType;
};

/** columns and relationships of "class_flag" */
export type Class_FlagType = {
  __typename?: 'class_flag';
  /** An object relationship */
  class: ClassesType;
  class_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "class_flag" */
export type Class_Flag_AggregateType = {
  __typename?: 'class_flag_aggregate';
  aggregate?: Maybe<Class_Flag_Aggregate_FieldsType>;
  nodes: Array<Class_FlagType>;
};

export type Class_Flag_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Class_Flag_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Class_Flag_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Class_Flag_Aggregate_Bool_Exp_CountType>;
};

export type Class_Flag_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Class_Flag_Select_Column_Class_Flag_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Flag_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Flag_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Class_Flag_Select_Column_Class_Flag_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Flag_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Flag_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Flag_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_flag" */
export type Class_Flag_Aggregate_FieldsType = {
  __typename?: 'class_flag_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Flag_Max_FieldsType>;
  min?: Maybe<Class_Flag_Min_FieldsType>;
};


/** aggregate fields of "class_flag" */
export type Class_Flag_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_flag" */
export type Class_Flag_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Flag_Max_Order_ByType>;
  min?: InputMaybe<Class_Flag_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_flag" */
export type Class_Flag_Arr_Rel_Insert_InputType = {
  data: Array<Class_Flag_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Flag_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_flag". All fields are combined with a logical 'AND'. */
export type Class_Flag_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Flag_Bool_ExpType>>;
  _not?: InputMaybe<Class_Flag_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Flag_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_active?: InputMaybe<Boolean_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_flag" */
export enum Class_Flag_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassFlagPkeyType = 'class_flag_pkey'
}

/** input type for inserting data into table "class_flag" */
export type Class_Flag_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Flag_Max_FieldsType = {
  __typename?: 'class_flag_max_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_flag" */
export type Class_Flag_Max_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Flag_Min_FieldsType = {
  __typename?: 'class_flag_min_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_flag" */
export type Class_Flag_Min_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_flag" */
export type Class_Flag_Mutation_ResponseType = {
  __typename?: 'class_flag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_FlagType>;
};

/** on_conflict condition type for table "class_flag" */
export type Class_Flag_On_ConflictType = {
  constraint: Class_Flag_ConstraintType;
  update_columns?: Array<Class_Flag_Update_ColumnType>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_flag". */
export type Class_Flag_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  is_active?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_flag */
export type Class_Flag_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_flag" */
export enum Class_Flag_Select_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  IsActiveType = 'is_active',
  /** column name */
  UserIdType = 'user_id'
}

/** select "class_flag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_flag" */
export enum Class_Flag_Select_Column_Class_Flag_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsActiveType = 'is_active'
}

/** select "class_flag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_flag" */
export enum Class_Flag_Select_Column_Class_Flag_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsActiveType = 'is_active'
}

/** input type for updating data in table "class_flag" */
export type Class_Flag_Set_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_flag" */
export type Class_Flag_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Flag_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Flag_Stream_Cursor_Value_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_flag" */
export enum Class_Flag_Update_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  IsActiveType = 'is_active',
  /** column name */
  UserIdType = 'user_id'
}

export type Class_Flag_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Flag_Set_InputType>;
  where: Class_Flag_Bool_ExpType;
};

/** columns and relationships of "class_levels" */
export type Class_LevelsType = {
  __typename?: 'class_levels';
  /** An object relationship */
  class: ClassesType;
  class_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  level: LevelsType;
  level_id: Scalars['uuid'];
};

/** aggregated selection of "class_levels" */
export type Class_Levels_AggregateType = {
  __typename?: 'class_levels_aggregate';
  aggregate?: Maybe<Class_Levels_Aggregate_FieldsType>;
  nodes: Array<Class_LevelsType>;
};

export type Class_Levels_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Class_Levels_Aggregate_Bool_Exp_CountType>;
};

export type Class_Levels_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Levels_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_levels" */
export type Class_Levels_Aggregate_FieldsType = {
  __typename?: 'class_levels_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Levels_Max_FieldsType>;
  min?: Maybe<Class_Levels_Min_FieldsType>;
};


/** aggregate fields of "class_levels" */
export type Class_Levels_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_levels" */
export type Class_Levels_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Levels_Max_Order_ByType>;
  min?: InputMaybe<Class_Levels_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_levels" */
export type Class_Levels_Arr_Rel_Insert_InputType = {
  data: Array<Class_Levels_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Levels_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_levels". All fields are combined with a logical 'AND'. */
export type Class_Levels_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Levels_Bool_ExpType>>;
  _not?: InputMaybe<Class_Levels_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Levels_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  level?: InputMaybe<Levels_Bool_ExpType>;
  level_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_levels" */
export enum Class_Levels_ConstraintType {
  /** unique or primary key constraint on columns "class_id", "level_id" */
  ClassLevelsClassIdLevelIdKeyType = 'class_levels_class_id_level_id_key',
  /** unique or primary key constraint on columns "id" */
  ClassLevelsPkeyType = 'class_levels_pkey'
}

/** input type for inserting data into table "class_levels" */
export type Class_Levels_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Levels_Obj_Rel_Insert_InputType>;
  level_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Levels_Max_FieldsType = {
  __typename?: 'class_levels_max_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  level_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_levels" */
export type Class_Levels_Max_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Levels_Min_FieldsType = {
  __typename?: 'class_levels_min_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  level_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_levels" */
export type Class_Levels_Min_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_levels" */
export type Class_Levels_Mutation_ResponseType = {
  __typename?: 'class_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_LevelsType>;
};

/** on_conflict condition type for table "class_levels" */
export type Class_Levels_On_ConflictType = {
  constraint: Class_Levels_ConstraintType;
  update_columns?: Array<Class_Levels_Update_ColumnType>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_levels". */
export type Class_Levels_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  level?: InputMaybe<Levels_Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_levels */
export type Class_Levels_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_levels" */
export enum Class_Levels_Select_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  LevelIdType = 'level_id'
}

/** input type for updating data in table "class_levels" */
export type Class_Levels_Set_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_levels" */
export type Class_Levels_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Levels_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Levels_Stream_Cursor_Value_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_levels" */
export enum Class_Levels_Update_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  LevelIdType = 'level_id'
}

export type Class_Levels_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Levels_Set_InputType>;
  where: Class_Levels_Bool_ExpType;
};

/** columns and relationships of "class_owners" */
export type Class_OwnersType = {
  __typename?: 'class_owners';
  /** An object relationship */
  class: ClassesType;
  class_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_payment_receiver: Scalars['Boolean'];
  /** An object relationship */
  teacher: TeachersType;
  teacher_id: Scalars['uuid'];
};

/** aggregated selection of "class_owners" */
export type Class_Owners_AggregateType = {
  __typename?: 'class_owners_aggregate';
  aggregate?: Maybe<Class_Owners_Aggregate_FieldsType>;
  nodes: Array<Class_OwnersType>;
};

export type Class_Owners_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Class_Owners_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Class_Owners_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Class_Owners_Aggregate_Bool_Exp_CountType>;
};

export type Class_Owners_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Class_Owners_Select_Column_Class_Owners_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Owners_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Owners_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Class_Owners_Select_Column_Class_Owners_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Owners_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Owners_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Owners_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_owners" */
export type Class_Owners_Aggregate_FieldsType = {
  __typename?: 'class_owners_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Owners_Max_FieldsType>;
  min?: Maybe<Class_Owners_Min_FieldsType>;
};


/** aggregate fields of "class_owners" */
export type Class_Owners_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_owners" */
export type Class_Owners_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Owners_Max_Order_ByType>;
  min?: InputMaybe<Class_Owners_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_owners" */
export type Class_Owners_Arr_Rel_Insert_InputType = {
  data: Array<Class_Owners_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Owners_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_owners". All fields are combined with a logical 'AND'. */
export type Class_Owners_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Owners_Bool_ExpType>>;
  _not?: InputMaybe<Class_Owners_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Owners_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_payment_receiver?: InputMaybe<Boolean_Comparison_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_owners" */
export enum Class_Owners_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassOwnersPkeyType = 'class_owners_pkey'
}

/** input type for inserting data into table "class_owners" */
export type Class_Owners_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_payment_receiver?: InputMaybe<Scalars['Boolean']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Owners_Max_FieldsType = {
  __typename?: 'class_owners_max_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_owners" */
export type Class_Owners_Max_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Owners_Min_FieldsType = {
  __typename?: 'class_owners_min_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_owners" */
export type Class_Owners_Min_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_owners" */
export type Class_Owners_Mutation_ResponseType = {
  __typename?: 'class_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_OwnersType>;
};

/** on_conflict condition type for table "class_owners" */
export type Class_Owners_On_ConflictType = {
  constraint: Class_Owners_ConstraintType;
  update_columns?: Array<Class_Owners_Update_ColumnType>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_owners". */
export type Class_Owners_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  is_payment_receiver?: InputMaybe<Order_ByType>;
  teacher?: InputMaybe<Teachers_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_owners */
export type Class_Owners_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_owners" */
export enum Class_Owners_Select_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  IsPaymentReceiverType = 'is_payment_receiver',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** select "class_owners_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_owners" */
export enum Class_Owners_Select_Column_Class_Owners_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsPaymentReceiverType = 'is_payment_receiver'
}

/** select "class_owners_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_owners" */
export enum Class_Owners_Select_Column_Class_Owners_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsPaymentReceiverType = 'is_payment_receiver'
}

/** input type for updating data in table "class_owners" */
export type Class_Owners_Set_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_payment_receiver?: InputMaybe<Scalars['Boolean']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_owners" */
export type Class_Owners_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Owners_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Owners_Stream_Cursor_Value_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_payment_receiver?: InputMaybe<Scalars['Boolean']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_owners" */
export enum Class_Owners_Update_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  IsPaymentReceiverType = 'is_payment_receiver',
  /** column name */
  TeacherIdType = 'teacher_id'
}

export type Class_Owners_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Owners_Set_InputType>;
  where: Class_Owners_Bool_ExpType;
};

/** columns and relationships of "class_teachers" */
export type Class_TeachersType = {
  __typename?: 'class_teachers';
  /** An object relationship */
  class?: Maybe<ClassesType>;
  class_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_owner?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  teacher?: Maybe<TeachersType>;
  teacher_id: Scalars['uuid'];
};

/** aggregated selection of "class_teachers" */
export type Class_Teachers_AggregateType = {
  __typename?: 'class_teachers_aggregate';
  aggregate?: Maybe<Class_Teachers_Aggregate_FieldsType>;
  nodes: Array<Class_TeachersType>;
};

export type Class_Teachers_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Class_Teachers_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Class_Teachers_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Class_Teachers_Aggregate_Bool_Exp_CountType>;
};

export type Class_Teachers_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Class_Teachers_Select_Column_Class_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Teachers_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Teachers_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Class_Teachers_Select_Column_Class_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Teachers_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Class_Teachers_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Class_Teachers_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "class_teachers" */
export type Class_Teachers_Aggregate_FieldsType = {
  __typename?: 'class_teachers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Class_Teachers_Max_FieldsType>;
  min?: Maybe<Class_Teachers_Min_FieldsType>;
};


/** aggregate fields of "class_teachers" */
export type Class_Teachers_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "class_teachers" */
export type Class_Teachers_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Class_Teachers_Max_Order_ByType>;
  min?: InputMaybe<Class_Teachers_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "class_teachers" */
export type Class_Teachers_Arr_Rel_Insert_InputType = {
  data: Array<Class_Teachers_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Class_Teachers_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "class_teachers". All fields are combined with a logical 'AND'. */
export type Class_Teachers_Bool_ExpType = {
  _and?: InputMaybe<Array<Class_Teachers_Bool_ExpType>>;
  _not?: InputMaybe<Class_Teachers_Bool_ExpType>;
  _or?: InputMaybe<Array<Class_Teachers_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_owner?: InputMaybe<Boolean_Comparison_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "class_teachers" */
export enum Class_Teachers_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassTeachersPkeyType = 'class_teachers_pkey'
}

/** input type for inserting data into table "class_teachers" */
export type Class_Teachers_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_owner?: InputMaybe<Scalars['Boolean']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Class_Teachers_Max_FieldsType = {
  __typename?: 'class_teachers_max_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "class_teachers" */
export type Class_Teachers_Max_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Class_Teachers_Min_FieldsType = {
  __typename?: 'class_teachers_min_fields';
  class_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "class_teachers" */
export type Class_Teachers_Min_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "class_teachers" */
export type Class_Teachers_Mutation_ResponseType = {
  __typename?: 'class_teachers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Class_TeachersType>;
};

/** on_conflict condition type for table "class_teachers" */
export type Class_Teachers_On_ConflictType = {
  constraint: Class_Teachers_ConstraintType;
  update_columns?: Array<Class_Teachers_Update_ColumnType>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};

/** Ordering options when selecting data from "class_teachers". */
export type Class_Teachers_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  is_owner?: InputMaybe<Order_ByType>;
  teacher?: InputMaybe<Teachers_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: class_teachers */
export type Class_Teachers_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "class_teachers" */
export enum Class_Teachers_Select_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  IsOwnerType = 'is_owner',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** select "class_teachers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "class_teachers" */
export enum Class_Teachers_Select_Column_Class_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsOwnerType = 'is_owner'
}

/** select "class_teachers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "class_teachers" */
export enum Class_Teachers_Select_Column_Class_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsOwnerType = 'is_owner'
}

/** input type for updating data in table "class_teachers" */
export type Class_Teachers_Set_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_owner?: InputMaybe<Scalars['Boolean']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "class_teachers" */
export type Class_Teachers_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Class_Teachers_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Class_Teachers_Stream_Cursor_Value_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_owner?: InputMaybe<Scalars['Boolean']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "class_teachers" */
export enum Class_Teachers_Update_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  IdType = 'id',
  /** column name */
  IsOwnerType = 'is_owner',
  /** column name */
  TeacherIdType = 'teacher_id'
}

export type Class_Teachers_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Class_Teachers_Set_InputType>;
  where: Class_Teachers_Bool_ExpType;
};

/** columns and relationships of "classes" */
export type ClassesType = {
  __typename?: 'classes';
  booking_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** An array relationship */
  class_booking_options: Array<Class_Booking_OptionType>;
  /** An aggregate relationship */
  class_booking_options_aggregate: Class_Booking_Option_AggregateType;
  /** An array relationship */
  class_events: Array<Class_EventsType>;
  /** An aggregate relationship */
  class_events_aggregate: Class_Events_AggregateType;
  /** An array relationship */
  class_favorits: Array<Class_FavoritesType>;
  /** An aggregate relationship */
  class_favorits_aggregate: Class_Favorites_AggregateType;
  /** An array relationship */
  class_flags: Array<Class_FlagType>;
  /** An aggregate relationship */
  class_flags_aggregate: Class_Flag_AggregateType;
  /** An array relationship */
  class_levels: Array<Class_LevelsType>;
  /** An aggregate relationship */
  class_levels_aggregate: Class_Levels_AggregateType;
  /** An array relationship */
  class_owners: Array<Class_OwnersType>;
  /** An aggregate relationship */
  class_owners_aggregate: Class_Owners_AggregateType;
  class_pass_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  class_teachers: Array<Class_TeachersType>;
  /** An aggregate relationship */
  class_teachers_aggregate: Class_Teachers_AggregateType;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<UsersType>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description: Scalars['String'];
  event_type?: Maybe<Event_Type_EnumType>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  invites: Array<InvitesType>;
  /** An aggregate relationship */
  invites_aggregate: Invites_AggregateType;
  is_classe?: Maybe<Scalars['Boolean']>;
  location: Scalars['geography'];
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name: Scalars['String'];
  max_booking_slots?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  pricing?: Maybe<Scalars['String']>;
  pricing_short?: Maybe<Scalars['String']>;
  /** An array relationship */
  recurring_patterns: Array<Recurring_PatternsType>;
  /** An aggregate relationship */
  recurring_patterns_aggregate: Recurring_Patterns_AggregateType;
  requirements?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  usc_url?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Booking_OptionsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Booking_Options_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_FavoritsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Favorits_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_FlagsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Flag_Order_ByType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Flags_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Flag_Order_ByType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_OwnersArgsType = {
  distinct_on?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Owners_Order_ByType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Owners_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Owners_Order_ByType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_TeachersArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesClass_Teachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesInvitesArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesInvites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesRecurring_PatternsArgsType = {
  distinct_on?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Patterns_Order_ByType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};


/** columns and relationships of "classes" */
export type ClassesRecurring_Patterns_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Patterns_Order_ByType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};

/** aggregated selection of "classes" */
export type Classes_AggregateType = {
  __typename?: 'classes_aggregate';
  aggregate?: Maybe<Classes_Aggregate_FieldsType>;
  nodes: Array<ClassesType>;
};

export type Classes_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Classes_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Classes_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Classes_Aggregate_Bool_Exp_CountType>;
};

export type Classes_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Classes_Select_Column_Classes_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classes_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Classes_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Classes_Select_Column_Classes_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classes_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Classes_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Classes_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Classes_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "classes" */
export type Classes_Aggregate_FieldsType = {
  __typename?: 'classes_aggregate_fields';
  avg?: Maybe<Classes_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Classes_Max_FieldsType>;
  min?: Maybe<Classes_Min_FieldsType>;
  stddev?: Maybe<Classes_Stddev_FieldsType>;
  stddev_pop?: Maybe<Classes_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Classes_Stddev_Samp_FieldsType>;
  sum?: Maybe<Classes_Sum_FieldsType>;
  var_pop?: Maybe<Classes_Var_Pop_FieldsType>;
  var_samp?: Maybe<Classes_Var_Samp_FieldsType>;
  variance?: Maybe<Classes_Variance_FieldsType>;
};


/** aggregate fields of "classes" */
export type Classes_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Classes_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "classes" */
export type Classes_Aggregate_Order_ByType = {
  avg?: InputMaybe<Classes_Avg_Order_ByType>;
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Classes_Max_Order_ByType>;
  min?: InputMaybe<Classes_Min_Order_ByType>;
  stddev?: InputMaybe<Classes_Stddev_Order_ByType>;
  stddev_pop?: InputMaybe<Classes_Stddev_Pop_Order_ByType>;
  stddev_samp?: InputMaybe<Classes_Stddev_Samp_Order_ByType>;
  sum?: InputMaybe<Classes_Sum_Order_ByType>;
  var_pop?: InputMaybe<Classes_Var_Pop_Order_ByType>;
  var_samp?: InputMaybe<Classes_Var_Samp_Order_ByType>;
  variance?: InputMaybe<Classes_Variance_Order_ByType>;
};

/** input type for inserting array relation for remote table "classes" */
export type Classes_Arr_Rel_Insert_InputType = {
  data: Array<Classes_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Classes_On_ConflictType>;
};

/** aggregate avg on columns */
export type Classes_Avg_FieldsType = {
  __typename?: 'classes_avg_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "classes" */
export type Classes_Avg_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export type Classes_Bool_ExpType = {
  _and?: InputMaybe<Array<Classes_Bool_ExpType>>;
  _not?: InputMaybe<Classes_Bool_ExpType>;
  _or?: InputMaybe<Array<Classes_Bool_ExpType>>;
  booking_email?: InputMaybe<String_Comparison_ExpType>;
  city?: InputMaybe<String_Comparison_ExpType>;
  class_booking_options?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
  class_booking_options_aggregate?: InputMaybe<Class_Booking_Option_Aggregate_Bool_ExpType>;
  class_events?: InputMaybe<Class_Events_Bool_ExpType>;
  class_events_aggregate?: InputMaybe<Class_Events_Aggregate_Bool_ExpType>;
  class_favorits?: InputMaybe<Class_Favorites_Bool_ExpType>;
  class_favorits_aggregate?: InputMaybe<Class_Favorites_Aggregate_Bool_ExpType>;
  class_flags?: InputMaybe<Class_Flag_Bool_ExpType>;
  class_flags_aggregate?: InputMaybe<Class_Flag_Aggregate_Bool_ExpType>;
  class_levels?: InputMaybe<Class_Levels_Bool_ExpType>;
  class_levels_aggregate?: InputMaybe<Class_Levels_Aggregate_Bool_ExpType>;
  class_owners?: InputMaybe<Class_Owners_Bool_ExpType>;
  class_owners_aggregate?: InputMaybe<Class_Owners_Aggregate_Bool_ExpType>;
  class_pass_url?: InputMaybe<String_Comparison_ExpType>;
  class_teachers?: InputMaybe<Class_Teachers_Bool_ExpType>;
  class_teachers_aggregate?: InputMaybe<Class_Teachers_Aggregate_Bool_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by?: InputMaybe<Users_Bool_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  description?: InputMaybe<String_Comparison_ExpType>;
  event_type?: InputMaybe<Event_Type_Enum_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  image_url?: InputMaybe<String_Comparison_ExpType>;
  invites?: InputMaybe<Invites_Bool_ExpType>;
  invites_aggregate?: InputMaybe<Invites_Aggregate_Bool_ExpType>;
  is_classe?: InputMaybe<Boolean_Comparison_ExpType>;
  location?: InputMaybe<Geography_Comparison_ExpType>;
  location_city?: InputMaybe<String_Comparison_ExpType>;
  location_country?: InputMaybe<String_Comparison_ExpType>;
  location_name?: InputMaybe<String_Comparison_ExpType>;
  max_booking_slots?: InputMaybe<Int_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  pricing?: InputMaybe<String_Comparison_ExpType>;
  pricing_short?: InputMaybe<String_Comparison_ExpType>;
  recurring_patterns?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
  recurring_patterns_aggregate?: InputMaybe<Recurring_Patterns_Aggregate_Bool_ExpType>;
  requirements?: InputMaybe<String_Comparison_ExpType>;
  timezone?: InputMaybe<String_Comparison_ExpType>;
  url_slug?: InputMaybe<String_Comparison_ExpType>;
  usc_url?: InputMaybe<String_Comparison_ExpType>;
  website_url?: InputMaybe<String_Comparison_ExpType>;
};

export type Classes_By_Location_V1_ArgsType = {
  lat?: InputMaybe<Scalars['numeric']>;
  lng?: InputMaybe<Scalars['numeric']>;
};

/** unique or primary key constraints on table "classes" */
export enum Classes_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ClassesPkeyType = 'classes_pkey',
  /** unique or primary key constraint on columns "url_slug" */
  ClassesUrlSlugKeyType = 'classes_url_slug_key'
}

/** input type for incrementing numeric columns in table "classes" */
export type Classes_Inc_InputType = {
  max_booking_slots?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "classes" */
export type Classes_Insert_InputType = {
  booking_email?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  class_booking_options?: InputMaybe<Class_Booking_Option_Arr_Rel_Insert_InputType>;
  class_events?: InputMaybe<Class_Events_Arr_Rel_Insert_InputType>;
  class_favorits?: InputMaybe<Class_Favorites_Arr_Rel_Insert_InputType>;
  class_flags?: InputMaybe<Class_Flag_Arr_Rel_Insert_InputType>;
  class_levels?: InputMaybe<Class_Levels_Arr_Rel_Insert_InputType>;
  class_owners?: InputMaybe<Class_Owners_Arr_Rel_Insert_InputType>;
  class_pass_url?: InputMaybe<Scalars['String']>;
  class_teachers?: InputMaybe<Class_Teachers_Arr_Rel_Insert_InputType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<Event_Type_EnumType>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  invites?: InputMaybe<Invites_Arr_Rel_Insert_InputType>;
  is_classe?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  pricing_short?: InputMaybe<Scalars['String']>;
  recurring_patterns?: InputMaybe<Recurring_Patterns_Arr_Rel_Insert_InputType>;
  requirements?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Classes_Max_FieldsType = {
  __typename?: 'classes_max_fields';
  booking_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  class_pass_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  pricing_short?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  usc_url?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "classes" */
export type Classes_Max_Order_ByType = {
  booking_email?: InputMaybe<Order_ByType>;
  city?: InputMaybe<Order_ByType>;
  class_pass_url?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_url?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  pricing_short?: InputMaybe<Order_ByType>;
  requirements?: InputMaybe<Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  usc_url?: InputMaybe<Order_ByType>;
  website_url?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Classes_Min_FieldsType = {
  __typename?: 'classes_min_fields';
  booking_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  class_pass_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  pricing_short?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  usc_url?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "classes" */
export type Classes_Min_Order_ByType = {
  booking_email?: InputMaybe<Order_ByType>;
  city?: InputMaybe<Order_ByType>;
  class_pass_url?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_url?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  pricing_short?: InputMaybe<Order_ByType>;
  requirements?: InputMaybe<Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  usc_url?: InputMaybe<Order_ByType>;
  website_url?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "classes" */
export type Classes_Mutation_ResponseType = {
  __typename?: 'classes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClassesType>;
};

/** input type for inserting object relation for remote table "classes" */
export type Classes_Obj_Rel_Insert_InputType = {
  data: Classes_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Classes_On_ConflictType>;
};

/** on_conflict condition type for table "classes" */
export type Classes_On_ConflictType = {
  constraint: Classes_ConstraintType;
  update_columns?: Array<Classes_Update_ColumnType>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};

/** Ordering options when selecting data from "classes". */
export type Classes_Order_ByType = {
  booking_email?: InputMaybe<Order_ByType>;
  city?: InputMaybe<Order_ByType>;
  class_booking_options_aggregate?: InputMaybe<Class_Booking_Option_Aggregate_Order_ByType>;
  class_events_aggregate?: InputMaybe<Class_Events_Aggregate_Order_ByType>;
  class_favorits_aggregate?: InputMaybe<Class_Favorites_Aggregate_Order_ByType>;
  class_flags_aggregate?: InputMaybe<Class_Flag_Aggregate_Order_ByType>;
  class_levels_aggregate?: InputMaybe<Class_Levels_Aggregate_Order_ByType>;
  class_owners_aggregate?: InputMaybe<Class_Owners_Aggregate_Order_ByType>;
  class_pass_url?: InputMaybe<Order_ByType>;
  class_teachers_aggregate?: InputMaybe<Class_Teachers_Aggregate_Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by?: InputMaybe<Users_Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  event_type?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_url?: InputMaybe<Order_ByType>;
  invites_aggregate?: InputMaybe<Invites_Aggregate_Order_ByType>;
  is_classe?: InputMaybe<Order_ByType>;
  location?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  pricing_short?: InputMaybe<Order_ByType>;
  recurring_patterns_aggregate?: InputMaybe<Recurring_Patterns_Aggregate_Order_ByType>;
  requirements?: InputMaybe<Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  usc_url?: InputMaybe<Order_ByType>;
  website_url?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: classes */
export type Classes_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "classes" */
export enum Classes_Select_ColumnType {
  /** column name */
  BookingEmailType = 'booking_email',
  /** column name */
  CityType = 'city',
  /** column name */
  ClassPassUrlType = 'class_pass_url',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  EventTypeType = 'event_type',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageUrlType = 'image_url',
  /** column name */
  IsClasseType = 'is_classe',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationCityType = 'location_city',
  /** column name */
  LocationCountryType = 'location_country',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  MaxBookingSlotsType = 'max_booking_slots',
  /** column name */
  NameType = 'name',
  /** column name */
  PricingType = 'pricing',
  /** column name */
  PricingShortType = 'pricing_short',
  /** column name */
  RequirementsType = 'requirements',
  /** column name */
  TimezoneType = 'timezone',
  /** column name */
  UrlSlugType = 'url_slug',
  /** column name */
  UscUrlType = 'usc_url',
  /** column name */
  WebsiteUrlType = 'website_url'
}

/** select "classes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "classes" */
export enum Classes_Select_Column_Classes_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsClasseType = 'is_classe'
}

/** select "classes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "classes" */
export enum Classes_Select_Column_Classes_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsClasseType = 'is_classe'
}

/** input type for updating data in table "classes" */
export type Classes_Set_InputType = {
  booking_email?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  class_pass_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<Event_Type_EnumType>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_classe?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  pricing_short?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Classes_Stddev_FieldsType = {
  __typename?: 'classes_stddev_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "classes" */
export type Classes_Stddev_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_pop on columns */
export type Classes_Stddev_Pop_FieldsType = {
  __typename?: 'classes_stddev_pop_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "classes" */
export type Classes_Stddev_Pop_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_samp on columns */
export type Classes_Stddev_Samp_FieldsType = {
  __typename?: 'classes_stddev_samp_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "classes" */
export type Classes_Stddev_Samp_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** Streaming cursor of the table "classes" */
export type Classes_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Classes_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Classes_Stream_Cursor_Value_InputType = {
  booking_email?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  class_pass_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  event_type?: InputMaybe<Event_Type_EnumType>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_classe?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  pricing_short?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Classes_Sum_FieldsType = {
  __typename?: 'classes_sum_fields';
  max_booking_slots?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "classes" */
export type Classes_Sum_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** update columns of table "classes" */
export enum Classes_Update_ColumnType {
  /** column name */
  BookingEmailType = 'booking_email',
  /** column name */
  CityType = 'city',
  /** column name */
  ClassPassUrlType = 'class_pass_url',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  EventTypeType = 'event_type',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageUrlType = 'image_url',
  /** column name */
  IsClasseType = 'is_classe',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationCityType = 'location_city',
  /** column name */
  LocationCountryType = 'location_country',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  MaxBookingSlotsType = 'max_booking_slots',
  /** column name */
  NameType = 'name',
  /** column name */
  PricingType = 'pricing',
  /** column name */
  PricingShortType = 'pricing_short',
  /** column name */
  RequirementsType = 'requirements',
  /** column name */
  TimezoneType = 'timezone',
  /** column name */
  UrlSlugType = 'url_slug',
  /** column name */
  UscUrlType = 'usc_url',
  /** column name */
  WebsiteUrlType = 'website_url'
}

export type Classes_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Classes_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Classes_Set_InputType>;
  where: Classes_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Classes_Var_Pop_FieldsType = {
  __typename?: 'classes_var_pop_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "classes" */
export type Classes_Var_Pop_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate var_samp on columns */
export type Classes_Var_Samp_FieldsType = {
  __typename?: 'classes_var_samp_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "classes" */
export type Classes_Var_Samp_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** aggregate variance on columns */
export type Classes_Variance_FieldsType = {
  __typename?: 'classes_variance_fields';
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "classes" */
export type Classes_Variance_Order_ByType = {
  max_booking_slots?: InputMaybe<Order_ByType>;
};

/** columns and relationships of "communities" */
export type CommunitiesType = {
  __typename?: 'communities';
  /** An array relationship */
  community_messages: Array<Community_MessagesType>;
  /** An aggregate relationship */
  community_messages_aggregate: Community_Messages_AggregateType;
  confirmation_status?: Maybe<Confirmation_Status_EnumType>;
  confirmed: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An array relationship */
  jams: Array<JamsType>;
  /** An aggregate relationship */
  jams_aggregate: Jams_AggregateType;
  latitude: Scalars['float8'];
  location: Scalars['geography'];
  longitude: Scalars['float8'];
  name: Scalars['String'];
  proposed_by_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  proposed_by_user?: Maybe<UsersType>;
  /** An array relationship */
  teacher: Array<TeachersType>;
  /** An aggregate relationship */
  teacher_aggregate: Teachers_AggregateType;
  teacher_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  users: Array<User_CommunitiesType>;
  /** An aggregate relationship */
  users_aggregate: User_Communities_AggregateType;
};


/** columns and relationships of "communities" */
export type CommunitiesCommunity_MessagesArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesCommunity_Messages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesJamsArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesJams_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesTeacherArgsType = {
  distinct_on?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teachers_Order_ByType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesTeacher_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teachers_Order_ByType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesUsersArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


/** columns and relationships of "communities" */
export type CommunitiesUsers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};

/** aggregated selection of "communities" */
export type Communities_AggregateType = {
  __typename?: 'communities_aggregate';
  aggregate?: Maybe<Communities_Aggregate_FieldsType>;
  nodes: Array<CommunitiesType>;
};

/** aggregate fields of "communities" */
export type Communities_Aggregate_FieldsType = {
  __typename?: 'communities_aggregate_fields';
  avg?: Maybe<Communities_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Communities_Max_FieldsType>;
  min?: Maybe<Communities_Min_FieldsType>;
  stddev?: Maybe<Communities_Stddev_FieldsType>;
  stddev_pop?: Maybe<Communities_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Communities_Stddev_Samp_FieldsType>;
  sum?: Maybe<Communities_Sum_FieldsType>;
  var_pop?: Maybe<Communities_Var_Pop_FieldsType>;
  var_samp?: Maybe<Communities_Var_Samp_FieldsType>;
  variance?: Maybe<Communities_Variance_FieldsType>;
};


/** aggregate fields of "communities" */
export type Communities_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Communities_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Communities_Avg_FieldsType = {
  __typename?: 'communities_avg_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "communities". All fields are combined with a logical 'AND'. */
export type Communities_Bool_ExpType = {
  _and?: InputMaybe<Array<Communities_Bool_ExpType>>;
  _not?: InputMaybe<Communities_Bool_ExpType>;
  _or?: InputMaybe<Array<Communities_Bool_ExpType>>;
  community_messages?: InputMaybe<Community_Messages_Bool_ExpType>;
  community_messages_aggregate?: InputMaybe<Community_Messages_Aggregate_Bool_ExpType>;
  confirmation_status?: InputMaybe<Confirmation_Status_Enum_Comparison_ExpType>;
  confirmed?: InputMaybe<Boolean_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  jams?: InputMaybe<Jams_Bool_ExpType>;
  jams_aggregate?: InputMaybe<Jams_Aggregate_Bool_ExpType>;
  latitude?: InputMaybe<Float8_Comparison_ExpType>;
  location?: InputMaybe<Geography_Comparison_ExpType>;
  longitude?: InputMaybe<Float8_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  proposed_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  proposed_by_user?: InputMaybe<Users_Bool_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_aggregate?: InputMaybe<Teachers_Aggregate_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
  users?: InputMaybe<User_Communities_Bool_ExpType>;
  users_aggregate?: InputMaybe<User_Communities_Aggregate_Bool_ExpType>;
};

export type Communities_By_Location_V1_ArgsType = {
  lat?: InputMaybe<Scalars['numeric']>;
  lng?: InputMaybe<Scalars['numeric']>;
};

/** unique or primary key constraints on table "communities" */
export enum Communities_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  CommunityPkeyType = 'community_pkey'
}

/** input type for incrementing numeric columns in table "communities" */
export type Communities_Inc_InputType = {
  latitude?: InputMaybe<Scalars['float8']>;
  longitude?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "communities" */
export type Communities_Insert_InputType = {
  community_messages?: InputMaybe<Community_Messages_Arr_Rel_Insert_InputType>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  jams?: InputMaybe<Jams_Arr_Rel_Insert_InputType>;
  latitude?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  longitude?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  proposed_by_id?: InputMaybe<Scalars['uuid']>;
  proposed_by_user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  teacher?: InputMaybe<Teachers_Arr_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  users?: InputMaybe<User_Communities_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Communities_Max_FieldsType = {
  __typename?: 'communities_max_fields';
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  proposed_by_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Communities_Min_FieldsType = {
  __typename?: 'communities_min_fields';
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  proposed_by_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "communities" */
export type Communities_Mutation_ResponseType = {
  __typename?: 'communities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CommunitiesType>;
};

/** input type for inserting object relation for remote table "communities" */
export type Communities_Obj_Rel_Insert_InputType = {
  data: Communities_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Communities_On_ConflictType>;
};

/** on_conflict condition type for table "communities" */
export type Communities_On_ConflictType = {
  constraint: Communities_ConstraintType;
  update_columns?: Array<Communities_Update_ColumnType>;
  where?: InputMaybe<Communities_Bool_ExpType>;
};

/** Ordering options when selecting data from "communities". */
export type Communities_Order_ByType = {
  community_messages_aggregate?: InputMaybe<Community_Messages_Aggregate_Order_ByType>;
  confirmation_status?: InputMaybe<Order_ByType>;
  confirmed?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  jams_aggregate?: InputMaybe<Jams_Aggregate_Order_ByType>;
  latitude?: InputMaybe<Order_ByType>;
  location?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  proposed_by_id?: InputMaybe<Order_ByType>;
  proposed_by_user?: InputMaybe<Users_Order_ByType>;
  teacher_aggregate?: InputMaybe<Teachers_Aggregate_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  users_aggregate?: InputMaybe<User_Communities_Aggregate_Order_ByType>;
};

/** primary key columns input for table: communities */
export type Communities_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "communities" */
export enum Communities_Select_ColumnType {
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  ConfirmedType = 'confirmed',
  /** column name */
  IdType = 'id',
  /** column name */
  LatitudeType = 'latitude',
  /** column name */
  LocationType = 'location',
  /** column name */
  LongitudeType = 'longitude',
  /** column name */
  NameType = 'name',
  /** column name */
  ProposedByIdType = 'proposed_by_id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** input type for updating data in table "communities" */
export type Communities_Set_InputType = {
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  longitude?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  proposed_by_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Communities_Stddev_FieldsType = {
  __typename?: 'communities_stddev_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Communities_Stddev_Pop_FieldsType = {
  __typename?: 'communities_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Communities_Stddev_Samp_FieldsType = {
  __typename?: 'communities_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "communities" */
export type Communities_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Communities_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Communities_Stream_Cursor_Value_InputType = {
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  longitude?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  proposed_by_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Communities_Sum_FieldsType = {
  __typename?: 'communities_sum_fields';
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
};

/** update columns of table "communities" */
export enum Communities_Update_ColumnType {
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  ConfirmedType = 'confirmed',
  /** column name */
  IdType = 'id',
  /** column name */
  LatitudeType = 'latitude',
  /** column name */
  LocationType = 'location',
  /** column name */
  LongitudeType = 'longitude',
  /** column name */
  NameType = 'name',
  /** column name */
  ProposedByIdType = 'proposed_by_id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

export type Communities_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Communities_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Communities_Set_InputType>;
  where: Communities_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Communities_Var_Pop_FieldsType = {
  __typename?: 'communities_var_pop_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Communities_Var_Samp_FieldsType = {
  __typename?: 'communities_var_samp_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Communities_Variance_FieldsType = {
  __typename?: 'communities_variance_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "community_messages" */
export type Community_MessagesType = {
  __typename?: 'community_messages';
  /** An object relationship */
  community: CommunitiesType;
  community_id: Scalars['uuid'];
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  from_user: UsersType;
  from_user_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "community_messages" */
export type Community_Messages_AggregateType = {
  __typename?: 'community_messages_aggregate';
  aggregate?: Maybe<Community_Messages_Aggregate_FieldsType>;
  nodes: Array<Community_MessagesType>;
};

export type Community_Messages_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Community_Messages_Aggregate_Bool_Exp_CountType>;
};

export type Community_Messages_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Community_Messages_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "community_messages" */
export type Community_Messages_Aggregate_FieldsType = {
  __typename?: 'community_messages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Community_Messages_Max_FieldsType>;
  min?: Maybe<Community_Messages_Min_FieldsType>;
};


/** aggregate fields of "community_messages" */
export type Community_Messages_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "community_messages" */
export type Community_Messages_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Community_Messages_Max_Order_ByType>;
  min?: InputMaybe<Community_Messages_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "community_messages" */
export type Community_Messages_Arr_Rel_Insert_InputType = {
  data: Array<Community_Messages_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Community_Messages_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "community_messages". All fields are combined with a logical 'AND'. */
export type Community_Messages_Bool_ExpType = {
  _and?: InputMaybe<Array<Community_Messages_Bool_ExpType>>;
  _not?: InputMaybe<Community_Messages_Bool_ExpType>;
  _or?: InputMaybe<Array<Community_Messages_Bool_ExpType>>;
  community?: InputMaybe<Communities_Bool_ExpType>;
  community_id?: InputMaybe<Uuid_Comparison_ExpType>;
  content?: InputMaybe<String_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  from_user?: InputMaybe<Users_Bool_ExpType>;
  from_user_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "community_messages" */
export enum Community_Messages_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  CommunityMessagesPkeyType = 'community_messages_pkey'
}

/** input type for inserting data into table "community_messages" */
export type Community_Messages_Insert_InputType = {
  community?: InputMaybe<Communities_Obj_Rel_Insert_InputType>;
  community_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from_user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  from_user_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Community_Messages_Max_FieldsType = {
  __typename?: 'community_messages_max_fields';
  community_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_user_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "community_messages" */
export type Community_Messages_Max_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  content?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  from_user_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Community_Messages_Min_FieldsType = {
  __typename?: 'community_messages_min_fields';
  community_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  from_user_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "community_messages" */
export type Community_Messages_Min_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  content?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  from_user_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "community_messages" */
export type Community_Messages_Mutation_ResponseType = {
  __typename?: 'community_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Community_MessagesType>;
};

/** on_conflict condition type for table "community_messages" */
export type Community_Messages_On_ConflictType = {
  constraint: Community_Messages_ConstraintType;
  update_columns?: Array<Community_Messages_Update_ColumnType>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};

/** Ordering options when selecting data from "community_messages". */
export type Community_Messages_Order_ByType = {
  community?: InputMaybe<Communities_Order_ByType>;
  community_id?: InputMaybe<Order_ByType>;
  content?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  from_user?: InputMaybe<Users_Order_ByType>;
  from_user_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: community_messages */
export type Community_Messages_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "community_messages" */
export enum Community_Messages_Select_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  ContentType = 'content',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  FromUserIdType = 'from_user_id',
  /** column name */
  IdType = 'id'
}

/** input type for updating data in table "community_messages" */
export type Community_Messages_Set_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from_user_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "community_messages" */
export type Community_Messages_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Community_Messages_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Community_Messages_Stream_Cursor_Value_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from_user_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "community_messages" */
export enum Community_Messages_Update_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  ContentType = 'content',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  FromUserIdType = 'from_user_id',
  /** column name */
  IdType = 'id'
}

export type Community_Messages_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Community_Messages_Set_InputType>;
  where: Community_Messages_Bool_ExpType;
};

/** columns and relationships of "config" */
export type ConfigType = {
  __typename?: 'config';
  id: Scalars['uuid'];
  min_version: Scalars['String'];
};

/** aggregated selection of "config" */
export type Config_AggregateType = {
  __typename?: 'config_aggregate';
  aggregate?: Maybe<Config_Aggregate_FieldsType>;
  nodes: Array<ConfigType>;
};

/** aggregate fields of "config" */
export type Config_Aggregate_FieldsType = {
  __typename?: 'config_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Config_Max_FieldsType>;
  min?: Maybe<Config_Min_FieldsType>;
};


/** aggregate fields of "config" */
export type Config_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Config_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "config". All fields are combined with a logical 'AND'. */
export type Config_Bool_ExpType = {
  _and?: InputMaybe<Array<Config_Bool_ExpType>>;
  _not?: InputMaybe<Config_Bool_ExpType>;
  _or?: InputMaybe<Array<Config_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  min_version?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "config" */
export enum Config_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ConfigPkeyType = 'config_pkey'
}

/** input type for inserting data into table "config" */
export type Config_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  min_version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Config_Max_FieldsType = {
  __typename?: 'config_max_fields';
  id?: Maybe<Scalars['uuid']>;
  min_version?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Config_Min_FieldsType = {
  __typename?: 'config_min_fields';
  id?: Maybe<Scalars['uuid']>;
  min_version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "config" */
export type Config_Mutation_ResponseType = {
  __typename?: 'config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigType>;
};

/** on_conflict condition type for table "config" */
export type Config_On_ConflictType = {
  constraint: Config_ConstraintType;
  update_columns?: Array<Config_Update_ColumnType>;
  where?: InputMaybe<Config_Bool_ExpType>;
};

/** Ordering options when selecting data from "config". */
export type Config_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  min_version?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: config */
export type Config_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "config" */
export enum Config_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  MinVersionType = 'min_version'
}

/** input type for updating data in table "config" */
export type Config_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  min_version?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "config" */
export type Config_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Config_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Config_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  min_version?: InputMaybe<Scalars['String']>;
};

/** update columns of table "config" */
export enum Config_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  MinVersionType = 'min_version'
}

export type Config_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Config_Set_InputType>;
  where: Config_Bool_ExpType;
};

/** columns and relationships of "confirmation_status" */
export type Confirmation_StatusType = {
  __typename?: 'confirmation_status';
  value: Scalars['String'];
};

/** aggregated selection of "confirmation_status" */
export type Confirmation_Status_AggregateType = {
  __typename?: 'confirmation_status_aggregate';
  aggregate?: Maybe<Confirmation_Status_Aggregate_FieldsType>;
  nodes: Array<Confirmation_StatusType>;
};

/** aggregate fields of "confirmation_status" */
export type Confirmation_Status_Aggregate_FieldsType = {
  __typename?: 'confirmation_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Confirmation_Status_Max_FieldsType>;
  min?: Maybe<Confirmation_Status_Min_FieldsType>;
};


/** aggregate fields of "confirmation_status" */
export type Confirmation_Status_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Confirmation_Status_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "confirmation_status". All fields are combined with a logical 'AND'. */
export type Confirmation_Status_Bool_ExpType = {
  _and?: InputMaybe<Array<Confirmation_Status_Bool_ExpType>>;
  _not?: InputMaybe<Confirmation_Status_Bool_ExpType>;
  _or?: InputMaybe<Array<Confirmation_Status_Bool_ExpType>>;
  value?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "confirmation_status" */
export enum Confirmation_Status_ConstraintType {
  /** unique or primary key constraint on columns "value" */
  ConfirmationStatusPkeyType = 'confirmation_status_pkey'
}

export enum Confirmation_Status_EnumType {
  ConfirmedType = 'Confirmed',
  PendingType = 'Pending',
  RejectedType = 'Rejected'
}

/** Boolean expression to compare columns of type "confirmation_status_enum". All fields are combined with logical 'AND'. */
export type Confirmation_Status_Enum_Comparison_ExpType = {
  _eq?: InputMaybe<Confirmation_Status_EnumType>;
  _in?: InputMaybe<Array<Confirmation_Status_EnumType>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Confirmation_Status_EnumType>;
  _nin?: InputMaybe<Array<Confirmation_Status_EnumType>>;
};

/** input type for inserting data into table "confirmation_status" */
export type Confirmation_Status_Insert_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Confirmation_Status_Max_FieldsType = {
  __typename?: 'confirmation_status_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Confirmation_Status_Min_FieldsType = {
  __typename?: 'confirmation_status_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "confirmation_status" */
export type Confirmation_Status_Mutation_ResponseType = {
  __typename?: 'confirmation_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Confirmation_StatusType>;
};

/** on_conflict condition type for table "confirmation_status" */
export type Confirmation_Status_On_ConflictType = {
  constraint: Confirmation_Status_ConstraintType;
  update_columns?: Array<Confirmation_Status_Update_ColumnType>;
  where?: InputMaybe<Confirmation_Status_Bool_ExpType>;
};

/** Ordering options when selecting data from "confirmation_status". */
export type Confirmation_Status_Order_ByType = {
  value?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: confirmation_status */
export type Confirmation_Status_Pk_Columns_InputType = {
  value: Scalars['String'];
};

/** select columns of table "confirmation_status" */
export enum Confirmation_Status_Select_ColumnType {
  /** column name */
  ValueType = 'value'
}

/** input type for updating data in table "confirmation_status" */
export type Confirmation_Status_Set_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "confirmation_status" */
export type Confirmation_Status_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Confirmation_Status_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Confirmation_Status_Stream_Cursor_Value_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "confirmation_status" */
export enum Confirmation_Status_Update_ColumnType {
  /** column name */
  ValueType = 'value'
}

export type Confirmation_Status_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Confirmation_Status_Set_InputType>;
  where: Confirmation_Status_Bool_ExpType;
};

/** columns and relationships of "created_invites" */
export type Created_InvitesType = {
  __typename?: 'created_invites';
  /** An object relationship */
  class?: Maybe<ClassesType>;
  confirmation_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  entity?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  event?: Maybe<EventsType>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  invited_user?: Maybe<UsersType>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "created_invites" */
export type Created_Invites_AggregateType = {
  __typename?: 'created_invites_aggregate';
  aggregate?: Maybe<Created_Invites_Aggregate_FieldsType>;
  nodes: Array<Created_InvitesType>;
};

/** aggregate fields of "created_invites" */
export type Created_Invites_Aggregate_FieldsType = {
  __typename?: 'created_invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Created_Invites_Max_FieldsType>;
  min?: Maybe<Created_Invites_Min_FieldsType>;
};


/** aggregate fields of "created_invites" */
export type Created_Invites_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Created_Invites_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "created_invites". All fields are combined with a logical 'AND'. */
export type Created_Invites_Bool_ExpType = {
  _and?: InputMaybe<Array<Created_Invites_Bool_ExpType>>;
  _not?: InputMaybe<Created_Invites_Bool_ExpType>;
  _or?: InputMaybe<Array<Created_Invites_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  confirmation_status?: InputMaybe<String_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  email?: InputMaybe<String_Comparison_ExpType>;
  entity?: InputMaybe<String_Comparison_ExpType>;
  entity_id?: InputMaybe<Uuid_Comparison_ExpType>;
  event?: InputMaybe<Events_Bool_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  invited_user?: InputMaybe<Users_Bool_ExpType>;
  invited_user_id?: InputMaybe<Uuid_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

/** input type for inserting data into table "created_invites" */
export type Created_Invites_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  confirmation_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_InputType>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Created_Invites_Max_FieldsType = {
  __typename?: 'created_invites_max_fields';
  confirmation_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  entity?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Created_Invites_Min_FieldsType = {
  __typename?: 'created_invites_min_fields';
  confirmation_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  entity?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "created_invites" */
export type Created_Invites_Mutation_ResponseType = {
  __typename?: 'created_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Created_InvitesType>;
};

/** Ordering options when selecting data from "created_invites". */
export type Created_Invites_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  confirmation_status?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  email?: InputMaybe<Order_ByType>;
  entity?: InputMaybe<Order_ByType>;
  entity_id?: InputMaybe<Order_ByType>;
  event?: InputMaybe<Events_Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  invited_user?: InputMaybe<Users_Order_ByType>;
  invited_user_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** select columns of table "created_invites" */
export enum Created_Invites_Select_ColumnType {
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  EmailType = 'email',
  /** column name */
  EntityType = 'entity',
  /** column name */
  EntityIdType = 'entity_id',
  /** column name */
  IdType = 'id',
  /** column name */
  InvitedUserIdType = 'invited_user_id',
  /** column name */
  UpdatedAtType = 'updated_at'
}

/** input type for updating data in table "created_invites" */
export type Created_Invites_Set_InputType = {
  confirmation_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "created_invites" */
export type Created_Invites_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Created_Invites_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Created_Invites_Stream_Cursor_Value_InputType = {
  confirmation_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Created_Invites_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Created_Invites_Set_InputType>;
  where: Created_Invites_Bool_ExpType;
};

/** ordering argument of a cursor */
export enum Cursor_OrderingType {
  /** ascending ordering of the cursor */
  AscType = 'ASC',
  /** descending ordering of the cursor */
  DescType = 'DESC'
}

/** user-events */
export type Event_BookmarksType = {
  __typename?: 'event_bookmarks';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  event?: Maybe<EventsType>;
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user?: Maybe<UsersType>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "event_bookmarks" */
export type Event_Bookmarks_AggregateType = {
  __typename?: 'event_bookmarks_aggregate';
  aggregate?: Maybe<Event_Bookmarks_Aggregate_FieldsType>;
  nodes: Array<Event_BookmarksType>;
};

export type Event_Bookmarks_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Event_Bookmarks_Aggregate_Bool_Exp_CountType>;
};

export type Event_Bookmarks_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "event_bookmarks" */
export type Event_Bookmarks_Aggregate_FieldsType = {
  __typename?: 'event_bookmarks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Bookmarks_Max_FieldsType>;
  min?: Maybe<Event_Bookmarks_Min_FieldsType>;
};


/** aggregate fields of "event_bookmarks" */
export type Event_Bookmarks_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_bookmarks" */
export type Event_Bookmarks_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Event_Bookmarks_Max_Order_ByType>;
  min?: InputMaybe<Event_Bookmarks_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "event_bookmarks" */
export type Event_Bookmarks_Arr_Rel_Insert_InputType = {
  data: Array<Event_Bookmarks_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Bookmarks_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "event_bookmarks". All fields are combined with a logical 'AND'. */
export type Event_Bookmarks_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Bookmarks_Bool_ExpType>>;
  _not?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Bookmarks_Bool_ExpType>>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  event?: InputMaybe<Events_Bool_ExpType>;
  event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_bookmarks" */
export enum Event_Bookmarks_ConstraintType {
  /** unique or primary key constraint on columns "event_id", "user_id" */
  EventBookmarksEventIdUserIdKeyType = 'event_bookmarks_event_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  EventBookmarksPkeyType = 'event_bookmarks_pkey'
}

/** input type for inserting data into table "event_bookmarks" */
export type Event_Bookmarks_Insert_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_InputType>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_Bookmarks_Max_FieldsType = {
  __typename?: 'event_bookmarks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_bookmarks" */
export type Event_Bookmarks_Max_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Event_Bookmarks_Min_FieldsType = {
  __typename?: 'event_bookmarks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_bookmarks" */
export type Event_Bookmarks_Min_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "event_bookmarks" */
export type Event_Bookmarks_Mutation_ResponseType = {
  __typename?: 'event_bookmarks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_BookmarksType>;
};

/** on_conflict condition type for table "event_bookmarks" */
export type Event_Bookmarks_On_ConflictType = {
  constraint: Event_Bookmarks_ConstraintType;
  update_columns?: Array<Event_Bookmarks_Update_ColumnType>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_bookmarks". */
export type Event_Bookmarks_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  event?: InputMaybe<Events_Order_ByType>;
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_bookmarks */
export type Event_Bookmarks_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "event_bookmarks" */
export enum Event_Bookmarks_Select_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "event_bookmarks" */
export type Event_Bookmarks_Set_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_bookmarks" */
export type Event_Bookmarks_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Bookmarks_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Bookmarks_Stream_Cursor_Value_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_bookmarks" */
export enum Event_Bookmarks_Update_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

export type Event_Bookmarks_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Bookmarks_Set_InputType>;
  where: Event_Bookmarks_Bool_ExpType;
};

/** a single event unit consiting of a specific date and refering to one instance of an parent event. */
export type Event_InstanceType = {
  __typename?: 'event_instance';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  early_bird_end_date?: Maybe<Scalars['timestamptz']>;
  early_bird_start_date?: Maybe<Scalars['timestamptz']>;
  end_date: Scalars['timestamptz'];
  /** An object relationship */
  event_template?: Maybe<Event_TemplateType>;
  event_template_id: Scalars['uuid'];
  id: Scalars['uuid'];
  img_url?: Maybe<Scalars['String']>;
  is_cancelled: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  start_date: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "event_instance" */
export type Event_Instance_AggregateType = {
  __typename?: 'event_instance_aggregate';
  aggregate?: Maybe<Event_Instance_Aggregate_FieldsType>;
  nodes: Array<Event_InstanceType>;
};

/** aggregate fields of "event_instance" */
export type Event_Instance_Aggregate_FieldsType = {
  __typename?: 'event_instance_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Instance_Max_FieldsType>;
  min?: Maybe<Event_Instance_Min_FieldsType>;
};


/** aggregate fields of "event_instance" */
export type Event_Instance_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Instance_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_instance". All fields are combined with a logical 'AND'. */
export type Event_Instance_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Instance_Bool_ExpType>>;
  _not?: InputMaybe<Event_Instance_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Instance_Bool_ExpType>>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  description?: InputMaybe<String_Comparison_ExpType>;
  early_bird_end_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  early_bird_start_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  end_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  event_template?: InputMaybe<Event_Template_Bool_ExpType>;
  event_template_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  img_url?: InputMaybe<String_Comparison_ExpType>;
  is_cancelled?: InputMaybe<Boolean_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  start_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_instance" */
export enum Event_Instance_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  EventInstancePkeyType = 'event_instance_pkey'
}

/** input type for inserting data into table "event_instance" */
export type Event_Instance_Insert_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  early_bird_end_date?: InputMaybe<Scalars['timestamptz']>;
  early_bird_start_date?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  event_template?: InputMaybe<Event_Template_Obj_Rel_Insert_InputType>;
  event_template_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_url?: InputMaybe<Scalars['String']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Event_Instance_Max_FieldsType = {
  __typename?: 'event_instance_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  early_bird_end_date?: Maybe<Scalars['timestamptz']>;
  early_bird_start_date?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  event_template_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  img_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Event_Instance_Min_FieldsType = {
  __typename?: 'event_instance_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  early_bird_end_date?: Maybe<Scalars['timestamptz']>;
  early_bird_start_date?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  event_template_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  img_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_instance" */
export type Event_Instance_Mutation_ResponseType = {
  __typename?: 'event_instance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_InstanceType>;
};

/** on_conflict condition type for table "event_instance" */
export type Event_Instance_On_ConflictType = {
  constraint: Event_Instance_ConstraintType;
  update_columns?: Array<Event_Instance_Update_ColumnType>;
  where?: InputMaybe<Event_Instance_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_instance". */
export type Event_Instance_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  early_bird_end_date?: InputMaybe<Order_ByType>;
  early_bird_start_date?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  event_template?: InputMaybe<Event_Template_Order_ByType>;
  event_template_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  img_url?: InputMaybe<Order_ByType>;
  is_cancelled?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_instance */
export type Event_Instance_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "event_instance" */
export enum Event_Instance_Select_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  EarlyBirdEndDateType = 'early_bird_end_date',
  /** column name */
  EarlyBirdStartDateType = 'early_bird_start_date',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  EventTemplateIdType = 'event_template_id',
  /** column name */
  IdType = 'id',
  /** column name */
  ImgUrlType = 'img_url',
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  NameType = 'name',
  /** column name */
  StartDateType = 'start_date',
  /** column name */
  UpdatedAtType = 'updated_at'
}

/** input type for updating data in table "event_instance" */
export type Event_Instance_Set_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  early_bird_end_date?: InputMaybe<Scalars['timestamptz']>;
  early_bird_start_date?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  event_template_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_url?: InputMaybe<Scalars['String']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_instance" */
export type Event_Instance_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Instance_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Instance_Stream_Cursor_Value_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  early_bird_end_date?: InputMaybe<Scalars['timestamptz']>;
  early_bird_start_date?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  event_template_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_url?: InputMaybe<Scalars['String']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_instance" */
export enum Event_Instance_Update_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  EarlyBirdEndDateType = 'early_bird_end_date',
  /** column name */
  EarlyBirdStartDateType = 'early_bird_start_date',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  EventTemplateIdType = 'event_template_id',
  /** column name */
  IdType = 'id',
  /** column name */
  ImgUrlType = 'img_url',
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  NameType = 'name',
  /** column name */
  StartDateType = 'start_date',
  /** column name */
  UpdatedAtType = 'updated_at'
}

export type Event_Instance_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Instance_Set_InputType>;
  where: Event_Instance_Bool_ExpType;
};

/** columns and relationships of "event_owners" */
export type Event_OwnersType = {
  __typename?: 'event_owners';
  /** An object relationship */
  event: EventsType;
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "event_owners" */
export type Event_Owners_AggregateType = {
  __typename?: 'event_owners_aggregate';
  aggregate?: Maybe<Event_Owners_Aggregate_FieldsType>;
  nodes: Array<Event_OwnersType>;
};

export type Event_Owners_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Event_Owners_Aggregate_Bool_Exp_CountType>;
};

export type Event_Owners_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Owners_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "event_owners" */
export type Event_Owners_Aggregate_FieldsType = {
  __typename?: 'event_owners_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Owners_Max_FieldsType>;
  min?: Maybe<Event_Owners_Min_FieldsType>;
};


/** aggregate fields of "event_owners" */
export type Event_Owners_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_owners" */
export type Event_Owners_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Event_Owners_Max_Order_ByType>;
  min?: InputMaybe<Event_Owners_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "event_owners" */
export type Event_Owners_Arr_Rel_Insert_InputType = {
  data: Array<Event_Owners_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Owners_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "event_owners". All fields are combined with a logical 'AND'. */
export type Event_Owners_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Owners_Bool_ExpType>>;
  _not?: InputMaybe<Event_Owners_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Owners_Bool_ExpType>>;
  event?: InputMaybe<Events_Bool_ExpType>;
  event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_owners" */
export enum Event_Owners_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  EventOwnerPkeyType = 'event_owner_pkey'
}

/** input type for inserting data into table "event_owners" */
export type Event_Owners_Insert_InputType = {
  event?: InputMaybe<Events_Obj_Rel_Insert_InputType>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_Owners_Max_FieldsType = {
  __typename?: 'event_owners_max_fields';
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_owners" */
export type Event_Owners_Max_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Event_Owners_Min_FieldsType = {
  __typename?: 'event_owners_min_fields';
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_owners" */
export type Event_Owners_Min_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "event_owners" */
export type Event_Owners_Mutation_ResponseType = {
  __typename?: 'event_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_OwnersType>;
};

/** on_conflict condition type for table "event_owners" */
export type Event_Owners_On_ConflictType = {
  constraint: Event_Owners_ConstraintType;
  update_columns?: Array<Event_Owners_Update_ColumnType>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_owners". */
export type Event_Owners_Order_ByType = {
  event?: InputMaybe<Events_Order_ByType>;
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_owners */
export type Event_Owners_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "event_owners" */
export enum Event_Owners_Select_ColumnType {
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "event_owners" */
export type Event_Owners_Set_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_owners" */
export type Event_Owners_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Owners_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Owners_Stream_Cursor_Value_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_owners" */
export enum Event_Owners_Update_ColumnType {
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

export type Event_Owners_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Owners_Set_InputType>;
  where: Event_Owners_Bool_ExpType;
};

/** columns and relationships of "event_source" */
export type Event_SourceType = {
  __typename?: 'event_source';
  value: Scalars['String'];
};

/** aggregated selection of "event_source" */
export type Event_Source_AggregateType = {
  __typename?: 'event_source_aggregate';
  aggregate?: Maybe<Event_Source_Aggregate_FieldsType>;
  nodes: Array<Event_SourceType>;
};

/** aggregate fields of "event_source" */
export type Event_Source_Aggregate_FieldsType = {
  __typename?: 'event_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Source_Max_FieldsType>;
  min?: Maybe<Event_Source_Min_FieldsType>;
};


/** aggregate fields of "event_source" */
export type Event_Source_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Source_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_source". All fields are combined with a logical 'AND'. */
export type Event_Source_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Source_Bool_ExpType>>;
  _not?: InputMaybe<Event_Source_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Source_Bool_ExpType>>;
  value?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_source" */
export enum Event_Source_ConstraintType {
  /** unique or primary key constraint on columns "value" */
  EventSourcePkeyType = 'event_source_pkey'
}

export enum Event_Source_EnumType {
  CrawledType = 'Crawled',
  SubmittedType = 'Submitted'
}

/** Boolean expression to compare columns of type "event_source_enum". All fields are combined with logical 'AND'. */
export type Event_Source_Enum_Comparison_ExpType = {
  _eq?: InputMaybe<Event_Source_EnumType>;
  _in?: InputMaybe<Array<Event_Source_EnumType>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Event_Source_EnumType>;
  _nin?: InputMaybe<Array<Event_Source_EnumType>>;
};

/** input type for inserting data into table "event_source" */
export type Event_Source_Insert_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Event_Source_Max_FieldsType = {
  __typename?: 'event_source_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Event_Source_Min_FieldsType = {
  __typename?: 'event_source_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_source" */
export type Event_Source_Mutation_ResponseType = {
  __typename?: 'event_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_SourceType>;
};

/** on_conflict condition type for table "event_source" */
export type Event_Source_On_ConflictType = {
  constraint: Event_Source_ConstraintType;
  update_columns?: Array<Event_Source_Update_ColumnType>;
  where?: InputMaybe<Event_Source_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_source". */
export type Event_Source_Order_ByType = {
  value?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_source */
export type Event_Source_Pk_Columns_InputType = {
  value: Scalars['String'];
};

/** select columns of table "event_source" */
export enum Event_Source_Select_ColumnType {
  /** column name */
  ValueType = 'value'
}

/** input type for updating data in table "event_source" */
export type Event_Source_Set_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_source" */
export type Event_Source_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Source_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Source_Stream_Cursor_Value_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_source" */
export enum Event_Source_Update_ColumnType {
  /** column name */
  ValueType = 'value'
}

export type Event_Source_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Source_Set_InputType>;
  where: Event_Source_Bool_ExpType;
};

/** columns and relationships of "event_teachers" */
export type Event_TeachersType = {
  __typename?: 'event_teachers';
  /** An object relationship */
  event: EventsType;
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  teacher?: Maybe<TeachersType>;
  teacher_id: Scalars['uuid'];
};

/** aggregated selection of "event_teachers" */
export type Event_Teachers_AggregateType = {
  __typename?: 'event_teachers_aggregate';
  aggregate?: Maybe<Event_Teachers_Aggregate_FieldsType>;
  nodes: Array<Event_TeachersType>;
};

export type Event_Teachers_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Event_Teachers_Aggregate_Bool_Exp_CountType>;
};

export type Event_Teachers_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_Teachers_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "event_teachers" */
export type Event_Teachers_Aggregate_FieldsType = {
  __typename?: 'event_teachers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Teachers_Max_FieldsType>;
  min?: Maybe<Event_Teachers_Min_FieldsType>;
};


/** aggregate fields of "event_teachers" */
export type Event_Teachers_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_teachers" */
export type Event_Teachers_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Event_Teachers_Max_Order_ByType>;
  min?: InputMaybe<Event_Teachers_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "event_teachers" */
export type Event_Teachers_Arr_Rel_Insert_InputType = {
  data: Array<Event_Teachers_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Teachers_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "event_teachers". All fields are combined with a logical 'AND'. */
export type Event_Teachers_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Teachers_Bool_ExpType>>;
  _not?: InputMaybe<Event_Teachers_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Teachers_Bool_ExpType>>;
  event?: InputMaybe<Events_Bool_ExpType>;
  event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_teachers" */
export enum Event_Teachers_ConstraintType {
  /** unique or primary key constraint on columns "event_id", "teacher_id" */
  EventTeachersEventIdTeacherIdKeyType = 'event_teachers_event_id_teacher_id_key',
  /** unique or primary key constraint on columns "id" */
  EventTeachersPkeyType = 'event_teachers_pkey'
}

/** input type for inserting data into table "event_teachers" */
export type Event_Teachers_Insert_InputType = {
  event?: InputMaybe<Events_Obj_Rel_Insert_InputType>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_Teachers_Max_FieldsType = {
  __typename?: 'event_teachers_max_fields';
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_teachers" */
export type Event_Teachers_Max_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Event_Teachers_Min_FieldsType = {
  __typename?: 'event_teachers_min_fields';
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_teachers" */
export type Event_Teachers_Min_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "event_teachers" */
export type Event_Teachers_Mutation_ResponseType = {
  __typename?: 'event_teachers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_TeachersType>;
};

/** on_conflict condition type for table "event_teachers" */
export type Event_Teachers_On_ConflictType = {
  constraint: Event_Teachers_ConstraintType;
  update_columns?: Array<Event_Teachers_Update_ColumnType>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_teachers". */
export type Event_Teachers_Order_ByType = {
  event?: InputMaybe<Events_Order_ByType>;
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher?: InputMaybe<Teachers_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_teachers */
export type Event_Teachers_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "event_teachers" */
export enum Event_Teachers_Select_ColumnType {
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** input type for updating data in table "event_teachers" */
export type Event_Teachers_Set_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_teachers" */
export type Event_Teachers_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Teachers_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Teachers_Stream_Cursor_Value_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_teachers" */
export enum Event_Teachers_Update_ColumnType {
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

export type Event_Teachers_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Teachers_Set_InputType>;
  where: Event_Teachers_Bool_ExpType;
};

/** This is the mother class that together with a event_instance creates an event */
export type Event_TemplateType = {
  __typename?: 'event_template';
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  img_url?: Maybe<Scalars['String']>;
  location: Scalars['geography'];
  location_name: Scalars['String'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "event_template" */
export type Event_Template_AggregateType = {
  __typename?: 'event_template_aggregate';
  aggregate?: Maybe<Event_Template_Aggregate_FieldsType>;
  nodes: Array<Event_TemplateType>;
};

/** aggregate fields of "event_template" */
export type Event_Template_Aggregate_FieldsType = {
  __typename?: 'event_template_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Template_Max_FieldsType>;
  min?: Maybe<Event_Template_Min_FieldsType>;
};


/** aggregate fields of "event_template" */
export type Event_Template_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Template_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_template". All fields are combined with a logical 'AND'. */
export type Event_Template_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Template_Bool_ExpType>>;
  _not?: InputMaybe<Event_Template_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Template_Bool_ExpType>>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  description?: InputMaybe<String_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  img_url?: InputMaybe<String_Comparison_ExpType>;
  location?: InputMaybe<Geography_Comparison_ExpType>;
  location_name?: InputMaybe<String_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_template" */
export enum Event_Template_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  EventTemplatePkeyType = 'event_template_pkey'
}

/** input type for inserting data into table "event_template" */
export type Event_Template_Insert_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_url?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Event_Template_Max_FieldsType = {
  __typename?: 'event_template_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  img_url?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Event_Template_Min_FieldsType = {
  __typename?: 'event_template_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  img_url?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "event_template" */
export type Event_Template_Mutation_ResponseType = {
  __typename?: 'event_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_TemplateType>;
};

/** input type for inserting object relation for remote table "event_template" */
export type Event_Template_Obj_Rel_Insert_InputType = {
  data: Event_Template_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_Template_On_ConflictType>;
};

/** on_conflict condition type for table "event_template" */
export type Event_Template_On_ConflictType = {
  constraint: Event_Template_ConstraintType;
  update_columns?: Array<Event_Template_Update_ColumnType>;
  where?: InputMaybe<Event_Template_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_template". */
export type Event_Template_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  img_url?: InputMaybe<Order_ByType>;
  location?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_template */
export type Event_Template_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "event_template" */
export enum Event_Template_Select_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  IdType = 'id',
  /** column name */
  ImgUrlType = 'img_url',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  NameType = 'name',
  /** column name */
  UpdatedAtType = 'updated_at'
}

/** input type for updating data in table "event_template" */
export type Event_Template_Set_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_url?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "event_template" */
export type Event_Template_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Template_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Template_Stream_Cursor_Value_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_url?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "event_template" */
export enum Event_Template_Update_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  IdType = 'id',
  /** column name */
  ImgUrlType = 'img_url',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  NameType = 'name',
  /** column name */
  UpdatedAtType = 'updated_at'
}

export type Event_Template_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Template_Set_InputType>;
  where: Event_Template_Bool_ExpType;
};

/** columns and relationships of "event_type" */
export type Event_TypeType = {
  __typename?: 'event_type';
  /** An array relationship */
  classes: Array<ClassesType>;
  /** An aggregate relationship */
  classes_aggregate: Classes_AggregateType;
  value: Scalars['String'];
};


/** columns and relationships of "event_type" */
export type Event_TypeClassesArgsType = {
  distinct_on?: InputMaybe<Array<Classes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classes_Order_ByType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};


/** columns and relationships of "event_type" */
export type Event_TypeClasses_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Classes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classes_Order_ByType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};

/** aggregated selection of "event_type" */
export type Event_Type_AggregateType = {
  __typename?: 'event_type_aggregate';
  aggregate?: Maybe<Event_Type_Aggregate_FieldsType>;
  nodes: Array<Event_TypeType>;
};

/** aggregate fields of "event_type" */
export type Event_Type_Aggregate_FieldsType = {
  __typename?: 'event_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_Type_Max_FieldsType>;
  min?: Maybe<Event_Type_Min_FieldsType>;
};


/** aggregate fields of "event_type" */
export type Event_Type_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_Type_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "event_type". All fields are combined with a logical 'AND'. */
export type Event_Type_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_Type_Bool_ExpType>>;
  _not?: InputMaybe<Event_Type_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_Type_Bool_ExpType>>;
  classes?: InputMaybe<Classes_Bool_ExpType>;
  classes_aggregate?: InputMaybe<Classes_Aggregate_Bool_ExpType>;
  value?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_type" */
export enum Event_Type_ConstraintType {
  /** unique or primary key constraint on columns "value" */
  EventTypePkeyType = 'event_type_pkey'
}

export enum Event_Type_EnumType {
  ClassesType = 'Classes',
  FestivalsAndConsType = 'FestivalsAndCons',
  JamsType = 'Jams',
  RetreatsType = 'Retreats',
  TrainingsType = 'Trainings',
  WorkshopsType = 'Workshops'
}

/** Boolean expression to compare columns of type "event_type_enum". All fields are combined with logical 'AND'. */
export type Event_Type_Enum_Comparison_ExpType = {
  _eq?: InputMaybe<Event_Type_EnumType>;
  _in?: InputMaybe<Array<Event_Type_EnumType>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Event_Type_EnumType>;
  _nin?: InputMaybe<Array<Event_Type_EnumType>>;
};

/** input type for inserting data into table "event_type" */
export type Event_Type_Insert_InputType = {
  classes?: InputMaybe<Classes_Arr_Rel_Insert_InputType>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Event_Type_Max_FieldsType = {
  __typename?: 'event_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Event_Type_Min_FieldsType = {
  __typename?: 'event_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "event_type" */
export type Event_Type_Mutation_ResponseType = {
  __typename?: 'event_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_TypeType>;
};

/** on_conflict condition type for table "event_type" */
export type Event_Type_On_ConflictType = {
  constraint: Event_Type_ConstraintType;
  update_columns?: Array<Event_Type_Update_ColumnType>;
  where?: InputMaybe<Event_Type_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_type". */
export type Event_Type_Order_ByType = {
  classes_aggregate?: InputMaybe<Classes_Aggregate_Order_ByType>;
  value?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_type */
export type Event_Type_Pk_Columns_InputType = {
  value: Scalars['String'];
};

/** select columns of table "event_type" */
export enum Event_Type_Select_ColumnType {
  /** column name */
  ValueType = 'value'
}

/** input type for updating data in table "event_type" */
export type Event_Type_Set_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "event_type" */
export type Event_Type_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_Type_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Type_Stream_Cursor_Value_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "event_type" */
export enum Event_Type_Update_ColumnType {
  /** column name */
  ValueType = 'value'
}

export type Event_Type_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_Type_Set_InputType>;
  where: Event_Type_Bool_ExpType;
};

/** columns and relationships of "event_user_participants" */
export type Event_User_ParticipantsType = {
  __typename?: 'event_user_participants';
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "event_user_participants" */
export type Event_User_Participants_AggregateType = {
  __typename?: 'event_user_participants_aggregate';
  aggregate?: Maybe<Event_User_Participants_Aggregate_FieldsType>;
  nodes: Array<Event_User_ParticipantsType>;
};

export type Event_User_Participants_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Event_User_Participants_Aggregate_Bool_Exp_CountType>;
};

export type Event_User_Participants_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Event_User_Participants_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "event_user_participants" */
export type Event_User_Participants_Aggregate_FieldsType = {
  __typename?: 'event_user_participants_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Event_User_Participants_Max_FieldsType>;
  min?: Maybe<Event_User_Participants_Min_FieldsType>;
};


/** aggregate fields of "event_user_participants" */
export type Event_User_Participants_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "event_user_participants" */
export type Event_User_Participants_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Event_User_Participants_Max_Order_ByType>;
  min?: InputMaybe<Event_User_Participants_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "event_user_participants" */
export type Event_User_Participants_Arr_Rel_Insert_InputType = {
  data: Array<Event_User_Participants_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Event_User_Participants_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "event_user_participants". All fields are combined with a logical 'AND'. */
export type Event_User_Participants_Bool_ExpType = {
  _and?: InputMaybe<Array<Event_User_Participants_Bool_ExpType>>;
  _not?: InputMaybe<Event_User_Participants_Bool_ExpType>;
  _or?: InputMaybe<Array<Event_User_Participants_Bool_ExpType>>;
  event_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "event_user_participants" */
export enum Event_User_Participants_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  EventUserParticipantsPkeyType = 'event_user_participants_pkey'
}

/** input type for inserting data into table "event_user_participants" */
export type Event_User_Participants_Insert_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Event_User_Participants_Max_FieldsType = {
  __typename?: 'event_user_participants_max_fields';
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "event_user_participants" */
export type Event_User_Participants_Max_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Event_User_Participants_Min_FieldsType = {
  __typename?: 'event_user_participants_min_fields';
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "event_user_participants" */
export type Event_User_Participants_Min_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "event_user_participants" */
export type Event_User_Participants_Mutation_ResponseType = {
  __typename?: 'event_user_participants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Event_User_ParticipantsType>;
};

/** on_conflict condition type for table "event_user_participants" */
export type Event_User_Participants_On_ConflictType = {
  constraint: Event_User_Participants_ConstraintType;
  update_columns?: Array<Event_User_Participants_Update_ColumnType>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};

/** Ordering options when selecting data from "event_user_participants". */
export type Event_User_Participants_Order_ByType = {
  event_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: event_user_participants */
export type Event_User_Participants_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "event_user_participants" */
export enum Event_User_Participants_Select_ColumnType {
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "event_user_participants" */
export type Event_User_Participants_Set_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "event_user_participants" */
export type Event_User_Participants_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Event_User_Participants_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Event_User_Participants_Stream_Cursor_Value_InputType = {
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "event_user_participants" */
export enum Event_User_Participants_Update_ColumnType {
  /** column name */
  EventIdType = 'event_id',
  /** column name */
  IdType = 'id',
  /** column name */
  UserIdType = 'user_id'
}

export type Event_User_Participants_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Event_User_Participants_Set_InputType>;
  where: Event_User_Participants_Bool_ExpType;
};

/** columns and relationships of "events" */
export type EventsType = {
  __typename?: 'events';
  booked_out?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  bookmarks: Array<Event_BookmarksType>;
  /** An aggregate relationship */
  bookmarks_aggregate: Event_Bookmarks_AggregateType;
  confirmation_status: Confirmation_Status_EnumType;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  created_by: UsersType;
  created_by_id: Scalars['uuid'];
  description: Scalars['String'];
  early_bird_until?: Maybe<Scalars['timestamptz']>;
  end_date: Scalars['timestamptz'];
  end_date_tz?: Maybe<Scalars['timestamp']>;
  event_source: Event_Source_EnumType;
  event_type: Event_Type_EnumType;
  highlight_requested?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  /** An array relationship */
  invites: Array<InvitesType>;
  /** An aggregate relationship */
  invites_aggregate: Invites_AggregateType;
  is_food_included?: Maybe<Scalars['Boolean']>;
  is_highlighted: Scalars['Boolean'];
  links?: Maybe<Scalars['_text']>;
  location?: Maybe<Scalars['geography']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  main_image_url: Scalars['String'];
  name: Scalars['String'];
  origin_creator_name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  origin_location_name?: Maybe<Scalars['String']>;
  origin_updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  owners: Array<Event_OwnersType>;
  /** An aggregate relationship */
  owners_aggregate: Event_Owners_AggregateType;
  pretix_name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  regular_single_day_price?: Maybe<Scalars['float8']>;
  start_date: Scalars['timestamptz'];
  start_date_tz?: Maybe<Scalars['timestamp']>;
  target_level_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  teachers: Array<Event_TeachersType>;
  /** An aggregate relationship */
  teachers_aggregate: Event_Teachers_AggregateType;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_participants: Array<Event_User_ParticipantsType>;
  /** An aggregate relationship */
  user_participants_aggregate: Event_User_Participants_AggregateType;
};


/** columns and relationships of "events" */
export type EventsBookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsBookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsInvitesArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsInvites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsOwnersArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsOwners_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsTeachersArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsTeachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsUser_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_User_Participants_Order_ByType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};


/** columns and relationships of "events" */
export type EventsUser_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_User_Participants_Order_ByType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};

/** aggregated selection of "events" */
export type Events_AggregateType = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_FieldsType>;
  nodes: Array<EventsType>;
};

export type Events_Aggregate_Bool_ExpType = {
  avg?: InputMaybe<Events_Aggregate_Bool_Exp_AvgType>;
  bool_and?: InputMaybe<Events_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Events_Aggregate_Bool_Exp_Bool_OrType>;
  corr?: InputMaybe<Events_Aggregate_Bool_Exp_CorrType>;
  count?: InputMaybe<Events_Aggregate_Bool_Exp_CountType>;
  covar_samp?: InputMaybe<Events_Aggregate_Bool_Exp_Covar_SampType>;
  max?: InputMaybe<Events_Aggregate_Bool_Exp_MaxType>;
  min?: InputMaybe<Events_Aggregate_Bool_Exp_MinType>;
  stddev_samp?: InputMaybe<Events_Aggregate_Bool_Exp_Stddev_SampType>;
  sum?: InputMaybe<Events_Aggregate_Bool_Exp_SumType>;
  var_samp?: InputMaybe<Events_Aggregate_Bool_Exp_Var_SampType>;
};

export type Events_Aggregate_Bool_Exp_AvgType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Avg_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_CorrType = {
  arguments: Events_Aggregate_Bool_Exp_Corr_ArgumentsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Corr_ArgumentsType = {
  X: Events_Select_Column_Events_Aggregate_Bool_Exp_Corr_Arguments_ColumnsType;
  Y: Events_Select_Column_Events_Aggregate_Bool_Exp_Corr_Arguments_ColumnsType;
};

export type Events_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Events_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Covar_SampType = {
  arguments: Events_Aggregate_Bool_Exp_Covar_Samp_ArgumentsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Covar_Samp_ArgumentsType = {
  X: Events_Select_Column_Events_Aggregate_Bool_Exp_Covar_Samp_Arguments_ColumnsType;
  Y: Events_Select_Column_Events_Aggregate_Bool_Exp_Covar_Samp_Arguments_ColumnsType;
};

export type Events_Aggregate_Bool_Exp_MaxType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Max_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_MinType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Min_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Stddev_SampType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Stddev_Samp_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_SumType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Sum_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

export type Events_Aggregate_Bool_Exp_Var_SampType = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Var_Samp_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Events_Bool_ExpType>;
  predicate: Float8_Comparison_ExpType;
};

/** aggregate fields of "events" */
export type Events_Aggregate_FieldsType = {
  __typename?: 'events_aggregate_fields';
  avg?: Maybe<Events_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Events_Max_FieldsType>;
  min?: Maybe<Events_Min_FieldsType>;
  stddev?: Maybe<Events_Stddev_FieldsType>;
  stddev_pop?: Maybe<Events_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Events_Stddev_Samp_FieldsType>;
  sum?: Maybe<Events_Sum_FieldsType>;
  var_pop?: Maybe<Events_Var_Pop_FieldsType>;
  var_samp?: Maybe<Events_Var_Samp_FieldsType>;
  variance?: Maybe<Events_Variance_FieldsType>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Events_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_ByType = {
  avg?: InputMaybe<Events_Avg_Order_ByType>;
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Events_Max_Order_ByType>;
  min?: InputMaybe<Events_Min_Order_ByType>;
  stddev?: InputMaybe<Events_Stddev_Order_ByType>;
  stddev_pop?: InputMaybe<Events_Stddev_Pop_Order_ByType>;
  stddev_samp?: InputMaybe<Events_Stddev_Samp_Order_ByType>;
  sum?: InputMaybe<Events_Sum_Order_ByType>;
  var_pop?: InputMaybe<Events_Var_Pop_Order_ByType>;
  var_samp?: InputMaybe<Events_Var_Samp_Order_ByType>;
  variance?: InputMaybe<Events_Variance_Order_ByType>;
};

/** input type for inserting array relation for remote table "events" */
export type Events_Arr_Rel_Insert_InputType = {
  data: Array<Events_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_ConflictType>;
};

/** aggregate avg on columns */
export type Events_Avg_FieldsType = {
  __typename?: 'events_avg_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "events" */
export type Events_Avg_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_ExpType = {
  _and?: InputMaybe<Array<Events_Bool_ExpType>>;
  _not?: InputMaybe<Events_Bool_ExpType>;
  _or?: InputMaybe<Array<Events_Bool_ExpType>>;
  booked_out?: InputMaybe<Boolean_Comparison_ExpType>;
  bookmarks?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
  bookmarks_aggregate?: InputMaybe<Event_Bookmarks_Aggregate_Bool_ExpType>;
  confirmation_status?: InputMaybe<Confirmation_Status_Enum_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by?: InputMaybe<Users_Bool_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  description?: InputMaybe<String_Comparison_ExpType>;
  early_bird_until?: InputMaybe<Timestamptz_Comparison_ExpType>;
  end_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  end_date_tz?: InputMaybe<Timestamp_Comparison_ExpType>;
  event_source?: InputMaybe<Event_Source_Enum_Comparison_ExpType>;
  event_type?: InputMaybe<Event_Type_Enum_Comparison_ExpType>;
  highlight_requested?: InputMaybe<Boolean_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  invites?: InputMaybe<Invites_Bool_ExpType>;
  invites_aggregate?: InputMaybe<Invites_Aggregate_Bool_ExpType>;
  is_food_included?: InputMaybe<Boolean_Comparison_ExpType>;
  is_highlighted?: InputMaybe<Boolean_Comparison_ExpType>;
  links?: InputMaybe<_Text_Comparison_ExpType>;
  location?: InputMaybe<Geography_Comparison_ExpType>;
  location_city?: InputMaybe<String_Comparison_ExpType>;
  location_country?: InputMaybe<String_Comparison_ExpType>;
  location_name?: InputMaybe<String_Comparison_ExpType>;
  main_image_url?: InputMaybe<String_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  origin_creator_name?: InputMaybe<String_Comparison_ExpType>;
  origin_id?: InputMaybe<String_Comparison_ExpType>;
  origin_location_name?: InputMaybe<String_Comparison_ExpType>;
  origin_updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  owners?: InputMaybe<Event_Owners_Bool_ExpType>;
  owners_aggregate?: InputMaybe<Event_Owners_Aggregate_Bool_ExpType>;
  pretix_name?: InputMaybe<String_Comparison_ExpType>;
  pricing?: InputMaybe<String_Comparison_ExpType>;
  regular_single_day_price?: InputMaybe<Float8_Comparison_ExpType>;
  start_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  start_date_tz?: InputMaybe<Timestamp_Comparison_ExpType>;
  target_level_id?: InputMaybe<Uuid_Comparison_ExpType>;
  teachers?: InputMaybe<Event_Teachers_Bool_ExpType>;
  teachers_aggregate?: InputMaybe<Event_Teachers_Aggregate_Bool_ExpType>;
  timezone?: InputMaybe<String_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  url?: InputMaybe<String_Comparison_ExpType>;
  url_slug?: InputMaybe<String_Comparison_ExpType>;
  user_participants?: InputMaybe<Event_User_Participants_Bool_ExpType>;
  user_participants_aggregate?: InputMaybe<Event_User_Participants_Aggregate_Bool_ExpType>;
};

/** unique or primary key constraints on table "events" */
export enum Events_ConstraintType {
  /** unique or primary key constraint on columns "origin_id" */
  EventsOriginIdKeyType = 'events_origin_id_key',
  /** unique or primary key constraint on columns "id" */
  EventsPkeyType = 'events_pkey',
  /** unique or primary key constraint on columns "url_slug" */
  EventsUrlSlugKeyType = 'events_url_slug_key'
}

/** input type for incrementing numeric columns in table "events" */
export type Events_Inc_InputType = {
  regular_single_day_price?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "events" */
export type Events_Insert_InputType = {
  booked_out?: InputMaybe<Scalars['Boolean']>;
  bookmarks?: InputMaybe<Event_Bookmarks_Arr_Rel_Insert_InputType>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  early_bird_until?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  end_date_tz?: InputMaybe<Scalars['timestamp']>;
  event_source?: InputMaybe<Event_Source_EnumType>;
  event_type?: InputMaybe<Event_Type_EnumType>;
  highlight_requested?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  invites?: InputMaybe<Invites_Arr_Rel_Insert_InputType>;
  is_food_included?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Scalars['_text']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  main_image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  origin_creator_name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  origin_location_name?: InputMaybe<Scalars['String']>;
  origin_updated_at?: InputMaybe<Scalars['timestamptz']>;
  owners?: InputMaybe<Event_Owners_Arr_Rel_Insert_InputType>;
  pretix_name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  regular_single_day_price?: InputMaybe<Scalars['float8']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  start_date_tz?: InputMaybe<Scalars['timestamp']>;
  target_level_id?: InputMaybe<Scalars['uuid']>;
  teachers?: InputMaybe<Event_Teachers_Arr_Rel_Insert_InputType>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  user_participants?: InputMaybe<Event_User_Participants_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Events_Max_FieldsType = {
  __typename?: 'events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  early_bird_until?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  end_date_tz?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  main_image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin_creator_name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  origin_location_name?: Maybe<Scalars['String']>;
  origin_updated_at?: Maybe<Scalars['timestamptz']>;
  pretix_name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  regular_single_day_price?: Maybe<Scalars['float8']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  start_date_tz?: Maybe<Scalars['timestamp']>;
  target_level_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  early_bird_until?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  end_date_tz?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  main_image_url?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  origin_creator_name?: InputMaybe<Order_ByType>;
  origin_id?: InputMaybe<Order_ByType>;
  origin_location_name?: InputMaybe<Order_ByType>;
  origin_updated_at?: InputMaybe<Order_ByType>;
  pretix_name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  regular_single_day_price?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  start_date_tz?: InputMaybe<Order_ByType>;
  target_level_id?: InputMaybe<Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  url?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Events_Min_FieldsType = {
  __typename?: 'events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  early_bird_until?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  end_date_tz?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  main_image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  origin_creator_name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  origin_location_name?: Maybe<Scalars['String']>;
  origin_updated_at?: Maybe<Scalars['timestamptz']>;
  pretix_name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  regular_single_day_price?: Maybe<Scalars['float8']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  start_date_tz?: Maybe<Scalars['timestamp']>;
  target_level_id?: Maybe<Scalars['uuid']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  early_bird_until?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  end_date_tz?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  main_image_url?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  origin_creator_name?: InputMaybe<Order_ByType>;
  origin_id?: InputMaybe<Order_ByType>;
  origin_location_name?: InputMaybe<Order_ByType>;
  origin_updated_at?: InputMaybe<Order_ByType>;
  pretix_name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  regular_single_day_price?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  start_date_tz?: InputMaybe<Order_ByType>;
  target_level_id?: InputMaybe<Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  url?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_ResponseType = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EventsType>;
};

/** input type for inserting object relation for remote table "events" */
export type Events_Obj_Rel_Insert_InputType = {
  data: Events_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_ConflictType>;
};

/** on_conflict condition type for table "events" */
export type Events_On_ConflictType = {
  constraint: Events_ConstraintType;
  update_columns?: Array<Events_Update_ColumnType>;
  where?: InputMaybe<Events_Bool_ExpType>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_ByType = {
  booked_out?: InputMaybe<Order_ByType>;
  bookmarks_aggregate?: InputMaybe<Event_Bookmarks_Aggregate_Order_ByType>;
  confirmation_status?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by?: InputMaybe<Users_Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  early_bird_until?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  end_date_tz?: InputMaybe<Order_ByType>;
  event_source?: InputMaybe<Order_ByType>;
  event_type?: InputMaybe<Order_ByType>;
  highlight_requested?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  invites_aggregate?: InputMaybe<Invites_Aggregate_Order_ByType>;
  is_food_included?: InputMaybe<Order_ByType>;
  is_highlighted?: InputMaybe<Order_ByType>;
  links?: InputMaybe<Order_ByType>;
  location?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  main_image_url?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  origin_creator_name?: InputMaybe<Order_ByType>;
  origin_id?: InputMaybe<Order_ByType>;
  origin_location_name?: InputMaybe<Order_ByType>;
  origin_updated_at?: InputMaybe<Order_ByType>;
  owners_aggregate?: InputMaybe<Event_Owners_Aggregate_Order_ByType>;
  pretix_name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  regular_single_day_price?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  start_date_tz?: InputMaybe<Order_ByType>;
  target_level_id?: InputMaybe<Order_ByType>;
  teachers_aggregate?: InputMaybe<Event_Teachers_Aggregate_Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  url?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  user_participants_aggregate?: InputMaybe<Event_User_Participants_Aggregate_Order_ByType>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "events" */
export enum Events_Select_ColumnType {
  /** column name */
  BookedOutType = 'booked_out',
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  EarlyBirdUntilType = 'early_bird_until',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  EndDateTzType = 'end_date_tz',
  /** column name */
  EventSourceType = 'event_source',
  /** column name */
  EventTypeType = 'event_type',
  /** column name */
  HighlightRequestedType = 'highlight_requested',
  /** column name */
  IdType = 'id',
  /** column name */
  IsFoodIncludedType = 'is_food_included',
  /** column name */
  IsHighlightedType = 'is_highlighted',
  /** column name */
  LinksType = 'links',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationCityType = 'location_city',
  /** column name */
  LocationCountryType = 'location_country',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  MainImageUrlType = 'main_image_url',
  /** column name */
  NameType = 'name',
  /** column name */
  OriginCreatorNameType = 'origin_creator_name',
  /** column name */
  OriginIdType = 'origin_id',
  /** column name */
  OriginLocationNameType = 'origin_location_name',
  /** column name */
  OriginUpdatedAtType = 'origin_updated_at',
  /** column name */
  PretixNameType = 'pretix_name',
  /** column name */
  PricingType = 'pricing',
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price',
  /** column name */
  StartDateType = 'start_date',
  /** column name */
  StartDateTzType = 'start_date_tz',
  /** column name */
  TargetLevelIdType = 'target_level_id',
  /** column name */
  TimezoneType = 'timezone',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UrlType = 'url',
  /** column name */
  UrlSlugType = 'url_slug'
}

/** select "events_aggregate_bool_exp_avg_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Avg_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  BookedOutType = 'booked_out',
  /** column name */
  HighlightRequestedType = 'highlight_requested',
  /** column name */
  IsFoodIncludedType = 'is_food_included',
  /** column name */
  IsHighlightedType = 'is_highlighted'
}

/** select "events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  BookedOutType = 'booked_out',
  /** column name */
  HighlightRequestedType = 'highlight_requested',
  /** column name */
  IsFoodIncludedType = 'is_food_included',
  /** column name */
  IsHighlightedType = 'is_highlighted'
}

/** select "events_aggregate_bool_exp_corr_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Corr_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Covar_Samp_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_max_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Max_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_min_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Min_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Stddev_Samp_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_sum_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Sum_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** select "events_aggregate_bool_exp_var_samp_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Var_Samp_Arguments_ColumnsType {
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price'
}

/** input type for updating data in table "events" */
export type Events_Set_InputType = {
  booked_out?: InputMaybe<Scalars['Boolean']>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  early_bird_until?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  end_date_tz?: InputMaybe<Scalars['timestamp']>;
  event_source?: InputMaybe<Event_Source_EnumType>;
  event_type?: InputMaybe<Event_Type_EnumType>;
  highlight_requested?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_food_included?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Scalars['_text']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  main_image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  origin_creator_name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  origin_location_name?: InputMaybe<Scalars['String']>;
  origin_updated_at?: InputMaybe<Scalars['timestamptz']>;
  pretix_name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  regular_single_day_price?: InputMaybe<Scalars['float8']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  start_date_tz?: InputMaybe<Scalars['timestamp']>;
  target_level_id?: InputMaybe<Scalars['uuid']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Events_Stddev_FieldsType = {
  __typename?: 'events_stddev_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "events" */
export type Events_Stddev_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_pop on columns */
export type Events_Stddev_Pop_FieldsType = {
  __typename?: 'events_stddev_pop_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "events" */
export type Events_Stddev_Pop_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_samp on columns */
export type Events_Stddev_Samp_FieldsType = {
  __typename?: 'events_stddev_samp_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "events" */
export type Events_Stddev_Samp_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_InputType = {
  booked_out?: InputMaybe<Scalars['Boolean']>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  early_bird_until?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  end_date_tz?: InputMaybe<Scalars['timestamp']>;
  event_source?: InputMaybe<Event_Source_EnumType>;
  event_type?: InputMaybe<Event_Type_EnumType>;
  highlight_requested?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_food_included?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Scalars['_text']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  main_image_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  origin_creator_name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  origin_location_name?: InputMaybe<Scalars['String']>;
  origin_updated_at?: InputMaybe<Scalars['timestamptz']>;
  pretix_name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  regular_single_day_price?: InputMaybe<Scalars['float8']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  start_date_tz?: InputMaybe<Scalars['timestamp']>;
  target_level_id?: InputMaybe<Scalars['uuid']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Events_Sum_FieldsType = {
  __typename?: 'events_sum_fields';
  regular_single_day_price?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "events" */
export type Events_Sum_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** update columns of table "events" */
export enum Events_Update_ColumnType {
  /** column name */
  BookedOutType = 'booked_out',
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  EarlyBirdUntilType = 'early_bird_until',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  EndDateTzType = 'end_date_tz',
  /** column name */
  EventSourceType = 'event_source',
  /** column name */
  EventTypeType = 'event_type',
  /** column name */
  HighlightRequestedType = 'highlight_requested',
  /** column name */
  IdType = 'id',
  /** column name */
  IsFoodIncludedType = 'is_food_included',
  /** column name */
  IsHighlightedType = 'is_highlighted',
  /** column name */
  LinksType = 'links',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationCityType = 'location_city',
  /** column name */
  LocationCountryType = 'location_country',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  MainImageUrlType = 'main_image_url',
  /** column name */
  NameType = 'name',
  /** column name */
  OriginCreatorNameType = 'origin_creator_name',
  /** column name */
  OriginIdType = 'origin_id',
  /** column name */
  OriginLocationNameType = 'origin_location_name',
  /** column name */
  OriginUpdatedAtType = 'origin_updated_at',
  /** column name */
  PretixNameType = 'pretix_name',
  /** column name */
  PricingType = 'pricing',
  /** column name */
  RegularSingleDayPriceType = 'regular_single_day_price',
  /** column name */
  StartDateType = 'start_date',
  /** column name */
  StartDateTzType = 'start_date_tz',
  /** column name */
  TargetLevelIdType = 'target_level_id',
  /** column name */
  TimezoneType = 'timezone',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UrlType = 'url',
  /** column name */
  UrlSlugType = 'url_slug'
}

export type Events_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Events_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_InputType>;
  where: Events_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Events_Var_Pop_FieldsType = {
  __typename?: 'events_var_pop_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "events" */
export type Events_Var_Pop_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** aggregate var_samp on columns */
export type Events_Var_Samp_FieldsType = {
  __typename?: 'events_var_samp_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "events" */
export type Events_Var_Samp_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** aggregate variance on columns */
export type Events_Variance_FieldsType = {
  __typename?: 'events_variance_fields';
  regular_single_day_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "events" */
export type Events_Variance_Order_ByType = {
  regular_single_day_price?: InputMaybe<Order_ByType>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type Geography_Cast_ExpType = {
  geometry?: InputMaybe<Geometry_Comparison_ExpType>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_ExpType = {
  _cast?: InputMaybe<Geography_Cast_ExpType>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_InputType>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_ExpType = {
  geography?: InputMaybe<Geography_Comparison_ExpType>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_ExpType = {
  _cast?: InputMaybe<Geometry_Cast_ExpType>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_InputType>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_InputType>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "images" */
export type ImagesType = {
  __typename?: 'images';
  id: Scalars['uuid'];
  /** An array relationship */
  teacher_image: Array<Teacher_ImagesType>;
  /** An aggregate relationship */
  teacher_image_aggregate: Teacher_Images_AggregateType;
  url: Scalars['String'];
};


/** columns and relationships of "images" */
export type ImagesTeacher_ImageArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


/** columns and relationships of "images" */
export type ImagesTeacher_Image_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};

/** aggregated selection of "images" */
export type Images_AggregateType = {
  __typename?: 'images_aggregate';
  aggregate?: Maybe<Images_Aggregate_FieldsType>;
  nodes: Array<ImagesType>;
};

/** aggregate fields of "images" */
export type Images_Aggregate_FieldsType = {
  __typename?: 'images_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Images_Max_FieldsType>;
  min?: Maybe<Images_Min_FieldsType>;
};


/** aggregate fields of "images" */
export type Images_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Images_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "images". All fields are combined with a logical 'AND'. */
export type Images_Bool_ExpType = {
  _and?: InputMaybe<Array<Images_Bool_ExpType>>;
  _not?: InputMaybe<Images_Bool_ExpType>;
  _or?: InputMaybe<Array<Images_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher_image?: InputMaybe<Teacher_Images_Bool_ExpType>;
  teacher_image_aggregate?: InputMaybe<Teacher_Images_Aggregate_Bool_ExpType>;
  url?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "images" */
export enum Images_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  ImagePkeyType = 'image_pkey'
}

/** input type for inserting data into table "images" */
export type Images_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  teacher_image?: InputMaybe<Teacher_Images_Arr_Rel_Insert_InputType>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Images_Max_FieldsType = {
  __typename?: 'images_max_fields';
  id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Images_Min_FieldsType = {
  __typename?: 'images_min_fields';
  id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "images" */
export type Images_Mutation_ResponseType = {
  __typename?: 'images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ImagesType>;
};

/** input type for inserting object relation for remote table "images" */
export type Images_Obj_Rel_Insert_InputType = {
  data: Images_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Images_On_ConflictType>;
};

/** on_conflict condition type for table "images" */
export type Images_On_ConflictType = {
  constraint: Images_ConstraintType;
  update_columns?: Array<Images_Update_ColumnType>;
  where?: InputMaybe<Images_Bool_ExpType>;
};

/** Ordering options when selecting data from "images". */
export type Images_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  teacher_image_aggregate?: InputMaybe<Teacher_Images_Aggregate_Order_ByType>;
  url?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: images */
export type Images_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "images" */
export enum Images_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  UrlType = 'url'
}

/** input type for updating data in table "images" */
export type Images_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "images" */
export type Images_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Images_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Images_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "images" */
export enum Images_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  UrlType = 'url'
}

export type Images_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Images_Set_InputType>;
  where: Images_Bool_ExpType;
};

/** columns and relationships of "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_DistanceType = {
  __typename?: 'inherited_class_events_with_distance';
  available_booking_slots: Scalars['Int'];
  /** An object relationship */
  class?: Maybe<ClassesType>;
  class_id: Scalars['uuid'];
  created_at?: Maybe<Scalars['timestamptz']>;
  distance: Scalars['float8'];
  end_date?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_cancelled: Scalars['Boolean'];
  is_highlighted?: Maybe<Scalars['Boolean']>;
  max_booking_slots: Scalars['Int'];
  /** An array relationship */
  participants: Array<Class_Events_ParticipantsType>;
  /** An aggregate relationship */
  participants_aggregate: Class_Events_Participants_AggregateType;
  recurring_pattern_id: Scalars['uuid'];
  start_date: Scalars['timestamptz'];
};


/** columns and relationships of "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_DistanceParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


/** columns and relationships of "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_DistanceParticipants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};

export type Inherited_Class_Events_With_Distance_AggregateType = {
  __typename?: 'inherited_class_events_with_distance_aggregate';
  aggregate?: Maybe<Inherited_Class_Events_With_Distance_Aggregate_FieldsType>;
  nodes: Array<Inherited_Class_Events_With_DistanceType>;
};

/** aggregate fields of "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Aggregate_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_aggregate_fields';
  avg?: Maybe<Inherited_Class_Events_With_Distance_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Inherited_Class_Events_With_Distance_Max_FieldsType>;
  min?: Maybe<Inherited_Class_Events_With_Distance_Min_FieldsType>;
  stddev?: Maybe<Inherited_Class_Events_With_Distance_Stddev_FieldsType>;
  stddev_pop?: Maybe<Inherited_Class_Events_With_Distance_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Inherited_Class_Events_With_Distance_Stddev_Samp_FieldsType>;
  sum?: Maybe<Inherited_Class_Events_With_Distance_Sum_FieldsType>;
  var_pop?: Maybe<Inherited_Class_Events_With_Distance_Var_Pop_FieldsType>;
  var_samp?: Maybe<Inherited_Class_Events_With_Distance_Var_Samp_FieldsType>;
  variance?: Maybe<Inherited_Class_Events_With_Distance_Variance_FieldsType>;
};


/** aggregate fields of "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Inherited_Class_Events_With_Distance_Avg_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_avg_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "inherited.class_events_with_distance". All fields are combined with a logical 'AND'. */
export type Inherited_Class_Events_With_Distance_Bool_ExpType = {
  _and?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Bool_ExpType>>;
  _not?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
  _or?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Bool_ExpType>>;
  available_booking_slots?: InputMaybe<Int_Comparison_ExpType>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  distance?: InputMaybe<Float8_Comparison_ExpType>;
  end_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_cancelled?: InputMaybe<Boolean_Comparison_ExpType>;
  is_highlighted?: InputMaybe<Boolean_Comparison_ExpType>;
  max_booking_slots?: InputMaybe<Int_Comparison_ExpType>;
  participants?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
  participants_aggregate?: InputMaybe<Class_Events_Participants_Aggregate_Bool_ExpType>;
  recurring_pattern_id?: InputMaybe<Uuid_Comparison_ExpType>;
  start_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

/** input type for incrementing numeric columns in table "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Inc_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  distance?: InputMaybe<Scalars['float8']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Insert_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  distance?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  participants?: InputMaybe<Class_Events_Participants_Arr_Rel_Insert_InputType>;
  recurring_pattern_id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Inherited_Class_Events_With_Distance_Max_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_max_fields';
  available_booking_slots?: Maybe<Scalars['Int']>;
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  distance?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  recurring_pattern_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Inherited_Class_Events_With_Distance_Min_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_min_fields';
  available_booking_slots?: Maybe<Scalars['Int']>;
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  distance?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  recurring_pattern_id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Mutation_ResponseType = {
  __typename?: 'inherited_class_events_with_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Inherited_Class_Events_With_DistanceType>;
};

/** Ordering options when selecting data from "inherited.class_events_with_distance". */
export type Inherited_Class_Events_With_Distance_Order_ByType = {
  available_booking_slots?: InputMaybe<Order_ByType>;
  class?: InputMaybe<Classes_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  distance?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  is_cancelled?: InputMaybe<Order_ByType>;
  is_highlighted?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  participants_aggregate?: InputMaybe<Class_Events_Participants_Aggregate_Order_ByType>;
  recurring_pattern_id?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
};

/** select columns of table "inherited.class_events_with_distance" */
export enum Inherited_Class_Events_With_Distance_Select_ColumnType {
  /** column name */
  AvailableBookingSlotsType = 'available_booking_slots',
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DistanceType = 'distance',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  IdType = 'id',
  /** column name */
  IsCancelledType = 'is_cancelled',
  /** column name */
  IsHighlightedType = 'is_highlighted',
  /** column name */
  MaxBookingSlotsType = 'max_booking_slots',
  /** column name */
  RecurringPatternIdType = 'recurring_pattern_id',
  /** column name */
  StartDateType = 'start_date'
}

/** input type for updating data in table "inherited.class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Set_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  distance?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  recurring_pattern_id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Inherited_Class_Events_With_Distance_Stddev_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_stddev_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Inherited_Class_Events_With_Distance_Stddev_Pop_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_stddev_pop_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Inherited_Class_Events_With_Distance_Stddev_Samp_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_stddev_samp_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "inherited_class_events_with_distance" */
export type Inherited_Class_Events_With_Distance_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Inherited_Class_Events_With_Distance_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Inherited_Class_Events_With_Distance_Stream_Cursor_Value_InputType = {
  available_booking_slots?: InputMaybe<Scalars['Int']>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  distance?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_highlighted?: InputMaybe<Scalars['Boolean']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  recurring_pattern_id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Inherited_Class_Events_With_Distance_Sum_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_sum_fields';
  available_booking_slots?: Maybe<Scalars['Int']>;
  distance?: Maybe<Scalars['float8']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
};

export type Inherited_Class_Events_With_Distance_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inherited_Class_Events_With_Distance_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inherited_Class_Events_With_Distance_Set_InputType>;
  where: Inherited_Class_Events_With_Distance_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Inherited_Class_Events_With_Distance_Var_Pop_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_var_pop_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Inherited_Class_Events_With_Distance_Var_Samp_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_var_samp_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Inherited_Class_Events_With_Distance_Variance_FieldsType = {
  __typename?: 'inherited_class_events_with_distance_variance_fields';
  available_booking_slots?: Maybe<Scalars['Float']>;
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceType = {
  __typename?: 'inherited_classes_with_distance';
  booking_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  /** An array relationship */
  class_events: Array<Class_EventsType>;
  /** An aggregate relationship */
  class_events_aggregate: Class_Events_AggregateType;
  /** An array relationship */
  class_levels: Array<Class_LevelsType>;
  /** An aggregate relationship */
  class_levels_aggregate: Class_Levels_AggregateType;
  class_pass_url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['uuid']>;
  description: Scalars['String'];
  distance: Scalars['float8'];
  event_type?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_classe?: Maybe<Scalars['Boolean']>;
  location: Scalars['geography'];
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name: Scalars['String'];
  max_booking_slots?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  pricing?: Maybe<Scalars['String']>;
  pricing_short?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  /** An array relationship */
  teacher: Array<Class_TeachersType>;
  /** An aggregate relationship */
  teacher_aggregate: Class_Teachers_AggregateType;
  timezone?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  usc_url?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceClass_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceClass_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceClass_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceClass_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceTeacherArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


/** columns and relationships of "inherited.classes_with_distance" */
export type Inherited_Classes_With_DistanceTeacher_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};

export type Inherited_Classes_With_Distance_AggregateType = {
  __typename?: 'inherited_classes_with_distance_aggregate';
  aggregate?: Maybe<Inherited_Classes_With_Distance_Aggregate_FieldsType>;
  nodes: Array<Inherited_Classes_With_DistanceType>;
};

/** aggregate fields of "inherited.classes_with_distance" */
export type Inherited_Classes_With_Distance_Aggregate_FieldsType = {
  __typename?: 'inherited_classes_with_distance_aggregate_fields';
  avg?: Maybe<Inherited_Classes_With_Distance_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Inherited_Classes_With_Distance_Max_FieldsType>;
  min?: Maybe<Inherited_Classes_With_Distance_Min_FieldsType>;
  stddev?: Maybe<Inherited_Classes_With_Distance_Stddev_FieldsType>;
  stddev_pop?: Maybe<Inherited_Classes_With_Distance_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Inherited_Classes_With_Distance_Stddev_Samp_FieldsType>;
  sum?: Maybe<Inherited_Classes_With_Distance_Sum_FieldsType>;
  var_pop?: Maybe<Inherited_Classes_With_Distance_Var_Pop_FieldsType>;
  var_samp?: Maybe<Inherited_Classes_With_Distance_Var_Samp_FieldsType>;
  variance?: Maybe<Inherited_Classes_With_Distance_Variance_FieldsType>;
};


/** aggregate fields of "inherited.classes_with_distance" */
export type Inherited_Classes_With_Distance_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Inherited_Classes_With_Distance_Avg_FieldsType = {
  __typename?: 'inherited_classes_with_distance_avg_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "inherited.classes_with_distance". All fields are combined with a logical 'AND'. */
export type Inherited_Classes_With_Distance_Bool_ExpType = {
  _and?: InputMaybe<Array<Inherited_Classes_With_Distance_Bool_ExpType>>;
  _not?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
  _or?: InputMaybe<Array<Inherited_Classes_With_Distance_Bool_ExpType>>;
  booking_email?: InputMaybe<String_Comparison_ExpType>;
  city?: InputMaybe<String_Comparison_ExpType>;
  class_events?: InputMaybe<Class_Events_Bool_ExpType>;
  class_events_aggregate?: InputMaybe<Class_Events_Aggregate_Bool_ExpType>;
  class_levels?: InputMaybe<Class_Levels_Bool_ExpType>;
  class_levels_aggregate?: InputMaybe<Class_Levels_Aggregate_Bool_ExpType>;
  class_pass_url?: InputMaybe<String_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  description?: InputMaybe<String_Comparison_ExpType>;
  distance?: InputMaybe<Float8_Comparison_ExpType>;
  event_type?: InputMaybe<String_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  image_url?: InputMaybe<String_Comparison_ExpType>;
  is_classe?: InputMaybe<Boolean_Comparison_ExpType>;
  location?: InputMaybe<Geography_Comparison_ExpType>;
  location_city?: InputMaybe<String_Comparison_ExpType>;
  location_country?: InputMaybe<String_Comparison_ExpType>;
  location_name?: InputMaybe<String_Comparison_ExpType>;
  max_booking_slots?: InputMaybe<Int_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  pricing?: InputMaybe<String_Comparison_ExpType>;
  pricing_short?: InputMaybe<String_Comparison_ExpType>;
  requirements?: InputMaybe<String_Comparison_ExpType>;
  teacher?: InputMaybe<Class_Teachers_Bool_ExpType>;
  teacher_aggregate?: InputMaybe<Class_Teachers_Aggregate_Bool_ExpType>;
  timezone?: InputMaybe<String_Comparison_ExpType>;
  url_slug?: InputMaybe<String_Comparison_ExpType>;
  usc_url?: InputMaybe<String_Comparison_ExpType>;
  website_url?: InputMaybe<String_Comparison_ExpType>;
};

/** input type for incrementing numeric columns in table "inherited.classes_with_distance" */
export type Inherited_Classes_With_Distance_Inc_InputType = {
  distance?: InputMaybe<Scalars['float8']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "inherited.classes_with_distance" */
export type Inherited_Classes_With_Distance_Insert_InputType = {
  booking_email?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  class_events?: InputMaybe<Class_Events_Arr_Rel_Insert_InputType>;
  class_levels?: InputMaybe<Class_Levels_Arr_Rel_Insert_InputType>;
  class_pass_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['float8']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_classe?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  pricing_short?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  teacher?: InputMaybe<Class_Teachers_Arr_Rel_Insert_InputType>;
  timezone?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Inherited_Classes_With_Distance_Max_FieldsType = {
  __typename?: 'inherited_classes_with_distance_max_fields';
  booking_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  class_pass_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['float8']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  pricing_short?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  usc_url?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Inherited_Classes_With_Distance_Min_FieldsType = {
  __typename?: 'inherited_classes_with_distance_min_fields';
  booking_email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  class_pass_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['float8']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  location_city?: Maybe<Scalars['String']>;
  location_country?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pricing?: Maybe<Scalars['String']>;
  pricing_short?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  usc_url?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "inherited.classes_with_distance" */
export type Inherited_Classes_With_Distance_Mutation_ResponseType = {
  __typename?: 'inherited_classes_with_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Inherited_Classes_With_DistanceType>;
};

/** Ordering options when selecting data from "inherited.classes_with_distance". */
export type Inherited_Classes_With_Distance_Order_ByType = {
  booking_email?: InputMaybe<Order_ByType>;
  city?: InputMaybe<Order_ByType>;
  class_events_aggregate?: InputMaybe<Class_Events_Aggregate_Order_ByType>;
  class_levels_aggregate?: InputMaybe<Class_Levels_Aggregate_Order_ByType>;
  class_pass_url?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  distance?: InputMaybe<Order_ByType>;
  event_type?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_url?: InputMaybe<Order_ByType>;
  is_classe?: InputMaybe<Order_ByType>;
  location?: InputMaybe<Order_ByType>;
  location_city?: InputMaybe<Order_ByType>;
  location_country?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  max_booking_slots?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  pricing?: InputMaybe<Order_ByType>;
  pricing_short?: InputMaybe<Order_ByType>;
  requirements?: InputMaybe<Order_ByType>;
  teacher_aggregate?: InputMaybe<Class_Teachers_Aggregate_Order_ByType>;
  timezone?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  usc_url?: InputMaybe<Order_ByType>;
  website_url?: InputMaybe<Order_ByType>;
};

/** select columns of table "inherited.classes_with_distance" */
export enum Inherited_Classes_With_Distance_Select_ColumnType {
  /** column name */
  BookingEmailType = 'booking_email',
  /** column name */
  CityType = 'city',
  /** column name */
  ClassPassUrlType = 'class_pass_url',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  DistanceType = 'distance',
  /** column name */
  EventTypeType = 'event_type',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageUrlType = 'image_url',
  /** column name */
  IsClasseType = 'is_classe',
  /** column name */
  LocationType = 'location',
  /** column name */
  LocationCityType = 'location_city',
  /** column name */
  LocationCountryType = 'location_country',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  MaxBookingSlotsType = 'max_booking_slots',
  /** column name */
  NameType = 'name',
  /** column name */
  PricingType = 'pricing',
  /** column name */
  PricingShortType = 'pricing_short',
  /** column name */
  RequirementsType = 'requirements',
  /** column name */
  TimezoneType = 'timezone',
  /** column name */
  UrlSlugType = 'url_slug',
  /** column name */
  UscUrlType = 'usc_url',
  /** column name */
  WebsiteUrlType = 'website_url'
}

/** input type for updating data in table "inherited.classes_with_distance" */
export type Inherited_Classes_With_Distance_Set_InputType = {
  booking_email?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  class_pass_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['float8']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_classe?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  pricing_short?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Inherited_Classes_With_Distance_Stddev_FieldsType = {
  __typename?: 'inherited_classes_with_distance_stddev_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Inherited_Classes_With_Distance_Stddev_Pop_FieldsType = {
  __typename?: 'inherited_classes_with_distance_stddev_pop_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Inherited_Classes_With_Distance_Stddev_Samp_FieldsType = {
  __typename?: 'inherited_classes_with_distance_stddev_samp_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "inherited_classes_with_distance" */
export type Inherited_Classes_With_Distance_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Inherited_Classes_With_Distance_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Inherited_Classes_With_Distance_Stream_Cursor_Value_InputType = {
  booking_email?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  class_pass_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['float8']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_classe?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['geography']>;
  location_city?: InputMaybe<Scalars['String']>;
  location_country?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  pricing_short?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url_slug?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Inherited_Classes_With_Distance_Sum_FieldsType = {
  __typename?: 'inherited_classes_with_distance_sum_fields';
  distance?: Maybe<Scalars['float8']>;
  max_booking_slots?: Maybe<Scalars['Int']>;
};

export type Inherited_Classes_With_Distance_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inherited_Classes_With_Distance_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inherited_Classes_With_Distance_Set_InputType>;
  where: Inherited_Classes_With_Distance_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Inherited_Classes_With_Distance_Var_Pop_FieldsType = {
  __typename?: 'inherited_classes_with_distance_var_pop_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Inherited_Classes_With_Distance_Var_Samp_FieldsType = {
  __typename?: 'inherited_classes_with_distance_var_samp_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Inherited_Classes_With_Distance_Variance_FieldsType = {
  __typename?: 'inherited_classes_with_distance_variance_fields';
  distance?: Maybe<Scalars['Float']>;
  max_booking_slots?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceType = {
  __typename?: 'inherited_communities_with_distance';
  /** An array relationship */
  community_messages: Array<Community_MessagesType>;
  /** An aggregate relationship */
  community_messages_aggregate: Community_Messages_AggregateType;
  confirmation_status?: Maybe<Scalars['String']>;
  confirmed: Scalars['Boolean'];
  /** An object relationship */
  created_by?: Maybe<UsersType>;
  distance: Scalars['float8'];
  id: Scalars['uuid'];
  /** An array relationship */
  jams: Array<JamsType>;
  /** An aggregate relationship */
  jams_aggregate: Jams_AggregateType;
  latitude: Scalars['float8'];
  location: Scalars['geography'];
  longitude: Scalars['float8'];
  name: Scalars['String'];
  proposed_by_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  users: Array<User_CommunitiesType>;
  /** An aggregate relationship */
  users_aggregate: User_Communities_AggregateType;
};


/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceCommunity_MessagesArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceCommunity_Messages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceJamsArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceJams_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceUsersArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


/** columns and relationships of "inherited.communities_with_distance" */
export type Inherited_Communities_With_DistanceUsers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};

export type Inherited_Communities_With_Distance_AggregateType = {
  __typename?: 'inherited_communities_with_distance_aggregate';
  aggregate?: Maybe<Inherited_Communities_With_Distance_Aggregate_FieldsType>;
  nodes: Array<Inherited_Communities_With_DistanceType>;
};

/** aggregate fields of "inherited.communities_with_distance" */
export type Inherited_Communities_With_Distance_Aggregate_FieldsType = {
  __typename?: 'inherited_communities_with_distance_aggregate_fields';
  avg?: Maybe<Inherited_Communities_With_Distance_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Inherited_Communities_With_Distance_Max_FieldsType>;
  min?: Maybe<Inherited_Communities_With_Distance_Min_FieldsType>;
  stddev?: Maybe<Inherited_Communities_With_Distance_Stddev_FieldsType>;
  stddev_pop?: Maybe<Inherited_Communities_With_Distance_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Inherited_Communities_With_Distance_Stddev_Samp_FieldsType>;
  sum?: Maybe<Inherited_Communities_With_Distance_Sum_FieldsType>;
  var_pop?: Maybe<Inherited_Communities_With_Distance_Var_Pop_FieldsType>;
  var_samp?: Maybe<Inherited_Communities_With_Distance_Var_Samp_FieldsType>;
  variance?: Maybe<Inherited_Communities_With_Distance_Variance_FieldsType>;
};


/** aggregate fields of "inherited.communities_with_distance" */
export type Inherited_Communities_With_Distance_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Inherited_Communities_With_Distance_Avg_FieldsType = {
  __typename?: 'inherited_communities_with_distance_avg_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "inherited.communities_with_distance". All fields are combined with a logical 'AND'. */
export type Inherited_Communities_With_Distance_Bool_ExpType = {
  _and?: InputMaybe<Array<Inherited_Communities_With_Distance_Bool_ExpType>>;
  _not?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
  _or?: InputMaybe<Array<Inherited_Communities_With_Distance_Bool_ExpType>>;
  community_messages?: InputMaybe<Community_Messages_Bool_ExpType>;
  community_messages_aggregate?: InputMaybe<Community_Messages_Aggregate_Bool_ExpType>;
  confirmation_status?: InputMaybe<String_Comparison_ExpType>;
  confirmed?: InputMaybe<Boolean_Comparison_ExpType>;
  created_by?: InputMaybe<Users_Bool_ExpType>;
  distance?: InputMaybe<Float8_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  jams?: InputMaybe<Jams_Bool_ExpType>;
  jams_aggregate?: InputMaybe<Jams_Aggregate_Bool_ExpType>;
  latitude?: InputMaybe<Float8_Comparison_ExpType>;
  location?: InputMaybe<Geography_Comparison_ExpType>;
  longitude?: InputMaybe<Float8_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  proposed_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
  users?: InputMaybe<User_Communities_Bool_ExpType>;
  users_aggregate?: InputMaybe<User_Communities_Aggregate_Bool_ExpType>;
};

/** input type for incrementing numeric columns in table "inherited.communities_with_distance" */
export type Inherited_Communities_With_Distance_Inc_InputType = {
  distance?: InputMaybe<Scalars['float8']>;
  latitude?: InputMaybe<Scalars['float8']>;
  longitude?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "inherited.communities_with_distance" */
export type Inherited_Communities_With_Distance_Insert_InputType = {
  community_messages?: InputMaybe<Community_Messages_Arr_Rel_Insert_InputType>;
  confirmation_status?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  jams?: InputMaybe<Jams_Arr_Rel_Insert_InputType>;
  latitude?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  longitude?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  proposed_by_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  users?: InputMaybe<User_Communities_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Inherited_Communities_With_Distance_Max_FieldsType = {
  __typename?: 'inherited_communities_with_distance_max_fields';
  confirmation_status?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  proposed_by_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Inherited_Communities_With_Distance_Min_FieldsType = {
  __typename?: 'inherited_communities_with_distance_min_fields';
  confirmation_status?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
  name?: Maybe<Scalars['String']>;
  proposed_by_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "inherited.communities_with_distance" */
export type Inherited_Communities_With_Distance_Mutation_ResponseType = {
  __typename?: 'inherited_communities_with_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Inherited_Communities_With_DistanceType>;
};

/** Ordering options when selecting data from "inherited.communities_with_distance". */
export type Inherited_Communities_With_Distance_Order_ByType = {
  community_messages_aggregate?: InputMaybe<Community_Messages_Aggregate_Order_ByType>;
  confirmation_status?: InputMaybe<Order_ByType>;
  confirmed?: InputMaybe<Order_ByType>;
  created_by?: InputMaybe<Users_Order_ByType>;
  distance?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  jams_aggregate?: InputMaybe<Jams_Aggregate_Order_ByType>;
  latitude?: InputMaybe<Order_ByType>;
  location?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  proposed_by_id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  users_aggregate?: InputMaybe<User_Communities_Aggregate_Order_ByType>;
};

/** select columns of table "inherited.communities_with_distance" */
export enum Inherited_Communities_With_Distance_Select_ColumnType {
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  ConfirmedType = 'confirmed',
  /** column name */
  DistanceType = 'distance',
  /** column name */
  IdType = 'id',
  /** column name */
  LatitudeType = 'latitude',
  /** column name */
  LocationType = 'location',
  /** column name */
  LongitudeType = 'longitude',
  /** column name */
  NameType = 'name',
  /** column name */
  ProposedByIdType = 'proposed_by_id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** input type for updating data in table "inherited.communities_with_distance" */
export type Inherited_Communities_With_Distance_Set_InputType = {
  confirmation_status?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  longitude?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  proposed_by_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Inherited_Communities_With_Distance_Stddev_FieldsType = {
  __typename?: 'inherited_communities_with_distance_stddev_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Inherited_Communities_With_Distance_Stddev_Pop_FieldsType = {
  __typename?: 'inherited_communities_with_distance_stddev_pop_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Inherited_Communities_With_Distance_Stddev_Samp_FieldsType = {
  __typename?: 'inherited_communities_with_distance_stddev_samp_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "inherited_communities_with_distance" */
export type Inherited_Communities_With_Distance_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Inherited_Communities_With_Distance_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Inherited_Communities_With_Distance_Stream_Cursor_Value_InputType = {
  confirmation_status?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  latitude?: InputMaybe<Scalars['float8']>;
  location?: InputMaybe<Scalars['geography']>;
  longitude?: InputMaybe<Scalars['float8']>;
  name?: InputMaybe<Scalars['String']>;
  proposed_by_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Inherited_Communities_With_Distance_Sum_FieldsType = {
  __typename?: 'inherited_communities_with_distance_sum_fields';
  distance?: Maybe<Scalars['float8']>;
  latitude?: Maybe<Scalars['float8']>;
  longitude?: Maybe<Scalars['float8']>;
};

export type Inherited_Communities_With_Distance_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inherited_Communities_With_Distance_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inherited_Communities_With_Distance_Set_InputType>;
  where: Inherited_Communities_With_Distance_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Inherited_Communities_With_Distance_Var_Pop_FieldsType = {
  __typename?: 'inherited_communities_with_distance_var_pop_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Inherited_Communities_With_Distance_Var_Samp_FieldsType = {
  __typename?: 'inherited_communities_with_distance_var_samp_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Inherited_Communities_With_Distance_Variance_FieldsType = {
  __typename?: 'inherited_communities_with_distance_variance_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "inherited.jams_with_distance" */
export type Inherited_Jams_With_DistanceType = {
  __typename?: 'inherited_jams_with_distance';
  /** An object relationship */
  community?: Maybe<CommunitiesType>;
  community_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by?: Maybe<UsersType>;
  created_by_id: Scalars['uuid'];
  date: Scalars['timestamptz'];
  distance: Scalars['float8'];
  id: Scalars['uuid'];
  info?: Maybe<Scalars['String']>;
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  /** An array relationship */
  participants: Array<Jam_ParticipantsType>;
  /** An aggregate relationship */
  participants_aggregate: Jam_Participants_AggregateType;
};


/** columns and relationships of "inherited.jams_with_distance" */
export type Inherited_Jams_With_DistanceParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


/** columns and relationships of "inherited.jams_with_distance" */
export type Inherited_Jams_With_DistanceParticipants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};

/** aggregated selection of "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_AggregateType = {
  __typename?: 'inherited_jams_with_distance_aggregate';
  aggregate?: Maybe<Inherited_Jams_With_Distance_Aggregate_FieldsType>;
  nodes: Array<Inherited_Jams_With_DistanceType>;
};

/** aggregate fields of "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_Aggregate_FieldsType = {
  __typename?: 'inherited_jams_with_distance_aggregate_fields';
  avg?: Maybe<Inherited_Jams_With_Distance_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Inherited_Jams_With_Distance_Max_FieldsType>;
  min?: Maybe<Inherited_Jams_With_Distance_Min_FieldsType>;
  stddev?: Maybe<Inherited_Jams_With_Distance_Stddev_FieldsType>;
  stddev_pop?: Maybe<Inherited_Jams_With_Distance_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Inherited_Jams_With_Distance_Stddev_Samp_FieldsType>;
  sum?: Maybe<Inherited_Jams_With_Distance_Sum_FieldsType>;
  var_pop?: Maybe<Inherited_Jams_With_Distance_Var_Pop_FieldsType>;
  var_samp?: Maybe<Inherited_Jams_With_Distance_Var_Samp_FieldsType>;
  variance?: Maybe<Inherited_Jams_With_Distance_Variance_FieldsType>;
};


/** aggregate fields of "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Inherited_Jams_With_Distance_Avg_FieldsType = {
  __typename?: 'inherited_jams_with_distance_avg_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "inherited.jams_with_distance". All fields are combined with a logical 'AND'. */
export type Inherited_Jams_With_Distance_Bool_ExpType = {
  _and?: InputMaybe<Array<Inherited_Jams_With_Distance_Bool_ExpType>>;
  _not?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
  _or?: InputMaybe<Array<Inherited_Jams_With_Distance_Bool_ExpType>>;
  community?: InputMaybe<Communities_Bool_ExpType>;
  community_id?: InputMaybe<Uuid_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by?: InputMaybe<Users_Bool_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  distance?: InputMaybe<Float8_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  info?: InputMaybe<String_Comparison_ExpType>;
  latitude?: InputMaybe<Numeric_Comparison_ExpType>;
  longitude?: InputMaybe<Numeric_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  participants?: InputMaybe<Jam_Participants_Bool_ExpType>;
  participants_aggregate?: InputMaybe<Jam_Participants_Aggregate_Bool_ExpType>;
};

/** input type for incrementing numeric columns in table "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_Inc_InputType = {
  distance?: InputMaybe<Scalars['float8']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_Insert_InputType = {
  community?: InputMaybe<Communities_Obj_Rel_Insert_InputType>;
  community_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  info?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Jam_Participants_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Inherited_Jams_With_Distance_Max_FieldsType = {
  __typename?: 'inherited_jams_with_distance_max_fields';
  community_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  distance?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  info?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Inherited_Jams_With_Distance_Min_FieldsType = {
  __typename?: 'inherited_jams_with_distance_min_fields';
  community_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  distance?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['uuid']>;
  info?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_Mutation_ResponseType = {
  __typename?: 'inherited_jams_with_distance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Inherited_Jams_With_DistanceType>;
};

/** Ordering options when selecting data from "inherited.jams_with_distance". */
export type Inherited_Jams_With_Distance_Order_ByType = {
  community?: InputMaybe<Communities_Order_ByType>;
  community_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by?: InputMaybe<Users_Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  date?: InputMaybe<Order_ByType>;
  distance?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  info?: InputMaybe<Order_ByType>;
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  participants_aggregate?: InputMaybe<Jam_Participants_Aggregate_Order_ByType>;
};

/** select columns of table "inherited.jams_with_distance" */
export enum Inherited_Jams_With_Distance_Select_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DateType = 'date',
  /** column name */
  DistanceType = 'distance',
  /** column name */
  IdType = 'id',
  /** column name */
  InfoType = 'info',
  /** column name */
  LatitudeType = 'latitude',
  /** column name */
  LongitudeType = 'longitude',
  /** column name */
  NameType = 'name'
}

/** input type for updating data in table "inherited.jams_with_distance" */
export type Inherited_Jams_With_Distance_Set_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  info?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Inherited_Jams_With_Distance_Stddev_FieldsType = {
  __typename?: 'inherited_jams_with_distance_stddev_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Inherited_Jams_With_Distance_Stddev_Pop_FieldsType = {
  __typename?: 'inherited_jams_with_distance_stddev_pop_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Inherited_Jams_With_Distance_Stddev_Samp_FieldsType = {
  __typename?: 'inherited_jams_with_distance_stddev_samp_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "inherited_jams_with_distance" */
export type Inherited_Jams_With_Distance_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Inherited_Jams_With_Distance_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Inherited_Jams_With_Distance_Stream_Cursor_Value_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  info?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Inherited_Jams_With_Distance_Sum_FieldsType = {
  __typename?: 'inherited_jams_with_distance_sum_fields';
  distance?: Maybe<Scalars['float8']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

export type Inherited_Jams_With_Distance_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inherited_Jams_With_Distance_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inherited_Jams_With_Distance_Set_InputType>;
  where: Inherited_Jams_With_Distance_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Inherited_Jams_With_Distance_Var_Pop_FieldsType = {
  __typename?: 'inherited_jams_with_distance_var_pop_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Inherited_Jams_With_Distance_Var_Samp_FieldsType = {
  __typename?: 'inherited_jams_with_distance_var_samp_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Inherited_Jams_With_Distance_Variance_FieldsType = {
  __typename?: 'inherited_jams_with_distance_variance_fields';
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invite_entity" */
export type Invite_EntityType = {
  __typename?: 'invite_entity';
  value: Scalars['String'];
};

/** aggregated selection of "invite_entity" */
export type Invite_Entity_AggregateType = {
  __typename?: 'invite_entity_aggregate';
  aggregate?: Maybe<Invite_Entity_Aggregate_FieldsType>;
  nodes: Array<Invite_EntityType>;
};

/** aggregate fields of "invite_entity" */
export type Invite_Entity_Aggregate_FieldsType = {
  __typename?: 'invite_entity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invite_Entity_Max_FieldsType>;
  min?: Maybe<Invite_Entity_Min_FieldsType>;
};


/** aggregate fields of "invite_entity" */
export type Invite_Entity_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Invite_Entity_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "invite_entity". All fields are combined with a logical 'AND'. */
export type Invite_Entity_Bool_ExpType = {
  _and?: InputMaybe<Array<Invite_Entity_Bool_ExpType>>;
  _not?: InputMaybe<Invite_Entity_Bool_ExpType>;
  _or?: InputMaybe<Array<Invite_Entity_Bool_ExpType>>;
  value?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "invite_entity" */
export enum Invite_Entity_ConstraintType {
  /** unique or primary key constraint on columns "value" */
  InviteEntityPkeyType = 'invite_entity_pkey'
}

export enum Invite_Entity_EnumType {
  ClassType = 'class',
  ClassTeacherType = 'class_teacher',
  EventType = 'event',
  EventTeacherType = 'event_teacher'
}

/** Boolean expression to compare columns of type "invite_entity_enum". All fields are combined with logical 'AND'. */
export type Invite_Entity_Enum_Comparison_ExpType = {
  _eq?: InputMaybe<Invite_Entity_EnumType>;
  _in?: InputMaybe<Array<Invite_Entity_EnumType>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Invite_Entity_EnumType>;
  _nin?: InputMaybe<Array<Invite_Entity_EnumType>>;
};

/** input type for inserting data into table "invite_entity" */
export type Invite_Entity_Insert_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Invite_Entity_Max_FieldsType = {
  __typename?: 'invite_entity_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Invite_Entity_Min_FieldsType = {
  __typename?: 'invite_entity_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "invite_entity" */
export type Invite_Entity_Mutation_ResponseType = {
  __typename?: 'invite_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invite_EntityType>;
};

/** on_conflict condition type for table "invite_entity" */
export type Invite_Entity_On_ConflictType = {
  constraint: Invite_Entity_ConstraintType;
  update_columns?: Array<Invite_Entity_Update_ColumnType>;
  where?: InputMaybe<Invite_Entity_Bool_ExpType>;
};

/** Ordering options when selecting data from "invite_entity". */
export type Invite_Entity_Order_ByType = {
  value?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: invite_entity */
export type Invite_Entity_Pk_Columns_InputType = {
  value: Scalars['String'];
};

/** select columns of table "invite_entity" */
export enum Invite_Entity_Select_ColumnType {
  /** column name */
  ValueType = 'value'
}

/** input type for updating data in table "invite_entity" */
export type Invite_Entity_Set_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "invite_entity" */
export type Invite_Entity_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Invite_Entity_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Invite_Entity_Stream_Cursor_Value_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "invite_entity" */
export enum Invite_Entity_Update_ColumnType {
  /** column name */
  ValueType = 'value'
}

export type Invite_Entity_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invite_Entity_Set_InputType>;
  where: Invite_Entity_Bool_ExpType;
};

/** columns and relationships of "invites" */
export type InvitesType = {
  __typename?: 'invites';
  /** An object relationship */
  class?: Maybe<ClassesType>;
  confirmation_status: Confirmation_Status_EnumType;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: UsersType;
  created_by_id: Scalars['uuid'];
  email?: Maybe<Scalars['String']>;
  entity?: Maybe<Invite_Entity_EnumType>;
  entity_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  event?: Maybe<EventsType>;
  id: Scalars['uuid'];
  /** An object relationship */
  invited_user?: Maybe<UsersType>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "invites" */
export type Invites_AggregateType = {
  __typename?: 'invites_aggregate';
  aggregate?: Maybe<Invites_Aggregate_FieldsType>;
  nodes: Array<InvitesType>;
};

export type Invites_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Invites_Aggregate_Bool_Exp_CountType>;
};

export type Invites_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Invites_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invites_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "invites" */
export type Invites_Aggregate_FieldsType = {
  __typename?: 'invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invites_Max_FieldsType>;
  min?: Maybe<Invites_Min_FieldsType>;
};


/** aggregate fields of "invites" */
export type Invites_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Invites_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invites" */
export type Invites_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Invites_Max_Order_ByType>;
  min?: InputMaybe<Invites_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "invites" */
export type Invites_Arr_Rel_Insert_InputType = {
  data: Array<Invites_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invites_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "invites". All fields are combined with a logical 'AND'. */
export type Invites_Bool_ExpType = {
  _and?: InputMaybe<Array<Invites_Bool_ExpType>>;
  _not?: InputMaybe<Invites_Bool_ExpType>;
  _or?: InputMaybe<Array<Invites_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  confirmation_status?: InputMaybe<Confirmation_Status_Enum_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by?: InputMaybe<Users_Bool_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  email?: InputMaybe<String_Comparison_ExpType>;
  entity?: InputMaybe<Invite_Entity_Enum_Comparison_ExpType>;
  entity_id?: InputMaybe<Uuid_Comparison_ExpType>;
  event?: InputMaybe<Events_Bool_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  invited_user?: InputMaybe<Users_Bool_ExpType>;
  invited_user_id?: InputMaybe<Uuid_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
};

/** unique or primary key constraints on table "invites" */
export enum Invites_ConstraintType {
  /** unique or primary key constraint on columns "entity", "email", "entity_id" */
  InvitesEmailEntityIdEntityKeyType = 'invites_email_entity_id_entity_key',
  /** unique or primary key constraint on columns "entity", "entity_id", "invited_user_id" */
  InvitesInvitedUserIdEntityIdEntityKeyType = 'invites_invited_user_id_entity_id_entity_key',
  /** unique or primary key constraint on columns "id" */
  TeacherInvitesPkeyType = 'teacher_invites_pkey'
}

/** input type for inserting data into table "invites" */
export type Invites_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Invite_Entity_EnumType>;
  entity_id?: InputMaybe<Scalars['uuid']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_InputType>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Invites_Max_FieldsType = {
  __typename?: 'invites_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invites" */
export type Invites_Max_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  email?: InputMaybe<Order_ByType>;
  entity_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  invited_user_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Invites_Min_FieldsType = {
  __typename?: 'invites_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invites" */
export type Invites_Min_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  email?: InputMaybe<Order_ByType>;
  entity_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  invited_user_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "invites" */
export type Invites_Mutation_ResponseType = {
  __typename?: 'invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<InvitesType>;
};

/** on_conflict condition type for table "invites" */
export type Invites_On_ConflictType = {
  constraint: Invites_ConstraintType;
  update_columns?: Array<Invites_Update_ColumnType>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};

/** Ordering options when selecting data from "invites". */
export type Invites_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  confirmation_status?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by?: InputMaybe<Users_Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  email?: InputMaybe<Order_ByType>;
  entity?: InputMaybe<Order_ByType>;
  entity_id?: InputMaybe<Order_ByType>;
  event?: InputMaybe<Events_Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  invited_user?: InputMaybe<Users_Order_ByType>;
  invited_user_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: invites */
export type Invites_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "invites" */
export enum Invites_Select_ColumnType {
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  EmailType = 'email',
  /** column name */
  EntityType = 'entity',
  /** column name */
  EntityIdType = 'entity_id',
  /** column name */
  IdType = 'id',
  /** column name */
  InvitedUserIdType = 'invited_user_id',
  /** column name */
  UpdatedAtType = 'updated_at'
}

/** input type for updating data in table "invites" */
export type Invites_Set_InputType = {
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Invite_Entity_EnumType>;
  entity_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "invites" */
export type Invites_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Invites_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Invites_Stream_Cursor_Value_InputType = {
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Invite_Entity_EnumType>;
  entity_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "invites" */
export enum Invites_Update_ColumnType {
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  EmailType = 'email',
  /** column name */
  EntityType = 'entity',
  /** column name */
  EntityIdType = 'entity_id',
  /** column name */
  IdType = 'id',
  /** column name */
  InvitedUserIdType = 'invited_user_id',
  /** column name */
  UpdatedAtType = 'updated_at'
}

export type Invites_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invites_Set_InputType>;
  where: Invites_Bool_ExpType;
};

/** columns and relationships of "jam_participants" */
export type Jam_ParticipantsType = {
  __typename?: 'jam_participants';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  jam: JamsType;
  jam_id: Scalars['uuid'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "jam_participants" */
export type Jam_Participants_AggregateType = {
  __typename?: 'jam_participants_aggregate';
  aggregate?: Maybe<Jam_Participants_Aggregate_FieldsType>;
  nodes: Array<Jam_ParticipantsType>;
};

export type Jam_Participants_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Jam_Participants_Aggregate_Bool_Exp_CountType>;
};

export type Jam_Participants_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Jam_Participants_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "jam_participants" */
export type Jam_Participants_Aggregate_FieldsType = {
  __typename?: 'jam_participants_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Jam_Participants_Max_FieldsType>;
  min?: Maybe<Jam_Participants_Min_FieldsType>;
};


/** aggregate fields of "jam_participants" */
export type Jam_Participants_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jam_participants" */
export type Jam_Participants_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Jam_Participants_Max_Order_ByType>;
  min?: InputMaybe<Jam_Participants_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "jam_participants" */
export type Jam_Participants_Arr_Rel_Insert_InputType = {
  data: Array<Jam_Participants_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Jam_Participants_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "jam_participants". All fields are combined with a logical 'AND'. */
export type Jam_Participants_Bool_ExpType = {
  _and?: InputMaybe<Array<Jam_Participants_Bool_ExpType>>;
  _not?: InputMaybe<Jam_Participants_Bool_ExpType>;
  _or?: InputMaybe<Array<Jam_Participants_Bool_ExpType>>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  jam?: InputMaybe<Jams_Bool_ExpType>;
  jam_id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "jam_participants" */
export enum Jam_Participants_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  JamParticipantsPkeyType = 'jam_participants_pkey',
  /** unique or primary key constraint on columns "user_id", "jam_id" */
  JamParticipantsUserIdJamIdKeyType = 'jam_participants_user_id_jam_id_key'
}

/** input type for inserting data into table "jam_participants" */
export type Jam_Participants_Insert_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jam?: InputMaybe<Jams_Obj_Rel_Insert_InputType>;
  jam_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Jam_Participants_Max_FieldsType = {
  __typename?: 'jam_participants_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jam_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "jam_participants" */
export type Jam_Participants_Max_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  jam_id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Jam_Participants_Min_FieldsType = {
  __typename?: 'jam_participants_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  jam_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "jam_participants" */
export type Jam_Participants_Min_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  jam_id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "jam_participants" */
export type Jam_Participants_Mutation_ResponseType = {
  __typename?: 'jam_participants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Jam_ParticipantsType>;
};

/** on_conflict condition type for table "jam_participants" */
export type Jam_Participants_On_ConflictType = {
  constraint: Jam_Participants_ConstraintType;
  update_columns?: Array<Jam_Participants_Update_ColumnType>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};

/** Ordering options when selecting data from "jam_participants". */
export type Jam_Participants_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  jam?: InputMaybe<Jams_Order_ByType>;
  jam_id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: jam_participants */
export type Jam_Participants_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "jam_participants" */
export enum Jam_Participants_Select_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  JamIdType = 'jam_id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "jam_participants" */
export type Jam_Participants_Set_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jam_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "jam_participants" */
export type Jam_Participants_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Jam_Participants_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Jam_Participants_Stream_Cursor_Value_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jam_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "jam_participants" */
export enum Jam_Participants_Update_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  JamIdType = 'jam_id',
  /** column name */
  UserIdType = 'user_id'
}

export type Jam_Participants_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jam_Participants_Set_InputType>;
  where: Jam_Participants_Bool_ExpType;
};

/** columns and relationships of "jams" */
export type JamsType = {
  __typename?: 'jams';
  /** An object relationship */
  community: CommunitiesType;
  community_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  created_by: UsersType;
  created_by_id: Scalars['uuid'];
  date: Scalars['timestamptz'];
  id: Scalars['uuid'];
  info?: Maybe<Scalars['String']>;
  latitude: Scalars['numeric'];
  longitude: Scalars['numeric'];
  name: Scalars['String'];
  /** An array relationship */
  participants: Array<Jam_ParticipantsType>;
  /** An aggregate relationship */
  participants_aggregate: Jam_Participants_AggregateType;
};


/** columns and relationships of "jams" */
export type JamsParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


/** columns and relationships of "jams" */
export type JamsParticipants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};

/** aggregated selection of "jams" */
export type Jams_AggregateType = {
  __typename?: 'jams_aggregate';
  aggregate?: Maybe<Jams_Aggregate_FieldsType>;
  nodes: Array<JamsType>;
};

export type Jams_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Jams_Aggregate_Bool_Exp_CountType>;
};

export type Jams_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Jams_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Jams_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "jams" */
export type Jams_Aggregate_FieldsType = {
  __typename?: 'jams_aggregate_fields';
  avg?: Maybe<Jams_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Jams_Max_FieldsType>;
  min?: Maybe<Jams_Min_FieldsType>;
  stddev?: Maybe<Jams_Stddev_FieldsType>;
  stddev_pop?: Maybe<Jams_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Jams_Stddev_Samp_FieldsType>;
  sum?: Maybe<Jams_Sum_FieldsType>;
  var_pop?: Maybe<Jams_Var_Pop_FieldsType>;
  var_samp?: Maybe<Jams_Var_Samp_FieldsType>;
  variance?: Maybe<Jams_Variance_FieldsType>;
};


/** aggregate fields of "jams" */
export type Jams_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Jams_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jams" */
export type Jams_Aggregate_Order_ByType = {
  avg?: InputMaybe<Jams_Avg_Order_ByType>;
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Jams_Max_Order_ByType>;
  min?: InputMaybe<Jams_Min_Order_ByType>;
  stddev?: InputMaybe<Jams_Stddev_Order_ByType>;
  stddev_pop?: InputMaybe<Jams_Stddev_Pop_Order_ByType>;
  stddev_samp?: InputMaybe<Jams_Stddev_Samp_Order_ByType>;
  sum?: InputMaybe<Jams_Sum_Order_ByType>;
  var_pop?: InputMaybe<Jams_Var_Pop_Order_ByType>;
  var_samp?: InputMaybe<Jams_Var_Samp_Order_ByType>;
  variance?: InputMaybe<Jams_Variance_Order_ByType>;
};

/** input type for inserting array relation for remote table "jams" */
export type Jams_Arr_Rel_Insert_InputType = {
  data: Array<Jams_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Jams_On_ConflictType>;
};

/** aggregate avg on columns */
export type Jams_Avg_FieldsType = {
  __typename?: 'jams_avg_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "jams" */
export type Jams_Avg_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** Boolean expression to filter rows from the table "jams". All fields are combined with a logical 'AND'. */
export type Jams_Bool_ExpType = {
  _and?: InputMaybe<Array<Jams_Bool_ExpType>>;
  _not?: InputMaybe<Jams_Bool_ExpType>;
  _or?: InputMaybe<Array<Jams_Bool_ExpType>>;
  community?: InputMaybe<Communities_Bool_ExpType>;
  community_id?: InputMaybe<Uuid_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_by?: InputMaybe<Users_Bool_ExpType>;
  created_by_id?: InputMaybe<Uuid_Comparison_ExpType>;
  date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  info?: InputMaybe<String_Comparison_ExpType>;
  latitude?: InputMaybe<Numeric_Comparison_ExpType>;
  longitude?: InputMaybe<Numeric_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  participants?: InputMaybe<Jam_Participants_Bool_ExpType>;
  participants_aggregate?: InputMaybe<Jam_Participants_Aggregate_Bool_ExpType>;
};

export type Jams_By_Location_V1_ArgsType = {
  lat?: InputMaybe<Scalars['numeric']>;
  lng?: InputMaybe<Scalars['numeric']>;
};

/** unique or primary key constraints on table "jams" */
export enum Jams_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  JamPkeyType = 'jam_pkey'
}

/** input type for incrementing numeric columns in table "jams" */
export type Jams_Inc_InputType = {
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "jams" */
export type Jams_Insert_InputType = {
  community?: InputMaybe<Communities_Obj_Rel_Insert_InputType>;
  community_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  info?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Jam_Participants_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Jams_Max_FieldsType = {
  __typename?: 'jams_max_fields';
  community_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  info?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "jams" */
export type Jams_Max_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  info?: InputMaybe<Order_ByType>;
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Jams_Min_FieldsType = {
  __typename?: 'jams_min_fields';
  community_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['uuid']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  info?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "jams" */
export type Jams_Min_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  info?: InputMaybe<Order_ByType>;
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "jams" */
export type Jams_Mutation_ResponseType = {
  __typename?: 'jams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JamsType>;
};

/** input type for inserting object relation for remote table "jams" */
export type Jams_Obj_Rel_Insert_InputType = {
  data: Jams_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Jams_On_ConflictType>;
};

/** on_conflict condition type for table "jams" */
export type Jams_On_ConflictType = {
  constraint: Jams_ConstraintType;
  update_columns?: Array<Jams_Update_ColumnType>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};

/** Ordering options when selecting data from "jams". */
export type Jams_Order_ByType = {
  community?: InputMaybe<Communities_Order_ByType>;
  community_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_by?: InputMaybe<Users_Order_ByType>;
  created_by_id?: InputMaybe<Order_ByType>;
  date?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  info?: InputMaybe<Order_ByType>;
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  participants_aggregate?: InputMaybe<Jam_Participants_Aggregate_Order_ByType>;
};

/** primary key columns input for table: jams */
export type Jams_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "jams" */
export enum Jams_Select_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DateType = 'date',
  /** column name */
  IdType = 'id',
  /** column name */
  InfoType = 'info',
  /** column name */
  LatitudeType = 'latitude',
  /** column name */
  LongitudeType = 'longitude',
  /** column name */
  NameType = 'name'
}

/** input type for updating data in table "jams" */
export type Jams_Set_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  info?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Jams_Stddev_FieldsType = {
  __typename?: 'jams_stddev_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "jams" */
export type Jams_Stddev_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_pop on columns */
export type Jams_Stddev_Pop_FieldsType = {
  __typename?: 'jams_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "jams" */
export type Jams_Stddev_Pop_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_samp on columns */
export type Jams_Stddev_Samp_FieldsType = {
  __typename?: 'jams_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "jams" */
export type Jams_Stddev_Samp_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** Streaming cursor of the table "jams" */
export type Jams_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Jams_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Jams_Stream_Cursor_Value_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  info?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['numeric']>;
  longitude?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Jams_Sum_FieldsType = {
  __typename?: 'jams_sum_fields';
  latitude?: Maybe<Scalars['numeric']>;
  longitude?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "jams" */
export type Jams_Sum_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** update columns of table "jams" */
export enum Jams_Update_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  CreatedByIdType = 'created_by_id',
  /** column name */
  DateType = 'date',
  /** column name */
  IdType = 'id',
  /** column name */
  InfoType = 'info',
  /** column name */
  LatitudeType = 'latitude',
  /** column name */
  LongitudeType = 'longitude',
  /** column name */
  NameType = 'name'
}

export type Jams_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Jams_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jams_Set_InputType>;
  where: Jams_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Jams_Var_Pop_FieldsType = {
  __typename?: 'jams_var_pop_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "jams" */
export type Jams_Var_Pop_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** aggregate var_samp on columns */
export type Jams_Var_Samp_FieldsType = {
  __typename?: 'jams_var_samp_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "jams" */
export type Jams_Var_Samp_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** aggregate variance on columns */
export type Jams_Variance_FieldsType = {
  __typename?: 'jams_variance_fields';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "jams" */
export type Jams_Variance_Order_ByType = {
  latitude?: InputMaybe<Order_ByType>;
  longitude?: InputMaybe<Order_ByType>;
};

/** columns and relationships of "levels" */
export type LevelsType = {
  __typename?: 'levels';
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "levels" */
export type Levels_AggregateType = {
  __typename?: 'levels_aggregate';
  aggregate?: Maybe<Levels_Aggregate_FieldsType>;
  nodes: Array<LevelsType>;
};

/** aggregate fields of "levels" */
export type Levels_Aggregate_FieldsType = {
  __typename?: 'levels_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Levels_Max_FieldsType>;
  min?: Maybe<Levels_Min_FieldsType>;
};


/** aggregate fields of "levels" */
export type Levels_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Levels_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "levels". All fields are combined with a logical 'AND'. */
export type Levels_Bool_ExpType = {
  _and?: InputMaybe<Array<Levels_Bool_ExpType>>;
  _not?: InputMaybe<Levels_Bool_ExpType>;
  _or?: InputMaybe<Array<Levels_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "levels" */
export enum Levels_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  LevelsPkeyType = 'levels_pkey'
}

/** input type for inserting data into table "levels" */
export type Levels_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Levels_Max_FieldsType = {
  __typename?: 'levels_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Levels_Min_FieldsType = {
  __typename?: 'levels_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "levels" */
export type Levels_Mutation_ResponseType = {
  __typename?: 'levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<LevelsType>;
};

/** input type for inserting object relation for remote table "levels" */
export type Levels_Obj_Rel_Insert_InputType = {
  data: Levels_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Levels_On_ConflictType>;
};

/** on_conflict condition type for table "levels" */
export type Levels_On_ConflictType = {
  constraint: Levels_ConstraintType;
  update_columns?: Array<Levels_Update_ColumnType>;
  where?: InputMaybe<Levels_Bool_ExpType>;
};

/** Ordering options when selecting data from "levels". */
export type Levels_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: levels */
export type Levels_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "levels" */
export enum Levels_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  NameType = 'name'
}

/** input type for updating data in table "levels" */
export type Levels_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "levels" */
export type Levels_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Levels_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Levels_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "levels" */
export enum Levels_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  NameType = 'name'
}

export type Levels_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Levels_Set_InputType>;
  where: Levels_Bool_ExpType;
};

/** columns and relationships of "me" */
export type MeType = {
  __typename?: 'me';
  /** An object relationship */
  acro_role?: Maybe<Acro_RolesType>;
  acro_role_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  bookings: Array<Class_Event_BookingsType>;
  /** An aggregate relationship */
  bookings_aggregate: Class_Event_Bookings_AggregateType;
  /** An array relationship */
  bookmarks: Array<Event_BookmarksType>;
  /** An aggregate relationship */
  bookmarks_aggregate: Event_Bookmarks_AggregateType;
  /** An array relationship */
  class_favorits: Array<Class_FavoritesType>;
  /** An aggregate relationship */
  class_favorits_aggregate: Class_Favorites_AggregateType;
  /** An array relationship */
  communities: Array<User_CommunitiesType>;
  /** An aggregate relationship */
  communities_aggregate: User_Communities_AggregateType;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  created_invites: Array<InvitesType>;
  /** An aggregate relationship */
  created_invites_aggregate: Invites_AggregateType;
  email?: Maybe<Scalars['String']>;
  fcm_token?: Maybe<Scalars['String']>;
  /** An array relationship */
  followed_teacher: Array<Teacher_LikesType>;
  /** An aggregate relationship */
  followed_teacher_aggregate: Teacher_Likes_AggregateType;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  invites: Array<InvitesType>;
  /** An aggregate relationship */
  invites_aggregate: Invites_AggregateType;
  is_admin?: Maybe<Scalars['Boolean']>;
  is_email_verified?: Maybe<Scalars['Boolean']>;
  is_teacher?: Maybe<Scalars['Boolean']>;
  last_proposed_community_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  level?: Maybe<LevelsType>;
  level_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  participates: Array<Jam_ParticipantsType>;
  /** An aggregate relationship */
  participates_aggregate: Jam_Participants_AggregateType;
  teacher_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  teacher_profile?: Maybe<TeachersType>;
  used_teacher_signup?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  user_roles: Array<User_RolesType>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Roles_AggregateType;
};


/** columns and relationships of "me" */
export type MeBookingsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeBookings_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeBookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeBookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeClass_FavoritsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeClass_Favorits_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeCommunitiesArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeCommunities_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeCreated_InvitesArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeCreated_Invites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeFollowed_TeacherArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeFollowed_Teacher_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeInvitesArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeInvites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeParticipatesArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeParticipates_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeUser_RolesArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


/** columns and relationships of "me" */
export type MeUser_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};

/** aggregated selection of "me" */
export type Me_AggregateType = {
  __typename?: 'me_aggregate';
  aggregate?: Maybe<Me_Aggregate_FieldsType>;
  nodes: Array<MeType>;
};

/** aggregate fields of "me" */
export type Me_Aggregate_FieldsType = {
  __typename?: 'me_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Me_Max_FieldsType>;
  min?: Maybe<Me_Min_FieldsType>;
};


/** aggregate fields of "me" */
export type Me_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Me_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "me". All fields are combined with a logical 'AND'. */
export type Me_Bool_ExpType = {
  _and?: InputMaybe<Array<Me_Bool_ExpType>>;
  _not?: InputMaybe<Me_Bool_ExpType>;
  _or?: InputMaybe<Array<Me_Bool_ExpType>>;
  acro_role?: InputMaybe<Acro_Roles_Bool_ExpType>;
  acro_role_id?: InputMaybe<Uuid_Comparison_ExpType>;
  bio?: InputMaybe<String_Comparison_ExpType>;
  bookings?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
  bookings_aggregate?: InputMaybe<Class_Event_Bookings_Aggregate_Bool_ExpType>;
  bookmarks?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
  bookmarks_aggregate?: InputMaybe<Event_Bookmarks_Aggregate_Bool_ExpType>;
  class_favorits?: InputMaybe<Class_Favorites_Bool_ExpType>;
  class_favorits_aggregate?: InputMaybe<Class_Favorites_Aggregate_Bool_ExpType>;
  communities?: InputMaybe<User_Communities_Bool_ExpType>;
  communities_aggregate?: InputMaybe<User_Communities_Aggregate_Bool_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_invites?: InputMaybe<Invites_Bool_ExpType>;
  created_invites_aggregate?: InputMaybe<Invites_Aggregate_Bool_ExpType>;
  email?: InputMaybe<String_Comparison_ExpType>;
  fcm_token?: InputMaybe<String_Comparison_ExpType>;
  followed_teacher?: InputMaybe<Teacher_Likes_Bool_ExpType>;
  followed_teacher_aggregate?: InputMaybe<Teacher_Likes_Aggregate_Bool_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  image_url?: InputMaybe<String_Comparison_ExpType>;
  invites?: InputMaybe<Invites_Bool_ExpType>;
  invites_aggregate?: InputMaybe<Invites_Aggregate_Bool_ExpType>;
  is_admin?: InputMaybe<Boolean_Comparison_ExpType>;
  is_email_verified?: InputMaybe<Boolean_Comparison_ExpType>;
  is_teacher?: InputMaybe<Boolean_Comparison_ExpType>;
  last_proposed_community_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  level?: InputMaybe<Levels_Bool_ExpType>;
  level_id?: InputMaybe<Uuid_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  origin_id?: InputMaybe<String_Comparison_ExpType>;
  participates?: InputMaybe<Jam_Participants_Bool_ExpType>;
  participates_aggregate?: InputMaybe<Jam_Participants_Aggregate_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher_profile?: InputMaybe<Teachers_Bool_ExpType>;
  used_teacher_signup?: InputMaybe<Boolean_Comparison_ExpType>;
  user_roles?: InputMaybe<User_Roles_Bool_ExpType>;
  user_roles_aggregate?: InputMaybe<User_Roles_Aggregate_Bool_ExpType>;
};

/** input type for inserting data into table "me" */
export type Me_Insert_InputType = {
  acro_role?: InputMaybe<Acro_Roles_Obj_Rel_Insert_InputType>;
  acro_role_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  bookings?: InputMaybe<Class_Event_Bookings_Arr_Rel_Insert_InputType>;
  bookmarks?: InputMaybe<Event_Bookmarks_Arr_Rel_Insert_InputType>;
  class_favorits?: InputMaybe<Class_Favorites_Arr_Rel_Insert_InputType>;
  communities?: InputMaybe<User_Communities_Arr_Rel_Insert_InputType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_invites?: InputMaybe<Invites_Arr_Rel_Insert_InputType>;
  email?: InputMaybe<Scalars['String']>;
  fcm_token?: InputMaybe<Scalars['String']>;
  followed_teacher?: InputMaybe<Teacher_Likes_Arr_Rel_Insert_InputType>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  invites?: InputMaybe<Invites_Arr_Rel_Insert_InputType>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']>;
  is_teacher?: InputMaybe<Scalars['Boolean']>;
  last_proposed_community_at?: InputMaybe<Scalars['timestamptz']>;
  level?: InputMaybe<Levels_Obj_Rel_Insert_InputType>;
  level_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  participates?: InputMaybe<Jam_Participants_Arr_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  teacher_profile?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  used_teacher_signup?: InputMaybe<Scalars['Boolean']>;
  user_roles?: InputMaybe<User_Roles_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Me_Max_FieldsType = {
  __typename?: 'me_max_fields';
  acro_role_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fcm_token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  last_proposed_community_at?: Maybe<Scalars['timestamptz']>;
  level_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Me_Min_FieldsType = {
  __typename?: 'me_min_fields';
  acro_role_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fcm_token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  last_proposed_community_at?: Maybe<Scalars['timestamptz']>;
  level_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "me" */
export type Me_Mutation_ResponseType = {
  __typename?: 'me_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MeType>;
};

/** Ordering options when selecting data from "me". */
export type Me_Order_ByType = {
  acro_role?: InputMaybe<Acro_Roles_Order_ByType>;
  acro_role_id?: InputMaybe<Order_ByType>;
  bio?: InputMaybe<Order_ByType>;
  bookings_aggregate?: InputMaybe<Class_Event_Bookings_Aggregate_Order_ByType>;
  bookmarks_aggregate?: InputMaybe<Event_Bookmarks_Aggregate_Order_ByType>;
  class_favorits_aggregate?: InputMaybe<Class_Favorites_Aggregate_Order_ByType>;
  communities_aggregate?: InputMaybe<User_Communities_Aggregate_Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_invites_aggregate?: InputMaybe<Invites_Aggregate_Order_ByType>;
  email?: InputMaybe<Order_ByType>;
  fcm_token?: InputMaybe<Order_ByType>;
  followed_teacher_aggregate?: InputMaybe<Teacher_Likes_Aggregate_Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_url?: InputMaybe<Order_ByType>;
  invites_aggregate?: InputMaybe<Invites_Aggregate_Order_ByType>;
  is_admin?: InputMaybe<Order_ByType>;
  is_email_verified?: InputMaybe<Order_ByType>;
  is_teacher?: InputMaybe<Order_ByType>;
  last_proposed_community_at?: InputMaybe<Order_ByType>;
  level?: InputMaybe<Levels_Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  origin_id?: InputMaybe<Order_ByType>;
  participates_aggregate?: InputMaybe<Jam_Participants_Aggregate_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  teacher_profile?: InputMaybe<Teachers_Order_ByType>;
  used_teacher_signup?: InputMaybe<Order_ByType>;
  user_roles_aggregate?: InputMaybe<User_Roles_Aggregate_Order_ByType>;
};

/** select columns of table "me" */
export enum Me_Select_ColumnType {
  /** column name */
  AcroRoleIdType = 'acro_role_id',
  /** column name */
  BioType = 'bio',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EmailType = 'email',
  /** column name */
  FcmTokenType = 'fcm_token',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageUrlType = 'image_url',
  /** column name */
  IsAdminType = 'is_admin',
  /** column name */
  IsEmailVerifiedType = 'is_email_verified',
  /** column name */
  IsTeacherType = 'is_teacher',
  /** column name */
  LastProposedCommunityAtType = 'last_proposed_community_at',
  /** column name */
  LevelIdType = 'level_id',
  /** column name */
  NameType = 'name',
  /** column name */
  OriginIdType = 'origin_id',
  /** column name */
  TeacherIdType = 'teacher_id',
  /** column name */
  UsedTeacherSignupType = 'used_teacher_signup'
}

/** input type for updating data in table "me" */
export type Me_Set_InputType = {
  acro_role_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  fcm_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']>;
  is_teacher?: InputMaybe<Scalars['Boolean']>;
  last_proposed_community_at?: InputMaybe<Scalars['timestamptz']>;
  level_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  used_teacher_signup?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "me" */
export type Me_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Me_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Me_Stream_Cursor_Value_InputType = {
  acro_role_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  fcm_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']>;
  is_teacher?: InputMaybe<Scalars['Boolean']>;
  last_proposed_community_at?: InputMaybe<Scalars['timestamptz']>;
  level_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  used_teacher_signup?: InputMaybe<Scalars['Boolean']>;
};

export type Me_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Me_Set_InputType>;
  where: Me_Bool_ExpType;
};

/** mutation root */
export type Mutation_RootType = {
  __typename?: 'mutation_root';
  accept_invite: SuccessOutputType;
  create_payment_sheet: CreatePaymentIntentResponseType;
  create_stripe_user: CreateStripeUserResponseType;
  delete_account: DeleteAccountResponseType;
  /** delete data from the table: "acro_roles" */
  delete_acro_roles?: Maybe<Acro_Roles_Mutation_ResponseType>;
  /** delete single row from the table: "acro_roles" */
  delete_acro_roles_by_pk?: Maybe<Acro_RolesType>;
  /** delete data from the table: "booking_option" */
  delete_booking_option?: Maybe<Booking_Option_Mutation_ResponseType>;
  /** delete single row from the table: "booking_option" */
  delete_booking_option_by_pk?: Maybe<Booking_OptionType>;
  /** delete data from the table: "class_booking_option" */
  delete_class_booking_option?: Maybe<Class_Booking_Option_Mutation_ResponseType>;
  /** delete single row from the table: "class_booking_option" */
  delete_class_booking_option_by_pk?: Maybe<Class_Booking_OptionType>;
  /** delete data from the table: "class_event_bookings" */
  delete_class_event_bookings?: Maybe<Class_Event_Bookings_Mutation_ResponseType>;
  /** delete single row from the table: "class_event_bookings" */
  delete_class_event_bookings_by_pk?: Maybe<Class_Event_BookingsType>;
  /** delete data from the table: "class_event_bookmarks" */
  delete_class_event_bookmarks?: Maybe<Class_Event_Bookmarks_Mutation_ResponseType>;
  /** delete single row from the table: "class_event_bookmarks" */
  delete_class_event_bookmarks_by_pk?: Maybe<Class_Event_BookmarksType>;
  /** delete data from the table: "class_events" */
  delete_class_events?: Maybe<Class_Events_Mutation_ResponseType>;
  /** delete single row from the table: "class_events" */
  delete_class_events_by_pk?: Maybe<Class_EventsType>;
  /** delete data from the table: "class_events_participants" */
  delete_class_events_participants?: Maybe<Class_Events_Participants_Mutation_ResponseType>;
  /** delete single row from the table: "class_events_participants" */
  delete_class_events_participants_by_pk?: Maybe<Class_Events_ParticipantsType>;
  /** delete data from the table: "class_favorites" */
  delete_class_favorites?: Maybe<Class_Favorites_Mutation_ResponseType>;
  /** delete single row from the table: "class_favorites" */
  delete_class_favorites_by_pk?: Maybe<Class_FavoritesType>;
  /** delete data from the table: "class_flag" */
  delete_class_flag?: Maybe<Class_Flag_Mutation_ResponseType>;
  /** delete single row from the table: "class_flag" */
  delete_class_flag_by_pk?: Maybe<Class_FlagType>;
  /** delete data from the table: "class_levels" */
  delete_class_levels?: Maybe<Class_Levels_Mutation_ResponseType>;
  /** delete single row from the table: "class_levels" */
  delete_class_levels_by_pk?: Maybe<Class_LevelsType>;
  /** delete data from the table: "class_owners" */
  delete_class_owners?: Maybe<Class_Owners_Mutation_ResponseType>;
  /** delete single row from the table: "class_owners" */
  delete_class_owners_by_pk?: Maybe<Class_OwnersType>;
  /** delete data from the table: "class_teachers" */
  delete_class_teachers?: Maybe<Class_Teachers_Mutation_ResponseType>;
  /** delete single row from the table: "class_teachers" */
  delete_class_teachers_by_pk?: Maybe<Class_TeachersType>;
  /** delete data from the table: "classes" */
  delete_classes?: Maybe<Classes_Mutation_ResponseType>;
  /** delete single row from the table: "classes" */
  delete_classes_by_pk?: Maybe<ClassesType>;
  /** delete data from the table: "communities" */
  delete_communities?: Maybe<Communities_Mutation_ResponseType>;
  /** delete single row from the table: "communities" */
  delete_communities_by_pk?: Maybe<CommunitiesType>;
  /** delete data from the table: "community_messages" */
  delete_community_messages?: Maybe<Community_Messages_Mutation_ResponseType>;
  /** delete single row from the table: "community_messages" */
  delete_community_messages_by_pk?: Maybe<Community_MessagesType>;
  /** delete data from the table: "config" */
  delete_config?: Maybe<Config_Mutation_ResponseType>;
  /** delete single row from the table: "config" */
  delete_config_by_pk?: Maybe<ConfigType>;
  /** delete data from the table: "confirmation_status" */
  delete_confirmation_status?: Maybe<Confirmation_Status_Mutation_ResponseType>;
  /** delete single row from the table: "confirmation_status" */
  delete_confirmation_status_by_pk?: Maybe<Confirmation_StatusType>;
  /** delete data from the table: "created_invites" */
  delete_created_invites?: Maybe<Created_Invites_Mutation_ResponseType>;
  /** delete data from the table: "event_bookmarks" */
  delete_event_bookmarks?: Maybe<Event_Bookmarks_Mutation_ResponseType>;
  /** delete single row from the table: "event_bookmarks" */
  delete_event_bookmarks_by_pk?: Maybe<Event_BookmarksType>;
  /** delete data from the table: "event_instance" */
  delete_event_instance?: Maybe<Event_Instance_Mutation_ResponseType>;
  /** delete single row from the table: "event_instance" */
  delete_event_instance_by_pk?: Maybe<Event_InstanceType>;
  /** delete data from the table: "event_owners" */
  delete_event_owners?: Maybe<Event_Owners_Mutation_ResponseType>;
  /** delete single row from the table: "event_owners" */
  delete_event_owners_by_pk?: Maybe<Event_OwnersType>;
  /** delete data from the table: "event_source" */
  delete_event_source?: Maybe<Event_Source_Mutation_ResponseType>;
  /** delete single row from the table: "event_source" */
  delete_event_source_by_pk?: Maybe<Event_SourceType>;
  /** delete data from the table: "event_teachers" */
  delete_event_teachers?: Maybe<Event_Teachers_Mutation_ResponseType>;
  /** delete single row from the table: "event_teachers" */
  delete_event_teachers_by_pk?: Maybe<Event_TeachersType>;
  /** delete data from the table: "event_template" */
  delete_event_template?: Maybe<Event_Template_Mutation_ResponseType>;
  /** delete single row from the table: "event_template" */
  delete_event_template_by_pk?: Maybe<Event_TemplateType>;
  /** delete data from the table: "event_type" */
  delete_event_type?: Maybe<Event_Type_Mutation_ResponseType>;
  /** delete single row from the table: "event_type" */
  delete_event_type_by_pk?: Maybe<Event_TypeType>;
  /** delete data from the table: "event_user_participants" */
  delete_event_user_participants?: Maybe<Event_User_Participants_Mutation_ResponseType>;
  /** delete single row from the table: "event_user_participants" */
  delete_event_user_participants_by_pk?: Maybe<Event_User_ParticipantsType>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_ResponseType>;
  /** delete single row from the table: "events" */
  delete_events_by_pk?: Maybe<EventsType>;
  /** delete data from the table: "images" */
  delete_images?: Maybe<Images_Mutation_ResponseType>;
  /** delete single row from the table: "images" */
  delete_images_by_pk?: Maybe<ImagesType>;
  /** delete data from the table: "inherited.class_events_with_distance" */
  delete_inherited_class_events_with_distance?: Maybe<Inherited_Class_Events_With_Distance_Mutation_ResponseType>;
  /** delete data from the table: "inherited.classes_with_distance" */
  delete_inherited_classes_with_distance?: Maybe<Inherited_Classes_With_Distance_Mutation_ResponseType>;
  /** delete data from the table: "inherited.communities_with_distance" */
  delete_inherited_communities_with_distance?: Maybe<Inherited_Communities_With_Distance_Mutation_ResponseType>;
  /** delete data from the table: "inherited.jams_with_distance" */
  delete_inherited_jams_with_distance?: Maybe<Inherited_Jams_With_Distance_Mutation_ResponseType>;
  /** delete data from the table: "invite_entity" */
  delete_invite_entity?: Maybe<Invite_Entity_Mutation_ResponseType>;
  /** delete single row from the table: "invite_entity" */
  delete_invite_entity_by_pk?: Maybe<Invite_EntityType>;
  /** delete data from the table: "invites" */
  delete_invites?: Maybe<Invites_Mutation_ResponseType>;
  /** delete single row from the table: "invites" */
  delete_invites_by_pk?: Maybe<InvitesType>;
  /** delete data from the table: "jam_participants" */
  delete_jam_participants?: Maybe<Jam_Participants_Mutation_ResponseType>;
  /** delete single row from the table: "jam_participants" */
  delete_jam_participants_by_pk?: Maybe<Jam_ParticipantsType>;
  /** delete data from the table: "jams" */
  delete_jams?: Maybe<Jams_Mutation_ResponseType>;
  /** delete single row from the table: "jams" */
  delete_jams_by_pk?: Maybe<JamsType>;
  /** delete data from the table: "levels" */
  delete_levels?: Maybe<Levels_Mutation_ResponseType>;
  /** delete single row from the table: "levels" */
  delete_levels_by_pk?: Maybe<LevelsType>;
  /** delete data from the table: "me" */
  delete_me?: Maybe<Me_Mutation_ResponseType>;
  /** delete data from the table: "recurring_patterns" */
  delete_recurring_patterns?: Maybe<Recurring_Patterns_Mutation_ResponseType>;
  /** delete single row from the table: "recurring_patterns" */
  delete_recurring_patterns_by_pk?: Maybe<Recurring_PatternsType>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_ResponseType>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<RolesType>;
  /** delete data from the table: "teacher_images" */
  delete_teacher_images?: Maybe<Teacher_Images_Mutation_ResponseType>;
  /** delete single row from the table: "teacher_images" */
  delete_teacher_images_by_pk?: Maybe<Teacher_ImagesType>;
  /** delete data from the table: "teacher_levels" */
  delete_teacher_levels?: Maybe<Teacher_Levels_Mutation_ResponseType>;
  /** delete single row from the table: "teacher_levels" */
  delete_teacher_levels_by_pk?: Maybe<Teacher_LevelsType>;
  /** delete data from the table: "teacher_likes" */
  delete_teacher_likes?: Maybe<Teacher_Likes_Mutation_ResponseType>;
  /** delete single row from the table: "teacher_likes" */
  delete_teacher_likes_by_pk?: Maybe<Teacher_LikesType>;
  /** delete data from the table: "teacher_type" */
  delete_teacher_type?: Maybe<Teacher_Type_Mutation_ResponseType>;
  /** delete single row from the table: "teacher_type" */
  delete_teacher_type_by_pk?: Maybe<Teacher_TypeType>;
  /** delete data from the table: "teachers" */
  delete_teachers?: Maybe<Teachers_Mutation_ResponseType>;
  /** delete single row from the table: "teachers" */
  delete_teachers_by_pk?: Maybe<TeachersType>;
  /** delete data from the table: "user_communities" */
  delete_user_communities?: Maybe<User_Communities_Mutation_ResponseType>;
  /** delete single row from the table: "user_communities" */
  delete_user_communities_by_pk?: Maybe<User_CommunitiesType>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<User_Roles_Mutation_ResponseType>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<User_RolesType>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_ResponseType>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<UsersType>;
  /** insert data into the table: "acro_roles" */
  insert_acro_roles?: Maybe<Acro_Roles_Mutation_ResponseType>;
  /** insert a single row into the table: "acro_roles" */
  insert_acro_roles_one?: Maybe<Acro_RolesType>;
  /** insert data into the table: "booking_option" */
  insert_booking_option?: Maybe<Booking_Option_Mutation_ResponseType>;
  /** insert a single row into the table: "booking_option" */
  insert_booking_option_one?: Maybe<Booking_OptionType>;
  /** insert data into the table: "class_booking_option" */
  insert_class_booking_option?: Maybe<Class_Booking_Option_Mutation_ResponseType>;
  /** insert a single row into the table: "class_booking_option" */
  insert_class_booking_option_one?: Maybe<Class_Booking_OptionType>;
  /** insert data into the table: "class_event_bookings" */
  insert_class_event_bookings?: Maybe<Class_Event_Bookings_Mutation_ResponseType>;
  /** insert a single row into the table: "class_event_bookings" */
  insert_class_event_bookings_one?: Maybe<Class_Event_BookingsType>;
  /** insert data into the table: "class_event_bookmarks" */
  insert_class_event_bookmarks?: Maybe<Class_Event_Bookmarks_Mutation_ResponseType>;
  /** insert a single row into the table: "class_event_bookmarks" */
  insert_class_event_bookmarks_one?: Maybe<Class_Event_BookmarksType>;
  /** insert data into the table: "class_events" */
  insert_class_events?: Maybe<Class_Events_Mutation_ResponseType>;
  /** insert a single row into the table: "class_events" */
  insert_class_events_one?: Maybe<Class_EventsType>;
  /** insert data into the table: "class_events_participants" */
  insert_class_events_participants?: Maybe<Class_Events_Participants_Mutation_ResponseType>;
  /** insert a single row into the table: "class_events_participants" */
  insert_class_events_participants_one?: Maybe<Class_Events_ParticipantsType>;
  /** insert data into the table: "class_favorites" */
  insert_class_favorites?: Maybe<Class_Favorites_Mutation_ResponseType>;
  /** insert a single row into the table: "class_favorites" */
  insert_class_favorites_one?: Maybe<Class_FavoritesType>;
  /** insert data into the table: "class_flag" */
  insert_class_flag?: Maybe<Class_Flag_Mutation_ResponseType>;
  /** insert a single row into the table: "class_flag" */
  insert_class_flag_one?: Maybe<Class_FlagType>;
  /** insert data into the table: "class_levels" */
  insert_class_levels?: Maybe<Class_Levels_Mutation_ResponseType>;
  /** insert a single row into the table: "class_levels" */
  insert_class_levels_one?: Maybe<Class_LevelsType>;
  /** insert data into the table: "class_owners" */
  insert_class_owners?: Maybe<Class_Owners_Mutation_ResponseType>;
  /** insert a single row into the table: "class_owners" */
  insert_class_owners_one?: Maybe<Class_OwnersType>;
  /** insert data into the table: "class_teachers" */
  insert_class_teachers?: Maybe<Class_Teachers_Mutation_ResponseType>;
  /** insert a single row into the table: "class_teachers" */
  insert_class_teachers_one?: Maybe<Class_TeachersType>;
  /** insert data into the table: "classes" */
  insert_classes?: Maybe<Classes_Mutation_ResponseType>;
  /** insert a single row into the table: "classes" */
  insert_classes_one?: Maybe<ClassesType>;
  /** insert data into the table: "communities" */
  insert_communities?: Maybe<Communities_Mutation_ResponseType>;
  /** insert a single row into the table: "communities" */
  insert_communities_one?: Maybe<CommunitiesType>;
  /** insert data into the table: "community_messages" */
  insert_community_messages?: Maybe<Community_Messages_Mutation_ResponseType>;
  /** insert a single row into the table: "community_messages" */
  insert_community_messages_one?: Maybe<Community_MessagesType>;
  /** insert data into the table: "config" */
  insert_config?: Maybe<Config_Mutation_ResponseType>;
  /** insert a single row into the table: "config" */
  insert_config_one?: Maybe<ConfigType>;
  /** insert data into the table: "confirmation_status" */
  insert_confirmation_status?: Maybe<Confirmation_Status_Mutation_ResponseType>;
  /** insert a single row into the table: "confirmation_status" */
  insert_confirmation_status_one?: Maybe<Confirmation_StatusType>;
  /** insert data into the table: "created_invites" */
  insert_created_invites?: Maybe<Created_Invites_Mutation_ResponseType>;
  /** insert a single row into the table: "created_invites" */
  insert_created_invites_one?: Maybe<Created_InvitesType>;
  /** insert data into the table: "event_bookmarks" */
  insert_event_bookmarks?: Maybe<Event_Bookmarks_Mutation_ResponseType>;
  /** insert a single row into the table: "event_bookmarks" */
  insert_event_bookmarks_one?: Maybe<Event_BookmarksType>;
  /** insert data into the table: "event_instance" */
  insert_event_instance?: Maybe<Event_Instance_Mutation_ResponseType>;
  /** insert a single row into the table: "event_instance" */
  insert_event_instance_one?: Maybe<Event_InstanceType>;
  /** insert data into the table: "event_owners" */
  insert_event_owners?: Maybe<Event_Owners_Mutation_ResponseType>;
  /** insert a single row into the table: "event_owners" */
  insert_event_owners_one?: Maybe<Event_OwnersType>;
  /** insert data into the table: "event_source" */
  insert_event_source?: Maybe<Event_Source_Mutation_ResponseType>;
  /** insert a single row into the table: "event_source" */
  insert_event_source_one?: Maybe<Event_SourceType>;
  /** insert data into the table: "event_teachers" */
  insert_event_teachers?: Maybe<Event_Teachers_Mutation_ResponseType>;
  /** insert a single row into the table: "event_teachers" */
  insert_event_teachers_one?: Maybe<Event_TeachersType>;
  /** insert data into the table: "event_template" */
  insert_event_template?: Maybe<Event_Template_Mutation_ResponseType>;
  /** insert a single row into the table: "event_template" */
  insert_event_template_one?: Maybe<Event_TemplateType>;
  /** insert data into the table: "event_type" */
  insert_event_type?: Maybe<Event_Type_Mutation_ResponseType>;
  /** insert a single row into the table: "event_type" */
  insert_event_type_one?: Maybe<Event_TypeType>;
  /** insert data into the table: "event_user_participants" */
  insert_event_user_participants?: Maybe<Event_User_Participants_Mutation_ResponseType>;
  /** insert a single row into the table: "event_user_participants" */
  insert_event_user_participants_one?: Maybe<Event_User_ParticipantsType>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_ResponseType>;
  /** insert a single row into the table: "events" */
  insert_events_one?: Maybe<EventsType>;
  /** insert data into the table: "images" */
  insert_images?: Maybe<Images_Mutation_ResponseType>;
  /** insert a single row into the table: "images" */
  insert_images_one?: Maybe<ImagesType>;
  /** insert data into the table: "inherited.class_events_with_distance" */
  insert_inherited_class_events_with_distance?: Maybe<Inherited_Class_Events_With_Distance_Mutation_ResponseType>;
  /** insert a single row into the table: "inherited.class_events_with_distance" */
  insert_inherited_class_events_with_distance_one?: Maybe<Inherited_Class_Events_With_DistanceType>;
  /** insert data into the table: "inherited.classes_with_distance" */
  insert_inherited_classes_with_distance?: Maybe<Inherited_Classes_With_Distance_Mutation_ResponseType>;
  /** insert a single row into the table: "inherited.classes_with_distance" */
  insert_inherited_classes_with_distance_one?: Maybe<Inherited_Classes_With_DistanceType>;
  /** insert data into the table: "inherited.communities_with_distance" */
  insert_inherited_communities_with_distance?: Maybe<Inherited_Communities_With_Distance_Mutation_ResponseType>;
  /** insert a single row into the table: "inherited.communities_with_distance" */
  insert_inherited_communities_with_distance_one?: Maybe<Inherited_Communities_With_DistanceType>;
  /** insert data into the table: "inherited.jams_with_distance" */
  insert_inherited_jams_with_distance?: Maybe<Inherited_Jams_With_Distance_Mutation_ResponseType>;
  /** insert a single row into the table: "inherited.jams_with_distance" */
  insert_inherited_jams_with_distance_one?: Maybe<Inherited_Jams_With_DistanceType>;
  /** insert data into the table: "invite_entity" */
  insert_invite_entity?: Maybe<Invite_Entity_Mutation_ResponseType>;
  /** insert a single row into the table: "invite_entity" */
  insert_invite_entity_one?: Maybe<Invite_EntityType>;
  /** insert data into the table: "invites" */
  insert_invites?: Maybe<Invites_Mutation_ResponseType>;
  /** insert a single row into the table: "invites" */
  insert_invites_one?: Maybe<InvitesType>;
  /** insert data into the table: "jam_participants" */
  insert_jam_participants?: Maybe<Jam_Participants_Mutation_ResponseType>;
  /** insert a single row into the table: "jam_participants" */
  insert_jam_participants_one?: Maybe<Jam_ParticipantsType>;
  /** insert data into the table: "jams" */
  insert_jams?: Maybe<Jams_Mutation_ResponseType>;
  /** insert a single row into the table: "jams" */
  insert_jams_one?: Maybe<JamsType>;
  /** insert data into the table: "levels" */
  insert_levels?: Maybe<Levels_Mutation_ResponseType>;
  /** insert a single row into the table: "levels" */
  insert_levels_one?: Maybe<LevelsType>;
  /** insert data into the table: "me" */
  insert_me?: Maybe<Me_Mutation_ResponseType>;
  /** insert a single row into the table: "me" */
  insert_me_one?: Maybe<MeType>;
  /** insert data into the table: "recurring_patterns" */
  insert_recurring_patterns?: Maybe<Recurring_Patterns_Mutation_ResponseType>;
  /** insert a single row into the table: "recurring_patterns" */
  insert_recurring_patterns_one?: Maybe<Recurring_PatternsType>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_ResponseType>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<RolesType>;
  /** insert data into the table: "teacher_images" */
  insert_teacher_images?: Maybe<Teacher_Images_Mutation_ResponseType>;
  /** insert a single row into the table: "teacher_images" */
  insert_teacher_images_one?: Maybe<Teacher_ImagesType>;
  /** insert data into the table: "teacher_levels" */
  insert_teacher_levels?: Maybe<Teacher_Levels_Mutation_ResponseType>;
  /** insert a single row into the table: "teacher_levels" */
  insert_teacher_levels_one?: Maybe<Teacher_LevelsType>;
  /** insert data into the table: "teacher_likes" */
  insert_teacher_likes?: Maybe<Teacher_Likes_Mutation_ResponseType>;
  /** insert a single row into the table: "teacher_likes" */
  insert_teacher_likes_one?: Maybe<Teacher_LikesType>;
  /** insert data into the table: "teacher_type" */
  insert_teacher_type?: Maybe<Teacher_Type_Mutation_ResponseType>;
  /** insert a single row into the table: "teacher_type" */
  insert_teacher_type_one?: Maybe<Teacher_TypeType>;
  /** insert data into the table: "teachers" */
  insert_teachers?: Maybe<Teachers_Mutation_ResponseType>;
  /** insert a single row into the table: "teachers" */
  insert_teachers_one?: Maybe<TeachersType>;
  /** insert data into the table: "user_communities" */
  insert_user_communities?: Maybe<User_Communities_Mutation_ResponseType>;
  /** insert a single row into the table: "user_communities" */
  insert_user_communities_one?: Maybe<User_CommunitiesType>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<User_Roles_Mutation_ResponseType>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<User_RolesType>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_ResponseType>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<UsersType>;
  invite: SuccessOutputType;
  login: LoginResponseType;
  loginWithRefreshToken: LoginResponseType;
  payment_intent_succeeded: Scalars['Boolean'];
  register: RegisterResponseType;
  register_as_teacher: RegisterResponseType;
  reset_password: SuccessOutputType;
  send_verification_email: SuccessOutputType;
  signup_as_teacher: SuccessOutputType;
  /** update data of the table: "acro_roles" */
  update_acro_roles?: Maybe<Acro_Roles_Mutation_ResponseType>;
  /** update single row of the table: "acro_roles" */
  update_acro_roles_by_pk?: Maybe<Acro_RolesType>;
  /** update multiples rows of table: "acro_roles" */
  update_acro_roles_many?: Maybe<Array<Maybe<Acro_Roles_Mutation_ResponseType>>>;
  /** update data of the table: "booking_option" */
  update_booking_option?: Maybe<Booking_Option_Mutation_ResponseType>;
  /** update single row of the table: "booking_option" */
  update_booking_option_by_pk?: Maybe<Booking_OptionType>;
  /** update multiples rows of table: "booking_option" */
  update_booking_option_many?: Maybe<Array<Maybe<Booking_Option_Mutation_ResponseType>>>;
  /** update data of the table: "class_booking_option" */
  update_class_booking_option?: Maybe<Class_Booking_Option_Mutation_ResponseType>;
  /** update single row of the table: "class_booking_option" */
  update_class_booking_option_by_pk?: Maybe<Class_Booking_OptionType>;
  /** update multiples rows of table: "class_booking_option" */
  update_class_booking_option_many?: Maybe<Array<Maybe<Class_Booking_Option_Mutation_ResponseType>>>;
  /** update data of the table: "class_event_bookings" */
  update_class_event_bookings?: Maybe<Class_Event_Bookings_Mutation_ResponseType>;
  /** update single row of the table: "class_event_bookings" */
  update_class_event_bookings_by_pk?: Maybe<Class_Event_BookingsType>;
  /** update multiples rows of table: "class_event_bookings" */
  update_class_event_bookings_many?: Maybe<Array<Maybe<Class_Event_Bookings_Mutation_ResponseType>>>;
  /** update data of the table: "class_event_bookmarks" */
  update_class_event_bookmarks?: Maybe<Class_Event_Bookmarks_Mutation_ResponseType>;
  /** update single row of the table: "class_event_bookmarks" */
  update_class_event_bookmarks_by_pk?: Maybe<Class_Event_BookmarksType>;
  /** update multiples rows of table: "class_event_bookmarks" */
  update_class_event_bookmarks_many?: Maybe<Array<Maybe<Class_Event_Bookmarks_Mutation_ResponseType>>>;
  /** update data of the table: "class_events" */
  update_class_events?: Maybe<Class_Events_Mutation_ResponseType>;
  /** update single row of the table: "class_events" */
  update_class_events_by_pk?: Maybe<Class_EventsType>;
  /** update multiples rows of table: "class_events" */
  update_class_events_many?: Maybe<Array<Maybe<Class_Events_Mutation_ResponseType>>>;
  /** update data of the table: "class_events_participants" */
  update_class_events_participants?: Maybe<Class_Events_Participants_Mutation_ResponseType>;
  /** update single row of the table: "class_events_participants" */
  update_class_events_participants_by_pk?: Maybe<Class_Events_ParticipantsType>;
  /** update multiples rows of table: "class_events_participants" */
  update_class_events_participants_many?: Maybe<Array<Maybe<Class_Events_Participants_Mutation_ResponseType>>>;
  /** update data of the table: "class_favorites" */
  update_class_favorites?: Maybe<Class_Favorites_Mutation_ResponseType>;
  /** update single row of the table: "class_favorites" */
  update_class_favorites_by_pk?: Maybe<Class_FavoritesType>;
  /** update multiples rows of table: "class_favorites" */
  update_class_favorites_many?: Maybe<Array<Maybe<Class_Favorites_Mutation_ResponseType>>>;
  /** update data of the table: "class_flag" */
  update_class_flag?: Maybe<Class_Flag_Mutation_ResponseType>;
  /** update single row of the table: "class_flag" */
  update_class_flag_by_pk?: Maybe<Class_FlagType>;
  /** update multiples rows of table: "class_flag" */
  update_class_flag_many?: Maybe<Array<Maybe<Class_Flag_Mutation_ResponseType>>>;
  /** update data of the table: "class_levels" */
  update_class_levels?: Maybe<Class_Levels_Mutation_ResponseType>;
  /** update single row of the table: "class_levels" */
  update_class_levels_by_pk?: Maybe<Class_LevelsType>;
  /** update multiples rows of table: "class_levels" */
  update_class_levels_many?: Maybe<Array<Maybe<Class_Levels_Mutation_ResponseType>>>;
  /** update data of the table: "class_owners" */
  update_class_owners?: Maybe<Class_Owners_Mutation_ResponseType>;
  /** update single row of the table: "class_owners" */
  update_class_owners_by_pk?: Maybe<Class_OwnersType>;
  /** update multiples rows of table: "class_owners" */
  update_class_owners_many?: Maybe<Array<Maybe<Class_Owners_Mutation_ResponseType>>>;
  /** update data of the table: "class_teachers" */
  update_class_teachers?: Maybe<Class_Teachers_Mutation_ResponseType>;
  /** update single row of the table: "class_teachers" */
  update_class_teachers_by_pk?: Maybe<Class_TeachersType>;
  /** update multiples rows of table: "class_teachers" */
  update_class_teachers_many?: Maybe<Array<Maybe<Class_Teachers_Mutation_ResponseType>>>;
  /** update data of the table: "classes" */
  update_classes?: Maybe<Classes_Mutation_ResponseType>;
  /** update single row of the table: "classes" */
  update_classes_by_pk?: Maybe<ClassesType>;
  /** update multiples rows of table: "classes" */
  update_classes_many?: Maybe<Array<Maybe<Classes_Mutation_ResponseType>>>;
  /** update data of the table: "communities" */
  update_communities?: Maybe<Communities_Mutation_ResponseType>;
  /** update single row of the table: "communities" */
  update_communities_by_pk?: Maybe<CommunitiesType>;
  /** update multiples rows of table: "communities" */
  update_communities_many?: Maybe<Array<Maybe<Communities_Mutation_ResponseType>>>;
  /** update data of the table: "community_messages" */
  update_community_messages?: Maybe<Community_Messages_Mutation_ResponseType>;
  /** update single row of the table: "community_messages" */
  update_community_messages_by_pk?: Maybe<Community_MessagesType>;
  /** update multiples rows of table: "community_messages" */
  update_community_messages_many?: Maybe<Array<Maybe<Community_Messages_Mutation_ResponseType>>>;
  /** update data of the table: "config" */
  update_config?: Maybe<Config_Mutation_ResponseType>;
  /** update single row of the table: "config" */
  update_config_by_pk?: Maybe<ConfigType>;
  /** update multiples rows of table: "config" */
  update_config_many?: Maybe<Array<Maybe<Config_Mutation_ResponseType>>>;
  /** update data of the table: "confirmation_status" */
  update_confirmation_status?: Maybe<Confirmation_Status_Mutation_ResponseType>;
  /** update single row of the table: "confirmation_status" */
  update_confirmation_status_by_pk?: Maybe<Confirmation_StatusType>;
  /** update multiples rows of table: "confirmation_status" */
  update_confirmation_status_many?: Maybe<Array<Maybe<Confirmation_Status_Mutation_ResponseType>>>;
  /** update data of the table: "created_invites" */
  update_created_invites?: Maybe<Created_Invites_Mutation_ResponseType>;
  /** update multiples rows of table: "created_invites" */
  update_created_invites_many?: Maybe<Array<Maybe<Created_Invites_Mutation_ResponseType>>>;
  /** update data of the table: "event_bookmarks" */
  update_event_bookmarks?: Maybe<Event_Bookmarks_Mutation_ResponseType>;
  /** update single row of the table: "event_bookmarks" */
  update_event_bookmarks_by_pk?: Maybe<Event_BookmarksType>;
  /** update multiples rows of table: "event_bookmarks" */
  update_event_bookmarks_many?: Maybe<Array<Maybe<Event_Bookmarks_Mutation_ResponseType>>>;
  /** update data of the table: "event_instance" */
  update_event_instance?: Maybe<Event_Instance_Mutation_ResponseType>;
  /** update single row of the table: "event_instance" */
  update_event_instance_by_pk?: Maybe<Event_InstanceType>;
  /** update multiples rows of table: "event_instance" */
  update_event_instance_many?: Maybe<Array<Maybe<Event_Instance_Mutation_ResponseType>>>;
  /** update data of the table: "event_owners" */
  update_event_owners?: Maybe<Event_Owners_Mutation_ResponseType>;
  /** update single row of the table: "event_owners" */
  update_event_owners_by_pk?: Maybe<Event_OwnersType>;
  /** update multiples rows of table: "event_owners" */
  update_event_owners_many?: Maybe<Array<Maybe<Event_Owners_Mutation_ResponseType>>>;
  /** update data of the table: "event_source" */
  update_event_source?: Maybe<Event_Source_Mutation_ResponseType>;
  /** update single row of the table: "event_source" */
  update_event_source_by_pk?: Maybe<Event_SourceType>;
  /** update multiples rows of table: "event_source" */
  update_event_source_many?: Maybe<Array<Maybe<Event_Source_Mutation_ResponseType>>>;
  /** update data of the table: "event_teachers" */
  update_event_teachers?: Maybe<Event_Teachers_Mutation_ResponseType>;
  /** update single row of the table: "event_teachers" */
  update_event_teachers_by_pk?: Maybe<Event_TeachersType>;
  /** update multiples rows of table: "event_teachers" */
  update_event_teachers_many?: Maybe<Array<Maybe<Event_Teachers_Mutation_ResponseType>>>;
  /** update data of the table: "event_template" */
  update_event_template?: Maybe<Event_Template_Mutation_ResponseType>;
  /** update single row of the table: "event_template" */
  update_event_template_by_pk?: Maybe<Event_TemplateType>;
  /** update multiples rows of table: "event_template" */
  update_event_template_many?: Maybe<Array<Maybe<Event_Template_Mutation_ResponseType>>>;
  /** update data of the table: "event_type" */
  update_event_type?: Maybe<Event_Type_Mutation_ResponseType>;
  /** update single row of the table: "event_type" */
  update_event_type_by_pk?: Maybe<Event_TypeType>;
  /** update multiples rows of table: "event_type" */
  update_event_type_many?: Maybe<Array<Maybe<Event_Type_Mutation_ResponseType>>>;
  /** update data of the table: "event_user_participants" */
  update_event_user_participants?: Maybe<Event_User_Participants_Mutation_ResponseType>;
  /** update single row of the table: "event_user_participants" */
  update_event_user_participants_by_pk?: Maybe<Event_User_ParticipantsType>;
  /** update multiples rows of table: "event_user_participants" */
  update_event_user_participants_many?: Maybe<Array<Maybe<Event_User_Participants_Mutation_ResponseType>>>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_ResponseType>;
  /** update single row of the table: "events" */
  update_events_by_pk?: Maybe<EventsType>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_ResponseType>>>;
  /** update data of the table: "images" */
  update_images?: Maybe<Images_Mutation_ResponseType>;
  /** update single row of the table: "images" */
  update_images_by_pk?: Maybe<ImagesType>;
  /** update multiples rows of table: "images" */
  update_images_many?: Maybe<Array<Maybe<Images_Mutation_ResponseType>>>;
  /** update data of the table: "inherited.class_events_with_distance" */
  update_inherited_class_events_with_distance?: Maybe<Inherited_Class_Events_With_Distance_Mutation_ResponseType>;
  /** update multiples rows of table: "inherited.class_events_with_distance" */
  update_inherited_class_events_with_distance_many?: Maybe<Array<Maybe<Inherited_Class_Events_With_Distance_Mutation_ResponseType>>>;
  /** update data of the table: "inherited.classes_with_distance" */
  update_inherited_classes_with_distance?: Maybe<Inherited_Classes_With_Distance_Mutation_ResponseType>;
  /** update multiples rows of table: "inherited.classes_with_distance" */
  update_inherited_classes_with_distance_many?: Maybe<Array<Maybe<Inherited_Classes_With_Distance_Mutation_ResponseType>>>;
  /** update data of the table: "inherited.communities_with_distance" */
  update_inherited_communities_with_distance?: Maybe<Inherited_Communities_With_Distance_Mutation_ResponseType>;
  /** update multiples rows of table: "inherited.communities_with_distance" */
  update_inherited_communities_with_distance_many?: Maybe<Array<Maybe<Inherited_Communities_With_Distance_Mutation_ResponseType>>>;
  /** update data of the table: "inherited.jams_with_distance" */
  update_inherited_jams_with_distance?: Maybe<Inherited_Jams_With_Distance_Mutation_ResponseType>;
  /** update multiples rows of table: "inherited.jams_with_distance" */
  update_inherited_jams_with_distance_many?: Maybe<Array<Maybe<Inherited_Jams_With_Distance_Mutation_ResponseType>>>;
  /** update data of the table: "invite_entity" */
  update_invite_entity?: Maybe<Invite_Entity_Mutation_ResponseType>;
  /** update single row of the table: "invite_entity" */
  update_invite_entity_by_pk?: Maybe<Invite_EntityType>;
  /** update multiples rows of table: "invite_entity" */
  update_invite_entity_many?: Maybe<Array<Maybe<Invite_Entity_Mutation_ResponseType>>>;
  /** update data of the table: "invites" */
  update_invites?: Maybe<Invites_Mutation_ResponseType>;
  /** update single row of the table: "invites" */
  update_invites_by_pk?: Maybe<InvitesType>;
  /** update multiples rows of table: "invites" */
  update_invites_many?: Maybe<Array<Maybe<Invites_Mutation_ResponseType>>>;
  /** update data of the table: "jam_participants" */
  update_jam_participants?: Maybe<Jam_Participants_Mutation_ResponseType>;
  /** update single row of the table: "jam_participants" */
  update_jam_participants_by_pk?: Maybe<Jam_ParticipantsType>;
  /** update multiples rows of table: "jam_participants" */
  update_jam_participants_many?: Maybe<Array<Maybe<Jam_Participants_Mutation_ResponseType>>>;
  /** update data of the table: "jams" */
  update_jams?: Maybe<Jams_Mutation_ResponseType>;
  /** update single row of the table: "jams" */
  update_jams_by_pk?: Maybe<JamsType>;
  /** update multiples rows of table: "jams" */
  update_jams_many?: Maybe<Array<Maybe<Jams_Mutation_ResponseType>>>;
  /** update data of the table: "levels" */
  update_levels?: Maybe<Levels_Mutation_ResponseType>;
  /** update single row of the table: "levels" */
  update_levels_by_pk?: Maybe<LevelsType>;
  /** update multiples rows of table: "levels" */
  update_levels_many?: Maybe<Array<Maybe<Levels_Mutation_ResponseType>>>;
  /** update data of the table: "me" */
  update_me?: Maybe<Me_Mutation_ResponseType>;
  /** update multiples rows of table: "me" */
  update_me_many?: Maybe<Array<Maybe<Me_Mutation_ResponseType>>>;
  /** update data of the table: "recurring_patterns" */
  update_recurring_patterns?: Maybe<Recurring_Patterns_Mutation_ResponseType>;
  /** update single row of the table: "recurring_patterns" */
  update_recurring_patterns_by_pk?: Maybe<Recurring_PatternsType>;
  /** update multiples rows of table: "recurring_patterns" */
  update_recurring_patterns_many?: Maybe<Array<Maybe<Recurring_Patterns_Mutation_ResponseType>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_ResponseType>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<RolesType>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_ResponseType>>>;
  /** update data of the table: "teacher_images" */
  update_teacher_images?: Maybe<Teacher_Images_Mutation_ResponseType>;
  /** update single row of the table: "teacher_images" */
  update_teacher_images_by_pk?: Maybe<Teacher_ImagesType>;
  /** update multiples rows of table: "teacher_images" */
  update_teacher_images_many?: Maybe<Array<Maybe<Teacher_Images_Mutation_ResponseType>>>;
  /** update data of the table: "teacher_levels" */
  update_teacher_levels?: Maybe<Teacher_Levels_Mutation_ResponseType>;
  /** update single row of the table: "teacher_levels" */
  update_teacher_levels_by_pk?: Maybe<Teacher_LevelsType>;
  /** update multiples rows of table: "teacher_levels" */
  update_teacher_levels_many?: Maybe<Array<Maybe<Teacher_Levels_Mutation_ResponseType>>>;
  /** update data of the table: "teacher_likes" */
  update_teacher_likes?: Maybe<Teacher_Likes_Mutation_ResponseType>;
  /** update single row of the table: "teacher_likes" */
  update_teacher_likes_by_pk?: Maybe<Teacher_LikesType>;
  /** update multiples rows of table: "teacher_likes" */
  update_teacher_likes_many?: Maybe<Array<Maybe<Teacher_Likes_Mutation_ResponseType>>>;
  /** update data of the table: "teacher_type" */
  update_teacher_type?: Maybe<Teacher_Type_Mutation_ResponseType>;
  /** update single row of the table: "teacher_type" */
  update_teacher_type_by_pk?: Maybe<Teacher_TypeType>;
  /** update multiples rows of table: "teacher_type" */
  update_teacher_type_many?: Maybe<Array<Maybe<Teacher_Type_Mutation_ResponseType>>>;
  /** update data of the table: "teachers" */
  update_teachers?: Maybe<Teachers_Mutation_ResponseType>;
  /** update single row of the table: "teachers" */
  update_teachers_by_pk?: Maybe<TeachersType>;
  /** update multiples rows of table: "teachers" */
  update_teachers_many?: Maybe<Array<Maybe<Teachers_Mutation_ResponseType>>>;
  /** update data of the table: "user_communities" */
  update_user_communities?: Maybe<User_Communities_Mutation_ResponseType>;
  /** update single row of the table: "user_communities" */
  update_user_communities_by_pk?: Maybe<User_CommunitiesType>;
  /** update multiples rows of table: "user_communities" */
  update_user_communities_many?: Maybe<Array<Maybe<User_Communities_Mutation_ResponseType>>>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<User_Roles_Mutation_ResponseType>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<User_RolesType>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<User_Roles_Mutation_ResponseType>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_ResponseType>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<UsersType>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_ResponseType>>>;
  verify_email: Scalars['Boolean'];
  verify_stripe_account: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootAccept_InviteArgsType = {
  invite_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreate_Payment_SheetArgsType = {
  booking_option_id: Scalars['String'];
  class_event_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Acro_RolesArgsType = {
  where: Acro_Roles_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Acro_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Booking_OptionArgsType = {
  where: Booking_Option_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Booking_Option_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Booking_OptionArgsType = {
  where: Class_Booking_Option_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Booking_Option_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Event_BookingsArgsType = {
  where: Class_Event_Bookings_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Event_Bookings_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Event_BookmarksArgsType = {
  where: Class_Event_Bookmarks_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Event_Bookmarks_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_EventsArgsType = {
  where: Class_Events_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Events_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_Events_ParticipantsArgsType = {
  where: Class_Events_Participants_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Events_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_FavoritesArgsType = {
  where: Class_Favorites_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Favorites_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_FlagArgsType = {
  where: Class_Flag_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Flag_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_LevelsArgsType = {
  where: Class_Levels_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_OwnersArgsType = {
  where: Class_Owners_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Owners_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Class_TeachersArgsType = {
  where: Class_Teachers_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Class_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ClassesArgsType = {
  where: Classes_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Classes_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CommunitiesArgsType = {
  where: Communities_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Communities_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Community_MessagesArgsType = {
  where: Community_Messages_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Community_Messages_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ConfigArgsType = {
  where: Config_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Config_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Confirmation_StatusArgsType = {
  where: Confirmation_Status_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Confirmation_Status_By_PkArgsType = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Created_InvitesArgsType = {
  where: Created_Invites_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_BookmarksArgsType = {
  where: Event_Bookmarks_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Bookmarks_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_InstanceArgsType = {
  where: Event_Instance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Instance_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_OwnersArgsType = {
  where: Event_Owners_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Owners_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_SourceArgsType = {
  where: Event_Source_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Source_By_PkArgsType = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TeachersArgsType = {
  where: Event_Teachers_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TemplateArgsType = {
  where: Event_Template_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Template_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Event_TypeArgsType = {
  where: Event_Type_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_Type_By_PkArgsType = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Event_User_ParticipantsArgsType = {
  where: Event_User_Participants_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Event_User_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgsType = {
  where: Events_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Events_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ImagesArgsType = {
  where: Images_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Images_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Inherited_Class_Events_With_DistanceArgsType = {
  where: Inherited_Class_Events_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Inherited_Classes_With_DistanceArgsType = {
  where: Inherited_Classes_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Inherited_Communities_With_DistanceArgsType = {
  where: Inherited_Communities_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Inherited_Jams_With_DistanceArgsType = {
  where: Inherited_Jams_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Invite_EntityArgsType = {
  where: Invite_Entity_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Invite_Entity_By_PkArgsType = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_InvitesArgsType = {
  where: Invites_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Invites_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Jam_ParticipantsArgsType = {
  where: Jam_Participants_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Jam_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_JamsArgsType = {
  where: Jams_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Jams_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_LevelsArgsType = {
  where: Levels_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_MeArgsType = {
  where: Me_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Recurring_PatternsArgsType = {
  where: Recurring_Patterns_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Recurring_Patterns_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgsType = {
  where: Roles_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Teacher_ImagesArgsType = {
  where: Teacher_Images_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Teacher_Images_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Teacher_LevelsArgsType = {
  where: Teacher_Levels_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Teacher_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Teacher_LikesArgsType = {
  where: Teacher_Likes_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Teacher_Likes_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Teacher_TypeArgsType = {
  where: Teacher_Type_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Teacher_Type_By_PkArgsType = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TeachersArgsType = {
  where: Teachers_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_CommunitiesArgsType = {
  where: User_Communities_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_User_Communities_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_RolesArgsType = {
  where: User_Roles_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_User_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgsType = {
  where: Users_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgsType = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_Acro_RolesArgsType = {
  objects: Array<Acro_Roles_Insert_InputType>;
  on_conflict?: InputMaybe<Acro_Roles_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Acro_Roles_OneArgsType = {
  object: Acro_Roles_Insert_InputType;
  on_conflict?: InputMaybe<Acro_Roles_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_OptionArgsType = {
  objects: Array<Booking_Option_Insert_InputType>;
  on_conflict?: InputMaybe<Booking_Option_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Booking_Option_OneArgsType = {
  object: Booking_Option_Insert_InputType;
  on_conflict?: InputMaybe<Booking_Option_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Booking_OptionArgsType = {
  objects: Array<Class_Booking_Option_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Booking_Option_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Booking_Option_OneArgsType = {
  object: Class_Booking_Option_Insert_InputType;
  on_conflict?: InputMaybe<Class_Booking_Option_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Event_BookingsArgsType = {
  objects: Array<Class_Event_Bookings_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Event_Bookings_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Event_Bookings_OneArgsType = {
  object: Class_Event_Bookings_Insert_InputType;
  on_conflict?: InputMaybe<Class_Event_Bookings_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Event_BookmarksArgsType = {
  objects: Array<Class_Event_Bookmarks_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Event_Bookmarks_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Event_Bookmarks_OneArgsType = {
  object: Class_Event_Bookmarks_Insert_InputType;
  on_conflict?: InputMaybe<Class_Event_Bookmarks_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_EventsArgsType = {
  objects: Array<Class_Events_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Events_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Events_OneArgsType = {
  object: Class_Events_Insert_InputType;
  on_conflict?: InputMaybe<Class_Events_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Events_ParticipantsArgsType = {
  objects: Array<Class_Events_Participants_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Events_Participants_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Events_Participants_OneArgsType = {
  object: Class_Events_Participants_Insert_InputType;
  on_conflict?: InputMaybe<Class_Events_Participants_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_FavoritesArgsType = {
  objects: Array<Class_Favorites_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Favorites_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Favorites_OneArgsType = {
  object: Class_Favorites_Insert_InputType;
  on_conflict?: InputMaybe<Class_Favorites_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_FlagArgsType = {
  objects: Array<Class_Flag_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Flag_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Flag_OneArgsType = {
  object: Class_Flag_Insert_InputType;
  on_conflict?: InputMaybe<Class_Flag_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_LevelsArgsType = {
  objects: Array<Class_Levels_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Levels_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Levels_OneArgsType = {
  object: Class_Levels_Insert_InputType;
  on_conflict?: InputMaybe<Class_Levels_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_OwnersArgsType = {
  objects: Array<Class_Owners_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Owners_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Owners_OneArgsType = {
  object: Class_Owners_Insert_InputType;
  on_conflict?: InputMaybe<Class_Owners_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_TeachersArgsType = {
  objects: Array<Class_Teachers_Insert_InputType>;
  on_conflict?: InputMaybe<Class_Teachers_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Class_Teachers_OneArgsType = {
  object: Class_Teachers_Insert_InputType;
  on_conflict?: InputMaybe<Class_Teachers_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_ClassesArgsType = {
  objects: Array<Classes_Insert_InputType>;
  on_conflict?: InputMaybe<Classes_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Classes_OneArgsType = {
  object: Classes_Insert_InputType;
  on_conflict?: InputMaybe<Classes_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_CommunitiesArgsType = {
  objects: Array<Communities_Insert_InputType>;
  on_conflict?: InputMaybe<Communities_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Communities_OneArgsType = {
  object: Communities_Insert_InputType;
  on_conflict?: InputMaybe<Communities_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Community_MessagesArgsType = {
  objects: Array<Community_Messages_Insert_InputType>;
  on_conflict?: InputMaybe<Community_Messages_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Community_Messages_OneArgsType = {
  object: Community_Messages_Insert_InputType;
  on_conflict?: InputMaybe<Community_Messages_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_ConfigArgsType = {
  objects: Array<Config_Insert_InputType>;
  on_conflict?: InputMaybe<Config_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Config_OneArgsType = {
  object: Config_Insert_InputType;
  on_conflict?: InputMaybe<Config_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Confirmation_StatusArgsType = {
  objects: Array<Confirmation_Status_Insert_InputType>;
  on_conflict?: InputMaybe<Confirmation_Status_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Confirmation_Status_OneArgsType = {
  object: Confirmation_Status_Insert_InputType;
  on_conflict?: InputMaybe<Confirmation_Status_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Created_InvitesArgsType = {
  objects: Array<Created_Invites_Insert_InputType>;
};


/** mutation root */
export type Mutation_RootInsert_Created_Invites_OneArgsType = {
  object: Created_Invites_Insert_InputType;
};


/** mutation root */
export type Mutation_RootInsert_Event_BookmarksArgsType = {
  objects: Array<Event_Bookmarks_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Bookmarks_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Bookmarks_OneArgsType = {
  object: Event_Bookmarks_Insert_InputType;
  on_conflict?: InputMaybe<Event_Bookmarks_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_InstanceArgsType = {
  objects: Array<Event_Instance_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Instance_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Instance_OneArgsType = {
  object: Event_Instance_Insert_InputType;
  on_conflict?: InputMaybe<Event_Instance_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_OwnersArgsType = {
  objects: Array<Event_Owners_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Owners_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Owners_OneArgsType = {
  object: Event_Owners_Insert_InputType;
  on_conflict?: InputMaybe<Event_Owners_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_SourceArgsType = {
  objects: Array<Event_Source_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Source_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Source_OneArgsType = {
  object: Event_Source_Insert_InputType;
  on_conflict?: InputMaybe<Event_Source_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TeachersArgsType = {
  objects: Array<Event_Teachers_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Teachers_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Teachers_OneArgsType = {
  object: Event_Teachers_Insert_InputType;
  on_conflict?: InputMaybe<Event_Teachers_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TemplateArgsType = {
  objects: Array<Event_Template_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Template_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Template_OneArgsType = {
  object: Event_Template_Insert_InputType;
  on_conflict?: InputMaybe<Event_Template_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_TypeArgsType = {
  objects: Array<Event_Type_Insert_InputType>;
  on_conflict?: InputMaybe<Event_Type_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_Type_OneArgsType = {
  object: Event_Type_Insert_InputType;
  on_conflict?: InputMaybe<Event_Type_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_User_ParticipantsArgsType = {
  objects: Array<Event_User_Participants_Insert_InputType>;
  on_conflict?: InputMaybe<Event_User_Participants_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Event_User_Participants_OneArgsType = {
  object: Event_User_Participants_Insert_InputType;
  on_conflict?: InputMaybe<Event_User_Participants_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgsType = {
  objects: Array<Events_Insert_InputType>;
  on_conflict?: InputMaybe<Events_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Events_OneArgsType = {
  object: Events_Insert_InputType;
  on_conflict?: InputMaybe<Events_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_ImagesArgsType = {
  objects: Array<Images_Insert_InputType>;
  on_conflict?: InputMaybe<Images_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Images_OneArgsType = {
  object: Images_Insert_InputType;
  on_conflict?: InputMaybe<Images_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Class_Events_With_DistanceArgsType = {
  objects: Array<Inherited_Class_Events_With_Distance_Insert_InputType>;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Class_Events_With_Distance_OneArgsType = {
  object: Inherited_Class_Events_With_Distance_Insert_InputType;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Classes_With_DistanceArgsType = {
  objects: Array<Inherited_Classes_With_Distance_Insert_InputType>;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Classes_With_Distance_OneArgsType = {
  object: Inherited_Classes_With_Distance_Insert_InputType;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Communities_With_DistanceArgsType = {
  objects: Array<Inherited_Communities_With_Distance_Insert_InputType>;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Communities_With_Distance_OneArgsType = {
  object: Inherited_Communities_With_Distance_Insert_InputType;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Jams_With_DistanceArgsType = {
  objects: Array<Inherited_Jams_With_Distance_Insert_InputType>;
};


/** mutation root */
export type Mutation_RootInsert_Inherited_Jams_With_Distance_OneArgsType = {
  object: Inherited_Jams_With_Distance_Insert_InputType;
};


/** mutation root */
export type Mutation_RootInsert_Invite_EntityArgsType = {
  objects: Array<Invite_Entity_Insert_InputType>;
  on_conflict?: InputMaybe<Invite_Entity_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_Entity_OneArgsType = {
  object: Invite_Entity_Insert_InputType;
  on_conflict?: InputMaybe<Invite_Entity_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_InvitesArgsType = {
  objects: Array<Invites_Insert_InputType>;
  on_conflict?: InputMaybe<Invites_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Invites_OneArgsType = {
  object: Invites_Insert_InputType;
  on_conflict?: InputMaybe<Invites_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Jam_ParticipantsArgsType = {
  objects: Array<Jam_Participants_Insert_InputType>;
  on_conflict?: InputMaybe<Jam_Participants_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Jam_Participants_OneArgsType = {
  object: Jam_Participants_Insert_InputType;
  on_conflict?: InputMaybe<Jam_Participants_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_JamsArgsType = {
  objects: Array<Jams_Insert_InputType>;
  on_conflict?: InputMaybe<Jams_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Jams_OneArgsType = {
  object: Jams_Insert_InputType;
  on_conflict?: InputMaybe<Jams_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_LevelsArgsType = {
  objects: Array<Levels_Insert_InputType>;
  on_conflict?: InputMaybe<Levels_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Levels_OneArgsType = {
  object: Levels_Insert_InputType;
  on_conflict?: InputMaybe<Levels_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_MeArgsType = {
  objects: Array<Me_Insert_InputType>;
};


/** mutation root */
export type Mutation_RootInsert_Me_OneArgsType = {
  object: Me_Insert_InputType;
};


/** mutation root */
export type Mutation_RootInsert_Recurring_PatternsArgsType = {
  objects: Array<Recurring_Patterns_Insert_InputType>;
  on_conflict?: InputMaybe<Recurring_Patterns_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Recurring_Patterns_OneArgsType = {
  object: Recurring_Patterns_Insert_InputType;
  on_conflict?: InputMaybe<Recurring_Patterns_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgsType = {
  objects: Array<Roles_Insert_InputType>;
  on_conflict?: InputMaybe<Roles_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgsType = {
  object: Roles_Insert_InputType;
  on_conflict?: InputMaybe<Roles_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_ImagesArgsType = {
  objects: Array<Teacher_Images_Insert_InputType>;
  on_conflict?: InputMaybe<Teacher_Images_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_Images_OneArgsType = {
  object: Teacher_Images_Insert_InputType;
  on_conflict?: InputMaybe<Teacher_Images_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_LevelsArgsType = {
  objects: Array<Teacher_Levels_Insert_InputType>;
  on_conflict?: InputMaybe<Teacher_Levels_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_Levels_OneArgsType = {
  object: Teacher_Levels_Insert_InputType;
  on_conflict?: InputMaybe<Teacher_Levels_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_LikesArgsType = {
  objects: Array<Teacher_Likes_Insert_InputType>;
  on_conflict?: InputMaybe<Teacher_Likes_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_Likes_OneArgsType = {
  object: Teacher_Likes_Insert_InputType;
  on_conflict?: InputMaybe<Teacher_Likes_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_TypeArgsType = {
  objects: Array<Teacher_Type_Insert_InputType>;
  on_conflict?: InputMaybe<Teacher_Type_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teacher_Type_OneArgsType = {
  object: Teacher_Type_Insert_InputType;
  on_conflict?: InputMaybe<Teacher_Type_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_TeachersArgsType = {
  objects: Array<Teachers_Insert_InputType>;
  on_conflict?: InputMaybe<Teachers_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Teachers_OneArgsType = {
  object: Teachers_Insert_InputType;
  on_conflict?: InputMaybe<Teachers_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_User_CommunitiesArgsType = {
  objects: Array<User_Communities_Insert_InputType>;
  on_conflict?: InputMaybe<User_Communities_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_User_Communities_OneArgsType = {
  object: User_Communities_Insert_InputType;
  on_conflict?: InputMaybe<User_Communities_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_User_RolesArgsType = {
  objects: Array<User_Roles_Insert_InputType>;
  on_conflict?: InputMaybe<User_Roles_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_User_Roles_OneArgsType = {
  object: User_Roles_Insert_InputType;
  on_conflict?: InputMaybe<User_Roles_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgsType = {
  objects: Array<Users_Insert_InputType>;
  on_conflict?: InputMaybe<Users_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgsType = {
  object: Users_Insert_InputType;
  on_conflict?: InputMaybe<Users_On_ConflictType>;
};


/** mutation root */
export type Mutation_RootInviteArgsType = {
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootLoginArgsType = {
  input: LoginInputType;
};


/** mutation root */
export type Mutation_RootLoginWithRefreshTokenArgsType = {
  input: LoginWithRefreshTokenInputType;
};


/** mutation root */
export type Mutation_RootPayment_Intent_SucceededArgsType = {
  payment_intent_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRegisterArgsType = {
  input: RegisterInputType;
};


/** mutation root */
export type Mutation_RootRegister_As_TeacherArgsType = {
  input: RegisterInputType;
};


/** mutation root */
export type Mutation_RootReset_PasswordArgsType = {
  input: ResetPasswordInputType;
};


/** mutation root */
export type Mutation_RootUpdate_Acro_RolesArgsType = {
  _set?: InputMaybe<Acro_Roles_Set_InputType>;
  where: Acro_Roles_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Acro_Roles_By_PkArgsType = {
  _set?: InputMaybe<Acro_Roles_Set_InputType>;
  pk_columns: Acro_Roles_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Acro_Roles_ManyArgsType = {
  updates: Array<Acro_Roles_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_OptionArgsType = {
  _inc?: InputMaybe<Booking_Option_Inc_InputType>;
  _set?: InputMaybe<Booking_Option_Set_InputType>;
  where: Booking_Option_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Option_By_PkArgsType = {
  _inc?: InputMaybe<Booking_Option_Inc_InputType>;
  _set?: InputMaybe<Booking_Option_Set_InputType>;
  pk_columns: Booking_Option_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Booking_Option_ManyArgsType = {
  updates: Array<Booking_Option_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Booking_OptionArgsType = {
  _set?: InputMaybe<Class_Booking_Option_Set_InputType>;
  where: Class_Booking_Option_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Booking_Option_By_PkArgsType = {
  _set?: InputMaybe<Class_Booking_Option_Set_InputType>;
  pk_columns: Class_Booking_Option_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Booking_Option_ManyArgsType = {
  updates: Array<Class_Booking_Option_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Event_BookingsArgsType = {
  _inc?: InputMaybe<Class_Event_Bookings_Inc_InputType>;
  _set?: InputMaybe<Class_Event_Bookings_Set_InputType>;
  where: Class_Event_Bookings_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Event_Bookings_By_PkArgsType = {
  _inc?: InputMaybe<Class_Event_Bookings_Inc_InputType>;
  _set?: InputMaybe<Class_Event_Bookings_Set_InputType>;
  pk_columns: Class_Event_Bookings_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Event_Bookings_ManyArgsType = {
  updates: Array<Class_Event_Bookings_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Event_BookmarksArgsType = {
  _set?: InputMaybe<Class_Event_Bookmarks_Set_InputType>;
  where: Class_Event_Bookmarks_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Event_Bookmarks_By_PkArgsType = {
  _set?: InputMaybe<Class_Event_Bookmarks_Set_InputType>;
  pk_columns: Class_Event_Bookmarks_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Event_Bookmarks_ManyArgsType = {
  updates: Array<Class_Event_Bookmarks_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_EventsArgsType = {
  _inc?: InputMaybe<Class_Events_Inc_InputType>;
  _set?: InputMaybe<Class_Events_Set_InputType>;
  where: Class_Events_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Events_By_PkArgsType = {
  _inc?: InputMaybe<Class_Events_Inc_InputType>;
  _set?: InputMaybe<Class_Events_Set_InputType>;
  pk_columns: Class_Events_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Events_ManyArgsType = {
  updates: Array<Class_Events_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Events_ParticipantsArgsType = {
  _set?: InputMaybe<Class_Events_Participants_Set_InputType>;
  where: Class_Events_Participants_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Events_Participants_By_PkArgsType = {
  _set?: InputMaybe<Class_Events_Participants_Set_InputType>;
  pk_columns: Class_Events_Participants_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Events_Participants_ManyArgsType = {
  updates: Array<Class_Events_Participants_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_FavoritesArgsType = {
  _set?: InputMaybe<Class_Favorites_Set_InputType>;
  where: Class_Favorites_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Favorites_By_PkArgsType = {
  _set?: InputMaybe<Class_Favorites_Set_InputType>;
  pk_columns: Class_Favorites_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Favorites_ManyArgsType = {
  updates: Array<Class_Favorites_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_FlagArgsType = {
  _set?: InputMaybe<Class_Flag_Set_InputType>;
  where: Class_Flag_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Flag_By_PkArgsType = {
  _set?: InputMaybe<Class_Flag_Set_InputType>;
  pk_columns: Class_Flag_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Flag_ManyArgsType = {
  updates: Array<Class_Flag_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_LevelsArgsType = {
  _set?: InputMaybe<Class_Levels_Set_InputType>;
  where: Class_Levels_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Levels_By_PkArgsType = {
  _set?: InputMaybe<Class_Levels_Set_InputType>;
  pk_columns: Class_Levels_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Levels_ManyArgsType = {
  updates: Array<Class_Levels_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_OwnersArgsType = {
  _set?: InputMaybe<Class_Owners_Set_InputType>;
  where: Class_Owners_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Owners_By_PkArgsType = {
  _set?: InputMaybe<Class_Owners_Set_InputType>;
  pk_columns: Class_Owners_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Owners_ManyArgsType = {
  updates: Array<Class_Owners_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Class_TeachersArgsType = {
  _set?: InputMaybe<Class_Teachers_Set_InputType>;
  where: Class_Teachers_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Teachers_By_PkArgsType = {
  _set?: InputMaybe<Class_Teachers_Set_InputType>;
  pk_columns: Class_Teachers_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Class_Teachers_ManyArgsType = {
  updates: Array<Class_Teachers_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_ClassesArgsType = {
  _inc?: InputMaybe<Classes_Inc_InputType>;
  _set?: InputMaybe<Classes_Set_InputType>;
  where: Classes_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Classes_By_PkArgsType = {
  _inc?: InputMaybe<Classes_Inc_InputType>;
  _set?: InputMaybe<Classes_Set_InputType>;
  pk_columns: Classes_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Classes_ManyArgsType = {
  updates: Array<Classes_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_CommunitiesArgsType = {
  _inc?: InputMaybe<Communities_Inc_InputType>;
  _set?: InputMaybe<Communities_Set_InputType>;
  where: Communities_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Communities_By_PkArgsType = {
  _inc?: InputMaybe<Communities_Inc_InputType>;
  _set?: InputMaybe<Communities_Set_InputType>;
  pk_columns: Communities_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Communities_ManyArgsType = {
  updates: Array<Communities_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Community_MessagesArgsType = {
  _set?: InputMaybe<Community_Messages_Set_InputType>;
  where: Community_Messages_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Community_Messages_By_PkArgsType = {
  _set?: InputMaybe<Community_Messages_Set_InputType>;
  pk_columns: Community_Messages_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Community_Messages_ManyArgsType = {
  updates: Array<Community_Messages_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_ConfigArgsType = {
  _set?: InputMaybe<Config_Set_InputType>;
  where: Config_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Config_By_PkArgsType = {
  _set?: InputMaybe<Config_Set_InputType>;
  pk_columns: Config_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Config_ManyArgsType = {
  updates: Array<Config_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Confirmation_StatusArgsType = {
  _set?: InputMaybe<Confirmation_Status_Set_InputType>;
  where: Confirmation_Status_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Confirmation_Status_By_PkArgsType = {
  _set?: InputMaybe<Confirmation_Status_Set_InputType>;
  pk_columns: Confirmation_Status_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Confirmation_Status_ManyArgsType = {
  updates: Array<Confirmation_Status_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Created_InvitesArgsType = {
  _set?: InputMaybe<Created_Invites_Set_InputType>;
  where: Created_Invites_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Created_Invites_ManyArgsType = {
  updates: Array<Created_Invites_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_BookmarksArgsType = {
  _set?: InputMaybe<Event_Bookmarks_Set_InputType>;
  where: Event_Bookmarks_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Bookmarks_By_PkArgsType = {
  _set?: InputMaybe<Event_Bookmarks_Set_InputType>;
  pk_columns: Event_Bookmarks_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Bookmarks_ManyArgsType = {
  updates: Array<Event_Bookmarks_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_InstanceArgsType = {
  _set?: InputMaybe<Event_Instance_Set_InputType>;
  where: Event_Instance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Instance_By_PkArgsType = {
  _set?: InputMaybe<Event_Instance_Set_InputType>;
  pk_columns: Event_Instance_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Instance_ManyArgsType = {
  updates: Array<Event_Instance_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_OwnersArgsType = {
  _set?: InputMaybe<Event_Owners_Set_InputType>;
  where: Event_Owners_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Owners_By_PkArgsType = {
  _set?: InputMaybe<Event_Owners_Set_InputType>;
  pk_columns: Event_Owners_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Owners_ManyArgsType = {
  updates: Array<Event_Owners_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_SourceArgsType = {
  _set?: InputMaybe<Event_Source_Set_InputType>;
  where: Event_Source_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Source_By_PkArgsType = {
  _set?: InputMaybe<Event_Source_Set_InputType>;
  pk_columns: Event_Source_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Source_ManyArgsType = {
  updates: Array<Event_Source_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TeachersArgsType = {
  _set?: InputMaybe<Event_Teachers_Set_InputType>;
  where: Event_Teachers_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Teachers_By_PkArgsType = {
  _set?: InputMaybe<Event_Teachers_Set_InputType>;
  pk_columns: Event_Teachers_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Teachers_ManyArgsType = {
  updates: Array<Event_Teachers_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TemplateArgsType = {
  _set?: InputMaybe<Event_Template_Set_InputType>;
  where: Event_Template_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Template_By_PkArgsType = {
  _set?: InputMaybe<Event_Template_Set_InputType>;
  pk_columns: Event_Template_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Template_ManyArgsType = {
  updates: Array<Event_Template_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_TypeArgsType = {
  _set?: InputMaybe<Event_Type_Set_InputType>;
  where: Event_Type_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Type_By_PkArgsType = {
  _set?: InputMaybe<Event_Type_Set_InputType>;
  pk_columns: Event_Type_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_Type_ManyArgsType = {
  updates: Array<Event_Type_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Event_User_ParticipantsArgsType = {
  _set?: InputMaybe<Event_User_Participants_Set_InputType>;
  where: Event_User_Participants_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_User_Participants_By_PkArgsType = {
  _set?: InputMaybe<Event_User_Participants_Set_InputType>;
  pk_columns: Event_User_Participants_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Event_User_Participants_ManyArgsType = {
  updates: Array<Event_User_Participants_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgsType = {
  _inc?: InputMaybe<Events_Inc_InputType>;
  _set?: InputMaybe<Events_Set_InputType>;
  where: Events_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Events_By_PkArgsType = {
  _inc?: InputMaybe<Events_Inc_InputType>;
  _set?: InputMaybe<Events_Set_InputType>;
  pk_columns: Events_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgsType = {
  updates: Array<Events_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_ImagesArgsType = {
  _set?: InputMaybe<Images_Set_InputType>;
  where: Images_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Images_By_PkArgsType = {
  _set?: InputMaybe<Images_Set_InputType>;
  pk_columns: Images_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Images_ManyArgsType = {
  updates: Array<Images_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Class_Events_With_DistanceArgsType = {
  _inc?: InputMaybe<Inherited_Class_Events_With_Distance_Inc_InputType>;
  _set?: InputMaybe<Inherited_Class_Events_With_Distance_Set_InputType>;
  where: Inherited_Class_Events_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Class_Events_With_Distance_ManyArgsType = {
  updates: Array<Inherited_Class_Events_With_Distance_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Classes_With_DistanceArgsType = {
  _inc?: InputMaybe<Inherited_Classes_With_Distance_Inc_InputType>;
  _set?: InputMaybe<Inherited_Classes_With_Distance_Set_InputType>;
  where: Inherited_Classes_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Classes_With_Distance_ManyArgsType = {
  updates: Array<Inherited_Classes_With_Distance_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Communities_With_DistanceArgsType = {
  _inc?: InputMaybe<Inherited_Communities_With_Distance_Inc_InputType>;
  _set?: InputMaybe<Inherited_Communities_With_Distance_Set_InputType>;
  where: Inherited_Communities_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Communities_With_Distance_ManyArgsType = {
  updates: Array<Inherited_Communities_With_Distance_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Jams_With_DistanceArgsType = {
  _inc?: InputMaybe<Inherited_Jams_With_Distance_Inc_InputType>;
  _set?: InputMaybe<Inherited_Jams_With_Distance_Set_InputType>;
  where: Inherited_Jams_With_Distance_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Inherited_Jams_With_Distance_ManyArgsType = {
  updates: Array<Inherited_Jams_With_Distance_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_EntityArgsType = {
  _set?: InputMaybe<Invite_Entity_Set_InputType>;
  where: Invite_Entity_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Entity_By_PkArgsType = {
  _set?: InputMaybe<Invite_Entity_Set_InputType>;
  pk_columns: Invite_Entity_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Entity_ManyArgsType = {
  updates: Array<Invite_Entity_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitesArgsType = {
  _set?: InputMaybe<Invites_Set_InputType>;
  where: Invites_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Invites_By_PkArgsType = {
  _set?: InputMaybe<Invites_Set_InputType>;
  pk_columns: Invites_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Invites_ManyArgsType = {
  updates: Array<Invites_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Jam_ParticipantsArgsType = {
  _set?: InputMaybe<Jam_Participants_Set_InputType>;
  where: Jam_Participants_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Jam_Participants_By_PkArgsType = {
  _set?: InputMaybe<Jam_Participants_Set_InputType>;
  pk_columns: Jam_Participants_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Jam_Participants_ManyArgsType = {
  updates: Array<Jam_Participants_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_JamsArgsType = {
  _inc?: InputMaybe<Jams_Inc_InputType>;
  _set?: InputMaybe<Jams_Set_InputType>;
  where: Jams_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Jams_By_PkArgsType = {
  _inc?: InputMaybe<Jams_Inc_InputType>;
  _set?: InputMaybe<Jams_Set_InputType>;
  pk_columns: Jams_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Jams_ManyArgsType = {
  updates: Array<Jams_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_LevelsArgsType = {
  _set?: InputMaybe<Levels_Set_InputType>;
  where: Levels_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Levels_By_PkArgsType = {
  _set?: InputMaybe<Levels_Set_InputType>;
  pk_columns: Levels_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Levels_ManyArgsType = {
  updates: Array<Levels_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_MeArgsType = {
  _set?: InputMaybe<Me_Set_InputType>;
  where: Me_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Me_ManyArgsType = {
  updates: Array<Me_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Recurring_PatternsArgsType = {
  _inc?: InputMaybe<Recurring_Patterns_Inc_InputType>;
  _set?: InputMaybe<Recurring_Patterns_Set_InputType>;
  where: Recurring_Patterns_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Recurring_Patterns_By_PkArgsType = {
  _inc?: InputMaybe<Recurring_Patterns_Inc_InputType>;
  _set?: InputMaybe<Recurring_Patterns_Set_InputType>;
  pk_columns: Recurring_Patterns_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Recurring_Patterns_ManyArgsType = {
  updates: Array<Recurring_Patterns_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgsType = {
  _set?: InputMaybe<Roles_Set_InputType>;
  where: Roles_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgsType = {
  _set?: InputMaybe<Roles_Set_InputType>;
  pk_columns: Roles_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgsType = {
  updates: Array<Roles_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_ImagesArgsType = {
  _set?: InputMaybe<Teacher_Images_Set_InputType>;
  where: Teacher_Images_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Images_By_PkArgsType = {
  _set?: InputMaybe<Teacher_Images_Set_InputType>;
  pk_columns: Teacher_Images_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Images_ManyArgsType = {
  updates: Array<Teacher_Images_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_LevelsArgsType = {
  _set?: InputMaybe<Teacher_Levels_Set_InputType>;
  where: Teacher_Levels_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Levels_By_PkArgsType = {
  _set?: InputMaybe<Teacher_Levels_Set_InputType>;
  pk_columns: Teacher_Levels_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Levels_ManyArgsType = {
  updates: Array<Teacher_Levels_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_LikesArgsType = {
  _set?: InputMaybe<Teacher_Likes_Set_InputType>;
  where: Teacher_Likes_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Likes_By_PkArgsType = {
  _set?: InputMaybe<Teacher_Likes_Set_InputType>;
  pk_columns: Teacher_Likes_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Likes_ManyArgsType = {
  updates: Array<Teacher_Likes_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_TypeArgsType = {
  _set?: InputMaybe<Teacher_Type_Set_InputType>;
  where: Teacher_Type_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Type_By_PkArgsType = {
  _set?: InputMaybe<Teacher_Type_Set_InputType>;
  pk_columns: Teacher_Type_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Teacher_Type_ManyArgsType = {
  updates: Array<Teacher_Type_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_TeachersArgsType = {
  _set?: InputMaybe<Teachers_Set_InputType>;
  where: Teachers_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_By_PkArgsType = {
  _set?: InputMaybe<Teachers_Set_InputType>;
  pk_columns: Teachers_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Teachers_ManyArgsType = {
  updates: Array<Teachers_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_User_CommunitiesArgsType = {
  _set?: InputMaybe<User_Communities_Set_InputType>;
  where: User_Communities_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communities_By_PkArgsType = {
  _set?: InputMaybe<User_Communities_Set_InputType>;
  pk_columns: User_Communities_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_User_Communities_ManyArgsType = {
  updates: Array<User_Communities_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RolesArgsType = {
  _set?: InputMaybe<User_Roles_Set_InputType>;
  where: User_Roles_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_By_PkArgsType = {
  _set?: InputMaybe<User_Roles_Set_InputType>;
  pk_columns: User_Roles_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_ManyArgsType = {
  updates: Array<User_Roles_UpdatesType>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgsType = {
  _set?: InputMaybe<Users_Set_InputType>;
  where: Users_Bool_ExpType;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgsType = {
  _set?: InputMaybe<Users_Set_InputType>;
  pk_columns: Users_Pk_Columns_InputType;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgsType = {
  updates: Array<Users_UpdatesType>;
};


/** mutation root */
export type Mutation_RootVerify_EmailArgsType = {
  code: Scalars['String'];
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_ByType {
  /** in ascending order, nulls last */
  AscType = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirstType = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLastType = 'asc_nulls_last',
  /** in descending order, nulls first */
  DescType = 'desc',
  /** in descending order, nulls first */
  DescNullsFirstType = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLastType = 'desc_nulls_last'
}

export type Query_RootType = {
  __typename?: 'query_root';
  /** fetch data from the table: "acro_roles" */
  acro_roles: Array<Acro_RolesType>;
  /** fetch aggregated fields from the table: "acro_roles" */
  acro_roles_aggregate: Acro_Roles_AggregateType;
  /** fetch data from the table: "acro_roles" using primary key columns */
  acro_roles_by_pk?: Maybe<Acro_RolesType>;
  /** fetch data from the table: "booking_option" */
  booking_option: Array<Booking_OptionType>;
  /** fetch aggregated fields from the table: "booking_option" */
  booking_option_aggregate: Booking_Option_AggregateType;
  /** fetch data from the table: "booking_option" using primary key columns */
  booking_option_by_pk?: Maybe<Booking_OptionType>;
  /** fetch data from the table: "class_booking_option" */
  class_booking_option: Array<Class_Booking_OptionType>;
  /** fetch aggregated fields from the table: "class_booking_option" */
  class_booking_option_aggregate: Class_Booking_Option_AggregateType;
  /** fetch data from the table: "class_booking_option" using primary key columns */
  class_booking_option_by_pk?: Maybe<Class_Booking_OptionType>;
  /** fetch data from the table: "class_event_bookings" */
  class_event_bookings: Array<Class_Event_BookingsType>;
  /** fetch aggregated fields from the table: "class_event_bookings" */
  class_event_bookings_aggregate: Class_Event_Bookings_AggregateType;
  /** fetch data from the table: "class_event_bookings" using primary key columns */
  class_event_bookings_by_pk?: Maybe<Class_Event_BookingsType>;
  /** An array relationship */
  class_event_bookmarks: Array<Class_Event_BookmarksType>;
  /** An aggregate relationship */
  class_event_bookmarks_aggregate: Class_Event_Bookmarks_AggregateType;
  /** fetch data from the table: "class_event_bookmarks" using primary key columns */
  class_event_bookmarks_by_pk?: Maybe<Class_Event_BookmarksType>;
  /** An array relationship */
  class_events: Array<Class_EventsType>;
  /** An aggregate relationship */
  class_events_aggregate: Class_Events_AggregateType;
  /** execute function "class_events_by_location_v1" which returns "inherited.class_events_with_distance" */
  class_events_by_location_v1: Array<Inherited_Class_Events_With_DistanceType>;
  /** execute function "class_events_by_location_v1" and query aggregates on result of table type "inherited.class_events_with_distance" */
  class_events_by_location_v1_aggregate: Inherited_Class_Events_With_Distance_AggregateType;
  /** fetch data from the table: "class_events" using primary key columns */
  class_events_by_pk?: Maybe<Class_EventsType>;
  /** fetch data from the table: "class_events_participants" */
  class_events_participants: Array<Class_Events_ParticipantsType>;
  /** fetch aggregated fields from the table: "class_events_participants" */
  class_events_participants_aggregate: Class_Events_Participants_AggregateType;
  /** fetch data from the table: "class_events_participants" using primary key columns */
  class_events_participants_by_pk?: Maybe<Class_Events_ParticipantsType>;
  /** fetch data from the table: "class_favorites" */
  class_favorites: Array<Class_FavoritesType>;
  /** fetch aggregated fields from the table: "class_favorites" */
  class_favorites_aggregate: Class_Favorites_AggregateType;
  /** fetch data from the table: "class_favorites" using primary key columns */
  class_favorites_by_pk?: Maybe<Class_FavoritesType>;
  /** fetch data from the table: "class_flag" */
  class_flag: Array<Class_FlagType>;
  /** fetch aggregated fields from the table: "class_flag" */
  class_flag_aggregate: Class_Flag_AggregateType;
  /** fetch data from the table: "class_flag" using primary key columns */
  class_flag_by_pk?: Maybe<Class_FlagType>;
  /** An array relationship */
  class_levels: Array<Class_LevelsType>;
  /** An aggregate relationship */
  class_levels_aggregate: Class_Levels_AggregateType;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: Maybe<Class_LevelsType>;
  /** An array relationship */
  class_owners: Array<Class_OwnersType>;
  /** An aggregate relationship */
  class_owners_aggregate: Class_Owners_AggregateType;
  /** fetch data from the table: "class_owners" using primary key columns */
  class_owners_by_pk?: Maybe<Class_OwnersType>;
  /** An array relationship */
  class_teachers: Array<Class_TeachersType>;
  /** An aggregate relationship */
  class_teachers_aggregate: Class_Teachers_AggregateType;
  /** fetch data from the table: "class_teachers" using primary key columns */
  class_teachers_by_pk?: Maybe<Class_TeachersType>;
  /** An array relationship */
  classes: Array<ClassesType>;
  /** An aggregate relationship */
  classes_aggregate: Classes_AggregateType;
  /** execute function "classes_by_location_v1" which returns "inherited.classes_with_distance" */
  classes_by_location_v1: Array<Inherited_Classes_With_DistanceType>;
  /** execute function "classes_by_location_v1" and query aggregates on result of table type "inherited.classes_with_distance" */
  classes_by_location_v1_aggregate: Inherited_Classes_With_Distance_AggregateType;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: Maybe<ClassesType>;
  /** fetch data from the table: "communities" */
  communities: Array<CommunitiesType>;
  /** fetch aggregated fields from the table: "communities" */
  communities_aggregate: Communities_AggregateType;
  /** execute function "communities_by_location_v1" which returns "inherited.communities_with_distance" */
  communities_by_location_v1: Array<Inherited_Communities_With_DistanceType>;
  /** execute function "communities_by_location_v1" and query aggregates on result of table type "inherited.communities_with_distance" */
  communities_by_location_v1_aggregate: Inherited_Communities_With_Distance_AggregateType;
  /** fetch data from the table: "communities" using primary key columns */
  communities_by_pk?: Maybe<CommunitiesType>;
  /** An array relationship */
  community_messages: Array<Community_MessagesType>;
  /** An aggregate relationship */
  community_messages_aggregate: Community_Messages_AggregateType;
  /** fetch data from the table: "community_messages" using primary key columns */
  community_messages_by_pk?: Maybe<Community_MessagesType>;
  /** fetch data from the table: "config" */
  config: Array<ConfigType>;
  /** fetch aggregated fields from the table: "config" */
  config_aggregate: Config_AggregateType;
  /** fetch data from the table: "config" using primary key columns */
  config_by_pk?: Maybe<ConfigType>;
  /** fetch data from the table: "confirmation_status" */
  confirmation_status: Array<Confirmation_StatusType>;
  /** fetch aggregated fields from the table: "confirmation_status" */
  confirmation_status_aggregate: Confirmation_Status_AggregateType;
  /** fetch data from the table: "confirmation_status" using primary key columns */
  confirmation_status_by_pk?: Maybe<Confirmation_StatusType>;
  /** fetch data from the table: "created_invites" */
  created_invites: Array<Created_InvitesType>;
  /** fetch aggregated fields from the table: "created_invites" */
  created_invites_aggregate: Created_Invites_AggregateType;
  /** fetch data from the table: "event_bookmarks" */
  event_bookmarks: Array<Event_BookmarksType>;
  /** fetch aggregated fields from the table: "event_bookmarks" */
  event_bookmarks_aggregate: Event_Bookmarks_AggregateType;
  /** fetch data from the table: "event_bookmarks" using primary key columns */
  event_bookmarks_by_pk?: Maybe<Event_BookmarksType>;
  /** fetch data from the table: "event_instance" */
  event_instance: Array<Event_InstanceType>;
  /** fetch aggregated fields from the table: "event_instance" */
  event_instance_aggregate: Event_Instance_AggregateType;
  /** fetch data from the table: "event_instance" using primary key columns */
  event_instance_by_pk?: Maybe<Event_InstanceType>;
  /** fetch data from the table: "event_owners" */
  event_owners: Array<Event_OwnersType>;
  /** fetch aggregated fields from the table: "event_owners" */
  event_owners_aggregate: Event_Owners_AggregateType;
  /** fetch data from the table: "event_owners" using primary key columns */
  event_owners_by_pk?: Maybe<Event_OwnersType>;
  /** fetch data from the table: "event_source" */
  event_source: Array<Event_SourceType>;
  /** fetch aggregated fields from the table: "event_source" */
  event_source_aggregate: Event_Source_AggregateType;
  /** fetch data from the table: "event_source" using primary key columns */
  event_source_by_pk?: Maybe<Event_SourceType>;
  /** fetch data from the table: "event_teachers" */
  event_teachers: Array<Event_TeachersType>;
  /** fetch aggregated fields from the table: "event_teachers" */
  event_teachers_aggregate: Event_Teachers_AggregateType;
  /** fetch data from the table: "event_teachers" using primary key columns */
  event_teachers_by_pk?: Maybe<Event_TeachersType>;
  /** fetch data from the table: "event_template" */
  event_template: Array<Event_TemplateType>;
  /** fetch aggregated fields from the table: "event_template" */
  event_template_aggregate: Event_Template_AggregateType;
  /** fetch data from the table: "event_template" using primary key columns */
  event_template_by_pk?: Maybe<Event_TemplateType>;
  /** fetch data from the table: "event_type" */
  event_type: Array<Event_TypeType>;
  /** fetch aggregated fields from the table: "event_type" */
  event_type_aggregate: Event_Type_AggregateType;
  /** fetch data from the table: "event_type" using primary key columns */
  event_type_by_pk?: Maybe<Event_TypeType>;
  /** fetch data from the table: "event_user_participants" */
  event_user_participants: Array<Event_User_ParticipantsType>;
  /** fetch aggregated fields from the table: "event_user_participants" */
  event_user_participants_aggregate: Event_User_Participants_AggregateType;
  /** fetch data from the table: "event_user_participants" using primary key columns */
  event_user_participants_by_pk?: Maybe<Event_User_ParticipantsType>;
  /** fetch data from the table: "events" */
  events: Array<EventsType>;
  /** fetch aggregated fields from the table: "events" */
  events_aggregate: Events_AggregateType;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<EventsType>;
  get_all_invites: Array<InviteType>;
  get_class_slug_suggestion: Scalars['String'];
  get_event_slug_suggestion: Scalars['String'];
  get_teacher_slug_suggestion: Scalars['String'];
  /** fetch data from the table: "images" */
  images: Array<ImagesType>;
  /** fetch aggregated fields from the table: "images" */
  images_aggregate: Images_AggregateType;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<ImagesType>;
  /** fetch data from the table: "inherited.class_events_with_distance" */
  inherited_class_events_with_distance: Array<Inherited_Class_Events_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.class_events_with_distance" */
  inherited_class_events_with_distance_aggregate: Inherited_Class_Events_With_Distance_AggregateType;
  /** fetch data from the table: "inherited.classes_with_distance" */
  inherited_classes_with_distance: Array<Inherited_Classes_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.classes_with_distance" */
  inherited_classes_with_distance_aggregate: Inherited_Classes_With_Distance_AggregateType;
  /** fetch data from the table: "inherited.communities_with_distance" */
  inherited_communities_with_distance: Array<Inherited_Communities_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.communities_with_distance" */
  inherited_communities_with_distance_aggregate: Inherited_Communities_With_Distance_AggregateType;
  /** fetch data from the table: "inherited.jams_with_distance" */
  inherited_jams_with_distance: Array<Inherited_Jams_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.jams_with_distance" */
  inherited_jams_with_distance_aggregate: Inherited_Jams_With_Distance_AggregateType;
  invite_by_id: InviteType;
  /** fetch data from the table: "invite_entity" */
  invite_entity: Array<Invite_EntityType>;
  /** fetch aggregated fields from the table: "invite_entity" */
  invite_entity_aggregate: Invite_Entity_AggregateType;
  /** fetch data from the table: "invite_entity" using primary key columns */
  invite_entity_by_pk?: Maybe<Invite_EntityType>;
  /** An array relationship */
  invites: Array<InvitesType>;
  /** An aggregate relationship */
  invites_aggregate: Invites_AggregateType;
  /** fetch data from the table: "invites" using primary key columns */
  invites_by_pk?: Maybe<InvitesType>;
  is_class_slug_available: Scalars['Boolean'];
  is_event_slug_available: Scalars['Boolean'];
  is_teacher_slug_available: Scalars['Boolean'];
  /** fetch data from the table: "jam_participants" */
  jam_participants: Array<Jam_ParticipantsType>;
  /** fetch aggregated fields from the table: "jam_participants" */
  jam_participants_aggregate: Jam_Participants_AggregateType;
  /** fetch data from the table: "jam_participants" using primary key columns */
  jam_participants_by_pk?: Maybe<Jam_ParticipantsType>;
  /** An array relationship */
  jams: Array<JamsType>;
  /** An aggregate relationship */
  jams_aggregate: Jams_AggregateType;
  /** execute function "jams_by_location_v1" which returns "inherited.jams_with_distance" */
  jams_by_location_v1: Array<Inherited_Jams_With_DistanceType>;
  /** execute function "jams_by_location_v1" and query aggregates on result of table type "inherited.jams_with_distance" */
  jams_by_location_v1_aggregate: Inherited_Jams_With_Distance_AggregateType;
  /** fetch data from the table: "jams" using primary key columns */
  jams_by_pk?: Maybe<JamsType>;
  /** fetch data from the table: "levels" */
  levels: Array<LevelsType>;
  /** fetch aggregated fields from the table: "levels" */
  levels_aggregate: Levels_AggregateType;
  /** fetch data from the table: "levels" using primary key columns */
  levels_by_pk?: Maybe<LevelsType>;
  /** fetch data from the table: "me" */
  me: Array<MeType>;
  /** fetch aggregated fields from the table: "me" */
  me_aggregate: Me_AggregateType;
  place: PlaceType;
  places: Array<PlaceSuggestionType>;
  /** An array relationship */
  recurring_patterns: Array<Recurring_PatternsType>;
  /** An aggregate relationship */
  recurring_patterns_aggregate: Recurring_Patterns_AggregateType;
  /** fetch data from the table: "recurring_patterns" using primary key columns */
  recurring_patterns_by_pk?: Maybe<Recurring_PatternsType>;
  /** fetch data from the table: "roles" */
  roles: Array<RolesType>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_AggregateType;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<RolesType>;
  stripe_login_link: Scalars['String'];
  /** fetch data from the table: "teacher_images" */
  teacher_images: Array<Teacher_ImagesType>;
  /** fetch aggregated fields from the table: "teacher_images" */
  teacher_images_aggregate: Teacher_Images_AggregateType;
  /** fetch data from the table: "teacher_images" using primary key columns */
  teacher_images_by_pk?: Maybe<Teacher_ImagesType>;
  /** An array relationship */
  teacher_levels: Array<Teacher_LevelsType>;
  /** An aggregate relationship */
  teacher_levels_aggregate: Teacher_Levels_AggregateType;
  /** fetch data from the table: "teacher_levels" using primary key columns */
  teacher_levels_by_pk?: Maybe<Teacher_LevelsType>;
  /** An array relationship */
  teacher_likes: Array<Teacher_LikesType>;
  /** An aggregate relationship */
  teacher_likes_aggregate: Teacher_Likes_AggregateType;
  /** fetch data from the table: "teacher_likes" using primary key columns */
  teacher_likes_by_pk?: Maybe<Teacher_LikesType>;
  /** fetch data from the table: "teacher_type" */
  teacher_type: Array<Teacher_TypeType>;
  /** fetch aggregated fields from the table: "teacher_type" */
  teacher_type_aggregate: Teacher_Type_AggregateType;
  /** fetch data from the table: "teacher_type" using primary key columns */
  teacher_type_by_pk?: Maybe<Teacher_TypeType>;
  /** fetch data from the table: "teachers" */
  teachers: Array<TeachersType>;
  /** fetch aggregated fields from the table: "teachers" */
  teachers_aggregate: Teachers_AggregateType;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: Maybe<TeachersType>;
  /** An array relationship */
  user_communities: Array<User_CommunitiesType>;
  /** An aggregate relationship */
  user_communities_aggregate: User_Communities_AggregateType;
  /** fetch data from the table: "user_communities" using primary key columns */
  user_communities_by_pk?: Maybe<User_CommunitiesType>;
  /** An array relationship */
  user_roles: Array<User_RolesType>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Roles_AggregateType;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_RolesType>;
  /** fetch data from the table: "users" */
  users: Array<UsersType>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_AggregateType;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<UsersType>;
};


export type Query_RootAcro_RolesArgsType = {
  distinct_on?: InputMaybe<Array<Acro_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acro_Roles_Order_ByType>>;
  where?: InputMaybe<Acro_Roles_Bool_ExpType>;
};


export type Query_RootAcro_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Acro_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acro_Roles_Order_ByType>>;
  where?: InputMaybe<Acro_Roles_Bool_ExpType>;
};


export type Query_RootAcro_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootBooking_OptionArgsType = {
  distinct_on?: InputMaybe<Array<Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Option_Order_ByType>>;
  where?: InputMaybe<Booking_Option_Bool_ExpType>;
};


export type Query_RootBooking_Option_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Option_Order_ByType>>;
  where?: InputMaybe<Booking_Option_Bool_ExpType>;
};


export type Query_RootBooking_Option_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_Booking_OptionArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


export type Query_RootClass_Booking_Option_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


export type Query_RootClass_Booking_Option_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_Event_BookingsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


export type Query_RootClass_Event_Bookings_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


export type Query_RootClass_Event_Bookings_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_Event_BookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


export type Query_RootClass_Event_Bookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


export type Query_RootClass_Event_Bookmarks_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


export type Query_RootClass_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


export type Query_RootClass_Events_By_Location_V1ArgsType = {
  args: Class_Events_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Query_RootClass_Events_By_Location_V1_AggregateArgsType = {
  args: Class_Events_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Query_RootClass_Events_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_Events_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


export type Query_RootClass_Events_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


export type Query_RootClass_Events_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_FavoritesArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


export type Query_RootClass_Favorites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


export type Query_RootClass_Favorites_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_FlagArgsType = {
  distinct_on?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Flag_Order_ByType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


export type Query_RootClass_Flag_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Flag_Order_ByType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


export type Query_RootClass_Flag_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


export type Query_RootClass_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


export type Query_RootClass_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_OwnersArgsType = {
  distinct_on?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Owners_Order_ByType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


export type Query_RootClass_Owners_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Owners_Order_ByType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


export type Query_RootClass_Owners_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClass_TeachersArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


export type Query_RootClass_Teachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


export type Query_RootClass_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootClassesArgsType = {
  distinct_on?: InputMaybe<Array<Classes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classes_Order_ByType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};


export type Query_RootClasses_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Classes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classes_Order_ByType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};


export type Query_RootClasses_By_Location_V1ArgsType = {
  args: Classes_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Query_RootClasses_By_Location_V1_AggregateArgsType = {
  args: Classes_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Query_RootClasses_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootCommunitiesArgsType = {
  distinct_on?: InputMaybe<Array<Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communities_Order_ByType>>;
  where?: InputMaybe<Communities_Bool_ExpType>;
};


export type Query_RootCommunities_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communities_Order_ByType>>;
  where?: InputMaybe<Communities_Bool_ExpType>;
};


export type Query_RootCommunities_By_Location_V1ArgsType = {
  args: Communities_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Query_RootCommunities_By_Location_V1_AggregateArgsType = {
  args: Communities_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Query_RootCommunities_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootCommunity_MessagesArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


export type Query_RootCommunity_Messages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


export type Query_RootCommunity_Messages_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootConfigArgsType = {
  distinct_on?: InputMaybe<Array<Config_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Config_Order_ByType>>;
  where?: InputMaybe<Config_Bool_ExpType>;
};


export type Query_RootConfig_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Config_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Config_Order_ByType>>;
  where?: InputMaybe<Config_Bool_ExpType>;
};


export type Query_RootConfig_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootConfirmation_StatusArgsType = {
  distinct_on?: InputMaybe<Array<Confirmation_Status_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Confirmation_Status_Order_ByType>>;
  where?: InputMaybe<Confirmation_Status_Bool_ExpType>;
};


export type Query_RootConfirmation_Status_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Confirmation_Status_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Confirmation_Status_Order_ByType>>;
  where?: InputMaybe<Confirmation_Status_Bool_ExpType>;
};


export type Query_RootConfirmation_Status_By_PkArgsType = {
  value: Scalars['String'];
};


export type Query_RootCreated_InvitesArgsType = {
  distinct_on?: InputMaybe<Array<Created_Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Created_Invites_Order_ByType>>;
  where?: InputMaybe<Created_Invites_Bool_ExpType>;
};


export type Query_RootCreated_Invites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Created_Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Created_Invites_Order_ByType>>;
  where?: InputMaybe<Created_Invites_Bool_ExpType>;
};


export type Query_RootEvent_BookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


export type Query_RootEvent_Bookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


export type Query_RootEvent_Bookmarks_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_InstanceArgsType = {
  distinct_on?: InputMaybe<Array<Event_Instance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Instance_Order_ByType>>;
  where?: InputMaybe<Event_Instance_Bool_ExpType>;
};


export type Query_RootEvent_Instance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Instance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Instance_Order_ByType>>;
  where?: InputMaybe<Event_Instance_Bool_ExpType>;
};


export type Query_RootEvent_Instance_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_OwnersArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


export type Query_RootEvent_Owners_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


export type Query_RootEvent_Owners_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_SourceArgsType = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_ByType>>;
  where?: InputMaybe<Event_Source_Bool_ExpType>;
};


export type Query_RootEvent_Source_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_ByType>>;
  where?: InputMaybe<Event_Source_Bool_ExpType>;
};


export type Query_RootEvent_Source_By_PkArgsType = {
  value: Scalars['String'];
};


export type Query_RootEvent_TeachersArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


export type Query_RootEvent_Teachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


export type Query_RootEvent_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_TemplateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Template_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Template_Order_ByType>>;
  where?: InputMaybe<Event_Template_Bool_ExpType>;
};


export type Query_RootEvent_Template_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Template_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Template_Order_ByType>>;
  where?: InputMaybe<Event_Template_Bool_ExpType>;
};


export type Query_RootEvent_Template_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootEvent_TypeArgsType = {
  distinct_on?: InputMaybe<Array<Event_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Type_Order_ByType>>;
  where?: InputMaybe<Event_Type_Bool_ExpType>;
};


export type Query_RootEvent_Type_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Type_Order_ByType>>;
  where?: InputMaybe<Event_Type_Bool_ExpType>;
};


export type Query_RootEvent_Type_By_PkArgsType = {
  value: Scalars['String'];
};


export type Query_RootEvent_User_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_User_Participants_Order_ByType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};


export type Query_RootEvent_User_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_User_Participants_Order_ByType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};


export type Query_RootEvent_User_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootEventsArgsType = {
  distinct_on?: InputMaybe<Array<Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_ByType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


export type Query_RootEvents_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_ByType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


export type Query_RootEvents_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootGet_Class_Slug_SuggestionArgsType = {
  name: Scalars['String'];
};


export type Query_RootGet_Event_Slug_SuggestionArgsType = {
  name: Scalars['String'];
};


export type Query_RootGet_Teacher_Slug_SuggestionArgsType = {
  name: Scalars['String'];
};


export type Query_RootImagesArgsType = {
  distinct_on?: InputMaybe<Array<Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Images_Order_ByType>>;
  where?: InputMaybe<Images_Bool_ExpType>;
};


export type Query_RootImages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Images_Order_ByType>>;
  where?: InputMaybe<Images_Bool_ExpType>;
};


export type Query_RootImages_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootInherited_Class_Events_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Class_Events_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Classes_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Classes_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Communities_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Communities_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Jams_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Query_RootInherited_Jams_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Query_RootInvite_By_IdArgsType = {
  id: Scalars['String'];
};


export type Query_RootInvite_EntityArgsType = {
  distinct_on?: InputMaybe<Array<Invite_Entity_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Entity_Order_ByType>>;
  where?: InputMaybe<Invite_Entity_Bool_ExpType>;
};


export type Query_RootInvite_Entity_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invite_Entity_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Entity_Order_ByType>>;
  where?: InputMaybe<Invite_Entity_Bool_ExpType>;
};


export type Query_RootInvite_Entity_By_PkArgsType = {
  value: Scalars['String'];
};


export type Query_RootInvitesArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


export type Query_RootInvites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


export type Query_RootInvites_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootIs_Class_Slug_AvailableArgsType = {
  url_slug: Scalars['String'];
};


export type Query_RootIs_Event_Slug_AvailableArgsType = {
  url_slug: Scalars['String'];
};


export type Query_RootIs_Teacher_Slug_AvailableArgsType = {
  url_slug: Scalars['String'];
};


export type Query_RootJam_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


export type Query_RootJam_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


export type Query_RootJam_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootJamsArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


export type Query_RootJams_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


export type Query_RootJams_By_Location_V1ArgsType = {
  args: Jams_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Query_RootJams_By_Location_V1_AggregateArgsType = {
  args: Jams_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Query_RootJams_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootLevelsArgsType = {
  distinct_on?: InputMaybe<Array<Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Levels_Order_ByType>>;
  where?: InputMaybe<Levels_Bool_ExpType>;
};


export type Query_RootLevels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Levels_Order_ByType>>;
  where?: InputMaybe<Levels_Bool_ExpType>;
};


export type Query_RootLevels_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootMeArgsType = {
  distinct_on?: InputMaybe<Array<Me_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Me_Order_ByType>>;
  where?: InputMaybe<Me_Bool_ExpType>;
};


export type Query_RootMe_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Me_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Me_Order_ByType>>;
  where?: InputMaybe<Me_Bool_ExpType>;
};


export type Query_RootPlaceArgsType = {
  id: Scalars['String'];
};


export type Query_RootPlacesArgsType = {
  searchQuery: Scalars['String'];
};


export type Query_RootRecurring_PatternsArgsType = {
  distinct_on?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Patterns_Order_ByType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};


export type Query_RootRecurring_Patterns_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Patterns_Order_ByType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};


export type Query_RootRecurring_Patterns_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootRolesArgsType = {
  distinct_on?: InputMaybe<Array<Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_ByType>>;
  where?: InputMaybe<Roles_Bool_ExpType>;
};


export type Query_RootRoles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_ByType>>;
  where?: InputMaybe<Roles_Bool_ExpType>;
};


export type Query_RootRoles_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootTeacher_ImagesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


export type Query_RootTeacher_Images_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


export type Query_RootTeacher_Images_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootTeacher_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Levels_Order_ByType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


export type Query_RootTeacher_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Levels_Order_ByType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


export type Query_RootTeacher_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootTeacher_LikesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


export type Query_RootTeacher_Likes_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


export type Query_RootTeacher_Likes_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootTeacher_TypeArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Type_Order_ByType>>;
  where?: InputMaybe<Teacher_Type_Bool_ExpType>;
};


export type Query_RootTeacher_Type_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Type_Order_ByType>>;
  where?: InputMaybe<Teacher_Type_Bool_ExpType>;
};


export type Query_RootTeacher_Type_By_PkArgsType = {
  value: Scalars['String'];
};


export type Query_RootTeachersArgsType = {
  distinct_on?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teachers_Order_ByType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


export type Query_RootTeachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teachers_Order_ByType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


export type Query_RootTeachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootUser_CommunitiesArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


export type Query_RootUser_Communities_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


export type Query_RootUser_Communities_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootUser_RolesArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


export type Query_RootUser_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


export type Query_RootUser_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgsType = {
  distinct_on?: InputMaybe<Array<Users_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_ByType>>;
  where?: InputMaybe<Users_Bool_ExpType>;
};


export type Query_RootUsers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Users_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_ByType>>;
  where?: InputMaybe<Users_Bool_ExpType>;
};


export type Query_RootUsers_By_PkArgsType = {
  id: Scalars['uuid'];
};

/** columns and relationships of "recurring_patterns" */
export type Recurring_PatternsType = {
  __typename?: 'recurring_patterns';
  /** An object relationship */
  class: ClassesType;
  class_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  day_of_week: Scalars['Int'];
  end_date?: Maybe<Scalars['timestamptz']>;
  end_time: Scalars['timetz'];
  id: Scalars['uuid'];
  is_recurring: Scalars['Boolean'];
  recurring_every_x_weeks: Scalars['Int'];
  start_date?: Maybe<Scalars['timestamptz']>;
  start_time: Scalars['timetz'];
};

/** aggregated selection of "recurring_patterns" */
export type Recurring_Patterns_AggregateType = {
  __typename?: 'recurring_patterns_aggregate';
  aggregate?: Maybe<Recurring_Patterns_Aggregate_FieldsType>;
  nodes: Array<Recurring_PatternsType>;
};

export type Recurring_Patterns_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Recurring_Patterns_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Recurring_Patterns_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Recurring_Patterns_Aggregate_Bool_Exp_CountType>;
};

export type Recurring_Patterns_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Recurring_Patterns_Select_Column_Recurring_Patterns_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Recurring_Patterns_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Recurring_Patterns_Select_Column_Recurring_Patterns_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Recurring_Patterns_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "recurring_patterns" */
export type Recurring_Patterns_Aggregate_FieldsType = {
  __typename?: 'recurring_patterns_aggregate_fields';
  avg?: Maybe<Recurring_Patterns_Avg_FieldsType>;
  count: Scalars['Int'];
  max?: Maybe<Recurring_Patterns_Max_FieldsType>;
  min?: Maybe<Recurring_Patterns_Min_FieldsType>;
  stddev?: Maybe<Recurring_Patterns_Stddev_FieldsType>;
  stddev_pop?: Maybe<Recurring_Patterns_Stddev_Pop_FieldsType>;
  stddev_samp?: Maybe<Recurring_Patterns_Stddev_Samp_FieldsType>;
  sum?: Maybe<Recurring_Patterns_Sum_FieldsType>;
  var_pop?: Maybe<Recurring_Patterns_Var_Pop_FieldsType>;
  var_samp?: Maybe<Recurring_Patterns_Var_Samp_FieldsType>;
  variance?: Maybe<Recurring_Patterns_Variance_FieldsType>;
};


/** aggregate fields of "recurring_patterns" */
export type Recurring_Patterns_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recurring_patterns" */
export type Recurring_Patterns_Aggregate_Order_ByType = {
  avg?: InputMaybe<Recurring_Patterns_Avg_Order_ByType>;
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Recurring_Patterns_Max_Order_ByType>;
  min?: InputMaybe<Recurring_Patterns_Min_Order_ByType>;
  stddev?: InputMaybe<Recurring_Patterns_Stddev_Order_ByType>;
  stddev_pop?: InputMaybe<Recurring_Patterns_Stddev_Pop_Order_ByType>;
  stddev_samp?: InputMaybe<Recurring_Patterns_Stddev_Samp_Order_ByType>;
  sum?: InputMaybe<Recurring_Patterns_Sum_Order_ByType>;
  var_pop?: InputMaybe<Recurring_Patterns_Var_Pop_Order_ByType>;
  var_samp?: InputMaybe<Recurring_Patterns_Var_Samp_Order_ByType>;
  variance?: InputMaybe<Recurring_Patterns_Variance_Order_ByType>;
};

/** input type for inserting array relation for remote table "recurring_patterns" */
export type Recurring_Patterns_Arr_Rel_Insert_InputType = {
  data: Array<Recurring_Patterns_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Recurring_Patterns_On_ConflictType>;
};

/** aggregate avg on columns */
export type Recurring_Patterns_Avg_FieldsType = {
  __typename?: 'recurring_patterns_avg_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Avg_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** Boolean expression to filter rows from the table "recurring_patterns". All fields are combined with a logical 'AND'. */
export type Recurring_Patterns_Bool_ExpType = {
  _and?: InputMaybe<Array<Recurring_Patterns_Bool_ExpType>>;
  _not?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
  _or?: InputMaybe<Array<Recurring_Patterns_Bool_ExpType>>;
  class?: InputMaybe<Classes_Bool_ExpType>;
  class_id?: InputMaybe<Uuid_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  day_of_week?: InputMaybe<Int_Comparison_ExpType>;
  end_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  end_time?: InputMaybe<Timetz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_recurring?: InputMaybe<Boolean_Comparison_ExpType>;
  recurring_every_x_weeks?: InputMaybe<Int_Comparison_ExpType>;
  start_date?: InputMaybe<Timestamptz_Comparison_ExpType>;
  start_time?: InputMaybe<Timetz_Comparison_ExpType>;
};

/** unique or primary key constraints on table "recurring_patterns" */
export enum Recurring_Patterns_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  RecurringPatternsPkeyType = 'recurring_patterns_pkey'
}

/** input type for incrementing numeric columns in table "recurring_patterns" */
export type Recurring_Patterns_Inc_InputType = {
  day_of_week?: InputMaybe<Scalars['Int']>;
  recurring_every_x_weeks?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "recurring_patterns" */
export type Recurring_Patterns_Insert_InputType = {
  class?: InputMaybe<Classes_Obj_Rel_Insert_InputType>;
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day_of_week?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  end_time?: InputMaybe<Scalars['timetz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_recurring?: InputMaybe<Scalars['Boolean']>;
  recurring_every_x_weeks?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timetz']>;
};

/** aggregate max on columns */
export type Recurring_Patterns_Max_FieldsType = {
  __typename?: 'recurring_patterns_max_fields';
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  day_of_week?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  recurring_every_x_weeks?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  start_time?: Maybe<Scalars['timetz']>;
};

/** order by max() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Max_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  day_of_week?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  end_time?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  start_time?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Recurring_Patterns_Min_FieldsType = {
  __typename?: 'recurring_patterns_min_fields';
  class_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  day_of_week?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timetz']>;
  id?: Maybe<Scalars['uuid']>;
  recurring_every_x_weeks?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  start_time?: Maybe<Scalars['timetz']>;
};

/** order by min() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Min_Order_ByType = {
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  day_of_week?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  end_time?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  start_time?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "recurring_patterns" */
export type Recurring_Patterns_Mutation_ResponseType = {
  __typename?: 'recurring_patterns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Recurring_PatternsType>;
};

/** input type for inserting object relation for remote table "recurring_patterns" */
export type Recurring_Patterns_Obj_Rel_Insert_InputType = {
  data: Recurring_Patterns_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Recurring_Patterns_On_ConflictType>;
};

/** on_conflict condition type for table "recurring_patterns" */
export type Recurring_Patterns_On_ConflictType = {
  constraint: Recurring_Patterns_ConstraintType;
  update_columns?: Array<Recurring_Patterns_Update_ColumnType>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};

/** Ordering options when selecting data from "recurring_patterns". */
export type Recurring_Patterns_Order_ByType = {
  class?: InputMaybe<Classes_Order_ByType>;
  class_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  day_of_week?: InputMaybe<Order_ByType>;
  end_date?: InputMaybe<Order_ByType>;
  end_time?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  is_recurring?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
  start_date?: InputMaybe<Order_ByType>;
  start_time?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: recurring_patterns */
export type Recurring_Patterns_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "recurring_patterns" */
export enum Recurring_Patterns_Select_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DayOfWeekType = 'day_of_week',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  EndTimeType = 'end_time',
  /** column name */
  IdType = 'id',
  /** column name */
  IsRecurringType = 'is_recurring',
  /** column name */
  RecurringEveryXWeeksType = 'recurring_every_x_weeks',
  /** column name */
  StartDateType = 'start_date',
  /** column name */
  StartTimeType = 'start_time'
}

/** select "recurring_patterns_aggregate_bool_exp_bool_and_arguments_columns" columns of table "recurring_patterns" */
export enum Recurring_Patterns_Select_Column_Recurring_Patterns_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsRecurringType = 'is_recurring'
}

/** select "recurring_patterns_aggregate_bool_exp_bool_or_arguments_columns" columns of table "recurring_patterns" */
export enum Recurring_Patterns_Select_Column_Recurring_Patterns_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsRecurringType = 'is_recurring'
}

/** input type for updating data in table "recurring_patterns" */
export type Recurring_Patterns_Set_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day_of_week?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  end_time?: InputMaybe<Scalars['timetz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_recurring?: InputMaybe<Scalars['Boolean']>;
  recurring_every_x_weeks?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timetz']>;
};

/** aggregate stddev on columns */
export type Recurring_Patterns_Stddev_FieldsType = {
  __typename?: 'recurring_patterns_stddev_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Stddev_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_pop on columns */
export type Recurring_Patterns_Stddev_Pop_FieldsType = {
  __typename?: 'recurring_patterns_stddev_pop_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Stddev_Pop_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** aggregate stddev_samp on columns */
export type Recurring_Patterns_Stddev_Samp_FieldsType = {
  __typename?: 'recurring_patterns_stddev_samp_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Stddev_Samp_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** Streaming cursor of the table "recurring_patterns" */
export type Recurring_Patterns_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Recurring_Patterns_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Recurring_Patterns_Stream_Cursor_Value_InputType = {
  class_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  day_of_week?: InputMaybe<Scalars['Int']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  end_time?: InputMaybe<Scalars['timetz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_recurring?: InputMaybe<Scalars['Boolean']>;
  recurring_every_x_weeks?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timetz']>;
};

/** aggregate sum on columns */
export type Recurring_Patterns_Sum_FieldsType = {
  __typename?: 'recurring_patterns_sum_fields';
  day_of_week?: Maybe<Scalars['Int']>;
  recurring_every_x_weeks?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Sum_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** update columns of table "recurring_patterns" */
export enum Recurring_Patterns_Update_ColumnType {
  /** column name */
  ClassIdType = 'class_id',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DayOfWeekType = 'day_of_week',
  /** column name */
  EndDateType = 'end_date',
  /** column name */
  EndTimeType = 'end_time',
  /** column name */
  IdType = 'id',
  /** column name */
  IsRecurringType = 'is_recurring',
  /** column name */
  RecurringEveryXWeeksType = 'recurring_every_x_weeks',
  /** column name */
  StartDateType = 'start_date',
  /** column name */
  StartTimeType = 'start_time'
}

export type Recurring_Patterns_UpdatesType = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Recurring_Patterns_Inc_InputType>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Recurring_Patterns_Set_InputType>;
  where: Recurring_Patterns_Bool_ExpType;
};

/** aggregate var_pop on columns */
export type Recurring_Patterns_Var_Pop_FieldsType = {
  __typename?: 'recurring_patterns_var_pop_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Var_Pop_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** aggregate var_samp on columns */
export type Recurring_Patterns_Var_Samp_FieldsType = {
  __typename?: 'recurring_patterns_var_samp_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Var_Samp_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** aggregate variance on columns */
export type Recurring_Patterns_Variance_FieldsType = {
  __typename?: 'recurring_patterns_variance_fields';
  day_of_week?: Maybe<Scalars['Float']>;
  recurring_every_x_weeks?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recurring_patterns" */
export type Recurring_Patterns_Variance_Order_ByType = {
  day_of_week?: InputMaybe<Order_ByType>;
  recurring_every_x_weeks?: InputMaybe<Order_ByType>;
};

/** columns and relationships of "roles" */
export type RolesType = {
  __typename?: 'roles';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  user_roles: Array<User_RolesType>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Roles_AggregateType;
};


/** columns and relationships of "roles" */
export type RolesUser_RolesArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


/** columns and relationships of "roles" */
export type RolesUser_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};

/** aggregated selection of "roles" */
export type Roles_AggregateType = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_FieldsType>;
  nodes: Array<RolesType>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsType = {
  __typename?: 'roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_FieldsType>;
  min?: Maybe<Roles_Min_FieldsType>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Roles_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_ExpType = {
  _and?: InputMaybe<Array<Roles_Bool_ExpType>>;
  _not?: InputMaybe<Roles_Bool_ExpType>;
  _or?: InputMaybe<Array<Roles_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  user_roles?: InputMaybe<User_Roles_Bool_ExpType>;
  user_roles_aggregate?: InputMaybe<User_Roles_Aggregate_Bool_ExpType>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  RolePkeyType = 'role_pkey'
}

/** input type for inserting data into table "roles" */
export type Roles_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  user_roles?: InputMaybe<User_Roles_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Roles_Max_FieldsType = {
  __typename?: 'roles_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Roles_Min_FieldsType = {
  __typename?: 'roles_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_ResponseType = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RolesType>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_InputType = {
  data: Roles_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_ConflictType>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_ConflictType = {
  constraint: Roles_ConstraintType;
  update_columns?: Array<Roles_Update_ColumnType>;
  where?: InputMaybe<Roles_Bool_ExpType>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  user_roles_aggregate?: InputMaybe<User_Roles_Aggregate_Order_ByType>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "roles" */
export enum Roles_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  NameType = 'name'
}

/** input type for updating data in table "roles" */
export type Roles_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "roles" */
export enum Roles_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  NameType = 'name'
}

export type Roles_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_InputType>;
  where: Roles_Bool_ExpType;
};

export type St_D_Within_Geography_InputType = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_InputType = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

export type Subscription_RootType = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "acro_roles" */
  acro_roles: Array<Acro_RolesType>;
  /** fetch aggregated fields from the table: "acro_roles" */
  acro_roles_aggregate: Acro_Roles_AggregateType;
  /** fetch data from the table: "acro_roles" using primary key columns */
  acro_roles_by_pk?: Maybe<Acro_RolesType>;
  /** fetch data from the table in a streaming manner: "acro_roles" */
  acro_roles_stream: Array<Acro_RolesType>;
  /** fetch data from the table: "booking_option" */
  booking_option: Array<Booking_OptionType>;
  /** fetch aggregated fields from the table: "booking_option" */
  booking_option_aggregate: Booking_Option_AggregateType;
  /** fetch data from the table: "booking_option" using primary key columns */
  booking_option_by_pk?: Maybe<Booking_OptionType>;
  /** fetch data from the table in a streaming manner: "booking_option" */
  booking_option_stream: Array<Booking_OptionType>;
  /** fetch data from the table: "class_booking_option" */
  class_booking_option: Array<Class_Booking_OptionType>;
  /** fetch aggregated fields from the table: "class_booking_option" */
  class_booking_option_aggregate: Class_Booking_Option_AggregateType;
  /** fetch data from the table: "class_booking_option" using primary key columns */
  class_booking_option_by_pk?: Maybe<Class_Booking_OptionType>;
  /** fetch data from the table in a streaming manner: "class_booking_option" */
  class_booking_option_stream: Array<Class_Booking_OptionType>;
  /** fetch data from the table: "class_event_bookings" */
  class_event_bookings: Array<Class_Event_BookingsType>;
  /** fetch aggregated fields from the table: "class_event_bookings" */
  class_event_bookings_aggregate: Class_Event_Bookings_AggregateType;
  /** fetch data from the table: "class_event_bookings" using primary key columns */
  class_event_bookings_by_pk?: Maybe<Class_Event_BookingsType>;
  /** fetch data from the table in a streaming manner: "class_event_bookings" */
  class_event_bookings_stream: Array<Class_Event_BookingsType>;
  /** An array relationship */
  class_event_bookmarks: Array<Class_Event_BookmarksType>;
  /** An aggregate relationship */
  class_event_bookmarks_aggregate: Class_Event_Bookmarks_AggregateType;
  /** fetch data from the table: "class_event_bookmarks" using primary key columns */
  class_event_bookmarks_by_pk?: Maybe<Class_Event_BookmarksType>;
  /** fetch data from the table in a streaming manner: "class_event_bookmarks" */
  class_event_bookmarks_stream: Array<Class_Event_BookmarksType>;
  /** An array relationship */
  class_events: Array<Class_EventsType>;
  /** An aggregate relationship */
  class_events_aggregate: Class_Events_AggregateType;
  /** execute function "class_events_by_location_v1" which returns "inherited.class_events_with_distance" */
  class_events_by_location_v1: Array<Inherited_Class_Events_With_DistanceType>;
  /** execute function "class_events_by_location_v1" and query aggregates on result of table type "inherited.class_events_with_distance" */
  class_events_by_location_v1_aggregate: Inherited_Class_Events_With_Distance_AggregateType;
  /** fetch data from the table: "class_events" using primary key columns */
  class_events_by_pk?: Maybe<Class_EventsType>;
  /** fetch data from the table: "class_events_participants" */
  class_events_participants: Array<Class_Events_ParticipantsType>;
  /** fetch aggregated fields from the table: "class_events_participants" */
  class_events_participants_aggregate: Class_Events_Participants_AggregateType;
  /** fetch data from the table: "class_events_participants" using primary key columns */
  class_events_participants_by_pk?: Maybe<Class_Events_ParticipantsType>;
  /** fetch data from the table in a streaming manner: "class_events_participants" */
  class_events_participants_stream: Array<Class_Events_ParticipantsType>;
  /** fetch data from the table in a streaming manner: "class_events" */
  class_events_stream: Array<Class_EventsType>;
  /** fetch data from the table: "class_favorites" */
  class_favorites: Array<Class_FavoritesType>;
  /** fetch aggregated fields from the table: "class_favorites" */
  class_favorites_aggregate: Class_Favorites_AggregateType;
  /** fetch data from the table: "class_favorites" using primary key columns */
  class_favorites_by_pk?: Maybe<Class_FavoritesType>;
  /** fetch data from the table in a streaming manner: "class_favorites" */
  class_favorites_stream: Array<Class_FavoritesType>;
  /** fetch data from the table: "class_flag" */
  class_flag: Array<Class_FlagType>;
  /** fetch aggregated fields from the table: "class_flag" */
  class_flag_aggregate: Class_Flag_AggregateType;
  /** fetch data from the table: "class_flag" using primary key columns */
  class_flag_by_pk?: Maybe<Class_FlagType>;
  /** fetch data from the table in a streaming manner: "class_flag" */
  class_flag_stream: Array<Class_FlagType>;
  /** An array relationship */
  class_levels: Array<Class_LevelsType>;
  /** An aggregate relationship */
  class_levels_aggregate: Class_Levels_AggregateType;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: Maybe<Class_LevelsType>;
  /** fetch data from the table in a streaming manner: "class_levels" */
  class_levels_stream: Array<Class_LevelsType>;
  /** An array relationship */
  class_owners: Array<Class_OwnersType>;
  /** An aggregate relationship */
  class_owners_aggregate: Class_Owners_AggregateType;
  /** fetch data from the table: "class_owners" using primary key columns */
  class_owners_by_pk?: Maybe<Class_OwnersType>;
  /** fetch data from the table in a streaming manner: "class_owners" */
  class_owners_stream: Array<Class_OwnersType>;
  /** An array relationship */
  class_teachers: Array<Class_TeachersType>;
  /** An aggregate relationship */
  class_teachers_aggregate: Class_Teachers_AggregateType;
  /** fetch data from the table: "class_teachers" using primary key columns */
  class_teachers_by_pk?: Maybe<Class_TeachersType>;
  /** fetch data from the table in a streaming manner: "class_teachers" */
  class_teachers_stream: Array<Class_TeachersType>;
  /** An array relationship */
  classes: Array<ClassesType>;
  /** An aggregate relationship */
  classes_aggregate: Classes_AggregateType;
  /** execute function "classes_by_location_v1" which returns "inherited.classes_with_distance" */
  classes_by_location_v1: Array<Inherited_Classes_With_DistanceType>;
  /** execute function "classes_by_location_v1" and query aggregates on result of table type "inherited.classes_with_distance" */
  classes_by_location_v1_aggregate: Inherited_Classes_With_Distance_AggregateType;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: Maybe<ClassesType>;
  /** fetch data from the table in a streaming manner: "classes" */
  classes_stream: Array<ClassesType>;
  /** fetch data from the table: "communities" */
  communities: Array<CommunitiesType>;
  /** fetch aggregated fields from the table: "communities" */
  communities_aggregate: Communities_AggregateType;
  /** execute function "communities_by_location_v1" which returns "inherited.communities_with_distance" */
  communities_by_location_v1: Array<Inherited_Communities_With_DistanceType>;
  /** execute function "communities_by_location_v1" and query aggregates on result of table type "inherited.communities_with_distance" */
  communities_by_location_v1_aggregate: Inherited_Communities_With_Distance_AggregateType;
  /** fetch data from the table: "communities" using primary key columns */
  communities_by_pk?: Maybe<CommunitiesType>;
  /** fetch data from the table in a streaming manner: "communities" */
  communities_stream: Array<CommunitiesType>;
  /** An array relationship */
  community_messages: Array<Community_MessagesType>;
  /** An aggregate relationship */
  community_messages_aggregate: Community_Messages_AggregateType;
  /** fetch data from the table: "community_messages" using primary key columns */
  community_messages_by_pk?: Maybe<Community_MessagesType>;
  /** fetch data from the table in a streaming manner: "community_messages" */
  community_messages_stream: Array<Community_MessagesType>;
  /** fetch data from the table: "config" */
  config: Array<ConfigType>;
  /** fetch aggregated fields from the table: "config" */
  config_aggregate: Config_AggregateType;
  /** fetch data from the table: "config" using primary key columns */
  config_by_pk?: Maybe<ConfigType>;
  /** fetch data from the table in a streaming manner: "config" */
  config_stream: Array<ConfigType>;
  /** fetch data from the table: "confirmation_status" */
  confirmation_status: Array<Confirmation_StatusType>;
  /** fetch aggregated fields from the table: "confirmation_status" */
  confirmation_status_aggregate: Confirmation_Status_AggregateType;
  /** fetch data from the table: "confirmation_status" using primary key columns */
  confirmation_status_by_pk?: Maybe<Confirmation_StatusType>;
  /** fetch data from the table in a streaming manner: "confirmation_status" */
  confirmation_status_stream: Array<Confirmation_StatusType>;
  /** fetch data from the table: "created_invites" */
  created_invites: Array<Created_InvitesType>;
  /** fetch aggregated fields from the table: "created_invites" */
  created_invites_aggregate: Created_Invites_AggregateType;
  /** fetch data from the table in a streaming manner: "created_invites" */
  created_invites_stream: Array<Created_InvitesType>;
  /** fetch data from the table: "event_bookmarks" */
  event_bookmarks: Array<Event_BookmarksType>;
  /** fetch aggregated fields from the table: "event_bookmarks" */
  event_bookmarks_aggregate: Event_Bookmarks_AggregateType;
  /** fetch data from the table: "event_bookmarks" using primary key columns */
  event_bookmarks_by_pk?: Maybe<Event_BookmarksType>;
  /** fetch data from the table in a streaming manner: "event_bookmarks" */
  event_bookmarks_stream: Array<Event_BookmarksType>;
  /** fetch data from the table: "event_instance" */
  event_instance: Array<Event_InstanceType>;
  /** fetch aggregated fields from the table: "event_instance" */
  event_instance_aggregate: Event_Instance_AggregateType;
  /** fetch data from the table: "event_instance" using primary key columns */
  event_instance_by_pk?: Maybe<Event_InstanceType>;
  /** fetch data from the table in a streaming manner: "event_instance" */
  event_instance_stream: Array<Event_InstanceType>;
  /** fetch data from the table: "event_owners" */
  event_owners: Array<Event_OwnersType>;
  /** fetch aggregated fields from the table: "event_owners" */
  event_owners_aggregate: Event_Owners_AggregateType;
  /** fetch data from the table: "event_owners" using primary key columns */
  event_owners_by_pk?: Maybe<Event_OwnersType>;
  /** fetch data from the table in a streaming manner: "event_owners" */
  event_owners_stream: Array<Event_OwnersType>;
  /** fetch data from the table: "event_source" */
  event_source: Array<Event_SourceType>;
  /** fetch aggregated fields from the table: "event_source" */
  event_source_aggregate: Event_Source_AggregateType;
  /** fetch data from the table: "event_source" using primary key columns */
  event_source_by_pk?: Maybe<Event_SourceType>;
  /** fetch data from the table in a streaming manner: "event_source" */
  event_source_stream: Array<Event_SourceType>;
  /** fetch data from the table: "event_teachers" */
  event_teachers: Array<Event_TeachersType>;
  /** fetch aggregated fields from the table: "event_teachers" */
  event_teachers_aggregate: Event_Teachers_AggregateType;
  /** fetch data from the table: "event_teachers" using primary key columns */
  event_teachers_by_pk?: Maybe<Event_TeachersType>;
  /** fetch data from the table in a streaming manner: "event_teachers" */
  event_teachers_stream: Array<Event_TeachersType>;
  /** fetch data from the table: "event_template" */
  event_template: Array<Event_TemplateType>;
  /** fetch aggregated fields from the table: "event_template" */
  event_template_aggregate: Event_Template_AggregateType;
  /** fetch data from the table: "event_template" using primary key columns */
  event_template_by_pk?: Maybe<Event_TemplateType>;
  /** fetch data from the table in a streaming manner: "event_template" */
  event_template_stream: Array<Event_TemplateType>;
  /** fetch data from the table: "event_type" */
  event_type: Array<Event_TypeType>;
  /** fetch aggregated fields from the table: "event_type" */
  event_type_aggregate: Event_Type_AggregateType;
  /** fetch data from the table: "event_type" using primary key columns */
  event_type_by_pk?: Maybe<Event_TypeType>;
  /** fetch data from the table in a streaming manner: "event_type" */
  event_type_stream: Array<Event_TypeType>;
  /** fetch data from the table: "event_user_participants" */
  event_user_participants: Array<Event_User_ParticipantsType>;
  /** fetch aggregated fields from the table: "event_user_participants" */
  event_user_participants_aggregate: Event_User_Participants_AggregateType;
  /** fetch data from the table: "event_user_participants" using primary key columns */
  event_user_participants_by_pk?: Maybe<Event_User_ParticipantsType>;
  /** fetch data from the table in a streaming manner: "event_user_participants" */
  event_user_participants_stream: Array<Event_User_ParticipantsType>;
  /** fetch data from the table: "events" */
  events: Array<EventsType>;
  /** fetch aggregated fields from the table: "events" */
  events_aggregate: Events_AggregateType;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<EventsType>;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<EventsType>;
  /** fetch data from the table: "images" */
  images: Array<ImagesType>;
  /** fetch aggregated fields from the table: "images" */
  images_aggregate: Images_AggregateType;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<ImagesType>;
  /** fetch data from the table in a streaming manner: "images" */
  images_stream: Array<ImagesType>;
  /** fetch data from the table: "inherited.class_events_with_distance" */
  inherited_class_events_with_distance: Array<Inherited_Class_Events_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.class_events_with_distance" */
  inherited_class_events_with_distance_aggregate: Inherited_Class_Events_With_Distance_AggregateType;
  /** fetch data from the table in a streaming manner: "inherited.class_events_with_distance" */
  inherited_class_events_with_distance_stream: Array<Inherited_Class_Events_With_DistanceType>;
  /** fetch data from the table: "inherited.classes_with_distance" */
  inherited_classes_with_distance: Array<Inherited_Classes_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.classes_with_distance" */
  inherited_classes_with_distance_aggregate: Inherited_Classes_With_Distance_AggregateType;
  /** fetch data from the table in a streaming manner: "inherited.classes_with_distance" */
  inherited_classes_with_distance_stream: Array<Inherited_Classes_With_DistanceType>;
  /** fetch data from the table: "inherited.communities_with_distance" */
  inherited_communities_with_distance: Array<Inherited_Communities_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.communities_with_distance" */
  inherited_communities_with_distance_aggregate: Inherited_Communities_With_Distance_AggregateType;
  /** fetch data from the table in a streaming manner: "inherited.communities_with_distance" */
  inherited_communities_with_distance_stream: Array<Inherited_Communities_With_DistanceType>;
  /** fetch data from the table: "inherited.jams_with_distance" */
  inherited_jams_with_distance: Array<Inherited_Jams_With_DistanceType>;
  /** fetch aggregated fields from the table: "inherited.jams_with_distance" */
  inherited_jams_with_distance_aggregate: Inherited_Jams_With_Distance_AggregateType;
  /** fetch data from the table in a streaming manner: "inherited.jams_with_distance" */
  inherited_jams_with_distance_stream: Array<Inherited_Jams_With_DistanceType>;
  /** fetch data from the table: "invite_entity" */
  invite_entity: Array<Invite_EntityType>;
  /** fetch aggregated fields from the table: "invite_entity" */
  invite_entity_aggregate: Invite_Entity_AggregateType;
  /** fetch data from the table: "invite_entity" using primary key columns */
  invite_entity_by_pk?: Maybe<Invite_EntityType>;
  /** fetch data from the table in a streaming manner: "invite_entity" */
  invite_entity_stream: Array<Invite_EntityType>;
  /** An array relationship */
  invites: Array<InvitesType>;
  /** An aggregate relationship */
  invites_aggregate: Invites_AggregateType;
  /** fetch data from the table: "invites" using primary key columns */
  invites_by_pk?: Maybe<InvitesType>;
  /** fetch data from the table in a streaming manner: "invites" */
  invites_stream: Array<InvitesType>;
  /** fetch data from the table: "jam_participants" */
  jam_participants: Array<Jam_ParticipantsType>;
  /** fetch aggregated fields from the table: "jam_participants" */
  jam_participants_aggregate: Jam_Participants_AggregateType;
  /** fetch data from the table: "jam_participants" using primary key columns */
  jam_participants_by_pk?: Maybe<Jam_ParticipantsType>;
  /** fetch data from the table in a streaming manner: "jam_participants" */
  jam_participants_stream: Array<Jam_ParticipantsType>;
  /** An array relationship */
  jams: Array<JamsType>;
  /** An aggregate relationship */
  jams_aggregate: Jams_AggregateType;
  /** execute function "jams_by_location_v1" which returns "inherited.jams_with_distance" */
  jams_by_location_v1: Array<Inherited_Jams_With_DistanceType>;
  /** execute function "jams_by_location_v1" and query aggregates on result of table type "inherited.jams_with_distance" */
  jams_by_location_v1_aggregate: Inherited_Jams_With_Distance_AggregateType;
  /** fetch data from the table: "jams" using primary key columns */
  jams_by_pk?: Maybe<JamsType>;
  /** fetch data from the table in a streaming manner: "jams" */
  jams_stream: Array<JamsType>;
  /** fetch data from the table: "levels" */
  levels: Array<LevelsType>;
  /** fetch aggregated fields from the table: "levels" */
  levels_aggregate: Levels_AggregateType;
  /** fetch data from the table: "levels" using primary key columns */
  levels_by_pk?: Maybe<LevelsType>;
  /** fetch data from the table in a streaming manner: "levels" */
  levels_stream: Array<LevelsType>;
  /** fetch data from the table: "me" */
  me: Array<MeType>;
  /** fetch aggregated fields from the table: "me" */
  me_aggregate: Me_AggregateType;
  /** fetch data from the table in a streaming manner: "me" */
  me_stream: Array<MeType>;
  /** An array relationship */
  recurring_patterns: Array<Recurring_PatternsType>;
  /** An aggregate relationship */
  recurring_patterns_aggregate: Recurring_Patterns_AggregateType;
  /** fetch data from the table: "recurring_patterns" using primary key columns */
  recurring_patterns_by_pk?: Maybe<Recurring_PatternsType>;
  /** fetch data from the table in a streaming manner: "recurring_patterns" */
  recurring_patterns_stream: Array<Recurring_PatternsType>;
  /** fetch data from the table: "roles" */
  roles: Array<RolesType>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_AggregateType;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<RolesType>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<RolesType>;
  /** fetch data from the table: "teacher_images" */
  teacher_images: Array<Teacher_ImagesType>;
  /** fetch aggregated fields from the table: "teacher_images" */
  teacher_images_aggregate: Teacher_Images_AggregateType;
  /** fetch data from the table: "teacher_images" using primary key columns */
  teacher_images_by_pk?: Maybe<Teacher_ImagesType>;
  /** fetch data from the table in a streaming manner: "teacher_images" */
  teacher_images_stream: Array<Teacher_ImagesType>;
  /** An array relationship */
  teacher_levels: Array<Teacher_LevelsType>;
  /** An aggregate relationship */
  teacher_levels_aggregate: Teacher_Levels_AggregateType;
  /** fetch data from the table: "teacher_levels" using primary key columns */
  teacher_levels_by_pk?: Maybe<Teacher_LevelsType>;
  /** fetch data from the table in a streaming manner: "teacher_levels" */
  teacher_levels_stream: Array<Teacher_LevelsType>;
  /** An array relationship */
  teacher_likes: Array<Teacher_LikesType>;
  /** An aggregate relationship */
  teacher_likes_aggregate: Teacher_Likes_AggregateType;
  /** fetch data from the table: "teacher_likes" using primary key columns */
  teacher_likes_by_pk?: Maybe<Teacher_LikesType>;
  /** fetch data from the table in a streaming manner: "teacher_likes" */
  teacher_likes_stream: Array<Teacher_LikesType>;
  /** fetch data from the table: "teacher_type" */
  teacher_type: Array<Teacher_TypeType>;
  /** fetch aggregated fields from the table: "teacher_type" */
  teacher_type_aggregate: Teacher_Type_AggregateType;
  /** fetch data from the table: "teacher_type" using primary key columns */
  teacher_type_by_pk?: Maybe<Teacher_TypeType>;
  /** fetch data from the table in a streaming manner: "teacher_type" */
  teacher_type_stream: Array<Teacher_TypeType>;
  /** fetch data from the table: "teachers" */
  teachers: Array<TeachersType>;
  /** fetch aggregated fields from the table: "teachers" */
  teachers_aggregate: Teachers_AggregateType;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: Maybe<TeachersType>;
  /** fetch data from the table in a streaming manner: "teachers" */
  teachers_stream: Array<TeachersType>;
  /** An array relationship */
  user_communities: Array<User_CommunitiesType>;
  /** An aggregate relationship */
  user_communities_aggregate: User_Communities_AggregateType;
  /** fetch data from the table: "user_communities" using primary key columns */
  user_communities_by_pk?: Maybe<User_CommunitiesType>;
  /** fetch data from the table in a streaming manner: "user_communities" */
  user_communities_stream: Array<User_CommunitiesType>;
  /** An array relationship */
  user_roles: Array<User_RolesType>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Roles_AggregateType;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_RolesType>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  user_roles_stream: Array<User_RolesType>;
  /** fetch data from the table: "users" */
  users: Array<UsersType>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_AggregateType;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<UsersType>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<UsersType>;
};


export type Subscription_RootAcro_RolesArgsType = {
  distinct_on?: InputMaybe<Array<Acro_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acro_Roles_Order_ByType>>;
  where?: InputMaybe<Acro_Roles_Bool_ExpType>;
};


export type Subscription_RootAcro_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Acro_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acro_Roles_Order_ByType>>;
  where?: InputMaybe<Acro_Roles_Bool_ExpType>;
};


export type Subscription_RootAcro_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootAcro_Roles_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Acro_Roles_Stream_Cursor_InputType>>;
  where?: InputMaybe<Acro_Roles_Bool_ExpType>;
};


export type Subscription_RootBooking_OptionArgsType = {
  distinct_on?: InputMaybe<Array<Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Option_Order_ByType>>;
  where?: InputMaybe<Booking_Option_Bool_ExpType>;
};


export type Subscription_RootBooking_Option_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Booking_Option_Order_ByType>>;
  where?: InputMaybe<Booking_Option_Bool_ExpType>;
};


export type Subscription_RootBooking_Option_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootBooking_Option_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Booking_Option_Stream_Cursor_InputType>>;
  where?: InputMaybe<Booking_Option_Bool_ExpType>;
};


export type Subscription_RootClass_Booking_OptionArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


export type Subscription_RootClass_Booking_Option_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Booking_Option_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Booking_Option_Order_ByType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


export type Subscription_RootClass_Booking_Option_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Booking_Option_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Booking_Option_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Booking_Option_Bool_ExpType>;
};


export type Subscription_RootClass_Event_BookingsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


export type Subscription_RootClass_Event_Bookings_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookings_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookings_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


export type Subscription_RootClass_Event_Bookings_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Event_Bookings_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Event_Bookings_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
};


export type Subscription_RootClass_Event_BookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


export type Subscription_RootClass_Event_Bookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


export type Subscription_RootClass_Event_Bookmarks_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Event_Bookmarks_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Event_Bookmarks_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


export type Subscription_RootClass_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


export type Subscription_RootClass_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Order_ByType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


export type Subscription_RootClass_Events_By_Location_V1ArgsType = {
  args: Class_Events_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Subscription_RootClass_Events_By_Location_V1_AggregateArgsType = {
  args: Class_Events_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Subscription_RootClass_Events_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Events_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


export type Subscription_RootClass_Events_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


export type Subscription_RootClass_Events_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Events_Participants_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Events_Participants_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


export type Subscription_RootClass_Events_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Events_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Events_Bool_ExpType>;
};


export type Subscription_RootClass_FavoritesArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


export type Subscription_RootClass_Favorites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Favorites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Favorites_Order_ByType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


export type Subscription_RootClass_Favorites_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Favorites_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Favorites_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Favorites_Bool_ExpType>;
};


export type Subscription_RootClass_FlagArgsType = {
  distinct_on?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Flag_Order_ByType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


export type Subscription_RootClass_Flag_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Flag_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Flag_Order_ByType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


export type Subscription_RootClass_Flag_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Flag_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Flag_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Flag_Bool_ExpType>;
};


export type Subscription_RootClass_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


export type Subscription_RootClass_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Levels_Order_ByType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


export type Subscription_RootClass_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Levels_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Levels_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Levels_Bool_ExpType>;
};


export type Subscription_RootClass_OwnersArgsType = {
  distinct_on?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Owners_Order_ByType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


export type Subscription_RootClass_Owners_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Owners_Order_ByType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


export type Subscription_RootClass_Owners_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Owners_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Owners_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Owners_Bool_ExpType>;
};


export type Subscription_RootClass_TeachersArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


export type Subscription_RootClass_Teachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


export type Subscription_RootClass_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClass_Teachers_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Class_Teachers_Stream_Cursor_InputType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


export type Subscription_RootClassesArgsType = {
  distinct_on?: InputMaybe<Array<Classes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classes_Order_ByType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};


export type Subscription_RootClasses_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Classes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Classes_Order_ByType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};


export type Subscription_RootClasses_By_Location_V1ArgsType = {
  args: Classes_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Subscription_RootClasses_By_Location_V1_AggregateArgsType = {
  args: Classes_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Subscription_RootClasses_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootClasses_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Classes_Stream_Cursor_InputType>>;
  where?: InputMaybe<Classes_Bool_ExpType>;
};


export type Subscription_RootCommunitiesArgsType = {
  distinct_on?: InputMaybe<Array<Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communities_Order_ByType>>;
  where?: InputMaybe<Communities_Bool_ExpType>;
};


export type Subscription_RootCommunities_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Communities_Order_ByType>>;
  where?: InputMaybe<Communities_Bool_ExpType>;
};


export type Subscription_RootCommunities_By_Location_V1ArgsType = {
  args: Communities_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Subscription_RootCommunities_By_Location_V1_AggregateArgsType = {
  args: Communities_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Subscription_RootCommunities_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootCommunities_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Communities_Stream_Cursor_InputType>>;
  where?: InputMaybe<Communities_Bool_ExpType>;
};


export type Subscription_RootCommunity_MessagesArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


export type Subscription_RootCommunity_Messages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Community_Messages_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Community_Messages_Order_ByType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


export type Subscription_RootCommunity_Messages_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootCommunity_Messages_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Community_Messages_Stream_Cursor_InputType>>;
  where?: InputMaybe<Community_Messages_Bool_ExpType>;
};


export type Subscription_RootConfigArgsType = {
  distinct_on?: InputMaybe<Array<Config_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Config_Order_ByType>>;
  where?: InputMaybe<Config_Bool_ExpType>;
};


export type Subscription_RootConfig_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Config_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Config_Order_ByType>>;
  where?: InputMaybe<Config_Bool_ExpType>;
};


export type Subscription_RootConfig_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootConfig_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Config_Stream_Cursor_InputType>>;
  where?: InputMaybe<Config_Bool_ExpType>;
};


export type Subscription_RootConfirmation_StatusArgsType = {
  distinct_on?: InputMaybe<Array<Confirmation_Status_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Confirmation_Status_Order_ByType>>;
  where?: InputMaybe<Confirmation_Status_Bool_ExpType>;
};


export type Subscription_RootConfirmation_Status_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Confirmation_Status_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Confirmation_Status_Order_ByType>>;
  where?: InputMaybe<Confirmation_Status_Bool_ExpType>;
};


export type Subscription_RootConfirmation_Status_By_PkArgsType = {
  value: Scalars['String'];
};


export type Subscription_RootConfirmation_Status_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Confirmation_Status_Stream_Cursor_InputType>>;
  where?: InputMaybe<Confirmation_Status_Bool_ExpType>;
};


export type Subscription_RootCreated_InvitesArgsType = {
  distinct_on?: InputMaybe<Array<Created_Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Created_Invites_Order_ByType>>;
  where?: InputMaybe<Created_Invites_Bool_ExpType>;
};


export type Subscription_RootCreated_Invites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Created_Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Created_Invites_Order_ByType>>;
  where?: InputMaybe<Created_Invites_Bool_ExpType>;
};


export type Subscription_RootCreated_Invites_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Created_Invites_Stream_Cursor_InputType>>;
  where?: InputMaybe<Created_Invites_Bool_ExpType>;
};


export type Subscription_RootEvent_BookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


export type Subscription_RootEvent_Bookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


export type Subscription_RootEvent_Bookmarks_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_Bookmarks_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Bookmarks_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Bookmarks_Bool_ExpType>;
};


export type Subscription_RootEvent_InstanceArgsType = {
  distinct_on?: InputMaybe<Array<Event_Instance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Instance_Order_ByType>>;
  where?: InputMaybe<Event_Instance_Bool_ExpType>;
};


export type Subscription_RootEvent_Instance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Instance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Instance_Order_ByType>>;
  where?: InputMaybe<Event_Instance_Bool_ExpType>;
};


export type Subscription_RootEvent_Instance_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_Instance_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Instance_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Instance_Bool_ExpType>;
};


export type Subscription_RootEvent_OwnersArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


export type Subscription_RootEvent_Owners_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


export type Subscription_RootEvent_Owners_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_Owners_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Owners_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


export type Subscription_RootEvent_SourceArgsType = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_ByType>>;
  where?: InputMaybe<Event_Source_Bool_ExpType>;
};


export type Subscription_RootEvent_Source_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Source_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Source_Order_ByType>>;
  where?: InputMaybe<Event_Source_Bool_ExpType>;
};


export type Subscription_RootEvent_Source_By_PkArgsType = {
  value: Scalars['String'];
};


export type Subscription_RootEvent_Source_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Source_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Source_Bool_ExpType>;
};


export type Subscription_RootEvent_TeachersArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


export type Subscription_RootEvent_Teachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


export type Subscription_RootEvent_Teachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_Teachers_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Teachers_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


export type Subscription_RootEvent_TemplateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Template_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Template_Order_ByType>>;
  where?: InputMaybe<Event_Template_Bool_ExpType>;
};


export type Subscription_RootEvent_Template_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Template_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Template_Order_ByType>>;
  where?: InputMaybe<Event_Template_Bool_ExpType>;
};


export type Subscription_RootEvent_Template_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_Template_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Template_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Template_Bool_ExpType>;
};


export type Subscription_RootEvent_TypeArgsType = {
  distinct_on?: InputMaybe<Array<Event_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Type_Order_ByType>>;
  where?: InputMaybe<Event_Type_Bool_ExpType>;
};


export type Subscription_RootEvent_Type_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Type_Order_ByType>>;
  where?: InputMaybe<Event_Type_Bool_ExpType>;
};


export type Subscription_RootEvent_Type_By_PkArgsType = {
  value: Scalars['String'];
};


export type Subscription_RootEvent_Type_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_Type_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_Type_Bool_ExpType>;
};


export type Subscription_RootEvent_User_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_User_Participants_Order_ByType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};


export type Subscription_RootEvent_User_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_User_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_User_Participants_Order_ByType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};


export type Subscription_RootEvent_User_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvent_User_Participants_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Event_User_Participants_Stream_Cursor_InputType>>;
  where?: InputMaybe<Event_User_Participants_Bool_ExpType>;
};


export type Subscription_RootEventsArgsType = {
  distinct_on?: InputMaybe<Array<Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_ByType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


export type Subscription_RootEvents_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_ByType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


export type Subscription_RootEvents_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootEvents_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_InputType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


export type Subscription_RootImagesArgsType = {
  distinct_on?: InputMaybe<Array<Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Images_Order_ByType>>;
  where?: InputMaybe<Images_Bool_ExpType>;
};


export type Subscription_RootImages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Images_Order_ByType>>;
  where?: InputMaybe<Images_Bool_ExpType>;
};


export type Subscription_RootImages_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootImages_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Images_Stream_Cursor_InputType>>;
  where?: InputMaybe<Images_Bool_ExpType>;
};


export type Subscription_RootInherited_Class_Events_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Class_Events_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Class_Events_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Class_Events_With_Distance_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Inherited_Class_Events_With_Distance_Stream_Cursor_InputType>>;
  where?: InputMaybe<Inherited_Class_Events_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Classes_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Classes_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Classes_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Classes_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Classes_With_Distance_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Inherited_Classes_With_Distance_Stream_Cursor_InputType>>;
  where?: InputMaybe<Inherited_Classes_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Communities_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Communities_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Communities_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Communities_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Communities_With_Distance_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Inherited_Communities_With_Distance_Stream_Cursor_InputType>>;
  where?: InputMaybe<Inherited_Communities_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Jams_With_DistanceArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Jams_With_Distance_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInherited_Jams_With_Distance_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Inherited_Jams_With_Distance_Stream_Cursor_InputType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Subscription_RootInvite_EntityArgsType = {
  distinct_on?: InputMaybe<Array<Invite_Entity_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Entity_Order_ByType>>;
  where?: InputMaybe<Invite_Entity_Bool_ExpType>;
};


export type Subscription_RootInvite_Entity_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invite_Entity_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Entity_Order_ByType>>;
  where?: InputMaybe<Invite_Entity_Bool_ExpType>;
};


export type Subscription_RootInvite_Entity_By_PkArgsType = {
  value: Scalars['String'];
};


export type Subscription_RootInvite_Entity_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invite_Entity_Stream_Cursor_InputType>>;
  where?: InputMaybe<Invite_Entity_Bool_ExpType>;
};


export type Subscription_RootInvitesArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


export type Subscription_RootInvites_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Invites_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invites_Order_ByType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


export type Subscription_RootInvites_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvites_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invites_Stream_Cursor_InputType>>;
  where?: InputMaybe<Invites_Bool_ExpType>;
};


export type Subscription_RootJam_ParticipantsArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


export type Subscription_RootJam_Participants_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jam_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jam_Participants_Order_ByType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


export type Subscription_RootJam_Participants_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootJam_Participants_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Jam_Participants_Stream_Cursor_InputType>>;
  where?: InputMaybe<Jam_Participants_Bool_ExpType>;
};


export type Subscription_RootJamsArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


export type Subscription_RootJams_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


export type Subscription_RootJams_By_Location_V1ArgsType = {
  args: Jams_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Subscription_RootJams_By_Location_V1_AggregateArgsType = {
  args: Jams_By_Location_V1_ArgsType;
  distinct_on?: InputMaybe<Array<Inherited_Jams_With_Distance_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inherited_Jams_With_Distance_Order_ByType>>;
  where?: InputMaybe<Inherited_Jams_With_Distance_Bool_ExpType>;
};


export type Subscription_RootJams_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootJams_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Jams_Stream_Cursor_InputType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


export type Subscription_RootLevelsArgsType = {
  distinct_on?: InputMaybe<Array<Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Levels_Order_ByType>>;
  where?: InputMaybe<Levels_Bool_ExpType>;
};


export type Subscription_RootLevels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Levels_Order_ByType>>;
  where?: InputMaybe<Levels_Bool_ExpType>;
};


export type Subscription_RootLevels_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootLevels_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Levels_Stream_Cursor_InputType>>;
  where?: InputMaybe<Levels_Bool_ExpType>;
};


export type Subscription_RootMeArgsType = {
  distinct_on?: InputMaybe<Array<Me_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Me_Order_ByType>>;
  where?: InputMaybe<Me_Bool_ExpType>;
};


export type Subscription_RootMe_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Me_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Me_Order_ByType>>;
  where?: InputMaybe<Me_Bool_ExpType>;
};


export type Subscription_RootMe_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Me_Stream_Cursor_InputType>>;
  where?: InputMaybe<Me_Bool_ExpType>;
};


export type Subscription_RootRecurring_PatternsArgsType = {
  distinct_on?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Patterns_Order_ByType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};


export type Subscription_RootRecurring_Patterns_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Recurring_Patterns_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Recurring_Patterns_Order_ByType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};


export type Subscription_RootRecurring_Patterns_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootRecurring_Patterns_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Recurring_Patterns_Stream_Cursor_InputType>>;
  where?: InputMaybe<Recurring_Patterns_Bool_ExpType>;
};


export type Subscription_RootRolesArgsType = {
  distinct_on?: InputMaybe<Array<Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_ByType>>;
  where?: InputMaybe<Roles_Bool_ExpType>;
};


export type Subscription_RootRoles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_ByType>>;
  where?: InputMaybe<Roles_Bool_ExpType>;
};


export type Subscription_RootRoles_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootRoles_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_InputType>>;
  where?: InputMaybe<Roles_Bool_ExpType>;
};


export type Subscription_RootTeacher_ImagesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


export type Subscription_RootTeacher_Images_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


export type Subscription_RootTeacher_Images_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeacher_Images_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teacher_Images_Stream_Cursor_InputType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


export type Subscription_RootTeacher_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Levels_Order_ByType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


export type Subscription_RootTeacher_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Levels_Order_ByType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


export type Subscription_RootTeacher_Levels_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeacher_Levels_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teacher_Levels_Stream_Cursor_InputType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


export type Subscription_RootTeacher_LikesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


export type Subscription_RootTeacher_Likes_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


export type Subscription_RootTeacher_Likes_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeacher_Likes_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teacher_Likes_Stream_Cursor_InputType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


export type Subscription_RootTeacher_TypeArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Type_Order_ByType>>;
  where?: InputMaybe<Teacher_Type_Bool_ExpType>;
};


export type Subscription_RootTeacher_Type_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Type_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Type_Order_ByType>>;
  where?: InputMaybe<Teacher_Type_Bool_ExpType>;
};


export type Subscription_RootTeacher_Type_By_PkArgsType = {
  value: Scalars['String'];
};


export type Subscription_RootTeacher_Type_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teacher_Type_Stream_Cursor_InputType>>;
  where?: InputMaybe<Teacher_Type_Bool_ExpType>;
};


export type Subscription_RootTeachersArgsType = {
  distinct_on?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teachers_Order_ByType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


export type Subscription_RootTeachers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teachers_Order_ByType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


export type Subscription_RootTeachers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootTeachers_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Teachers_Stream_Cursor_InputType>>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};


export type Subscription_RootUser_CommunitiesArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


export type Subscription_RootUser_Communities_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


export type Subscription_RootUser_Communities_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Communities_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Communities_Stream_Cursor_InputType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


export type Subscription_RootUser_RolesArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


export type Subscription_RootUser_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


export type Subscription_RootUser_Roles_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Roles_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Roles_Stream_Cursor_InputType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


export type Subscription_RootUsersArgsType = {
  distinct_on?: InputMaybe<Array<Users_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_ByType>>;
  where?: InputMaybe<Users_Bool_ExpType>;
};


export type Subscription_RootUsers_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Users_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_ByType>>;
  where?: InputMaybe<Users_Bool_ExpType>;
};


export type Subscription_RootUsers_By_PkArgsType = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgsType = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_InputType>>;
  where?: InputMaybe<Users_Bool_ExpType>;
};

/** columns and relationships of "teacher_images" */
export type Teacher_ImagesType = {
  __typename?: 'teacher_images';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  image: ImagesType;
  image_id: Scalars['uuid'];
  is_profile_picture: Scalars['Boolean'];
  /** An object relationship */
  teacher: TeachersType;
  teacher_id: Scalars['uuid'];
};

/** aggregated selection of "teacher_images" */
export type Teacher_Images_AggregateType = {
  __typename?: 'teacher_images_aggregate';
  aggregate?: Maybe<Teacher_Images_Aggregate_FieldsType>;
  nodes: Array<Teacher_ImagesType>;
};

export type Teacher_Images_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Teacher_Images_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Teacher_Images_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Teacher_Images_Aggregate_Bool_Exp_CountType>;
};

export type Teacher_Images_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Teacher_Images_Select_Column_Teacher_Images_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teacher_Images_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Teacher_Images_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Teacher_Images_Select_Column_Teacher_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teacher_Images_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Teacher_Images_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teacher_Images_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "teacher_images" */
export type Teacher_Images_Aggregate_FieldsType = {
  __typename?: 'teacher_images_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Teacher_Images_Max_FieldsType>;
  min?: Maybe<Teacher_Images_Min_FieldsType>;
};


/** aggregate fields of "teacher_images" */
export type Teacher_Images_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teacher_images" */
export type Teacher_Images_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Teacher_Images_Max_Order_ByType>;
  min?: InputMaybe<Teacher_Images_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "teacher_images" */
export type Teacher_Images_Arr_Rel_Insert_InputType = {
  data: Array<Teacher_Images_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teacher_Images_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "teacher_images". All fields are combined with a logical 'AND'. */
export type Teacher_Images_Bool_ExpType = {
  _and?: InputMaybe<Array<Teacher_Images_Bool_ExpType>>;
  _not?: InputMaybe<Teacher_Images_Bool_ExpType>;
  _or?: InputMaybe<Array<Teacher_Images_Bool_ExpType>>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  image?: InputMaybe<Images_Bool_ExpType>;
  image_id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_profile_picture?: InputMaybe<Boolean_Comparison_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "teacher_images" */
export enum Teacher_Images_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  TeacherImagesPkeyType = 'teacher_images_pkey'
}

/** input type for inserting data into table "teacher_images" */
export type Teacher_Images_Insert_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_InputType>;
  image_id?: InputMaybe<Scalars['uuid']>;
  is_profile_picture?: InputMaybe<Scalars['Boolean']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Teacher_Images_Max_FieldsType = {
  __typename?: 'teacher_images_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "teacher_images" */
export type Teacher_Images_Max_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Teacher_Images_Min_FieldsType = {
  __typename?: 'teacher_images_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "teacher_images" */
export type Teacher_Images_Min_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "teacher_images" */
export type Teacher_Images_Mutation_ResponseType = {
  __typename?: 'teacher_images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teacher_ImagesType>;
};

/** on_conflict condition type for table "teacher_images" */
export type Teacher_Images_On_ConflictType = {
  constraint: Teacher_Images_ConstraintType;
  update_columns?: Array<Teacher_Images_Update_ColumnType>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};

/** Ordering options when selecting data from "teacher_images". */
export type Teacher_Images_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image?: InputMaybe<Images_Order_ByType>;
  image_id?: InputMaybe<Order_ByType>;
  is_profile_picture?: InputMaybe<Order_ByType>;
  teacher?: InputMaybe<Teachers_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: teacher_images */
export type Teacher_Images_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "teacher_images" */
export enum Teacher_Images_Select_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageIdType = 'image_id',
  /** column name */
  IsProfilePictureType = 'is_profile_picture',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** select "teacher_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teacher_images" */
export enum Teacher_Images_Select_Column_Teacher_Images_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsProfilePictureType = 'is_profile_picture'
}

/** select "teacher_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teacher_images" */
export enum Teacher_Images_Select_Column_Teacher_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsProfilePictureType = 'is_profile_picture'
}

/** input type for updating data in table "teacher_images" */
export type Teacher_Images_Set_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_id?: InputMaybe<Scalars['uuid']>;
  is_profile_picture?: InputMaybe<Scalars['Boolean']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "teacher_images" */
export type Teacher_Images_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Teacher_Images_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Teacher_Images_Stream_Cursor_Value_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_id?: InputMaybe<Scalars['uuid']>;
  is_profile_picture?: InputMaybe<Scalars['Boolean']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "teacher_images" */
export enum Teacher_Images_Update_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageIdType = 'image_id',
  /** column name */
  IsProfilePictureType = 'is_profile_picture',
  /** column name */
  TeacherIdType = 'teacher_id'
}

export type Teacher_Images_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teacher_Images_Set_InputType>;
  where: Teacher_Images_Bool_ExpType;
};

/** columns and relationships of "teacher_levels" */
export type Teacher_LevelsType = {
  __typename?: 'teacher_levels';
  id: Scalars['uuid'];
  /** An object relationship */
  level: LevelsType;
  level_id: Scalars['uuid'];
  /** An object relationship */
  teacher: TeachersType;
  teacher_id: Scalars['uuid'];
};

/** aggregated selection of "teacher_levels" */
export type Teacher_Levels_AggregateType = {
  __typename?: 'teacher_levels_aggregate';
  aggregate?: Maybe<Teacher_Levels_Aggregate_FieldsType>;
  nodes: Array<Teacher_LevelsType>;
};

export type Teacher_Levels_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Teacher_Levels_Aggregate_Bool_Exp_CountType>;
};

export type Teacher_Levels_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teacher_Levels_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "teacher_levels" */
export type Teacher_Levels_Aggregate_FieldsType = {
  __typename?: 'teacher_levels_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Teacher_Levels_Max_FieldsType>;
  min?: Maybe<Teacher_Levels_Min_FieldsType>;
};


/** aggregate fields of "teacher_levels" */
export type Teacher_Levels_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teacher_levels" */
export type Teacher_Levels_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Teacher_Levels_Max_Order_ByType>;
  min?: InputMaybe<Teacher_Levels_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "teacher_levels" */
export type Teacher_Levels_Arr_Rel_Insert_InputType = {
  data: Array<Teacher_Levels_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teacher_Levels_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "teacher_levels". All fields are combined with a logical 'AND'. */
export type Teacher_Levels_Bool_ExpType = {
  _and?: InputMaybe<Array<Teacher_Levels_Bool_ExpType>>;
  _not?: InputMaybe<Teacher_Levels_Bool_ExpType>;
  _or?: InputMaybe<Array<Teacher_Levels_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  level?: InputMaybe<Levels_Bool_ExpType>;
  level_id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "teacher_levels" */
export enum Teacher_Levels_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  TeacherLevelsPkeyType = 'teacher_levels_pkey'
}

/** input type for inserting data into table "teacher_levels" */
export type Teacher_Levels_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Levels_Obj_Rel_Insert_InputType>;
  level_id?: InputMaybe<Scalars['uuid']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Teacher_Levels_Max_FieldsType = {
  __typename?: 'teacher_levels_max_fields';
  id?: Maybe<Scalars['uuid']>;
  level_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "teacher_levels" */
export type Teacher_Levels_Max_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Teacher_Levels_Min_FieldsType = {
  __typename?: 'teacher_levels_min_fields';
  id?: Maybe<Scalars['uuid']>;
  level_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "teacher_levels" */
export type Teacher_Levels_Min_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "teacher_levels" */
export type Teacher_Levels_Mutation_ResponseType = {
  __typename?: 'teacher_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teacher_LevelsType>;
};

/** on_conflict condition type for table "teacher_levels" */
export type Teacher_Levels_On_ConflictType = {
  constraint: Teacher_Levels_ConstraintType;
  update_columns?: Array<Teacher_Levels_Update_ColumnType>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};

/** Ordering options when selecting data from "teacher_levels". */
export type Teacher_Levels_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  level?: InputMaybe<Levels_Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
  teacher?: InputMaybe<Teachers_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: teacher_levels */
export type Teacher_Levels_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "teacher_levels" */
export enum Teacher_Levels_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  LevelIdType = 'level_id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

/** input type for updating data in table "teacher_levels" */
export type Teacher_Levels_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  level_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "teacher_levels" */
export type Teacher_Levels_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Teacher_Levels_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Teacher_Levels_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  level_id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "teacher_levels" */
export enum Teacher_Levels_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  LevelIdType = 'level_id',
  /** column name */
  TeacherIdType = 'teacher_id'
}

export type Teacher_Levels_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teacher_Levels_Set_InputType>;
  where: Teacher_Levels_Bool_ExpType;
};

/** columns and relationships of "teacher_likes" */
export type Teacher_LikesType = {
  __typename?: 'teacher_likes';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  teacher?: Maybe<TeachersType>;
  teacher_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "teacher_likes" */
export type Teacher_Likes_AggregateType = {
  __typename?: 'teacher_likes_aggregate';
  aggregate?: Maybe<Teacher_Likes_Aggregate_FieldsType>;
  nodes: Array<Teacher_LikesType>;
};

export type Teacher_Likes_Aggregate_Bool_ExpType = {
  count?: InputMaybe<Teacher_Likes_Aggregate_Bool_Exp_CountType>;
};

export type Teacher_Likes_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teacher_Likes_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "teacher_likes" */
export type Teacher_Likes_Aggregate_FieldsType = {
  __typename?: 'teacher_likes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Teacher_Likes_Max_FieldsType>;
  min?: Maybe<Teacher_Likes_Min_FieldsType>;
};


/** aggregate fields of "teacher_likes" */
export type Teacher_Likes_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teacher_likes" */
export type Teacher_Likes_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Teacher_Likes_Max_Order_ByType>;
  min?: InputMaybe<Teacher_Likes_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "teacher_likes" */
export type Teacher_Likes_Arr_Rel_Insert_InputType = {
  data: Array<Teacher_Likes_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teacher_Likes_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "teacher_likes". All fields are combined with a logical 'AND'. */
export type Teacher_Likes_Bool_ExpType = {
  _and?: InputMaybe<Array<Teacher_Likes_Bool_ExpType>>;
  _not?: InputMaybe<Teacher_Likes_Bool_ExpType>;
  _or?: InputMaybe<Array<Teacher_Likes_Bool_ExpType>>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher?: InputMaybe<Teachers_Bool_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "teacher_likes" */
export enum Teacher_Likes_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  TeacherLikesPkeyType = 'teacher_likes_pkey',
  /** unique or primary key constraint on columns "user_id", "teacher_id" */
  TeacherLikesUserIdTeacherIdKeyType = 'teacher_likes_user_id_teacher_id_key'
}

/** input type for inserting data into table "teacher_likes" */
export type Teacher_Likes_Insert_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  teacher?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Teacher_Likes_Max_FieldsType = {
  __typename?: 'teacher_likes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "teacher_likes" */
export type Teacher_Likes_Max_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Teacher_Likes_Min_FieldsType = {
  __typename?: 'teacher_likes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "teacher_likes" */
export type Teacher_Likes_Min_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "teacher_likes" */
export type Teacher_Likes_Mutation_ResponseType = {
  __typename?: 'teacher_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teacher_LikesType>;
};

/** on_conflict condition type for table "teacher_likes" */
export type Teacher_Likes_On_ConflictType = {
  constraint: Teacher_Likes_ConstraintType;
  update_columns?: Array<Teacher_Likes_Update_ColumnType>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};

/** Ordering options when selecting data from "teacher_likes". */
export type Teacher_Likes_Order_ByType = {
  created_at?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  teacher?: InputMaybe<Teachers_Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: teacher_likes */
export type Teacher_Likes_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "teacher_likes" */
export enum Teacher_Likes_Select_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  TeacherIdType = 'teacher_id',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "teacher_likes" */
export type Teacher_Likes_Set_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "teacher_likes" */
export type Teacher_Likes_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Teacher_Likes_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Teacher_Likes_Stream_Cursor_Value_InputType = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "teacher_likes" */
export enum Teacher_Likes_Update_ColumnType {
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  IdType = 'id',
  /** column name */
  TeacherIdType = 'teacher_id',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UserIdType = 'user_id'
}

export type Teacher_Likes_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teacher_Likes_Set_InputType>;
  where: Teacher_Likes_Bool_ExpType;
};

/** columns and relationships of "teacher_type" */
export type Teacher_TypeType = {
  __typename?: 'teacher_type';
  value: Scalars['String'];
};

/** aggregated selection of "teacher_type" */
export type Teacher_Type_AggregateType = {
  __typename?: 'teacher_type_aggregate';
  aggregate?: Maybe<Teacher_Type_Aggregate_FieldsType>;
  nodes: Array<Teacher_TypeType>;
};

/** aggregate fields of "teacher_type" */
export type Teacher_Type_Aggregate_FieldsType = {
  __typename?: 'teacher_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Teacher_Type_Max_FieldsType>;
  min?: Maybe<Teacher_Type_Min_FieldsType>;
};


/** aggregate fields of "teacher_type" */
export type Teacher_Type_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Teacher_Type_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "teacher_type". All fields are combined with a logical 'AND'. */
export type Teacher_Type_Bool_ExpType = {
  _and?: InputMaybe<Array<Teacher_Type_Bool_ExpType>>;
  _not?: InputMaybe<Teacher_Type_Bool_ExpType>;
  _or?: InputMaybe<Array<Teacher_Type_Bool_ExpType>>;
  value?: InputMaybe<String_Comparison_ExpType>;
};

/** unique or primary key constraints on table "teacher_type" */
export enum Teacher_Type_ConstraintType {
  /** unique or primary key constraint on columns "value" */
  TeacherTypePkeyType = 'teacher_type_pkey'
}

export enum Teacher_Type_EnumType {
  AnonymousType = 'Anonymous',
  StudioType = 'Studio',
  TeacherType = 'Teacher'
}

/** Boolean expression to compare columns of type "teacher_type_enum". All fields are combined with logical 'AND'. */
export type Teacher_Type_Enum_Comparison_ExpType = {
  _eq?: InputMaybe<Teacher_Type_EnumType>;
  _in?: InputMaybe<Array<Teacher_Type_EnumType>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Teacher_Type_EnumType>;
  _nin?: InputMaybe<Array<Teacher_Type_EnumType>>;
};

/** input type for inserting data into table "teacher_type" */
export type Teacher_Type_Insert_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Teacher_Type_Max_FieldsType = {
  __typename?: 'teacher_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Teacher_Type_Min_FieldsType = {
  __typename?: 'teacher_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "teacher_type" */
export type Teacher_Type_Mutation_ResponseType = {
  __typename?: 'teacher_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Teacher_TypeType>;
};

/** on_conflict condition type for table "teacher_type" */
export type Teacher_Type_On_ConflictType = {
  constraint: Teacher_Type_ConstraintType;
  update_columns?: Array<Teacher_Type_Update_ColumnType>;
  where?: InputMaybe<Teacher_Type_Bool_ExpType>;
};

/** Ordering options when selecting data from "teacher_type". */
export type Teacher_Type_Order_ByType = {
  value?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: teacher_type */
export type Teacher_Type_Pk_Columns_InputType = {
  value: Scalars['String'];
};

/** select columns of table "teacher_type" */
export enum Teacher_Type_Select_ColumnType {
  /** column name */
  ValueType = 'value'
}

/** input type for updating data in table "teacher_type" */
export type Teacher_Type_Set_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "teacher_type" */
export type Teacher_Type_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Teacher_Type_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Teacher_Type_Stream_Cursor_Value_InputType = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "teacher_type" */
export enum Teacher_Type_Update_ColumnType {
  /** column name */
  ValueType = 'value'
}

export type Teacher_Type_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teacher_Type_Set_InputType>;
  where: Teacher_Type_Bool_ExpType;
};

/** columns and relationships of "teachers" */
export type TeachersType = {
  __typename?: 'teachers';
  /** An array relationship */
  classes: Array<Class_TeachersType>;
  /** An aggregate relationship */
  classes_aggregate: Class_Teachers_AggregateType;
  /** An object relationship */
  community?: Maybe<CommunitiesType>;
  community_id?: Maybe<Scalars['uuid']>;
  confirmation_status: Confirmation_Status_EnumType;
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  /** An array relationship */
  events: Array<Event_TeachersType>;
  /** An aggregate relationship */
  events_aggregate: Event_Teachers_AggregateType;
  id: Scalars['uuid'];
  /** An array relationship */
  images: Array<Teacher_ImagesType>;
  /** An aggregate relationship */
  images_aggregate: Teacher_Images_AggregateType;
  instagram_name?: Maybe<Scalars['String']>;
  invite_id?: Maybe<Scalars['uuid']>;
  is_organization?: Maybe<Scalars['Boolean']>;
  is_stripe_enabled: Scalars['Boolean'];
  location_name?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  owned_events: Array<Event_OwnersType>;
  /** An aggregate relationship */
  owned_events_aggregate: Event_Owners_AggregateType;
  signup_message?: Maybe<Scalars['String']>;
  stripe_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  teacher_levels: Array<Teacher_LevelsType>;
  /** An aggregate relationship */
  teacher_levels_aggregate: Teacher_Levels_AggregateType;
  type?: Maybe<Teacher_Type_EnumType>;
  url_slug?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
  /** An array relationship */
  user_likes: Array<Teacher_LikesType>;
  /** An aggregate relationship */
  user_likes_aggregate: Teacher_Likes_AggregateType;
};


/** columns and relationships of "teachers" */
export type TeachersClassesArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersClasses_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Teachers_Order_ByType>>;
  where?: InputMaybe<Class_Teachers_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersEventsArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersEvents_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Teachers_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Teachers_Order_ByType>>;
  where?: InputMaybe<Event_Teachers_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersImagesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersImages_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Images_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Images_Order_ByType>>;
  where?: InputMaybe<Teacher_Images_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersOwned_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersOwned_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersTeacher_LevelsArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Levels_Order_ByType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersTeacher_Levels_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Levels_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Levels_Order_ByType>>;
  where?: InputMaybe<Teacher_Levels_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersUser_LikesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


/** columns and relationships of "teachers" */
export type TeachersUser_Likes_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};

/** aggregated selection of "teachers" */
export type Teachers_AggregateType = {
  __typename?: 'teachers_aggregate';
  aggregate?: Maybe<Teachers_Aggregate_FieldsType>;
  nodes: Array<TeachersType>;
};

export type Teachers_Aggregate_Bool_ExpType = {
  bool_and?: InputMaybe<Teachers_Aggregate_Bool_Exp_Bool_AndType>;
  bool_or?: InputMaybe<Teachers_Aggregate_Bool_Exp_Bool_OrType>;
  count?: InputMaybe<Teachers_Aggregate_Bool_Exp_CountType>;
};

export type Teachers_Aggregate_Bool_Exp_Bool_AndType = {
  arguments: Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teachers_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Teachers_Aggregate_Bool_Exp_Bool_OrType = {
  arguments: Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teachers_Bool_ExpType>;
  predicate: Boolean_Comparison_ExpType;
};

export type Teachers_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Teachers_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "teachers" */
export type Teachers_Aggregate_FieldsType = {
  __typename?: 'teachers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Teachers_Max_FieldsType>;
  min?: Maybe<Teachers_Min_FieldsType>;
};


/** aggregate fields of "teachers" */
export type Teachers_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Teachers_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "teachers" */
export type Teachers_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<Teachers_Max_Order_ByType>;
  min?: InputMaybe<Teachers_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "teachers" */
export type Teachers_Arr_Rel_Insert_InputType = {
  data: Array<Teachers_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export type Teachers_Bool_ExpType = {
  _and?: InputMaybe<Array<Teachers_Bool_ExpType>>;
  _not?: InputMaybe<Teachers_Bool_ExpType>;
  _or?: InputMaybe<Array<Teachers_Bool_ExpType>>;
  classes?: InputMaybe<Class_Teachers_Bool_ExpType>;
  classes_aggregate?: InputMaybe<Class_Teachers_Aggregate_Bool_ExpType>;
  community?: InputMaybe<Communities_Bool_ExpType>;
  community_id?: InputMaybe<Uuid_Comparison_ExpType>;
  confirmation_status?: InputMaybe<Confirmation_Status_Enum_Comparison_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  description?: InputMaybe<String_Comparison_ExpType>;
  events?: InputMaybe<Event_Teachers_Bool_ExpType>;
  events_aggregate?: InputMaybe<Event_Teachers_Aggregate_Bool_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  images?: InputMaybe<Teacher_Images_Bool_ExpType>;
  images_aggregate?: InputMaybe<Teacher_Images_Aggregate_Bool_ExpType>;
  instagram_name?: InputMaybe<String_Comparison_ExpType>;
  invite_id?: InputMaybe<Uuid_Comparison_ExpType>;
  is_organization?: InputMaybe<Boolean_Comparison_ExpType>;
  is_stripe_enabled?: InputMaybe<Boolean_Comparison_ExpType>;
  location_name?: InputMaybe<String_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  owned_events?: InputMaybe<Event_Owners_Bool_ExpType>;
  owned_events_aggregate?: InputMaybe<Event_Owners_Aggregate_Bool_ExpType>;
  signup_message?: InputMaybe<String_Comparison_ExpType>;
  stripe_id?: InputMaybe<String_Comparison_ExpType>;
  teacher_levels?: InputMaybe<Teacher_Levels_Bool_ExpType>;
  teacher_levels_aggregate?: InputMaybe<Teacher_Levels_Aggregate_Bool_ExpType>;
  type?: InputMaybe<Teacher_Type_Enum_Comparison_ExpType>;
  url_slug?: InputMaybe<String_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
  user_likes?: InputMaybe<Teacher_Likes_Bool_ExpType>;
  user_likes_aggregate?: InputMaybe<Teacher_Likes_Aggregate_Bool_ExpType>;
};

/** unique or primary key constraints on table "teachers" */
export enum Teachers_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  TeachersPkeyType = 'teachers_pkey',
  /** unique or primary key constraint on columns "url_slug" */
  TeachersUrlSlugKeyType = 'teachers_url_slug_key',
  /** unique or primary key constraint on columns "user_id" */
  TeachersUserIdKeyType = 'teachers_user_id_key'
}

/** input type for inserting data into table "teachers" */
export type Teachers_Insert_InputType = {
  classes?: InputMaybe<Class_Teachers_Arr_Rel_Insert_InputType>;
  community?: InputMaybe<Communities_Obj_Rel_Insert_InputType>;
  community_id?: InputMaybe<Scalars['uuid']>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Event_Teachers_Arr_Rel_Insert_InputType>;
  id?: InputMaybe<Scalars['uuid']>;
  images?: InputMaybe<Teacher_Images_Arr_Rel_Insert_InputType>;
  instagram_name?: InputMaybe<Scalars['String']>;
  invite_id?: InputMaybe<Scalars['uuid']>;
  is_organization?: InputMaybe<Scalars['Boolean']>;
  is_stripe_enabled?: InputMaybe<Scalars['Boolean']>;
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owned_events?: InputMaybe<Event_Owners_Arr_Rel_Insert_InputType>;
  signup_message?: InputMaybe<Scalars['String']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  teacher_levels?: InputMaybe<Teacher_Levels_Arr_Rel_Insert_InputType>;
  type?: InputMaybe<Teacher_Type_EnumType>;
  url_slug?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_likes?: InputMaybe<Teacher_Likes_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Teachers_Max_FieldsType = {
  __typename?: 'teachers_max_fields';
  community_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram_name?: Maybe<Scalars['String']>;
  invite_id?: Maybe<Scalars['uuid']>;
  location_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  signup_message?: Maybe<Scalars['String']>;
  stripe_id?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "teachers" */
export type Teachers_Max_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  instagram_name?: InputMaybe<Order_ByType>;
  invite_id?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  signup_message?: InputMaybe<Order_ByType>;
  stripe_id?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type Teachers_Min_FieldsType = {
  __typename?: 'teachers_min_fields';
  community_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram_name?: Maybe<Scalars['String']>;
  invite_id?: Maybe<Scalars['uuid']>;
  location_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  signup_message?: Maybe<Scalars['String']>;
  stripe_id?: Maybe<Scalars['String']>;
  url_slug?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "teachers" */
export type Teachers_Min_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  instagram_name?: InputMaybe<Order_ByType>;
  invite_id?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  signup_message?: InputMaybe<Order_ByType>;
  stripe_id?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "teachers" */
export type Teachers_Mutation_ResponseType = {
  __typename?: 'teachers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TeachersType>;
};

/** input type for inserting object relation for remote table "teachers" */
export type Teachers_Obj_Rel_Insert_InputType = {
  data: Teachers_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Teachers_On_ConflictType>;
};

/** on_conflict condition type for table "teachers" */
export type Teachers_On_ConflictType = {
  constraint: Teachers_ConstraintType;
  update_columns?: Array<Teachers_Update_ColumnType>;
  where?: InputMaybe<Teachers_Bool_ExpType>;
};

/** Ordering options when selecting data from "teachers". */
export type Teachers_Order_ByType = {
  classes_aggregate?: InputMaybe<Class_Teachers_Aggregate_Order_ByType>;
  community?: InputMaybe<Communities_Order_ByType>;
  community_id?: InputMaybe<Order_ByType>;
  confirmation_status?: InputMaybe<Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  description?: InputMaybe<Order_ByType>;
  events_aggregate?: InputMaybe<Event_Teachers_Aggregate_Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  images_aggregate?: InputMaybe<Teacher_Images_Aggregate_Order_ByType>;
  instagram_name?: InputMaybe<Order_ByType>;
  invite_id?: InputMaybe<Order_ByType>;
  is_organization?: InputMaybe<Order_ByType>;
  is_stripe_enabled?: InputMaybe<Order_ByType>;
  location_name?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  owned_events_aggregate?: InputMaybe<Event_Owners_Aggregate_Order_ByType>;
  signup_message?: InputMaybe<Order_ByType>;
  stripe_id?: InputMaybe<Order_ByType>;
  teacher_levels_aggregate?: InputMaybe<Teacher_Levels_Aggregate_Order_ByType>;
  type?: InputMaybe<Order_ByType>;
  url_slug?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
  user_likes_aggregate?: InputMaybe<Teacher_Likes_Aggregate_Order_ByType>;
};

/** primary key columns input for table: teachers */
export type Teachers_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "teachers" */
export enum Teachers_Select_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  IdType = 'id',
  /** column name */
  InstagramNameType = 'instagram_name',
  /** column name */
  InviteIdType = 'invite_id',
  /** column name */
  IsOrganizationType = 'is_organization',
  /** column name */
  IsStripeEnabledType = 'is_stripe_enabled',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  NameType = 'name',
  /** column name */
  SignupMessageType = 'signup_message',
  /** column name */
  StripeIdType = 'stripe_id',
  /** column name */
  TypeType = 'type',
  /** column name */
  UrlSlugType = 'url_slug',
  /** column name */
  UserIdType = 'user_id'
}

/** select "teachers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teachers" */
export enum Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsType {
  /** column name */
  IsOrganizationType = 'is_organization',
  /** column name */
  IsStripeEnabledType = 'is_stripe_enabled'
}

/** select "teachers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teachers" */
export enum Teachers_Select_Column_Teachers_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsType {
  /** column name */
  IsOrganizationType = 'is_organization',
  /** column name */
  IsStripeEnabledType = 'is_stripe_enabled'
}

/** input type for updating data in table "teachers" */
export type Teachers_Set_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram_name?: InputMaybe<Scalars['String']>;
  invite_id?: InputMaybe<Scalars['uuid']>;
  is_organization?: InputMaybe<Scalars['Boolean']>;
  is_stripe_enabled?: InputMaybe<Scalars['Boolean']>;
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  signup_message?: InputMaybe<Scalars['String']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Teacher_Type_EnumType>;
  url_slug?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "teachers" */
export type Teachers_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Teachers_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Teachers_Stream_Cursor_Value_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  confirmation_status?: InputMaybe<Confirmation_Status_EnumType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram_name?: InputMaybe<Scalars['String']>;
  invite_id?: InputMaybe<Scalars['uuid']>;
  is_organization?: InputMaybe<Scalars['Boolean']>;
  is_stripe_enabled?: InputMaybe<Scalars['Boolean']>;
  location_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  signup_message?: InputMaybe<Scalars['String']>;
  stripe_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Teacher_Type_EnumType>;
  url_slug?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "teachers" */
export enum Teachers_Update_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  ConfirmationStatusType = 'confirmation_status',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  DescriptionType = 'description',
  /** column name */
  IdType = 'id',
  /** column name */
  InstagramNameType = 'instagram_name',
  /** column name */
  InviteIdType = 'invite_id',
  /** column name */
  IsOrganizationType = 'is_organization',
  /** column name */
  IsStripeEnabledType = 'is_stripe_enabled',
  /** column name */
  LocationNameType = 'location_name',
  /** column name */
  NameType = 'name',
  /** column name */
  SignupMessageType = 'signup_message',
  /** column name */
  StripeIdType = 'stripe_id',
  /** column name */
  TypeType = 'type',
  /** column name */
  UrlSlugType = 'url_slug',
  /** column name */
  UserIdType = 'user_id'
}

export type Teachers_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teachers_Set_InputType>;
  where: Teachers_Bool_ExpType;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type Timetz_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['timetz']>;
  _gt?: InputMaybe<Scalars['timetz']>;
  _gte?: InputMaybe<Scalars['timetz']>;
  _in?: InputMaybe<Array<Scalars['timetz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timetz']>;
  _lte?: InputMaybe<Scalars['timetz']>;
  _neq?: InputMaybe<Scalars['timetz']>;
  _nin?: InputMaybe<Array<Scalars['timetz']>>;
};

/** columns and relationships of "user_communities" */
export type User_CommunitiesType = {
  __typename?: 'user_communities';
  /** An object relationship */
  community: CommunitiesType;
  community_id: Scalars['uuid'];
  id: Scalars['uuid'];
  last_visited_at: Scalars['timestamptz'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_communities" */
export type User_Communities_AggregateType = {
  __typename?: 'user_communities_aggregate';
  aggregate?: Maybe<User_Communities_Aggregate_FieldsType>;
  nodes: Array<User_CommunitiesType>;
};

export type User_Communities_Aggregate_Bool_ExpType = {
  count?: InputMaybe<User_Communities_Aggregate_Bool_Exp_CountType>;
};

export type User_Communities_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Communities_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "user_communities" */
export type User_Communities_Aggregate_FieldsType = {
  __typename?: 'user_communities_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Communities_Max_FieldsType>;
  min?: Maybe<User_Communities_Min_FieldsType>;
};


/** aggregate fields of "user_communities" */
export type User_Communities_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_communities" */
export type User_Communities_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<User_Communities_Max_Order_ByType>;
  min?: InputMaybe<User_Communities_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "user_communities" */
export type User_Communities_Arr_Rel_Insert_InputType = {
  data: Array<User_Communities_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Communities_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "user_communities". All fields are combined with a logical 'AND'. */
export type User_Communities_Bool_ExpType = {
  _and?: InputMaybe<Array<User_Communities_Bool_ExpType>>;
  _not?: InputMaybe<User_Communities_Bool_ExpType>;
  _or?: InputMaybe<Array<User_Communities_Bool_ExpType>>;
  community?: InputMaybe<Communities_Bool_ExpType>;
  community_id?: InputMaybe<Uuid_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  last_visited_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "user_communities" */
export enum User_Communities_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  UserCommunitiesPkeyType = 'user_communities_pkey'
}

/** input type for inserting data into table "user_communities" */
export type User_Communities_Insert_InputType = {
  community?: InputMaybe<Communities_Obj_Rel_Insert_InputType>;
  community_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_visited_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Communities_Max_FieldsType = {
  __typename?: 'user_communities_max_fields';
  community_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_visited_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_communities" */
export type User_Communities_Max_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  last_visited_at?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type User_Communities_Min_FieldsType = {
  __typename?: 'user_communities_min_fields';
  community_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_visited_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_communities" */
export type User_Communities_Min_Order_ByType = {
  community_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  last_visited_at?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "user_communities" */
export type User_Communities_Mutation_ResponseType = {
  __typename?: 'user_communities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_CommunitiesType>;
};

/** on_conflict condition type for table "user_communities" */
export type User_Communities_On_ConflictType = {
  constraint: User_Communities_ConstraintType;
  update_columns?: Array<User_Communities_Update_ColumnType>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};

/** Ordering options when selecting data from "user_communities". */
export type User_Communities_Order_ByType = {
  community?: InputMaybe<Communities_Order_ByType>;
  community_id?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  last_visited_at?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: user_communities */
export type User_Communities_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "user_communities" */
export enum User_Communities_Select_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  IdType = 'id',
  /** column name */
  LastVisitedAtType = 'last_visited_at',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "user_communities" */
export type User_Communities_Set_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_visited_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_communities" */
export type User_Communities_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: User_Communities_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type User_Communities_Stream_Cursor_Value_InputType = {
  community_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_visited_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_communities" */
export enum User_Communities_Update_ColumnType {
  /** column name */
  CommunityIdType = 'community_id',
  /** column name */
  IdType = 'id',
  /** column name */
  LastVisitedAtType = 'last_visited_at',
  /** column name */
  UserIdType = 'user_id'
}

export type User_Communities_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Communities_Set_InputType>;
  where: User_Communities_Bool_ExpType;
};

/** columns and relationships of "user_roles" */
export type User_RolesType = {
  __typename?: 'user_roles';
  id: Scalars['uuid'];
  /** An object relationship */
  role: RolesType;
  role_id: Scalars['uuid'];
  /** An object relationship */
  user: UsersType;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_roles" */
export type User_Roles_AggregateType = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<User_Roles_Aggregate_FieldsType>;
  nodes: Array<User_RolesType>;
};

export type User_Roles_Aggregate_Bool_ExpType = {
  count?: InputMaybe<User_Roles_Aggregate_Bool_Exp_CountType>;
};

export type User_Roles_Aggregate_Bool_Exp_CountType = {
  arguments?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Roles_Bool_ExpType>;
  predicate: Int_Comparison_ExpType;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsType = {
  __typename?: 'user_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Roles_Max_FieldsType>;
  min?: Maybe<User_Roles_Min_FieldsType>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles" */
export type User_Roles_Aggregate_Order_ByType = {
  count?: InputMaybe<Order_ByType>;
  max?: InputMaybe<User_Roles_Max_Order_ByType>;
  min?: InputMaybe<User_Roles_Min_Order_ByType>;
};

/** input type for inserting array relation for remote table "user_roles" */
export type User_Roles_Arr_Rel_Insert_InputType = {
  data: Array<User_Roles_Insert_InputType>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Roles_On_ConflictType>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_ExpType = {
  _and?: InputMaybe<Array<User_Roles_Bool_ExpType>>;
  _not?: InputMaybe<User_Roles_Bool_ExpType>;
  _or?: InputMaybe<Array<User_Roles_Bool_ExpType>>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  role?: InputMaybe<Roles_Bool_ExpType>;
  role_id?: InputMaybe<Uuid_Comparison_ExpType>;
  user?: InputMaybe<Users_Bool_ExpType>;
  user_id?: InputMaybe<Uuid_Comparison_ExpType>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_ConstraintType {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkeyType = 'user_roles_pkey',
  /** unique or primary key constraint on columns "role_id", "user_id" */
  UserRolesUserIdRoleIdKeyType = 'user_roles_user_id_role_id_key'
}

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_InputType>;
  role_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_InputType>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Roles_Max_FieldsType = {
  __typename?: 'user_roles_max_fields';
  id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_roles" */
export type User_Roles_Max_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  role_id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** aggregate min on columns */
export type User_Roles_Min_FieldsType = {
  __typename?: 'user_roles_min_fields';
  id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_roles" */
export type User_Roles_Min_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  role_id?: InputMaybe<Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_ResponseType = {
  __typename?: 'user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_RolesType>;
};

/** on_conflict condition type for table "user_roles" */
export type User_Roles_On_ConflictType = {
  constraint: User_Roles_ConstraintType;
  update_columns?: Array<User_Roles_Update_ColumnType>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};

/** Ordering options when selecting data from "user_roles". */
export type User_Roles_Order_ByType = {
  id?: InputMaybe<Order_ByType>;
  role?: InputMaybe<Roles_Order_ByType>;
  role_id?: InputMaybe<Order_ByType>;
  user?: InputMaybe<Users_Order_ByType>;
  user_id?: InputMaybe<Order_ByType>;
};

/** primary key columns input for table: user_roles */
export type User_Roles_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  RoleIdType = 'role_id',
  /** column name */
  UserIdType = 'user_id'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_roles" */
export type User_Roles_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: User_Roles_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type User_Roles_Stream_Cursor_Value_InputType = {
  id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_ColumnType {
  /** column name */
  IdType = 'id',
  /** column name */
  RoleIdType = 'role_id',
  /** column name */
  UserIdType = 'user_id'
}

export type User_Roles_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Roles_Set_InputType>;
  where: User_Roles_Bool_ExpType;
};

/** columns and relationships of "users" */
export type UsersType = {
  __typename?: 'users';
  /** An object relationship */
  acro_role?: Maybe<Acro_RolesType>;
  acro_role_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  /** An array relationship */
  class_event_bookmarks: Array<Class_Event_BookmarksType>;
  /** An aggregate relationship */
  class_event_bookmarks_aggregate: Class_Event_Bookmarks_AggregateType;
  /** An array relationship */
  class_event_participations: Array<Class_Events_ParticipantsType>;
  /** An aggregate relationship */
  class_event_participations_aggregate: Class_Events_Participants_AggregateType;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  created_events: Array<EventsType>;
  /** An aggregate relationship */
  created_events_aggregate: Events_AggregateType;
  /** An array relationship */
  created_jams: Array<JamsType>;
  /** An aggregate relationship */
  created_jams_aggregate: Jams_AggregateType;
  email?: Maybe<Scalars['String']>;
  email_verification_code?: Maybe<Scalars['String']>;
  fcm_token?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_admin: Scalars['Boolean'];
  is_email_verified: Scalars['Boolean'];
  is_newsletter_enabled?: Maybe<Scalars['Boolean']>;
  is_teacher: Scalars['Boolean'];
  last_proposed_community_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  level?: Maybe<LevelsType>;
  level_id?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  origin_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  owned_events: Array<Event_OwnersType>;
  /** An aggregate relationship */
  owned_events_aggregate: Event_Owners_AggregateType;
  stripe_cus?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  teacher_likes: Array<Teacher_LikesType>;
  /** An aggregate relationship */
  teacher_likes_aggregate: Teacher_Likes_AggregateType;
  /** An object relationship */
  teacher_profile?: Maybe<TeachersType>;
  updated_at: Scalars['timestamptz'];
  used_teacher_signup: Scalars['Boolean'];
  /** An array relationship */
  user_communities: Array<User_CommunitiesType>;
  /** An aggregate relationship */
  user_communities_aggregate: User_Communities_AggregateType;
  /** An array relationship */
  user_roles: Array<User_RolesType>;
  /** An aggregate relationship */
  user_roles_aggregate: User_Roles_AggregateType;
};


/** columns and relationships of "users" */
export type UsersClass_Event_BookmarksArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersClass_Event_Bookmarks_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Event_Bookmarks_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Event_Bookmarks_Order_ByType>>;
  where?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersClass_Event_ParticipationsArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersClass_Event_Participations_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Class_Events_Participants_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Class_Events_Participants_Order_ByType>>;
  where?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersCreated_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_ByType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersCreated_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Events_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_ByType>>;
  where?: InputMaybe<Events_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersCreated_JamsArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersCreated_Jams_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Jams_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jams_Order_ByType>>;
  where?: InputMaybe<Jams_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersOwned_EventsArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersOwned_Events_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Event_Owners_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Event_Owners_Order_ByType>>;
  where?: InputMaybe<Event_Owners_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersTeacher_LikesArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersTeacher_Likes_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<Teacher_Likes_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Teacher_Likes_Order_ByType>>;
  where?: InputMaybe<Teacher_Likes_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersUser_CommunitiesArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersUser_Communities_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Communities_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Communities_Order_ByType>>;
  where?: InputMaybe<User_Communities_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersUser_RolesArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};


/** columns and relationships of "users" */
export type UsersUser_Roles_AggregateArgsType = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_ColumnType>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_ByType>>;
  where?: InputMaybe<User_Roles_Bool_ExpType>;
};

/** aggregated selection of "users" */
export type Users_AggregateType = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_FieldsType>;
  nodes: Array<UsersType>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_FieldsType = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_FieldsType>;
  min?: Maybe<Users_Min_FieldsType>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgsType = {
  columns?: InputMaybe<Array<Users_Select_ColumnType>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_ExpType = {
  _and?: InputMaybe<Array<Users_Bool_ExpType>>;
  _not?: InputMaybe<Users_Bool_ExpType>;
  _or?: InputMaybe<Array<Users_Bool_ExpType>>;
  acro_role?: InputMaybe<Acro_Roles_Bool_ExpType>;
  acro_role_id?: InputMaybe<Uuid_Comparison_ExpType>;
  bio?: InputMaybe<String_Comparison_ExpType>;
  class_event_bookmarks?: InputMaybe<Class_Event_Bookmarks_Bool_ExpType>;
  class_event_bookmarks_aggregate?: InputMaybe<Class_Event_Bookmarks_Aggregate_Bool_ExpType>;
  class_event_participations?: InputMaybe<Class_Events_Participants_Bool_ExpType>;
  class_event_participations_aggregate?: InputMaybe<Class_Events_Participants_Aggregate_Bool_ExpType>;
  created_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  created_events?: InputMaybe<Events_Bool_ExpType>;
  created_events_aggregate?: InputMaybe<Events_Aggregate_Bool_ExpType>;
  created_jams?: InputMaybe<Jams_Bool_ExpType>;
  created_jams_aggregate?: InputMaybe<Jams_Aggregate_Bool_ExpType>;
  email?: InputMaybe<String_Comparison_ExpType>;
  email_verification_code?: InputMaybe<String_Comparison_ExpType>;
  fcm_token?: InputMaybe<String_Comparison_ExpType>;
  id?: InputMaybe<Uuid_Comparison_ExpType>;
  image_url?: InputMaybe<String_Comparison_ExpType>;
  is_admin?: InputMaybe<Boolean_Comparison_ExpType>;
  is_email_verified?: InputMaybe<Boolean_Comparison_ExpType>;
  is_newsletter_enabled?: InputMaybe<Boolean_Comparison_ExpType>;
  is_teacher?: InputMaybe<Boolean_Comparison_ExpType>;
  last_proposed_community_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  level?: InputMaybe<Levels_Bool_ExpType>;
  level_id?: InputMaybe<Uuid_Comparison_ExpType>;
  name?: InputMaybe<String_Comparison_ExpType>;
  origin_id?: InputMaybe<String_Comparison_ExpType>;
  owned_events?: InputMaybe<Event_Owners_Bool_ExpType>;
  owned_events_aggregate?: InputMaybe<Event_Owners_Aggregate_Bool_ExpType>;
  stripe_cus?: InputMaybe<String_Comparison_ExpType>;
  stripe_customer_id?: InputMaybe<String_Comparison_ExpType>;
  teacher_id?: InputMaybe<Uuid_Comparison_ExpType>;
  teacher_likes?: InputMaybe<Teacher_Likes_Bool_ExpType>;
  teacher_likes_aggregate?: InputMaybe<Teacher_Likes_Aggregate_Bool_ExpType>;
  teacher_profile?: InputMaybe<Teachers_Bool_ExpType>;
  updated_at?: InputMaybe<Timestamptz_Comparison_ExpType>;
  used_teacher_signup?: InputMaybe<Boolean_Comparison_ExpType>;
  user_communities?: InputMaybe<User_Communities_Bool_ExpType>;
  user_communities_aggregate?: InputMaybe<User_Communities_Aggregate_Bool_ExpType>;
  user_roles?: InputMaybe<User_Roles_Bool_ExpType>;
  user_roles_aggregate?: InputMaybe<User_Roles_Aggregate_Bool_ExpType>;
};

/** unique or primary key constraints on table "users" */
export enum Users_ConstraintType {
  /** unique or primary key constraint on columns "origin_id" */
  UserOriginIdKeyType = 'user_origin_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkeyType = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type Users_Insert_InputType = {
  acro_role?: InputMaybe<Acro_Roles_Obj_Rel_Insert_InputType>;
  acro_role_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  class_event_bookmarks?: InputMaybe<Class_Event_Bookmarks_Arr_Rel_Insert_InputType>;
  class_event_participations?: InputMaybe<Class_Events_Participants_Arr_Rel_Insert_InputType>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_events?: InputMaybe<Events_Arr_Rel_Insert_InputType>;
  created_jams?: InputMaybe<Jams_Arr_Rel_Insert_InputType>;
  email?: InputMaybe<Scalars['String']>;
  email_verification_code?: InputMaybe<Scalars['String']>;
  fcm_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']>;
  is_newsletter_enabled?: InputMaybe<Scalars['Boolean']>;
  is_teacher?: InputMaybe<Scalars['Boolean']>;
  last_proposed_community_at?: InputMaybe<Scalars['timestamptz']>;
  level?: InputMaybe<Levels_Obj_Rel_Insert_InputType>;
  level_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  owned_events?: InputMaybe<Event_Owners_Arr_Rel_Insert_InputType>;
  stripe_cus?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  teacher_likes?: InputMaybe<Teacher_Likes_Arr_Rel_Insert_InputType>;
  teacher_profile?: InputMaybe<Teachers_Obj_Rel_Insert_InputType>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_teacher_signup?: InputMaybe<Scalars['Boolean']>;
  user_communities?: InputMaybe<User_Communities_Arr_Rel_Insert_InputType>;
  user_roles?: InputMaybe<User_Roles_Arr_Rel_Insert_InputType>;
};

/** aggregate max on columns */
export type Users_Max_FieldsType = {
  __typename?: 'users_max_fields';
  acro_role_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verification_code?: Maybe<Scalars['String']>;
  fcm_token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  last_proposed_community_at?: Maybe<Scalars['timestamptz']>;
  level_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  stripe_cus?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Users_Min_FieldsType = {
  __typename?: 'users_min_fields';
  acro_role_id?: Maybe<Scalars['uuid']>;
  bio?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verification_code?: Maybe<Scalars['String']>;
  fcm_token?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  last_proposed_community_at?: Maybe<Scalars['timestamptz']>;
  level_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  origin_id?: Maybe<Scalars['String']>;
  stripe_cus?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_ResponseType = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersType>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_InputType = {
  data: Users_Insert_InputType;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_ConflictType>;
};

/** on_conflict condition type for table "users" */
export type Users_On_ConflictType = {
  constraint: Users_ConstraintType;
  update_columns?: Array<Users_Update_ColumnType>;
  where?: InputMaybe<Users_Bool_ExpType>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_ByType = {
  acro_role?: InputMaybe<Acro_Roles_Order_ByType>;
  acro_role_id?: InputMaybe<Order_ByType>;
  bio?: InputMaybe<Order_ByType>;
  class_event_bookmarks_aggregate?: InputMaybe<Class_Event_Bookmarks_Aggregate_Order_ByType>;
  class_event_participations_aggregate?: InputMaybe<Class_Events_Participants_Aggregate_Order_ByType>;
  created_at?: InputMaybe<Order_ByType>;
  created_events_aggregate?: InputMaybe<Events_Aggregate_Order_ByType>;
  created_jams_aggregate?: InputMaybe<Jams_Aggregate_Order_ByType>;
  email?: InputMaybe<Order_ByType>;
  email_verification_code?: InputMaybe<Order_ByType>;
  fcm_token?: InputMaybe<Order_ByType>;
  id?: InputMaybe<Order_ByType>;
  image_url?: InputMaybe<Order_ByType>;
  is_admin?: InputMaybe<Order_ByType>;
  is_email_verified?: InputMaybe<Order_ByType>;
  is_newsletter_enabled?: InputMaybe<Order_ByType>;
  is_teacher?: InputMaybe<Order_ByType>;
  last_proposed_community_at?: InputMaybe<Order_ByType>;
  level?: InputMaybe<Levels_Order_ByType>;
  level_id?: InputMaybe<Order_ByType>;
  name?: InputMaybe<Order_ByType>;
  origin_id?: InputMaybe<Order_ByType>;
  owned_events_aggregate?: InputMaybe<Event_Owners_Aggregate_Order_ByType>;
  stripe_cus?: InputMaybe<Order_ByType>;
  stripe_customer_id?: InputMaybe<Order_ByType>;
  teacher_id?: InputMaybe<Order_ByType>;
  teacher_likes_aggregate?: InputMaybe<Teacher_Likes_Aggregate_Order_ByType>;
  teacher_profile?: InputMaybe<Teachers_Order_ByType>;
  updated_at?: InputMaybe<Order_ByType>;
  used_teacher_signup?: InputMaybe<Order_ByType>;
  user_communities_aggregate?: InputMaybe<User_Communities_Aggregate_Order_ByType>;
  user_roles_aggregate?: InputMaybe<User_Roles_Aggregate_Order_ByType>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_InputType = {
  id: Scalars['uuid'];
};

/** select columns of table "users" */
export enum Users_Select_ColumnType {
  /** column name */
  AcroRoleIdType = 'acro_role_id',
  /** column name */
  BioType = 'bio',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EmailType = 'email',
  /** column name */
  EmailVerificationCodeType = 'email_verification_code',
  /** column name */
  FcmTokenType = 'fcm_token',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageUrlType = 'image_url',
  /** column name */
  IsAdminType = 'is_admin',
  /** column name */
  IsEmailVerifiedType = 'is_email_verified',
  /** column name */
  IsNewsletterEnabledType = 'is_newsletter_enabled',
  /** column name */
  IsTeacherType = 'is_teacher',
  /** column name */
  LastProposedCommunityAtType = 'last_proposed_community_at',
  /** column name */
  LevelIdType = 'level_id',
  /** column name */
  NameType = 'name',
  /** column name */
  OriginIdType = 'origin_id',
  /** column name */
  StripeCusType = 'stripe_cus',
  /** column name */
  StripeCustomerIdType = 'stripe_customer_id',
  /** column name */
  TeacherIdType = 'teacher_id',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UsedTeacherSignupType = 'used_teacher_signup'
}

/** input type for updating data in table "users" */
export type Users_Set_InputType = {
  acro_role_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_verification_code?: InputMaybe<Scalars['String']>;
  fcm_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']>;
  is_newsletter_enabled?: InputMaybe<Scalars['Boolean']>;
  is_teacher?: InputMaybe<Scalars['Boolean']>;
  last_proposed_community_at?: InputMaybe<Scalars['timestamptz']>;
  level_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  stripe_cus?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_teacher_signup?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_InputType = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_InputType;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_OrderingType>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_InputType = {
  acro_role_id?: InputMaybe<Scalars['uuid']>;
  bio?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  email_verification_code?: InputMaybe<Scalars['String']>;
  fcm_token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_admin?: InputMaybe<Scalars['Boolean']>;
  is_email_verified?: InputMaybe<Scalars['Boolean']>;
  is_newsletter_enabled?: InputMaybe<Scalars['Boolean']>;
  is_teacher?: InputMaybe<Scalars['Boolean']>;
  last_proposed_community_at?: InputMaybe<Scalars['timestamptz']>;
  level_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  origin_id?: InputMaybe<Scalars['String']>;
  stripe_cus?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  used_teacher_signup?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "users" */
export enum Users_Update_ColumnType {
  /** column name */
  AcroRoleIdType = 'acro_role_id',
  /** column name */
  BioType = 'bio',
  /** column name */
  CreatedAtType = 'created_at',
  /** column name */
  EmailType = 'email',
  /** column name */
  EmailVerificationCodeType = 'email_verification_code',
  /** column name */
  FcmTokenType = 'fcm_token',
  /** column name */
  IdType = 'id',
  /** column name */
  ImageUrlType = 'image_url',
  /** column name */
  IsAdminType = 'is_admin',
  /** column name */
  IsEmailVerifiedType = 'is_email_verified',
  /** column name */
  IsNewsletterEnabledType = 'is_newsletter_enabled',
  /** column name */
  IsTeacherType = 'is_teacher',
  /** column name */
  LastProposedCommunityAtType = 'last_proposed_community_at',
  /** column name */
  LevelIdType = 'level_id',
  /** column name */
  NameType = 'name',
  /** column name */
  OriginIdType = 'origin_id',
  /** column name */
  StripeCusType = 'stripe_cus',
  /** column name */
  StripeCustomerIdType = 'stripe_customer_id',
  /** column name */
  TeacherIdType = 'teacher_id',
  /** column name */
  UpdatedAtType = 'updated_at',
  /** column name */
  UsedTeacherSignupType = 'used_teacher_signup'
}

export type Users_UpdatesType = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_InputType>;
  where: Users_Bool_ExpType;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_ExpType = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type ClassFragmentType = { __typename?: 'classes', id: any, city?: string | undefined, name: string, pricing?: string | undefined, location_name: string, location: any, image_url?: string | undefined, description: string, class_pass_url?: string | undefined, requirements?: string | undefined, usc_url?: string | undefined, is_classe?: boolean | undefined, timezone?: string | undefined, website_url?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, email?: string | undefined, invited_user?: { __typename?: 'users', name: string } | undefined }>, class_teachers: Array<{ __typename?: 'class_teachers', is_owner?: boolean | undefined, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, class_levels: Array<{ __typename?: 'class_levels', level: { __typename?: 'levels', id: any, name: string } }>, recurring_patterns: Array<{ __typename?: 'recurring_patterns', id: any, start_time: any, end_time: any, day_of_week: number, created_at: any, class_id: any, start_date?: any | undefined, end_date?: any | undefined, recurring_every_x_weeks: number, is_recurring: boolean }> };

export type GetClassByPkAsTeacherQueryVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type GetClassByPkAsTeacherQueryType = { __typename?: 'query_root', classes_by_pk?: { __typename?: 'classes', id: any, city?: string | undefined, name: string, pricing?: string | undefined, location_name: string, location: any, image_url?: string | undefined, description: string, class_pass_url?: string | undefined, requirements?: string | undefined, usc_url?: string | undefined, is_classe?: boolean | undefined, timezone?: string | undefined, website_url?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, email?: string | undefined, invited_user?: { __typename?: 'users', name: string } | undefined }>, class_teachers: Array<{ __typename?: 'class_teachers', is_owner?: boolean | undefined, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, class_levels: Array<{ __typename?: 'class_levels', level: { __typename?: 'levels', id: any, name: string } }>, recurring_patterns: Array<{ __typename?: 'recurring_patterns', id: any, start_time: any, end_time: any, day_of_week: number, created_at: any, class_id: any, start_date?: any | undefined, end_date?: any | undefined, recurring_every_x_weeks: number, is_recurring: boolean }> } | undefined };

export type MyMutationMutationVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type MyMutationMutationType = { __typename?: 'mutation_root', update_class_events_by_pk?: { __typename?: 'class_events', id: any } | undefined };

export type LoginMutationVariablesType = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutationType = { __typename?: 'mutation_root', login: { __typename?: 'LoginResponse', token: string, refreshToken: string } };

export type InsertClassMutationMutationVariablesType = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
  image_url: Scalars['String'];
  class_pass_url?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  event_type: Event_Type_EnumType;
  requirements?: InputMaybe<Scalars['String']>;
  location: Scalars['geography'];
  location_name: Scalars['String'];
  location_city: Scalars['String'];
  location_country: Scalars['String'];
  is_classe: Scalars['Boolean'];
  timezone: Scalars['String'];
  url_slug: Scalars['String'];
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  created_by_id?: InputMaybe<Scalars['uuid']>;
  class_owners: Array<Class_Owners_Insert_InputType> | Class_Owners_Insert_InputType;
  class_booking_options: Array<Class_Booking_Option_Insert_InputType> | Class_Booking_Option_Insert_InputType;
  recurring_patterns: Array<Recurring_Patterns_Insert_InputType> | Recurring_Patterns_Insert_InputType;
  class_teachers: Array<Class_Teachers_Insert_InputType> | Class_Teachers_Insert_InputType;
  class_levels: Array<Class_Levels_Insert_InputType> | Class_Levels_Insert_InputType;
}>;


export type InsertClassMutationMutationType = { __typename?: 'mutation_root', insert_classes_one?: { __typename?: 'classes', id: any } | undefined };

export type UpdateClassMutationMutationVariablesType = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
  city: Scalars['String'];
  description: Scalars['String'];
  image_url: Scalars['String'];
  location: Scalars['geography'];
  location_name: Scalars['String'];
  location_city: Scalars['String'];
  location_country: Scalars['String'];
  event_type: Event_Type_EnumType;
  is_classe: Scalars['Boolean'];
  timezone: Scalars['String'];
  url_slug: Scalars['String'];
  class_pass_url?: InputMaybe<Scalars['String']>;
  usc_url?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
  pricing?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  max_booking_slots?: InputMaybe<Scalars['Int']>;
  class_booking_options: Array<Class_Booking_Option_Insert_InputType> | Class_Booking_Option_Insert_InputType;
  recurring_patterns: Array<Recurring_Patterns_Insert_InputType> | Recurring_Patterns_Insert_InputType;
  class_teachers: Array<Class_Teachers_Insert_InputType> | Class_Teachers_Insert_InputType;
  class_owners: Array<Class_Owners_Insert_InputType> | Class_Owners_Insert_InputType;
  class_levels: Array<Class_Levels_Insert_InputType> | Class_Levels_Insert_InputType;
}>;


export type UpdateClassMutationMutationType = { __typename?: 'mutation_root', delete_booking_option?: { __typename?: 'booking_option_mutation_response', affected_rows: number } | undefined, delete_classes_by_pk?: { __typename?: 'classes', id: any } | undefined, insert_classes?: { __typename?: 'classes_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'classes', id: any, city?: string | undefined, name: string, pricing?: string | undefined, location_name: string, location: any, image_url?: string | undefined, description: string, class_pass_url?: string | undefined, requirements?: string | undefined, usc_url?: string | undefined, website_url?: string | undefined, is_classe?: boolean | undefined, timezone?: string | undefined, url_slug?: string | undefined, class_teachers: Array<{ __typename?: 'class_teachers', teacher?: { __typename?: 'teachers', id: any, name: string } | undefined }>, class_levels: Array<{ __typename?: 'class_levels', level: { __typename?: 'levels', id: any, name: string } }>, recurring_patterns: Array<{ __typename?: 'recurring_patterns', id: any, start_time: any, end_time: any, day_of_week: number, created_at: any, class_id: any }> }> } | undefined };

export type ClassEventBookingsFieldsFragmentType = { __typename?: 'class_event_bookings', id: any, created_at?: any | undefined, status: string, amount: any, currency: string, booking_option?: { __typename?: 'booking_option', id: any, title: string, price: any } | undefined, user?: { __typename?: 'users', id: any, email?: string | undefined, name: string, level?: { __typename?: 'levels', id: any, name: string } | undefined, acro_role?: { __typename?: 'acro_roles', name: string, id: any } | undefined } | undefined, class_event?: { __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, max_booking_slots: number, class?: { __typename?: 'classes', id: any, name: string } | undefined } | undefined };

export type ClassEventFieldsFragmentType = { __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, is_cancelled: boolean, class?: { __typename?: 'classes', id: any, name: string } | undefined };

export type CreatedInvitesFieldsFragmentType = { __typename?: 'created_invites', id?: any | undefined, entity_id?: any | undefined, entity?: string | undefined, email?: string | undefined, created_by_id?: any | undefined, created_at?: any | undefined, confirmation_status?: string | undefined, updated_at?: any | undefined, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, invited_user?: { __typename?: 'users', id: any, name: string, teacher_profile?: { __typename?: 'teachers', id: any, name: string } | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined };

export type EventFieldsFragmentType = { __typename?: 'events', id: any, event_type: Event_Type_EnumType, event_source: Event_Source_EnumType, end_date: any, description: string, created_at?: any | undefined, location?: any | undefined, location_city?: string | undefined, location_country?: string | undefined, location_name?: string | undefined, main_image_url: string, name: string, pricing?: string | undefined, start_date: any, url?: string | undefined, links?: any | undefined, is_highlighted: boolean, highlight_requested?: boolean | undefined, updated_at?: any | undefined, confirmation_status: Confirmation_Status_EnumType, timezone?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } }>, owners: Array<{ __typename?: 'event_owners', user: { __typename?: 'users', id: any, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } }>, teachers: Array<{ __typename?: 'event_teachers', event_id: any, teacher_id: any, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, created_by: { __typename?: 'users', id: any, name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } };

export type InviteFieldsFragmentType = { __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } };

export type MeFieldsFragmentType = { __typename?: 'me', id?: any | undefined, name?: string | undefined, image_url?: string | undefined, fcm_token?: string | undefined, bio?: string | undefined, email?: string | undefined, origin_id?: string | undefined, created_at?: any | undefined, is_admin?: boolean | undefined, used_teacher_signup?: boolean | undefined, is_email_verified?: boolean | undefined, invites: Array<{ __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } }>, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, stripe_id?: string | undefined, is_stripe_enabled: boolean, community?: { __typename?: 'communities', id: any, name: string, location: any, longitude: any, latitude: any } | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', url: string } }> } | undefined, user_roles: Array<{ __typename?: 'user_roles', role: { __typename?: 'roles', id: any, name: string } }> };

export type NestInviteFieldsFragmentType = { __typename?: 'Invite', id: string, entity_id?: string | undefined, entity?: string | undefined, email?: string | undefined, created_by_id: string, created_at: string, confirmation_status: string, updated_at: string, class?: { __typename?: 'ClassEntity', id: string, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'EventEntity', id: string, name: string, main_image_url?: string | undefined } | undefined, created_by: { __typename?: 'CreatedBy', name: string, image_url: string, teacher_profile?: { __typename?: 'TeacherProfile', name: string, images: Array<{ __typename?: 'TeacherImage', is_profile_picture: boolean, image: { __typename?: 'Image', url: string, id: string } }> } | undefined } };

export type TeacherFieldsFragmentType = { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> };

export type UserFieldsFragmentType = { __typename?: 'users', id: any, name: string, image_url?: string | undefined, fcm_token?: string | undefined, bio?: string | undefined, email?: string | undefined, origin_id?: string | undefined, created_at: any, is_admin: boolean, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, community?: { __typename?: 'communities', id: any, name: string, location: any, longitude: any, latitude: any } | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', url: string } }> } | undefined, user_roles: Array<{ __typename?: 'user_roles', role: { __typename?: 'roles', id: any, name: string } }> };

export type AcceptInviteMutationVariablesType = Exact<{
  id: Scalars['String'];
}>;


export type AcceptInviteMutationType = { __typename?: 'mutation_root', accept_invite: { __typename?: 'SuccessOutput', success: boolean } };

export type CancelClassEventMutationVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type CancelClassEventMutationType = { __typename?: 'mutation_root', update_class_events_by_pk?: { __typename?: 'class_events', id: any } | undefined };

export type CreateStripeUserMutationVariablesType = Exact<{ [key: string]: never; }>;


export type CreateStripeUserMutationType = { __typename?: 'mutation_root', create_stripe_user: { __typename?: 'CreateStripeUserResponse', url: string } };

export type DeleteAccountMutationVariablesType = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutationType = { __typename?: 'mutation_root', delete_account: { __typename?: 'DeleteAccountResponse', success: boolean } };

export type DeleteInviteByPkMutationVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteInviteByPkMutationType = { __typename?: 'mutation_root', delete_invites_by_pk?: { __typename?: 'invites', id: any } | undefined };

export type ResetPasswordMutationVariablesType = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutationType = { __typename?: 'mutation_root', reset_password: { __typename?: 'SuccessOutput', success: boolean } };

export type InviteMutationVariablesType = Exact<{
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
}>;


export type InviteMutationType = { __typename?: 'mutation_root', invite: { __typename?: 'SuccessOutput', success: boolean } };

export type LoginWithRefreshTokenMutationVariablesType = Exact<{
  refreshToken: Scalars['String'];
}>;


export type LoginWithRefreshTokenMutationType = { __typename?: 'mutation_root', loginWithRefreshToken: { __typename?: 'LoginResponse', token: string, refreshToken: string } };

export type RegisterAsTeacherMutationVariablesType = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  name: Scalars['String'];
  inviteId?: InputMaybe<Scalars['String']>;
}>;


export type RegisterAsTeacherMutationType = { __typename?: 'mutation_root', register_as_teacher: { __typename?: 'RegisterResponse', token: string, refreshToken: string, user: { __typename?: 'RegisterUserResponse', id: string, name: string } } };

export type RejectInviteMutationVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type RejectInviteMutationType = { __typename?: 'mutation_root', update_invites_by_pk?: { __typename?: 'invites', id: any } | undefined };

export type SendVerificationEmailMutationVariablesType = Exact<{ [key: string]: never; }>;


export type SendVerificationEmailMutationType = { __typename?: 'mutation_root', send_verification_email: { __typename?: 'SuccessOutput', success: boolean } };

export type SignupAsTeacherMutationVariablesType = Exact<{ [key: string]: never; }>;


export type SignupAsTeacherMutationType = { __typename?: 'mutation_root', signup_as_teacher: { __typename?: 'SuccessOutput', success: boolean } };

export type UpdateTeacherAsAdminUserMutationVariablesType = Exact<{
  id: Scalars['uuid'];
  userId: Scalars['uuid'];
  name: Scalars['String'];
  description: Scalars['String'];
  is_organization: Scalars['Boolean'];
  instagram_name: Scalars['String'];
  url_slug: Scalars['String'];
  images: Array<Teacher_Images_Insert_InputType> | Teacher_Images_Insert_InputType;
  confirmation_status: Confirmation_Status_EnumType;
  signup_message: Scalars['String'];
  stripe_id: Scalars['String'];
  is_stripe_enabled: Scalars['Boolean'];
}>;


export type UpdateTeacherAsAdminUserMutationType = { __typename?: 'mutation_root', delete_teachers_by_pk?: { __typename?: 'teachers', id: any } | undefined, delete_teacher_images?: { __typename?: 'teacher_images_mutation_response', affected_rows: number } | undefined, insert_teachers?: { __typename?: 'teachers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> }> } | undefined };

export type UpdateTeacherAsTeacherUserMutationVariablesType = Exact<{
  id: Scalars['uuid'];
  userId: Scalars['uuid'];
  name: Scalars['String'];
  description: Scalars['String'];
  is_organization: Scalars['Boolean'];
  instagram_name: Scalars['String'];
  url_slug: Scalars['String'];
  type: Teacher_Type_EnumType;
  stripe_id: Scalars['String'];
  is_stripe_enabled: Scalars['Boolean'];
  images: Array<Teacher_Images_Insert_InputType> | Teacher_Images_Insert_InputType;
}>;


export type UpdateTeacherAsTeacherUserMutationType = { __typename?: 'mutation_root', delete_teachers_by_pk?: { __typename?: 'teachers', id: any } | undefined, delete_teacher_images?: { __typename?: 'teacher_images_mutation_response', affected_rows: number } | undefined, insert_teachers?: { __typename?: 'teachers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> }> } | undefined };

export type UpsertEventAsAdminUserMutationVariablesType = Exact<{
  event_id?: InputMaybe<Scalars['uuid']>;
  event: Events_Insert_InputType;
}>;


export type UpsertEventAsAdminUserMutationType = { __typename?: 'mutation_root', delete_event_teachers?: { __typename?: 'event_teachers_mutation_response', affected_rows: number } | undefined, delete_event_owners?: { __typename?: 'event_owners_mutation_response', affected_rows: number } | undefined, insert_events_one?: { __typename?: 'events', id: any } | undefined };

export type UpsertEventAsTeacherUserMutationVariablesType = Exact<{
  event_id: Scalars['uuid'];
  own_user_id: Scalars['uuid'];
  event: Events_Insert_InputType;
}>;


export type UpsertEventAsTeacherUserMutationType = { __typename?: 'mutation_root', delete_event_teachers?: { __typename?: 'event_teachers_mutation_response', affected_rows: number } | undefined, delete_event_owners?: { __typename?: 'event_owners_mutation_response', affected_rows: number } | undefined, insert_events_one?: { __typename?: 'events', id: any } | undefined };

export type VerifyEmailMutationVariablesType = Exact<{
  code: Scalars['String'];
}>;


export type VerifyEmailMutationType = { __typename?: 'mutation_root', verify_email: boolean };

export type VerifyStripeAccountMutationVariablesType = Exact<{ [key: string]: never; }>;


export type VerifyStripeAccountMutationType = { __typename?: 'mutation_root', verify_stripe_account: boolean };

export type GetAllBookingsPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
}>;


export type GetAllBookingsPageableQueryType = { __typename?: 'query_root', class_event_bookings: Array<{ __typename?: 'class_event_bookings', id: any, created_at?: any | undefined, status: string, amount: any, currency: string, booking_option?: { __typename?: 'booking_option', id: any, title: string, price: any } | undefined, user?: { __typename?: 'users', id: any, email?: string | undefined, name: string, level?: { __typename?: 'levels', id: any, name: string } | undefined, acro_role?: { __typename?: 'acro_roles', name: string, id: any } | undefined } | undefined, class_event?: { __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, max_booking_slots: number, class?: { __typename?: 'classes', id: any, name: string } | undefined } | undefined }>, class_event_bookings_aggregate: { __typename?: 'class_event_bookings_aggregate', aggregate?: { __typename?: 'class_event_bookings_aggregate_fields', count: number } | undefined } };

export type GetClassByPkQueryVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type GetClassByPkQueryType = { __typename?: 'query_root', classes_by_pk?: { __typename?: 'classes', id: any, city?: string | undefined, name: string, pricing?: string | undefined, location: any, location_name: string, location_city?: string | undefined, location_country?: string | undefined, event_type?: Event_Type_EnumType | undefined, image_url?: string | undefined, description: string, class_pass_url?: string | undefined, requirements?: string | undefined, usc_url?: string | undefined, is_classe?: boolean | undefined, timezone?: string | undefined, website_url?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, email?: string | undefined, entity?: Invite_Entity_EnumType | undefined, invited_user?: { __typename?: 'users', id: any, name: string, teacher_profile?: { __typename?: 'teachers', id: any, name: string } | undefined } | undefined }>, class_owners: Array<{ __typename?: 'class_owners', id: any, is_payment_receiver: boolean, teacher: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } }>, class_teachers: Array<{ __typename?: 'class_teachers', is_owner?: boolean | undefined, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, class_levels: Array<{ __typename?: 'class_levels', level: { __typename?: 'levels', id: any, name: string } }>, recurring_patterns: Array<{ __typename?: 'recurring_patterns', id: any, start_time: any, end_time: any, day_of_week: number, created_at: any, class_id: any, start_date?: any | undefined, end_date?: any | undefined, recurring_every_x_weeks: number, is_recurring: boolean }> } | undefined };

export type GetClassEventBookingsPageableQueryVariablesType = Exact<{
  classEventId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Class_Event_Bookings_Bool_ExpType>;
}>;


export type GetClassEventBookingsPageableQueryType = { __typename?: 'query_root', class_events_by_pk?: { __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, max_booking_slots: number, class?: { __typename?: 'classes', id: any, name: string, max_booking_slots?: number | undefined } | undefined } | undefined, class_event_bookings: Array<{ __typename?: 'class_event_bookings', id: any, created_at?: any | undefined, status: string, amount: any, currency: string, booking_option?: { __typename?: 'booking_option', id: any, title: string, price: any } | undefined, user?: { __typename?: 'users', id: any, email?: string | undefined, name: string, level?: { __typename?: 'levels', id: any, name: string } | undefined, acro_role?: { __typename?: 'acro_roles', name: string, id: any } | undefined } | undefined, class_event?: { __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, max_booking_slots: number, class?: { __typename?: 'classes', id: any, name: string } | undefined } | undefined }>, class_event_bookings_aggregate: { __typename?: 'class_event_bookings_aggregate', aggregate?: { __typename?: 'class_event_bookings_aggregate_fields', count: number } | undefined } };

export type GetClassEventsPageableQueryVariablesType = Exact<{
  classId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: Class_Events_Bool_ExpType;
}>;


export type GetClassEventsPageableQueryType = { __typename?: 'query_root', classes_by_pk?: { __typename?: 'classes', id: any, name: string } | undefined, class_events: Array<{ __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, is_cancelled: boolean, class?: { __typename?: 'classes', id: any, name: string } | undefined }>, class_events_aggregate: { __typename?: 'class_events_aggregate', aggregate?: { __typename?: 'class_events_aggregate_fields', count: number } | undefined } };

export type GetClassSlugSuggestionQueryVariablesType = Exact<{
  name: Scalars['String'];
}>;


export type GetClassSlugSuggestionQueryType = { __typename?: 'query_root', get_class_slug_suggestion: string };

export type GetClassesPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetClassesPageableQueryType = { __typename?: 'query_root', classes: Array<{ __typename?: 'classes', id: any, name: string, description: string, image_url?: string | undefined }>, classes_aggregate: { __typename?: 'classes_aggregate', aggregate?: { __typename?: 'classes_aggregate_fields', count: number } | undefined } };

export type GetConfirmationStatusQueryVariablesType = Exact<{ [key: string]: never; }>;


export type GetConfirmationStatusQueryType = { __typename?: 'query_root', confirmation_status: Array<{ __typename?: 'confirmation_status', value: string }> };

export type GetCreatedInvitesPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: Created_Invites_Bool_ExpType;
}>;


export type GetCreatedInvitesPageableQueryType = { __typename?: 'query_root', created_invites: Array<{ __typename?: 'created_invites', id?: any | undefined, entity_id?: any | undefined, entity?: string | undefined, email?: string | undefined, created_by_id?: any | undefined, created_at?: any | undefined, confirmation_status?: string | undefined, updated_at?: any | undefined, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, invited_user?: { __typename?: 'users', id: any, name: string, teacher_profile?: { __typename?: 'teachers', id: any, name: string } | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined }>, created_invites_aggregate: { __typename?: 'created_invites_aggregate', aggregate?: { __typename?: 'created_invites_aggregate_fields', count: number } | undefined } };

export type GetEventByPkAsAdminUserQueryVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventByPkAsAdminUserQueryType = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', confirmation_status: Confirmation_Status_EnumType, id: any, event_type: Event_Type_EnumType, event_source: Event_Source_EnumType, end_date: any, description: string, created_at?: any | undefined, location?: any | undefined, location_city?: string | undefined, location_country?: string | undefined, location_name?: string | undefined, main_image_url: string, name: string, pricing?: string | undefined, start_date: any, url?: string | undefined, links?: any | undefined, is_highlighted: boolean, highlight_requested?: boolean | undefined, updated_at?: any | undefined, timezone?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } }>, owners: Array<{ __typename?: 'event_owners', user: { __typename?: 'users', id: any, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } }>, teachers: Array<{ __typename?: 'event_teachers', event_id: any, teacher_id: any, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, created_by: { __typename?: 'users', id: any, name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } } | undefined };

export type GetEventByPkAsTeacherUserQueryVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type GetEventByPkAsTeacherUserQueryType = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, event_type: Event_Type_EnumType, event_source: Event_Source_EnumType, end_date: any, description: string, created_at?: any | undefined, location?: any | undefined, location_city?: string | undefined, location_country?: string | undefined, location_name?: string | undefined, main_image_url: string, name: string, pricing?: string | undefined, start_date: any, url?: string | undefined, links?: any | undefined, is_highlighted: boolean, highlight_requested?: boolean | undefined, updated_at?: any | undefined, confirmation_status: Confirmation_Status_EnumType, timezone?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } }>, owners: Array<{ __typename?: 'event_owners', user: { __typename?: 'users', id: any, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } }>, teachers: Array<{ __typename?: 'event_teachers', event_id: any, teacher_id: any, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, created_by: { __typename?: 'users', id: any, name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } } | undefined };

export type GetEventSlugSuggestionQueryVariablesType = Exact<{
  name: Scalars['String'];
}>;


export type GetEventSlugSuggestionQueryType = { __typename?: 'query_root', get_event_slug_suggestion: string };

export type GetEventsPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Events_Bool_ExpType>;
}>;


export type GetEventsPageableQueryType = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, event_type: Event_Type_EnumType, event_source: Event_Source_EnumType, end_date: any, description: string, created_at?: any | undefined, location?: any | undefined, location_city?: string | undefined, location_country?: string | undefined, location_name?: string | undefined, main_image_url: string, name: string, pricing?: string | undefined, start_date: any, url?: string | undefined, links?: any | undefined, is_highlighted: boolean, highlight_requested?: boolean | undefined, updated_at?: any | undefined, confirmation_status: Confirmation_Status_EnumType, timezone?: string | undefined, url_slug?: string | undefined, invites: Array<{ __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } }>, owners: Array<{ __typename?: 'event_owners', user: { __typename?: 'users', id: any, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } }>, teachers: Array<{ __typename?: 'event_teachers', event_id: any, teacher_id: any, teacher?: { __typename?: 'teachers', id: any, name: string, location_name?: string | undefined, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined }>, created_by: { __typename?: 'users', id: any, name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined } }>, events_aggregate: { __typename?: 'events_aggregate', aggregate?: { __typename?: 'events_aggregate_fields', count: number } | undefined } };

export type GetInviteByPkQueryVariablesType = Exact<{
  id: Scalars['String'];
}>;


export type GetInviteByPkQueryType = { __typename?: 'query_root', invite_by_id: { __typename?: 'Invite', id: string, entity_id?: string | undefined, entity?: string | undefined, email?: string | undefined, created_by_id: string, created_at: string, confirmation_status: string, updated_at: string, class?: { __typename?: 'ClassEntity', id: string, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'EventEntity', id: string, name: string, main_image_url?: string | undefined } | undefined, created_by: { __typename?: 'CreatedBy', name: string, image_url: string, teacher_profile?: { __typename?: 'TeacherProfile', name: string, images: Array<{ __typename?: 'TeacherImage', is_profile_picture: boolean, image: { __typename?: 'Image', url: string, id: string } }> } | undefined } } };

export type GetAllInvitesQueryVariablesType = Exact<{ [key: string]: never; }>;


export type GetAllInvitesQueryType = { __typename?: 'query_root', get_all_invites: Array<{ __typename?: 'Invite', id: string, entity_id?: string | undefined, entity?: string | undefined, email?: string | undefined, created_by_id: string, created_at: string, confirmation_status: string, updated_at: string, class?: { __typename?: 'ClassEntity', id: string, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'EventEntity', id: string, name: string, main_image_url?: string | undefined } | undefined, created_by: { __typename?: 'CreatedBy', name: string, image_url: string, teacher_profile?: { __typename?: 'TeacherProfile', name: string, images: Array<{ __typename?: 'TeacherImage', is_profile_picture: boolean, image: { __typename?: 'Image', url: string, id: string } }> } | undefined } }> };

export type IsClassSlugAvailableQueryVariablesType = Exact<{
  urlSlug: Scalars['String'];
}>;


export type IsClassSlugAvailableQueryType = { __typename?: 'query_root', is_class_slug_available: boolean };

export type IsEventSlugAvailableQueryVariablesType = Exact<{
  urlSlug: Scalars['String'];
}>;


export type IsEventSlugAvailableQueryType = { __typename?: 'query_root', is_event_slug_available: boolean };

export type IsTeacherSlugAvailableQueryVariablesType = Exact<{
  urlSlug: Scalars['String'];
}>;


export type IsTeacherSlugAvailableQueryType = { __typename?: 'query_root', is_teacher_slug_available: boolean };

export type GetMeQueryVariablesType = Exact<{ [key: string]: never; }>;


export type GetMeQueryType = { __typename?: 'query_root', me: Array<{ __typename?: 'me', id?: any | undefined, name?: string | undefined, image_url?: string | undefined, fcm_token?: string | undefined, bio?: string | undefined, email?: string | undefined, origin_id?: string | undefined, created_at?: any | undefined, is_admin?: boolean | undefined, used_teacher_signup?: boolean | undefined, is_email_verified?: boolean | undefined, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, stripe_id?: string | undefined, is_stripe_enabled: boolean, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, url_slug?: string | undefined, community?: { __typename?: 'communities', id: any, name: string, location: any, longitude: any, latitude: any } | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined, invites: Array<{ __typename?: 'invites', id: any, entity_id?: any | undefined, entity?: Invite_Entity_EnumType | undefined, email?: string | undefined, created_by_id: any, created_at: any, confirmation_status: Confirmation_Status_EnumType, updated_at: any, class?: { __typename?: 'classes', id: any, name: string, image_url?: string | undefined } | undefined, event?: { __typename?: 'events', id: any, name: string, main_image_url: string } | undefined, created_by: { __typename?: 'users', name: string, image_url?: string | undefined, teacher_profile?: { __typename?: 'teachers', name: string, images: Array<{ __typename?: 'teacher_images', is_profile_picture: boolean, image: { __typename?: 'images', url: string, id: any } }> } | undefined } }>, user_roles: Array<{ __typename?: 'user_roles', role: { __typename?: 'roles', id: any, name: string } }> }> };

export type GetRolesPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Roles_Bool_ExpType>;
}>;


export type GetRolesPageableQueryType = { __typename?: 'query_root', roles: Array<{ __typename?: 'roles', id: any, name: string }>, roles_aggregate: { __typename?: 'roles_aggregate', aggregate?: { __typename?: 'roles_aggregate_fields', count: number } | undefined } };

export type GetStripeLoginLinkQueryVariablesType = Exact<{ [key: string]: never; }>;


export type GetStripeLoginLinkQueryType = { __typename?: 'query_root', stripe_login_link: string };

export type GetTeacherByPkAsAdminUserQueryVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type GetTeacherByPkAsAdminUserQueryType = { __typename?: 'query_root', teachers_by_pk?: { __typename?: 'teachers', signup_message?: string | undefined, confirmation_status: Confirmation_Status_EnumType, id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined };

export type GetTeacherByPkAsTeacherUserQueryVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type GetTeacherByPkAsTeacherUserQueryType = { __typename?: 'query_root', teachers_by_pk?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, confirmation_status: Confirmation_Status_EnumType, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> } | undefined };

export type GetTeacherSlugSuggestionQueryVariablesType = Exact<{
  name: Scalars['String'];
}>;


export type GetTeacherSlugSuggestionQueryType = { __typename?: 'query_root', get_teacher_slug_suggestion: string };

export type GetTeachersPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: Teachers_Bool_ExpType;
}>;


export type GetTeachersPageableQueryType = { __typename?: 'query_root', teachers: Array<{ __typename?: 'teachers', confirmation_status: Confirmation_Status_EnumType, id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, type?: Teacher_Type_EnumType | undefined, user_id: any, is_stripe_enabled: boolean, stripe_id?: string | undefined, url_slug?: string | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', id: any, url: string } }> }>, teachers_aggregate: { __typename?: 'teachers_aggregate', aggregate?: { __typename?: 'teachers_aggregate_fields', count: number } | undefined } };

export type GetClassEventBookingsByClassEventPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  teacherId: Scalars['uuid'];
  classEventId: Scalars['uuid'];
}>;


export type GetClassEventBookingsByClassEventPageableQueryType = { __typename?: 'query_root', class_event_bookings: Array<{ __typename?: 'class_event_bookings', id: any, created_at?: any | undefined, status: string, amount: any, currency: string, booking_option?: { __typename?: 'booking_option', id: any, title: string, price: any } | undefined, user?: { __typename?: 'users', id: any, email?: string | undefined, name: string, level?: { __typename?: 'levels', id: any, name: string } | undefined, acro_role?: { __typename?: 'acro_roles', name: string, id: any } | undefined } | undefined, class_event?: { __typename?: 'class_events', id: any, start_date: any, end_date?: any | undefined, max_booking_slots: number, class?: { __typename?: 'classes', id: any, name: string } | undefined } | undefined }>, class_event_bookings_aggregate: { __typename?: 'class_event_bookings_aggregate', aggregate?: { __typename?: 'class_event_bookings_aggregate_fields', count: number } | undefined } };

export type GetUsersPageableQueryVariablesType = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: Users_Bool_ExpType;
}>;


export type GetUsersPageableQueryType = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, name: string, image_url?: string | undefined, fcm_token?: string | undefined, bio?: string | undefined, email?: string | undefined, origin_id?: string | undefined, created_at: any, is_admin: boolean, teacher_profile?: { __typename?: 'teachers', id: any, name: string, description: string, location_name?: string | undefined, instagram_name?: string | undefined, is_organization?: boolean | undefined, community?: { __typename?: 'communities', id: any, name: string, location: any, longitude: any, latitude: any } | undefined, teacher_levels: Array<{ __typename?: 'teacher_levels', level: { __typename?: 'levels', id: any, name: string } }>, user: { __typename?: 'users', id: any, name: string, image_url?: string | undefined }, images: Array<{ __typename?: 'teacher_images', id: any, is_profile_picture: boolean, image: { __typename?: 'images', url: string } }> } | undefined, user_roles: Array<{ __typename?: 'user_roles', role: { __typename?: 'roles', id: any, name: string } }> }>, users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | undefined } };

export type DeleteMutationVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteMutationType = { __typename?: 'mutation_root', delete_recurring_patterns?: { __typename?: 'recurring_patterns_mutation_response', affected_rows: number } | undefined, delete_class_events?: { __typename?: 'class_events_mutation_response', affected_rows: number } | undefined, delete_classes_by_pk?: { __typename?: 'classes', id: any } | undefined };

export type InsertMutationVariablesType = Exact<{
  userId: Scalars['uuid'];
  name: Scalars['String'];
  description: Scalars['String'];
  is_organization: Scalars['Boolean'];
  instagram_name?: InputMaybe<Scalars['String']>;
  signup_message?: InputMaybe<Scalars['String']>;
  type: Teacher_Type_EnumType;
  images: Array<Teacher_Images_Insert_InputType> | Teacher_Images_Insert_InputType;
}>;


export type InsertMutationType = { __typename?: 'mutation_root', insert_teachers?: { __typename?: 'teachers_mutation_response', affected_rows: number } | undefined };

export type DeleteTeacherMutationVariablesType = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteTeacherMutationType = { __typename?: 'mutation_root', delete_user_roles?: { __typename?: 'user_roles_mutation_response', affected_rows: number } | undefined, delete_images?: { __typename?: 'images_mutation_response', affected_rows: number } | undefined, delete_teacher_images?: { __typename?: 'teacher_images_mutation_response', affected_rows: number } | undefined, delete_class_owners?: { __typename?: 'class_owners_mutation_response', affected_rows: number } | undefined, delete_class_events?: { __typename?: 'class_events_mutation_response', affected_rows: number } | undefined, delete_classes?: { __typename?: 'classes_mutation_response', affected_rows: number } | undefined, delete_teachers_by_pk?: { __typename?: 'teachers', id: any } | undefined };

export type UpdateUserRolesMutationVariablesType = Exact<{
  userId: Scalars['uuid'];
  userRoles: Array<User_Roles_Insert_InputType> | User_Roles_Insert_InputType;
}>;


export type UpdateUserRolesMutationType = { __typename?: 'mutation_root', delete_user_roles?: { __typename?: 'user_roles_mutation_response', affected_rows: number } | undefined, insert_user_roles?: { __typename?: 'user_roles_mutation_response', affected_rows: number } | undefined };

export const ClassFragmentDocType = gql`
    fragment Class on classes {
  id
  city
  name
  pricing
  location_name
  location
  image_url
  description
  class_pass_url
  requirements
  usc_url
  is_classe
  timezone
  website_url
  url_slug
  invites(where: {confirmation_status: {_eq: Pending}}) {
    id
    email
    invited_user {
      name
    }
  }
  class_teachers {
    is_owner
    teacher {
      id
      name
      location_name
      images {
        id
        is_profile_picture
        image {
          id
          url
        }
      }
    }
  }
  class_levels {
    level {
      id
      name
    }
  }
  recurring_patterns(
    where: {_or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}
  ) {
    id
    start_time
    end_time
    day_of_week
    created_at
    class_id
    start_date
    end_date
    recurring_every_x_weeks
    is_recurring
  }
}
    `;
export const ClassEventBookingsFieldsFragmentDocType = gql`
    fragment ClassEventBookingsFields on class_event_bookings {
  id
  created_at
  status
  amount
  currency
  booking_option {
    id
    title
    price
  }
  user {
    id
    email
    name
    level {
      id
      name
    }
    acro_role {
      name
      id
    }
  }
  class_event {
    id
    start_date
    end_date
    max_booking_slots
    class {
      id
      name
    }
  }
}
    `;
export const ClassEventFieldsFragmentDocType = gql`
    fragment ClassEventFields on class_events {
  id
  start_date
  end_date
  is_cancelled
  class {
    id
    name
  }
}
    `;
export const CreatedInvitesFieldsFragmentDocType = gql`
    fragment CreatedInvitesFields on created_invites {
  id
  entity_id
  entity
  email
  created_by_id
  created_at
  confirmation_status
  updated_at
  class {
    id
    name
    image_url
  }
  invited_user {
    id
    name
    teacher_profile {
      id
      name
    }
  }
  event {
    id
    name
    main_image_url
  }
}
    `;
export const InviteFieldsFragmentDocType = gql`
    fragment InviteFields on invites {
  id
  entity_id
  entity
  email
  created_by_id
  created_at
  confirmation_status
  updated_at
  class {
    id
    name
    image_url
  }
  event {
    id
    name
    main_image_url
  }
  created_by {
    name
    image_url
    teacher_profile {
      name
      images {
        image {
          url
          id
        }
        is_profile_picture
      }
    }
  }
}
    `;
export const TeacherFieldsFragmentDocType = gql`
    fragment TeacherFields on teachers {
  id
  name
  description
  location_name
  instagram_name
  is_organization
  confirmation_status
  type
  user_id
  is_stripe_enabled
  stripe_id
  url_slug
  stripe_id
  teacher_levels {
    level {
      id
      name
    }
  }
  user {
    id
    name
    image_url
  }
  images {
    id
    is_profile_picture
    image {
      id
      url
    }
  }
}
    `;
export const EventFieldsFragmentDocType = gql`
    fragment EventFields on events {
  id
  event_type
  event_source
  end_date
  description
  created_at
  location
  location_city
  location_country
  location_name
  main_image_url
  name
  pricing
  start_date
  url
  links
  is_highlighted
  highlight_requested
  updated_at
  confirmation_status
  timezone
  url_slug
  invites(where: {confirmation_status: {_eq: Pending}}) {
    ...InviteFields
  }
  owners {
    user {
      id
      teacher_profile {
        ...TeacherFields
      }
    }
  }
  teachers {
    event_id
    teacher_id
    teacher {
      id
      name
      location_name
      images {
        id
        is_profile_picture
        image {
          id
          url
        }
      }
    }
  }
  created_by {
    id
    name
    image_url
    teacher_profile {
      ...TeacherFields
    }
  }
}
    ${InviteFieldsFragmentDocType}
${TeacherFieldsFragmentDocType}`;
export const MeFieldsFragmentDocType = gql`
    fragment MeFields on me {
  id
  name
  image_url
  fcm_token
  bio
  email
  origin_id
  created_at
  is_admin
  used_teacher_signup
  is_email_verified
  invites(where: {confirmation_status: {_eq: Pending}}) {
    id
    entity_id
    entity
    email
    created_by_id
    created_at
    confirmation_status
    updated_at
    class {
      id
      name
      image_url
    }
    event {
      id
      name
      main_image_url
    }
    created_by {
      name
      image_url
      teacher_profile {
        name
        images {
          image {
            url
            id
          }
          is_profile_picture
        }
      }
    }
  }
  teacher_profile {
    id
    name
    description
    location_name
    instagram_name
    is_organization
    stripe_id
    is_stripe_enabled
    community {
      id
      name
      location
      longitude
      latitude
    }
    teacher_levels {
      level {
        id
        name
      }
    }
    user {
      id
      name
      image_url
    }
    images {
      id
      is_profile_picture
      image {
        url
      }
    }
  }
  user_roles {
    role {
      id
      name
    }
  }
}
    `;
export const NestInviteFieldsFragmentDocType = gql`
    fragment NestInviteFields on Invite {
  id
  entity_id
  entity
  email
  created_by_id
  created_at
  confirmation_status
  updated_at
  class {
    id
    name
    image_url
  }
  event {
    id
    name
    main_image_url
  }
  created_by {
    name
    image_url
    teacher_profile {
      name
      images {
        image {
          url
          id
        }
        is_profile_picture
      }
    }
  }
}
    `;
export const UserFieldsFragmentDocType = gql`
    fragment UserFields on users {
  id
  name
  image_url
  fcm_token
  bio
  email
  origin_id
  created_at
  is_admin
  teacher_profile {
    id
    name
    description
    location_name
    instagram_name
    is_organization
    community {
      id
      name
      location
      longitude
      latitude
    }
    teacher_levels {
      level {
        id
        name
      }
    }
    user {
      id
      name
      image_url
    }
    images {
      id
      is_profile_picture
      image {
        url
      }
    }
  }
  user_roles {
    role {
      id
      name
    }
  }
}
    `;
export const GetClassByPkAsTeacherDocumentType = gql`
    query GetClassByPkAsTeacher($id: uuid!) {
  classes_by_pk(id: $id) {
    ...Class
  }
}
    ${ClassFragmentDocType}`;

/**
 * __useGetClassByPkAsTeacherQuery__
 *
 * To run a query within a React component, call `useGetClassByPkAsTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassByPkAsTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassByPkAsTeacherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassByPkAsTeacherQuery(baseOptions: Apollo.QueryHookOptions<GetClassByPkAsTeacherQueryType, GetClassByPkAsTeacherQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassByPkAsTeacherQueryType, GetClassByPkAsTeacherQueryVariablesType>(GetClassByPkAsTeacherDocumentType, options);
      }
export function useGetClassByPkAsTeacherLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassByPkAsTeacherQueryType, GetClassByPkAsTeacherQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassByPkAsTeacherQueryType, GetClassByPkAsTeacherQueryVariablesType>(GetClassByPkAsTeacherDocumentType, options);
        }
export type GetClassByPkAsTeacherQueryHookResult = ReturnType<typeof useGetClassByPkAsTeacherQuery>;
export type GetClassByPkAsTeacherLazyQueryTypeHookResult = ReturnType<typeof useGetClassByPkAsTeacherLazyQueryType>;
export type GetClassByPkAsTeacherQueryResultType = Apollo.QueryResult<GetClassByPkAsTeacherQueryType, GetClassByPkAsTeacherQueryVariablesType>;
export const MyMutationDocumentType = gql`
    mutation MyMutation($id: uuid!) {
  update_class_events_by_pk(pk_columns: {id: $id}, _set: {is_cancelled: true}) {
    id
  }
}
    `;
export type MyMutationMutationFnType = Apollo.MutationFunction<MyMutationMutationType, MyMutationMutationVariablesType>;

/**
 * __useMyMutationMutation__
 *
 * To run a mutation, you first call `useMyMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myMutationMutation, { data, loading, error }] = useMyMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyMutationMutation(baseOptions?: Apollo.MutationHookOptions<MyMutationMutationType, MyMutationMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyMutationMutationType, MyMutationMutationVariablesType>(MyMutationDocumentType, options);
      }
export type MyMutationMutationHookResult = ReturnType<typeof useMyMutationMutation>;
export type MyMutationMutationResultType = Apollo.MutationResult<MyMutationMutationType>;
export type MyMutationMutationOptionsType = Apollo.BaseMutationOptions<MyMutationMutationType, MyMutationMutationVariablesType>;
export const LoginDocumentType = gql`
    mutation Login($email: String!, $password: String!) {
  login(input: {email: $email, password: $password}) {
    token
    refreshToken
  }
}
    `;
export type LoginMutationFnType = Apollo.MutationFunction<LoginMutationType, LoginMutationVariablesType>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutationType, LoginMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutationType, LoginMutationVariablesType>(LoginDocumentType, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResultType = Apollo.MutationResult<LoginMutationType>;
export type LoginMutationOptionsType = Apollo.BaseMutationOptions<LoginMutationType, LoginMutationVariablesType>;
export const InsertClassMutationDocumentType = gql`
    mutation InsertClassMutation($name: String!, $description: String!, $image_url: String!, $class_pass_url: String, $usc_url: String, $website_url: String, $pricing: String, $event_type: event_type_enum!, $requirements: String, $location: geography!, $location_name: String!, $location_city: String!, $location_country: String!, $is_classe: Boolean!, $timezone: String!, $url_slug: String!, $max_booking_slots: Int, $created_by_id: uuid, $class_owners: [class_owners_insert_input!]!, $class_booking_options: [class_booking_option_insert_input!]!, $recurring_patterns: [recurring_patterns_insert_input!]!, $class_teachers: [class_teachers_insert_input!]!, $class_levels: [class_levels_insert_input!]!) {
  insert_classes_one(
    object: {name: $name, description: $description, image_url: $image_url, class_pass_url: $class_pass_url, usc_url: $usc_url, event_type: $event_type, website_url: $website_url, pricing: $pricing, requirements: $requirements, location: $location, location_name: $location_name, location_city: $location_city, location_country: $location_country, is_classe: $is_classe, timezone: $timezone, url_slug: $url_slug, max_booking_slots: $max_booking_slots, created_by_id: $created_by_id, recurring_patterns: {data: $recurring_patterns}, class_teachers: {data: $class_teachers}, class_owners: {data: $class_owners}, class_levels: {data: $class_levels}, class_booking_options: {data: $class_booking_options}}
  ) {
    id
  }
}
    `;
export type InsertClassMutationMutationFnType = Apollo.MutationFunction<InsertClassMutationMutationType, InsertClassMutationMutationVariablesType>;

/**
 * __useInsertClassMutationMutation__
 *
 * To run a mutation, you first call `useInsertClassMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertClassMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertClassMutationMutation, { data, loading, error }] = useInsertClassMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      image_url: // value for 'image_url'
 *      class_pass_url: // value for 'class_pass_url'
 *      usc_url: // value for 'usc_url'
 *      website_url: // value for 'website_url'
 *      pricing: // value for 'pricing'
 *      event_type: // value for 'event_type'
 *      requirements: // value for 'requirements'
 *      location: // value for 'location'
 *      location_name: // value for 'location_name'
 *      location_city: // value for 'location_city'
 *      location_country: // value for 'location_country'
 *      is_classe: // value for 'is_classe'
 *      timezone: // value for 'timezone'
 *      url_slug: // value for 'url_slug'
 *      max_booking_slots: // value for 'max_booking_slots'
 *      created_by_id: // value for 'created_by_id'
 *      class_owners: // value for 'class_owners'
 *      class_booking_options: // value for 'class_booking_options'
 *      recurring_patterns: // value for 'recurring_patterns'
 *      class_teachers: // value for 'class_teachers'
 *      class_levels: // value for 'class_levels'
 *   },
 * });
 */
export function useInsertClassMutationMutation(baseOptions?: Apollo.MutationHookOptions<InsertClassMutationMutationType, InsertClassMutationMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertClassMutationMutationType, InsertClassMutationMutationVariablesType>(InsertClassMutationDocumentType, options);
      }
export type InsertClassMutationMutationHookResult = ReturnType<typeof useInsertClassMutationMutation>;
export type InsertClassMutationMutationResultType = Apollo.MutationResult<InsertClassMutationMutationType>;
export type InsertClassMutationMutationOptionsType = Apollo.BaseMutationOptions<InsertClassMutationMutationType, InsertClassMutationMutationVariablesType>;
export const UpdateClassMutationDocumentType = gql`
    mutation UpdateClassMutation($id: uuid!, $name: String!, $city: String!, $description: String!, $image_url: String!, $location: geography!, $location_name: String!, $location_city: String!, $location_country: String!, $event_type: event_type_enum!, $is_classe: Boolean!, $timezone: String!, $url_slug: String!, $class_pass_url: String, $usc_url: String, $website_url: String, $pricing: String, $requirements: String, $max_booking_slots: Int, $class_booking_options: [class_booking_option_insert_input!]!, $recurring_patterns: [recurring_patterns_insert_input!]!, $class_teachers: [class_teachers_insert_input!]!, $class_owners: [class_owners_insert_input!]!, $class_levels: [class_levels_insert_input!]!) {
  delete_booking_option(where: {class_booking_options: {class_id: {_eq: $id}}}) {
    affected_rows
  }
  delete_classes_by_pk(id: $id) {
    id
  }
  insert_classes(
    objects: {id: $id, name: $name, city: $city, description: $description, event_type: $event_type, image_url: $image_url, class_pass_url: $class_pass_url, usc_url: $usc_url, is_classe: $is_classe, website_url: $website_url, pricing: $pricing, requirements: $requirements, location: $location, location_name: $location_name, location_city: $location_city, location_country: $location_country, timezone: $timezone, url_slug: $url_slug, max_booking_slots: $max_booking_slots, recurring_patterns: {data: $recurring_patterns}, class_teachers: {data: $class_teachers}, class_owners: {data: $class_owners}, class_levels: {data: $class_levels}, class_booking_options: {data: $class_booking_options}}
  ) {
    affected_rows
    returning {
      id
      city
      name
      pricing
      location_name
      location
      image_url
      description
      class_pass_url
      requirements
      usc_url
      website_url
      is_classe
      timezone
      url_slug
      class_teachers {
        teacher {
          id
          name
        }
      }
      class_levels {
        level {
          id
          name
        }
      }
      recurring_patterns {
        id
        start_time
        end_time
        day_of_week
        created_at
        class_id
      }
    }
  }
}
    `;
export type UpdateClassMutationMutationFnType = Apollo.MutationFunction<UpdateClassMutationMutationType, UpdateClassMutationMutationVariablesType>;

/**
 * __useUpdateClassMutationMutation__
 *
 * To run a mutation, you first call `useUpdateClassMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassMutationMutation, { data, loading, error }] = useUpdateClassMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      city: // value for 'city'
 *      description: // value for 'description'
 *      image_url: // value for 'image_url'
 *      location: // value for 'location'
 *      location_name: // value for 'location_name'
 *      location_city: // value for 'location_city'
 *      location_country: // value for 'location_country'
 *      event_type: // value for 'event_type'
 *      is_classe: // value for 'is_classe'
 *      timezone: // value for 'timezone'
 *      url_slug: // value for 'url_slug'
 *      class_pass_url: // value for 'class_pass_url'
 *      usc_url: // value for 'usc_url'
 *      website_url: // value for 'website_url'
 *      pricing: // value for 'pricing'
 *      requirements: // value for 'requirements'
 *      max_booking_slots: // value for 'max_booking_slots'
 *      class_booking_options: // value for 'class_booking_options'
 *      recurring_patterns: // value for 'recurring_patterns'
 *      class_teachers: // value for 'class_teachers'
 *      class_owners: // value for 'class_owners'
 *      class_levels: // value for 'class_levels'
 *   },
 * });
 */
export function useUpdateClassMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClassMutationMutationType, UpdateClassMutationMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClassMutationMutationType, UpdateClassMutationMutationVariablesType>(UpdateClassMutationDocumentType, options);
      }
export type UpdateClassMutationMutationHookResult = ReturnType<typeof useUpdateClassMutationMutation>;
export type UpdateClassMutationMutationResultType = Apollo.MutationResult<UpdateClassMutationMutationType>;
export type UpdateClassMutationMutationOptionsType = Apollo.BaseMutationOptions<UpdateClassMutationMutationType, UpdateClassMutationMutationVariablesType>;
export const AcceptInviteDocumentType = gql`
    mutation AcceptInvite($id: String!) {
  accept_invite(invite_id: $id) {
    success
  }
}
    `;
export type AcceptInviteMutationFnType = Apollo.MutationFunction<AcceptInviteMutationType, AcceptInviteMutationVariablesType>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutationType, AcceptInviteMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutationType, AcceptInviteMutationVariablesType>(AcceptInviteDocumentType, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResultType = Apollo.MutationResult<AcceptInviteMutationType>;
export type AcceptInviteMutationOptionsType = Apollo.BaseMutationOptions<AcceptInviteMutationType, AcceptInviteMutationVariablesType>;
export const CancelClassEventDocumentType = gql`
    mutation CancelClassEvent($id: uuid!) {
  update_class_events_by_pk(pk_columns: {id: $id}, _set: {is_cancelled: true}) {
    id
  }
}
    `;
export type CancelClassEventMutationFnType = Apollo.MutationFunction<CancelClassEventMutationType, CancelClassEventMutationVariablesType>;

/**
 * __useCancelClassEventMutation__
 *
 * To run a mutation, you first call `useCancelClassEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassEventMutation, { data, loading, error }] = useCancelClassEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelClassEventMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassEventMutationType, CancelClassEventMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassEventMutationType, CancelClassEventMutationVariablesType>(CancelClassEventDocumentType, options);
      }
export type CancelClassEventMutationHookResult = ReturnType<typeof useCancelClassEventMutation>;
export type CancelClassEventMutationResultType = Apollo.MutationResult<CancelClassEventMutationType>;
export type CancelClassEventMutationOptionsType = Apollo.BaseMutationOptions<CancelClassEventMutationType, CancelClassEventMutationVariablesType>;
export const CreateStripeUserDocumentType = gql`
    mutation CreateStripeUser {
  create_stripe_user {
    url
  }
}
    `;
export type CreateStripeUserMutationFnType = Apollo.MutationFunction<CreateStripeUserMutationType, CreateStripeUserMutationVariablesType>;

/**
 * __useCreateStripeUserMutation__
 *
 * To run a mutation, you first call `useCreateStripeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeUserMutation, { data, loading, error }] = useCreateStripeUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateStripeUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeUserMutationType, CreateStripeUserMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeUserMutationType, CreateStripeUserMutationVariablesType>(CreateStripeUserDocumentType, options);
      }
export type CreateStripeUserMutationHookResult = ReturnType<typeof useCreateStripeUserMutation>;
export type CreateStripeUserMutationResultType = Apollo.MutationResult<CreateStripeUserMutationType>;
export type CreateStripeUserMutationOptionsType = Apollo.BaseMutationOptions<CreateStripeUserMutationType, CreateStripeUserMutationVariablesType>;
export const DeleteAccountDocumentType = gql`
    mutation DeleteAccount {
  delete_account {
    success
  }
}
    `;
export type DeleteAccountMutationFnType = Apollo.MutationFunction<DeleteAccountMutationType, DeleteAccountMutationVariablesType>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutationType, DeleteAccountMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutationType, DeleteAccountMutationVariablesType>(DeleteAccountDocumentType, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResultType = Apollo.MutationResult<DeleteAccountMutationType>;
export type DeleteAccountMutationOptionsType = Apollo.BaseMutationOptions<DeleteAccountMutationType, DeleteAccountMutationVariablesType>;
export const DeleteInviteByPkDocumentType = gql`
    mutation DeleteInviteByPk($id: uuid!) {
  delete_invites_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteInviteByPkMutationFnType = Apollo.MutationFunction<DeleteInviteByPkMutationType, DeleteInviteByPkMutationVariablesType>;

/**
 * __useDeleteInviteByPkMutation__
 *
 * To run a mutation, you first call `useDeleteInviteByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInviteByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInviteByPkMutation, { data, loading, error }] = useDeleteInviteByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInviteByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInviteByPkMutationType, DeleteInviteByPkMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInviteByPkMutationType, DeleteInviteByPkMutationVariablesType>(DeleteInviteByPkDocumentType, options);
      }
export type DeleteInviteByPkMutationHookResult = ReturnType<typeof useDeleteInviteByPkMutation>;
export type DeleteInviteByPkMutationResultType = Apollo.MutationResult<DeleteInviteByPkMutationType>;
export type DeleteInviteByPkMutationOptionsType = Apollo.BaseMutationOptions<DeleteInviteByPkMutationType, DeleteInviteByPkMutationVariablesType>;
export const ResetPasswordDocumentType = gql`
    mutation ResetPassword($email: String!) {
  reset_password(input: {email: $email}) {
    success
  }
}
    `;
export type ResetPasswordMutationFnType = Apollo.MutationFunction<ResetPasswordMutationType, ResetPasswordMutationVariablesType>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutationType, ResetPasswordMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutationType, ResetPasswordMutationVariablesType>(ResetPasswordDocumentType, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResultType = Apollo.MutationResult<ResetPasswordMutationType>;
export type ResetPasswordMutationOptionsType = Apollo.BaseMutationOptions<ResetPasswordMutationType, ResetPasswordMutationVariablesType>;
export const InviteDocumentType = gql`
    mutation Invite($entityId: String, $entityType: String, $email: String, $userId: String) {
  invite(
    entity_id: $entityId
    entity: $entityType
    email: $email
    userId: $userId
  ) {
    success
  }
}
    `;
export type InviteMutationFnType = Apollo.MutationFunction<InviteMutationType, InviteMutationVariablesType>;

/**
 * __useInviteMutation__
 *
 * To run a mutation, you first call `useInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMutation, { data, loading, error }] = useInviteMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      email: // value for 'email'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInviteMutation(baseOptions?: Apollo.MutationHookOptions<InviteMutationType, InviteMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMutationType, InviteMutationVariablesType>(InviteDocumentType, options);
      }
export type InviteMutationHookResult = ReturnType<typeof useInviteMutation>;
export type InviteMutationResultType = Apollo.MutationResult<InviteMutationType>;
export type InviteMutationOptionsType = Apollo.BaseMutationOptions<InviteMutationType, InviteMutationVariablesType>;
export const LoginWithRefreshTokenDocumentType = gql`
    mutation LoginWithRefreshToken($refreshToken: String!) {
  loginWithRefreshToken(input: {refreshToken: $refreshToken}) {
    token
    refreshToken
  }
}
    `;
export type LoginWithRefreshTokenMutationFnType = Apollo.MutationFunction<LoginWithRefreshTokenMutationType, LoginWithRefreshTokenMutationVariablesType>;

/**
 * __useLoginWithRefreshTokenMutation__
 *
 * To run a mutation, you first call `useLoginWithRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithRefreshTokenMutation, { data, loading, error }] = useLoginWithRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useLoginWithRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithRefreshTokenMutationType, LoginWithRefreshTokenMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithRefreshTokenMutationType, LoginWithRefreshTokenMutationVariablesType>(LoginWithRefreshTokenDocumentType, options);
      }
export type LoginWithRefreshTokenMutationHookResult = ReturnType<typeof useLoginWithRefreshTokenMutation>;
export type LoginWithRefreshTokenMutationResultType = Apollo.MutationResult<LoginWithRefreshTokenMutationType>;
export type LoginWithRefreshTokenMutationOptionsType = Apollo.BaseMutationOptions<LoginWithRefreshTokenMutationType, LoginWithRefreshTokenMutationVariablesType>;
export const RegisterAsTeacherDocumentType = gql`
    mutation RegisterAsTeacher($email: String!, $password: String!, $name: String!, $inviteId: String) {
  register_as_teacher(
    input: {email: $email, password: $password, name: $name, inviteId: $inviteId}
  ) {
    token
    refreshToken
    user {
      id
      name
    }
  }
}
    `;
export type RegisterAsTeacherMutationFnType = Apollo.MutationFunction<RegisterAsTeacherMutationType, RegisterAsTeacherMutationVariablesType>;

/**
 * __useRegisterAsTeacherMutation__
 *
 * To run a mutation, you first call `useRegisterAsTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAsTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAsTeacherMutation, { data, loading, error }] = useRegisterAsTeacherMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRegisterAsTeacherMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAsTeacherMutationType, RegisterAsTeacherMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAsTeacherMutationType, RegisterAsTeacherMutationVariablesType>(RegisterAsTeacherDocumentType, options);
      }
export type RegisterAsTeacherMutationHookResult = ReturnType<typeof useRegisterAsTeacherMutation>;
export type RegisterAsTeacherMutationResultType = Apollo.MutationResult<RegisterAsTeacherMutationType>;
export type RegisterAsTeacherMutationOptionsType = Apollo.BaseMutationOptions<RegisterAsTeacherMutationType, RegisterAsTeacherMutationVariablesType>;
export const RejectInviteDocumentType = gql`
    mutation RejectInvite($id: uuid!) {
  update_invites_by_pk(
    pk_columns: {id: $id}
    _set: {confirmation_status: Rejected}
  ) {
    id
  }
}
    `;
export type RejectInviteMutationFnType = Apollo.MutationFunction<RejectInviteMutationType, RejectInviteMutationVariablesType>;

/**
 * __useRejectInviteMutation__
 *
 * To run a mutation, you first call `useRejectInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInviteMutation, { data, loading, error }] = useRejectInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRejectInviteMutation(baseOptions?: Apollo.MutationHookOptions<RejectInviteMutationType, RejectInviteMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectInviteMutationType, RejectInviteMutationVariablesType>(RejectInviteDocumentType, options);
      }
export type RejectInviteMutationHookResult = ReturnType<typeof useRejectInviteMutation>;
export type RejectInviteMutationResultType = Apollo.MutationResult<RejectInviteMutationType>;
export type RejectInviteMutationOptionsType = Apollo.BaseMutationOptions<RejectInviteMutationType, RejectInviteMutationVariablesType>;
export const SendVerificationEmailDocumentType = gql`
    mutation SendVerificationEmail {
  send_verification_email {
    success
  }
}
    `;
export type SendVerificationEmailMutationFnType = Apollo.MutationFunction<SendVerificationEmailMutationType, SendVerificationEmailMutationVariablesType>;

/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationEmailMutationType, SendVerificationEmailMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationEmailMutationType, SendVerificationEmailMutationVariablesType>(SendVerificationEmailDocumentType, options);
      }
export type SendVerificationEmailMutationHookResult = ReturnType<typeof useSendVerificationEmailMutation>;
export type SendVerificationEmailMutationResultType = Apollo.MutationResult<SendVerificationEmailMutationType>;
export type SendVerificationEmailMutationOptionsType = Apollo.BaseMutationOptions<SendVerificationEmailMutationType, SendVerificationEmailMutationVariablesType>;
export const SignupAsTeacherDocumentType = gql`
    mutation SignupAsTeacher {
  signup_as_teacher {
    success
  }
}
    `;
export type SignupAsTeacherMutationFnType = Apollo.MutationFunction<SignupAsTeacherMutationType, SignupAsTeacherMutationVariablesType>;

/**
 * __useSignupAsTeacherMutation__
 *
 * To run a mutation, you first call `useSignupAsTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupAsTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupAsTeacherMutation, { data, loading, error }] = useSignupAsTeacherMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignupAsTeacherMutation(baseOptions?: Apollo.MutationHookOptions<SignupAsTeacherMutationType, SignupAsTeacherMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupAsTeacherMutationType, SignupAsTeacherMutationVariablesType>(SignupAsTeacherDocumentType, options);
      }
export type SignupAsTeacherMutationHookResult = ReturnType<typeof useSignupAsTeacherMutation>;
export type SignupAsTeacherMutationResultType = Apollo.MutationResult<SignupAsTeacherMutationType>;
export type SignupAsTeacherMutationOptionsType = Apollo.BaseMutationOptions<SignupAsTeacherMutationType, SignupAsTeacherMutationVariablesType>;
export const UpdateTeacherAsAdminUserDocumentType = gql`
    mutation UpdateTeacherAsAdminUser($id: uuid!, $userId: uuid!, $name: String!, $description: String!, $is_organization: Boolean!, $instagram_name: String!, $url_slug: String!, $images: [teacher_images_insert_input!]!, $confirmation_status: confirmation_status_enum!, $signup_message: String!, $stripe_id: String!, $is_stripe_enabled: Boolean!) {
  delete_teachers_by_pk(id: $id) {
    id
  }
  delete_teacher_images(where: {teacher_id: {_eq: $id}}) {
    affected_rows
  }
  insert_teachers(
    objects: {id: $id, name: $name, description: $description, instagram_name: $instagram_name, is_organization: $is_organization, user_id: $userId, url_slug: $url_slug, images: {data: $images}, confirmation_status: $confirmation_status, signup_message: $signup_message, stripe_id: $stripe_id, is_stripe_enabled: $is_stripe_enabled}
  ) {
    affected_rows
    returning {
      ...TeacherFields
    }
  }
}
    ${TeacherFieldsFragmentDocType}`;
export type UpdateTeacherAsAdminUserMutationFnType = Apollo.MutationFunction<UpdateTeacherAsAdminUserMutationType, UpdateTeacherAsAdminUserMutationVariablesType>;

/**
 * __useUpdateTeacherAsAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherAsAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherAsAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherAsAdminUserMutation, { data, loading, error }] = useUpdateTeacherAsAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      is_organization: // value for 'is_organization'
 *      instagram_name: // value for 'instagram_name'
 *      url_slug: // value for 'url_slug'
 *      images: // value for 'images'
 *      confirmation_status: // value for 'confirmation_status'
 *      signup_message: // value for 'signup_message'
 *      stripe_id: // value for 'stripe_id'
 *      is_stripe_enabled: // value for 'is_stripe_enabled'
 *   },
 * });
 */
export function useUpdateTeacherAsAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeacherAsAdminUserMutationType, UpdateTeacherAsAdminUserMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeacherAsAdminUserMutationType, UpdateTeacherAsAdminUserMutationVariablesType>(UpdateTeacherAsAdminUserDocumentType, options);
      }
export type UpdateTeacherAsAdminUserMutationHookResult = ReturnType<typeof useUpdateTeacherAsAdminUserMutation>;
export type UpdateTeacherAsAdminUserMutationResultType = Apollo.MutationResult<UpdateTeacherAsAdminUserMutationType>;
export type UpdateTeacherAsAdminUserMutationOptionsType = Apollo.BaseMutationOptions<UpdateTeacherAsAdminUserMutationType, UpdateTeacherAsAdminUserMutationVariablesType>;
export const UpdateTeacherAsTeacherUserDocumentType = gql`
    mutation UpdateTeacherAsTeacherUser($id: uuid!, $userId: uuid!, $name: String!, $description: String!, $is_organization: Boolean!, $instagram_name: String!, $url_slug: String!, $type: teacher_type_enum!, $stripe_id: String!, $is_stripe_enabled: Boolean!, $images: [teacher_images_insert_input!]!) {
  delete_teachers_by_pk(id: $id) {
    id
  }
  delete_teacher_images(where: {teacher_id: {_eq: $id}}) {
    affected_rows
  }
  insert_teachers(
    objects: {id: $id, name: $name, description: $description, instagram_name: $instagram_name, is_organization: $is_organization, user_id: $userId, url_slug: $url_slug, type: $type, stripe_id: $stripe_id, is_stripe_enabled: $is_stripe_enabled, images: {data: $images}}
  ) {
    affected_rows
    returning {
      ...TeacherFields
    }
  }
}
    ${TeacherFieldsFragmentDocType}`;
export type UpdateTeacherAsTeacherUserMutationFnType = Apollo.MutationFunction<UpdateTeacherAsTeacherUserMutationType, UpdateTeacherAsTeacherUserMutationVariablesType>;

/**
 * __useUpdateTeacherAsTeacherUserMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherAsTeacherUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherAsTeacherUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherAsTeacherUserMutation, { data, loading, error }] = useUpdateTeacherAsTeacherUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      is_organization: // value for 'is_organization'
 *      instagram_name: // value for 'instagram_name'
 *      url_slug: // value for 'url_slug'
 *      type: // value for 'type'
 *      stripe_id: // value for 'stripe_id'
 *      is_stripe_enabled: // value for 'is_stripe_enabled'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useUpdateTeacherAsTeacherUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeacherAsTeacherUserMutationType, UpdateTeacherAsTeacherUserMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeacherAsTeacherUserMutationType, UpdateTeacherAsTeacherUserMutationVariablesType>(UpdateTeacherAsTeacherUserDocumentType, options);
      }
export type UpdateTeacherAsTeacherUserMutationHookResult = ReturnType<typeof useUpdateTeacherAsTeacherUserMutation>;
export type UpdateTeacherAsTeacherUserMutationResultType = Apollo.MutationResult<UpdateTeacherAsTeacherUserMutationType>;
export type UpdateTeacherAsTeacherUserMutationOptionsType = Apollo.BaseMutationOptions<UpdateTeacherAsTeacherUserMutationType, UpdateTeacherAsTeacherUserMutationVariablesType>;
export const UpsertEventAsAdminUserDocumentType = gql`
    mutation UpsertEventAsAdminUser($event_id: uuid, $event: events_insert_input!) {
  delete_event_teachers(where: {event_id: {_eq: $event_id}}) {
    affected_rows
  }
  delete_event_owners(where: {event_id: {_eq: $event_id}}) {
    affected_rows
  }
  insert_events_one(
    on_conflict: {constraint: events_pkey, update_columns: [name, description, links, start_date, end_date, start_date_tz, end_date_tz, event_type, pricing, main_image_url, url, location, location_city, location_country, highlight_requested, confirmation_status, timezone, url_slug]}
    object: $event
  ) {
    id
  }
}
    `;
export type UpsertEventAsAdminUserMutationFnType = Apollo.MutationFunction<UpsertEventAsAdminUserMutationType, UpsertEventAsAdminUserMutationVariablesType>;

/**
 * __useUpsertEventAsAdminUserMutation__
 *
 * To run a mutation, you first call `useUpsertEventAsAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEventAsAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEventAsAdminUserMutation, { data, loading, error }] = useUpsertEventAsAdminUserMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpsertEventAsAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEventAsAdminUserMutationType, UpsertEventAsAdminUserMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEventAsAdminUserMutationType, UpsertEventAsAdminUserMutationVariablesType>(UpsertEventAsAdminUserDocumentType, options);
      }
export type UpsertEventAsAdminUserMutationHookResult = ReturnType<typeof useUpsertEventAsAdminUserMutation>;
export type UpsertEventAsAdminUserMutationResultType = Apollo.MutationResult<UpsertEventAsAdminUserMutationType>;
export type UpsertEventAsAdminUserMutationOptionsType = Apollo.BaseMutationOptions<UpsertEventAsAdminUserMutationType, UpsertEventAsAdminUserMutationVariablesType>;
export const UpsertEventAsTeacherUserDocumentType = gql`
    mutation UpsertEventAsTeacherUser($event_id: uuid!, $own_user_id: uuid!, $event: events_insert_input!) {
  delete_event_teachers(where: {event_id: {_eq: $event_id}}) {
    affected_rows
  }
  delete_event_owners(
    where: {event_id: {_eq: $event_id}, user_id: {_neq: $own_user_id}}
  ) {
    affected_rows
  }
  insert_events_one(
    on_conflict: {constraint: events_pkey, update_columns: [name, description, links, start_date, end_date, start_date_tz, end_date_tz, event_type, pricing, main_image_url, url, location, location_city, location_country, highlight_requested, timezone, url_slug]}
    object: $event
  ) {
    id
  }
}
    `;
export type UpsertEventAsTeacherUserMutationFnType = Apollo.MutationFunction<UpsertEventAsTeacherUserMutationType, UpsertEventAsTeacherUserMutationVariablesType>;

/**
 * __useUpsertEventAsTeacherUserMutation__
 *
 * To run a mutation, you first call `useUpsertEventAsTeacherUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEventAsTeacherUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEventAsTeacherUserMutation, { data, loading, error }] = useUpsertEventAsTeacherUserMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      own_user_id: // value for 'own_user_id'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpsertEventAsTeacherUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEventAsTeacherUserMutationType, UpsertEventAsTeacherUserMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEventAsTeacherUserMutationType, UpsertEventAsTeacherUserMutationVariablesType>(UpsertEventAsTeacherUserDocumentType, options);
      }
export type UpsertEventAsTeacherUserMutationHookResult = ReturnType<typeof useUpsertEventAsTeacherUserMutation>;
export type UpsertEventAsTeacherUserMutationResultType = Apollo.MutationResult<UpsertEventAsTeacherUserMutationType>;
export type UpsertEventAsTeacherUserMutationOptionsType = Apollo.BaseMutationOptions<UpsertEventAsTeacherUserMutationType, UpsertEventAsTeacherUserMutationVariablesType>;
export const VerifyEmailDocumentType = gql`
    mutation VerifyEmail($code: String!) {
  verify_email(code: $code)
}
    `;
export type VerifyEmailMutationFnType = Apollo.MutationFunction<VerifyEmailMutationType, VerifyEmailMutationVariablesType>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutationType, VerifyEmailMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutationType, VerifyEmailMutationVariablesType>(VerifyEmailDocumentType, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResultType = Apollo.MutationResult<VerifyEmailMutationType>;
export type VerifyEmailMutationOptionsType = Apollo.BaseMutationOptions<VerifyEmailMutationType, VerifyEmailMutationVariablesType>;
export const VerifyStripeAccountDocumentType = gql`
    mutation VerifyStripeAccount {
  verify_stripe_account
}
    `;
export type VerifyStripeAccountMutationFnType = Apollo.MutationFunction<VerifyStripeAccountMutationType, VerifyStripeAccountMutationVariablesType>;

/**
 * __useVerifyStripeAccountMutation__
 *
 * To run a mutation, you first call `useVerifyStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyStripeAccountMutation, { data, loading, error }] = useVerifyStripeAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<VerifyStripeAccountMutationType, VerifyStripeAccountMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyStripeAccountMutationType, VerifyStripeAccountMutationVariablesType>(VerifyStripeAccountDocumentType, options);
      }
export type VerifyStripeAccountMutationHookResult = ReturnType<typeof useVerifyStripeAccountMutation>;
export type VerifyStripeAccountMutationResultType = Apollo.MutationResult<VerifyStripeAccountMutationType>;
export type VerifyStripeAccountMutationOptionsType = Apollo.BaseMutationOptions<VerifyStripeAccountMutationType, VerifyStripeAccountMutationVariablesType>;
export const GetAllBookingsPageableDocumentType = gql`
    query GetAllBookingsPageable($limit: Int, $offset: Int, $where: class_event_bookings_bool_exp) {
  class_event_bookings(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {created_at: desc}
  ) {
    ...ClassEventBookingsFields
  }
  class_event_bookings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${ClassEventBookingsFieldsFragmentDocType}`;

/**
 * __useGetAllBookingsPageableQuery__
 *
 * To run a query within a React component, call `useGetAllBookingsPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBookingsPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBookingsPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllBookingsPageableQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBookingsPageableQueryType, GetAllBookingsPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBookingsPageableQueryType, GetAllBookingsPageableQueryVariablesType>(GetAllBookingsPageableDocumentType, options);
      }
export function useGetAllBookingsPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBookingsPageableQueryType, GetAllBookingsPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBookingsPageableQueryType, GetAllBookingsPageableQueryVariablesType>(GetAllBookingsPageableDocumentType, options);
        }
export type GetAllBookingsPageableQueryHookResult = ReturnType<typeof useGetAllBookingsPageableQuery>;
export type GetAllBookingsPageableLazyQueryTypeHookResult = ReturnType<typeof useGetAllBookingsPageableLazyQueryType>;
export type GetAllBookingsPageableQueryResultType = Apollo.QueryResult<GetAllBookingsPageableQueryType, GetAllBookingsPageableQueryVariablesType>;
export const GetClassByPkDocumentType = gql`
    query GetClassByPk($id: uuid!) {
  classes_by_pk(id: $id) {
    id
    city
    name
    pricing
    location
    location_name
    location_city
    location_country
    event_type
    image_url
    description
    class_pass_url
    requirements
    usc_url
    is_classe
    timezone
    website_url
    url_slug
    invites(where: {confirmation_status: {_eq: Pending}}) {
      id
      email
      entity
      invited_user {
        id
        name
        teacher_profile {
          id
          name
        }
      }
    }
    class_owners {
      id
      is_payment_receiver
      teacher {
        id
        name
        location_name
        images {
          id
          is_profile_picture
          image {
            id
            url
          }
        }
      }
    }
    class_teachers {
      is_owner
      teacher {
        id
        name
        location_name
        images {
          id
          is_profile_picture
          image {
            id
            url
          }
        }
      }
    }
    class_levels {
      level {
        id
        name
      }
    }
    recurring_patterns(
      where: {_or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}
    ) {
      id
      start_time
      end_time
      day_of_week
      created_at
      class_id
      start_date
      end_date
      recurring_every_x_weeks
      is_recurring
    }
  }
}
    `;

/**
 * __useGetClassByPkQuery__
 *
 * To run a query within a React component, call `useGetClassByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassByPkQuery(baseOptions: Apollo.QueryHookOptions<GetClassByPkQueryType, GetClassByPkQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassByPkQueryType, GetClassByPkQueryVariablesType>(GetClassByPkDocumentType, options);
      }
export function useGetClassByPkLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassByPkQueryType, GetClassByPkQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassByPkQueryType, GetClassByPkQueryVariablesType>(GetClassByPkDocumentType, options);
        }
export type GetClassByPkQueryHookResult = ReturnType<typeof useGetClassByPkQuery>;
export type GetClassByPkLazyQueryTypeHookResult = ReturnType<typeof useGetClassByPkLazyQueryType>;
export type GetClassByPkQueryResultType = Apollo.QueryResult<GetClassByPkQueryType, GetClassByPkQueryVariablesType>;
export const GetClassEventBookingsPageableDocumentType = gql`
    query GetClassEventBookingsPageable($classEventId: uuid!, $limit: Int, $offset: Int, $where: class_event_bookings_bool_exp) {
  class_events_by_pk(id: $classEventId) {
    id
    start_date
    end_date
    max_booking_slots
    class {
      id
      name
      max_booking_slots
    }
  }
  class_event_bookings(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {created_at: desc}
  ) {
    ...ClassEventBookingsFields
  }
  class_event_bookings_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${ClassEventBookingsFieldsFragmentDocType}`;

/**
 * __useGetClassEventBookingsPageableQuery__
 *
 * To run a query within a React component, call `useGetClassEventBookingsPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassEventBookingsPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassEventBookingsPageableQuery({
 *   variables: {
 *      classEventId: // value for 'classEventId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClassEventBookingsPageableQuery(baseOptions: Apollo.QueryHookOptions<GetClassEventBookingsPageableQueryType, GetClassEventBookingsPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassEventBookingsPageableQueryType, GetClassEventBookingsPageableQueryVariablesType>(GetClassEventBookingsPageableDocumentType, options);
      }
export function useGetClassEventBookingsPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassEventBookingsPageableQueryType, GetClassEventBookingsPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassEventBookingsPageableQueryType, GetClassEventBookingsPageableQueryVariablesType>(GetClassEventBookingsPageableDocumentType, options);
        }
export type GetClassEventBookingsPageableQueryHookResult = ReturnType<typeof useGetClassEventBookingsPageableQuery>;
export type GetClassEventBookingsPageableLazyQueryTypeHookResult = ReturnType<typeof useGetClassEventBookingsPageableLazyQueryType>;
export type GetClassEventBookingsPageableQueryResultType = Apollo.QueryResult<GetClassEventBookingsPageableQueryType, GetClassEventBookingsPageableQueryVariablesType>;
export const GetClassEventsPageableDocumentType = gql`
    query GetClassEventsPageable($classId: uuid!, $limit: Int, $offset: Int, $where: class_events_bool_exp!) {
  classes_by_pk(id: $classId) {
    id
    name
  }
  class_events(
    limit: $limit
    offset: $offset
    order_by: {start_date: asc}
    where: $where
  ) {
    ...ClassEventFields
  }
  class_events_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${ClassEventFieldsFragmentDocType}`;

/**
 * __useGetClassEventsPageableQuery__
 *
 * To run a query within a React component, call `useGetClassEventsPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassEventsPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassEventsPageableQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetClassEventsPageableQuery(baseOptions: Apollo.QueryHookOptions<GetClassEventsPageableQueryType, GetClassEventsPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassEventsPageableQueryType, GetClassEventsPageableQueryVariablesType>(GetClassEventsPageableDocumentType, options);
      }
export function useGetClassEventsPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassEventsPageableQueryType, GetClassEventsPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassEventsPageableQueryType, GetClassEventsPageableQueryVariablesType>(GetClassEventsPageableDocumentType, options);
        }
export type GetClassEventsPageableQueryHookResult = ReturnType<typeof useGetClassEventsPageableQuery>;
export type GetClassEventsPageableLazyQueryTypeHookResult = ReturnType<typeof useGetClassEventsPageableLazyQueryType>;
export type GetClassEventsPageableQueryResultType = Apollo.QueryResult<GetClassEventsPageableQueryType, GetClassEventsPageableQueryVariablesType>;
export const GetClassSlugSuggestionDocumentType = gql`
    query GetClassSlugSuggestion($name: String!) {
  get_class_slug_suggestion(name: $name)
}
    `;

/**
 * __useGetClassSlugSuggestionQuery__
 *
 * To run a query within a React component, call `useGetClassSlugSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassSlugSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassSlugSuggestionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetClassSlugSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetClassSlugSuggestionQueryType, GetClassSlugSuggestionQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassSlugSuggestionQueryType, GetClassSlugSuggestionQueryVariablesType>(GetClassSlugSuggestionDocumentType, options);
      }
export function useGetClassSlugSuggestionLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassSlugSuggestionQueryType, GetClassSlugSuggestionQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassSlugSuggestionQueryType, GetClassSlugSuggestionQueryVariablesType>(GetClassSlugSuggestionDocumentType, options);
        }
export type GetClassSlugSuggestionQueryHookResult = ReturnType<typeof useGetClassSlugSuggestionQuery>;
export type GetClassSlugSuggestionLazyQueryTypeHookResult = ReturnType<typeof useGetClassSlugSuggestionLazyQueryType>;
export type GetClassSlugSuggestionQueryResultType = Apollo.QueryResult<GetClassSlugSuggestionQueryType, GetClassSlugSuggestionQueryVariablesType>;
export const GetClassesPageableDocumentType = gql`
    query GetClassesPageable($limit: Int, $offset: Int) {
  classes(limit: $limit, offset: $offset, order_by: {name: asc}) {
    id
    name
    description
    image_url
  }
  classes_aggregate {
    aggregate {
      count(distinct: true)
    }
  }
}
    `;

/**
 * __useGetClassesPageableQuery__
 *
 * To run a query within a React component, call `useGetClassesPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassesPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassesPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetClassesPageableQuery(baseOptions?: Apollo.QueryHookOptions<GetClassesPageableQueryType, GetClassesPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassesPageableQueryType, GetClassesPageableQueryVariablesType>(GetClassesPageableDocumentType, options);
      }
export function useGetClassesPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassesPageableQueryType, GetClassesPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassesPageableQueryType, GetClassesPageableQueryVariablesType>(GetClassesPageableDocumentType, options);
        }
export type GetClassesPageableQueryHookResult = ReturnType<typeof useGetClassesPageableQuery>;
export type GetClassesPageableLazyQueryTypeHookResult = ReturnType<typeof useGetClassesPageableLazyQueryType>;
export type GetClassesPageableQueryResultType = Apollo.QueryResult<GetClassesPageableQueryType, GetClassesPageableQueryVariablesType>;
export const GetConfirmationStatusDocumentType = gql`
    query GetConfirmationStatus {
  confirmation_status {
    value
  }
}
    `;

/**
 * __useGetConfirmationStatusQuery__
 *
 * To run a query within a React component, call `useGetConfirmationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfirmationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfirmationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfirmationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetConfirmationStatusQueryType, GetConfirmationStatusQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfirmationStatusQueryType, GetConfirmationStatusQueryVariablesType>(GetConfirmationStatusDocumentType, options);
      }
export function useGetConfirmationStatusLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetConfirmationStatusQueryType, GetConfirmationStatusQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfirmationStatusQueryType, GetConfirmationStatusQueryVariablesType>(GetConfirmationStatusDocumentType, options);
        }
export type GetConfirmationStatusQueryHookResult = ReturnType<typeof useGetConfirmationStatusQuery>;
export type GetConfirmationStatusLazyQueryTypeHookResult = ReturnType<typeof useGetConfirmationStatusLazyQueryType>;
export type GetConfirmationStatusQueryResultType = Apollo.QueryResult<GetConfirmationStatusQueryType, GetConfirmationStatusQueryVariablesType>;
export const GetCreatedInvitesPageableDocumentType = gql`
    query GetCreatedInvitesPageable($limit: Int, $offset: Int, $where: created_invites_bool_exp!) {
  created_invites(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {created_at: desc}
  ) {
    ...CreatedInvitesFields
  }
  created_invites_aggregate {
    aggregate {
      count
    }
  }
}
    ${CreatedInvitesFieldsFragmentDocType}`;

/**
 * __useGetCreatedInvitesPageableQuery__
 *
 * To run a query within a React component, call `useGetCreatedInvitesPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatedInvitesPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatedInvitesPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCreatedInvitesPageableQuery(baseOptions: Apollo.QueryHookOptions<GetCreatedInvitesPageableQueryType, GetCreatedInvitesPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreatedInvitesPageableQueryType, GetCreatedInvitesPageableQueryVariablesType>(GetCreatedInvitesPageableDocumentType, options);
      }
export function useGetCreatedInvitesPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreatedInvitesPageableQueryType, GetCreatedInvitesPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreatedInvitesPageableQueryType, GetCreatedInvitesPageableQueryVariablesType>(GetCreatedInvitesPageableDocumentType, options);
        }
export type GetCreatedInvitesPageableQueryHookResult = ReturnType<typeof useGetCreatedInvitesPageableQuery>;
export type GetCreatedInvitesPageableLazyQueryTypeHookResult = ReturnType<typeof useGetCreatedInvitesPageableLazyQueryType>;
export type GetCreatedInvitesPageableQueryResultType = Apollo.QueryResult<GetCreatedInvitesPageableQueryType, GetCreatedInvitesPageableQueryVariablesType>;
export const GetEventByPkAsAdminUserDocumentType = gql`
    query GetEventByPkAsAdminUser($id: uuid!) {
  events_by_pk(id: $id) {
    ...EventFields
    confirmation_status
  }
}
    ${EventFieldsFragmentDocType}`;

/**
 * __useGetEventByPkAsAdminUserQuery__
 *
 * To run a query within a React component, call `useGetEventByPkAsAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByPkAsAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByPkAsAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventByPkAsAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetEventByPkAsAdminUserQueryType, GetEventByPkAsAdminUserQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByPkAsAdminUserQueryType, GetEventByPkAsAdminUserQueryVariablesType>(GetEventByPkAsAdminUserDocumentType, options);
      }
export function useGetEventByPkAsAdminUserLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByPkAsAdminUserQueryType, GetEventByPkAsAdminUserQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByPkAsAdminUserQueryType, GetEventByPkAsAdminUserQueryVariablesType>(GetEventByPkAsAdminUserDocumentType, options);
        }
export type GetEventByPkAsAdminUserQueryHookResult = ReturnType<typeof useGetEventByPkAsAdminUserQuery>;
export type GetEventByPkAsAdminUserLazyQueryTypeHookResult = ReturnType<typeof useGetEventByPkAsAdminUserLazyQueryType>;
export type GetEventByPkAsAdminUserQueryResultType = Apollo.QueryResult<GetEventByPkAsAdminUserQueryType, GetEventByPkAsAdminUserQueryVariablesType>;
export const GetEventByPkAsTeacherUserDocumentType = gql`
    query GetEventByPkAsTeacherUser($id: uuid!) {
  events_by_pk(id: $id) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDocType}`;

/**
 * __useGetEventByPkAsTeacherUserQuery__
 *
 * To run a query within a React component, call `useGetEventByPkAsTeacherUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventByPkAsTeacherUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventByPkAsTeacherUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventByPkAsTeacherUserQuery(baseOptions: Apollo.QueryHookOptions<GetEventByPkAsTeacherUserQueryType, GetEventByPkAsTeacherUserQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventByPkAsTeacherUserQueryType, GetEventByPkAsTeacherUserQueryVariablesType>(GetEventByPkAsTeacherUserDocumentType, options);
      }
export function useGetEventByPkAsTeacherUserLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventByPkAsTeacherUserQueryType, GetEventByPkAsTeacherUserQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventByPkAsTeacherUserQueryType, GetEventByPkAsTeacherUserQueryVariablesType>(GetEventByPkAsTeacherUserDocumentType, options);
        }
export type GetEventByPkAsTeacherUserQueryHookResult = ReturnType<typeof useGetEventByPkAsTeacherUserQuery>;
export type GetEventByPkAsTeacherUserLazyQueryTypeHookResult = ReturnType<typeof useGetEventByPkAsTeacherUserLazyQueryType>;
export type GetEventByPkAsTeacherUserQueryResultType = Apollo.QueryResult<GetEventByPkAsTeacherUserQueryType, GetEventByPkAsTeacherUserQueryVariablesType>;
export const GetEventSlugSuggestionDocumentType = gql`
    query GetEventSlugSuggestion($name: String!) {
  get_event_slug_suggestion(name: $name)
}
    `;

/**
 * __useGetEventSlugSuggestionQuery__
 *
 * To run a query within a React component, call `useGetEventSlugSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventSlugSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventSlugSuggestionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEventSlugSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetEventSlugSuggestionQueryType, GetEventSlugSuggestionQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventSlugSuggestionQueryType, GetEventSlugSuggestionQueryVariablesType>(GetEventSlugSuggestionDocumentType, options);
      }
export function useGetEventSlugSuggestionLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventSlugSuggestionQueryType, GetEventSlugSuggestionQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventSlugSuggestionQueryType, GetEventSlugSuggestionQueryVariablesType>(GetEventSlugSuggestionDocumentType, options);
        }
export type GetEventSlugSuggestionQueryHookResult = ReturnType<typeof useGetEventSlugSuggestionQuery>;
export type GetEventSlugSuggestionLazyQueryTypeHookResult = ReturnType<typeof useGetEventSlugSuggestionLazyQueryType>;
export type GetEventSlugSuggestionQueryResultType = Apollo.QueryResult<GetEventSlugSuggestionQueryType, GetEventSlugSuggestionQueryVariablesType>;
export const GetEventsPageableDocumentType = gql`
    query GetEventsPageable($limit: Int, $offset: Int, $where: events_bool_exp) {
  events(
    limit: $limit
    offset: $offset
    where: $where
    order_by: {start_date: asc}
  ) {
    ...EventFields
  }
  events_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${EventFieldsFragmentDocType}`;

/**
 * __useGetEventsPageableQuery__
 *
 * To run a query within a React component, call `useGetEventsPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetEventsPageableQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsPageableQueryType, GetEventsPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsPageableQueryType, GetEventsPageableQueryVariablesType>(GetEventsPageableDocumentType, options);
      }
export function useGetEventsPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsPageableQueryType, GetEventsPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsPageableQueryType, GetEventsPageableQueryVariablesType>(GetEventsPageableDocumentType, options);
        }
export type GetEventsPageableQueryHookResult = ReturnType<typeof useGetEventsPageableQuery>;
export type GetEventsPageableLazyQueryTypeHookResult = ReturnType<typeof useGetEventsPageableLazyQueryType>;
export type GetEventsPageableQueryResultType = Apollo.QueryResult<GetEventsPageableQueryType, GetEventsPageableQueryVariablesType>;
export const GetInviteByPkDocumentType = gql`
    query GetInviteByPk($id: String!) {
  invite_by_id(id: $id) {
    ...NestInviteFields
  }
}
    ${NestInviteFieldsFragmentDocType}`;

/**
 * __useGetInviteByPkQuery__
 *
 * To run a query within a React component, call `useGetInviteByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInviteByPkQuery(baseOptions: Apollo.QueryHookOptions<GetInviteByPkQueryType, GetInviteByPkQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteByPkQueryType, GetInviteByPkQueryVariablesType>(GetInviteByPkDocumentType, options);
      }
export function useGetInviteByPkLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteByPkQueryType, GetInviteByPkQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteByPkQueryType, GetInviteByPkQueryVariablesType>(GetInviteByPkDocumentType, options);
        }
export type GetInviteByPkQueryHookResult = ReturnType<typeof useGetInviteByPkQuery>;
export type GetInviteByPkLazyQueryTypeHookResult = ReturnType<typeof useGetInviteByPkLazyQueryType>;
export type GetInviteByPkQueryResultType = Apollo.QueryResult<GetInviteByPkQueryType, GetInviteByPkQueryVariablesType>;
export const GetAllInvitesDocumentType = gql`
    query GetAllInvites {
  get_all_invites {
    ...NestInviteFields
  }
}
    ${NestInviteFieldsFragmentDocType}`;

/**
 * __useGetAllInvitesQuery__
 *
 * To run a query within a React component, call `useGetAllInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInvitesQueryType, GetAllInvitesQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInvitesQueryType, GetAllInvitesQueryVariablesType>(GetAllInvitesDocumentType, options);
      }
export function useGetAllInvitesLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInvitesQueryType, GetAllInvitesQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInvitesQueryType, GetAllInvitesQueryVariablesType>(GetAllInvitesDocumentType, options);
        }
export type GetAllInvitesQueryHookResult = ReturnType<typeof useGetAllInvitesQuery>;
export type GetAllInvitesLazyQueryTypeHookResult = ReturnType<typeof useGetAllInvitesLazyQueryType>;
export type GetAllInvitesQueryResultType = Apollo.QueryResult<GetAllInvitesQueryType, GetAllInvitesQueryVariablesType>;
export const IsClassSlugAvailableDocumentType = gql`
    query IsClassSlugAvailable($urlSlug: String!) {
  is_class_slug_available(url_slug: $urlSlug)
}
    `;

/**
 * __useIsClassSlugAvailableQuery__
 *
 * To run a query within a React component, call `useIsClassSlugAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsClassSlugAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsClassSlugAvailableQuery({
 *   variables: {
 *      urlSlug: // value for 'urlSlug'
 *   },
 * });
 */
export function useIsClassSlugAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsClassSlugAvailableQueryType, IsClassSlugAvailableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsClassSlugAvailableQueryType, IsClassSlugAvailableQueryVariablesType>(IsClassSlugAvailableDocumentType, options);
      }
export function useIsClassSlugAvailableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<IsClassSlugAvailableQueryType, IsClassSlugAvailableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsClassSlugAvailableQueryType, IsClassSlugAvailableQueryVariablesType>(IsClassSlugAvailableDocumentType, options);
        }
export type IsClassSlugAvailableQueryHookResult = ReturnType<typeof useIsClassSlugAvailableQuery>;
export type IsClassSlugAvailableLazyQueryTypeHookResult = ReturnType<typeof useIsClassSlugAvailableLazyQueryType>;
export type IsClassSlugAvailableQueryResultType = Apollo.QueryResult<IsClassSlugAvailableQueryType, IsClassSlugAvailableQueryVariablesType>;
export const IsEventSlugAvailableDocumentType = gql`
    query IsEventSlugAvailable($urlSlug: String!) {
  is_event_slug_available(url_slug: $urlSlug)
}
    `;

/**
 * __useIsEventSlugAvailableQuery__
 *
 * To run a query within a React component, call `useIsEventSlugAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEventSlugAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEventSlugAvailableQuery({
 *   variables: {
 *      urlSlug: // value for 'urlSlug'
 *   },
 * });
 */
export function useIsEventSlugAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsEventSlugAvailableQueryType, IsEventSlugAvailableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsEventSlugAvailableQueryType, IsEventSlugAvailableQueryVariablesType>(IsEventSlugAvailableDocumentType, options);
      }
export function useIsEventSlugAvailableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<IsEventSlugAvailableQueryType, IsEventSlugAvailableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsEventSlugAvailableQueryType, IsEventSlugAvailableQueryVariablesType>(IsEventSlugAvailableDocumentType, options);
        }
export type IsEventSlugAvailableQueryHookResult = ReturnType<typeof useIsEventSlugAvailableQuery>;
export type IsEventSlugAvailableLazyQueryTypeHookResult = ReturnType<typeof useIsEventSlugAvailableLazyQueryType>;
export type IsEventSlugAvailableQueryResultType = Apollo.QueryResult<IsEventSlugAvailableQueryType, IsEventSlugAvailableQueryVariablesType>;
export const IsTeacherSlugAvailableDocumentType = gql`
    query IsTeacherSlugAvailable($urlSlug: String!) {
  is_teacher_slug_available(url_slug: $urlSlug)
}
    `;

/**
 * __useIsTeacherSlugAvailableQuery__
 *
 * To run a query within a React component, call `useIsTeacherSlugAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsTeacherSlugAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsTeacherSlugAvailableQuery({
 *   variables: {
 *      urlSlug: // value for 'urlSlug'
 *   },
 * });
 */
export function useIsTeacherSlugAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsTeacherSlugAvailableQueryType, IsTeacherSlugAvailableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsTeacherSlugAvailableQueryType, IsTeacherSlugAvailableQueryVariablesType>(IsTeacherSlugAvailableDocumentType, options);
      }
export function useIsTeacherSlugAvailableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<IsTeacherSlugAvailableQueryType, IsTeacherSlugAvailableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsTeacherSlugAvailableQueryType, IsTeacherSlugAvailableQueryVariablesType>(IsTeacherSlugAvailableDocumentType, options);
        }
export type IsTeacherSlugAvailableQueryHookResult = ReturnType<typeof useIsTeacherSlugAvailableQuery>;
export type IsTeacherSlugAvailableLazyQueryTypeHookResult = ReturnType<typeof useIsTeacherSlugAvailableLazyQueryType>;
export type IsTeacherSlugAvailableQueryResultType = Apollo.QueryResult<IsTeacherSlugAvailableQueryType, IsTeacherSlugAvailableQueryVariablesType>;
export const GetMeDocumentType = gql`
    query GetMe {
  me {
    ...MeFields
    teacher_profile {
      ...TeacherFields
    }
  }
}
    ${MeFieldsFragmentDocType}
${TeacherFieldsFragmentDocType}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQueryType, GetMeQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQueryType, GetMeQueryVariablesType>(GetMeDocumentType, options);
      }
export function useGetMeLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQueryType, GetMeQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQueryType, GetMeQueryVariablesType>(GetMeDocumentType, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryTypeHookResult = ReturnType<typeof useGetMeLazyQueryType>;
export type GetMeQueryResultType = Apollo.QueryResult<GetMeQueryType, GetMeQueryVariablesType>;
export const GetRolesPageableDocumentType = gql`
    query GetRolesPageable($limit: Int, $offset: Int, $where: roles_bool_exp) {
  roles(limit: $limit, offset: $offset, where: $where) {
    id
    name
  }
  roles_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRolesPageableQuery__
 *
 * To run a query within a React component, call `useGetRolesPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetRolesPageableQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesPageableQueryType, GetRolesPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesPageableQueryType, GetRolesPageableQueryVariablesType>(GetRolesPageableDocumentType, options);
      }
export function useGetRolesPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesPageableQueryType, GetRolesPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesPageableQueryType, GetRolesPageableQueryVariablesType>(GetRolesPageableDocumentType, options);
        }
export type GetRolesPageableQueryHookResult = ReturnType<typeof useGetRolesPageableQuery>;
export type GetRolesPageableLazyQueryTypeHookResult = ReturnType<typeof useGetRolesPageableLazyQueryType>;
export type GetRolesPageableQueryResultType = Apollo.QueryResult<GetRolesPageableQueryType, GetRolesPageableQueryVariablesType>;
export const GetStripeLoginLinkDocumentType = gql`
    query GetStripeLoginLink {
  stripe_login_link
}
    `;

/**
 * __useGetStripeLoginLinkQuery__
 *
 * To run a query within a React component, call `useGetStripeLoginLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeLoginLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeLoginLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeLoginLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeLoginLinkQueryType, GetStripeLoginLinkQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeLoginLinkQueryType, GetStripeLoginLinkQueryVariablesType>(GetStripeLoginLinkDocumentType, options);
      }
export function useGetStripeLoginLinkLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeLoginLinkQueryType, GetStripeLoginLinkQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeLoginLinkQueryType, GetStripeLoginLinkQueryVariablesType>(GetStripeLoginLinkDocumentType, options);
        }
export type GetStripeLoginLinkQueryHookResult = ReturnType<typeof useGetStripeLoginLinkQuery>;
export type GetStripeLoginLinkLazyQueryTypeHookResult = ReturnType<typeof useGetStripeLoginLinkLazyQueryType>;
export type GetStripeLoginLinkQueryResultType = Apollo.QueryResult<GetStripeLoginLinkQueryType, GetStripeLoginLinkQueryVariablesType>;
export const GetTeacherByPkAsAdminUserDocumentType = gql`
    query GetTeacherByPkAsAdminUser($id: uuid!) {
  teachers_by_pk(id: $id) {
    ...TeacherFields
    signup_message
    confirmation_status
  }
}
    ${TeacherFieldsFragmentDocType}`;

/**
 * __useGetTeacherByPkAsAdminUserQuery__
 *
 * To run a query within a React component, call `useGetTeacherByPkAsAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherByPkAsAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherByPkAsAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeacherByPkAsAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetTeacherByPkAsAdminUserQueryType, GetTeacherByPkAsAdminUserQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherByPkAsAdminUserQueryType, GetTeacherByPkAsAdminUserQueryVariablesType>(GetTeacherByPkAsAdminUserDocumentType, options);
      }
export function useGetTeacherByPkAsAdminUserLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherByPkAsAdminUserQueryType, GetTeacherByPkAsAdminUserQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherByPkAsAdminUserQueryType, GetTeacherByPkAsAdminUserQueryVariablesType>(GetTeacherByPkAsAdminUserDocumentType, options);
        }
export type GetTeacherByPkAsAdminUserQueryHookResult = ReturnType<typeof useGetTeacherByPkAsAdminUserQuery>;
export type GetTeacherByPkAsAdminUserLazyQueryTypeHookResult = ReturnType<typeof useGetTeacherByPkAsAdminUserLazyQueryType>;
export type GetTeacherByPkAsAdminUserQueryResultType = Apollo.QueryResult<GetTeacherByPkAsAdminUserQueryType, GetTeacherByPkAsAdminUserQueryVariablesType>;
export const GetTeacherByPkAsTeacherUserDocumentType = gql`
    query GetTeacherByPkAsTeacherUser($id: uuid!) {
  teachers_by_pk(id: $id) {
    ...TeacherFields
  }
}
    ${TeacherFieldsFragmentDocType}`;

/**
 * __useGetTeacherByPkAsTeacherUserQuery__
 *
 * To run a query within a React component, call `useGetTeacherByPkAsTeacherUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherByPkAsTeacherUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherByPkAsTeacherUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeacherByPkAsTeacherUserQuery(baseOptions: Apollo.QueryHookOptions<GetTeacherByPkAsTeacherUserQueryType, GetTeacherByPkAsTeacherUserQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherByPkAsTeacherUserQueryType, GetTeacherByPkAsTeacherUserQueryVariablesType>(GetTeacherByPkAsTeacherUserDocumentType, options);
      }
export function useGetTeacherByPkAsTeacherUserLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherByPkAsTeacherUserQueryType, GetTeacherByPkAsTeacherUserQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherByPkAsTeacherUserQueryType, GetTeacherByPkAsTeacherUserQueryVariablesType>(GetTeacherByPkAsTeacherUserDocumentType, options);
        }
export type GetTeacherByPkAsTeacherUserQueryHookResult = ReturnType<typeof useGetTeacherByPkAsTeacherUserQuery>;
export type GetTeacherByPkAsTeacherUserLazyQueryTypeHookResult = ReturnType<typeof useGetTeacherByPkAsTeacherUserLazyQueryType>;
export type GetTeacherByPkAsTeacherUserQueryResultType = Apollo.QueryResult<GetTeacherByPkAsTeacherUserQueryType, GetTeacherByPkAsTeacherUserQueryVariablesType>;
export const GetTeacherSlugSuggestionDocumentType = gql`
    query GetTeacherSlugSuggestion($name: String!) {
  get_teacher_slug_suggestion(name: $name)
}
    `;

/**
 * __useGetTeacherSlugSuggestionQuery__
 *
 * To run a query within a React component, call `useGetTeacherSlugSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherSlugSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherSlugSuggestionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetTeacherSlugSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetTeacherSlugSuggestionQueryType, GetTeacherSlugSuggestionQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherSlugSuggestionQueryType, GetTeacherSlugSuggestionQueryVariablesType>(GetTeacherSlugSuggestionDocumentType, options);
      }
export function useGetTeacherSlugSuggestionLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherSlugSuggestionQueryType, GetTeacherSlugSuggestionQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherSlugSuggestionQueryType, GetTeacherSlugSuggestionQueryVariablesType>(GetTeacherSlugSuggestionDocumentType, options);
        }
export type GetTeacherSlugSuggestionQueryHookResult = ReturnType<typeof useGetTeacherSlugSuggestionQuery>;
export type GetTeacherSlugSuggestionLazyQueryTypeHookResult = ReturnType<typeof useGetTeacherSlugSuggestionLazyQueryType>;
export type GetTeacherSlugSuggestionQueryResultType = Apollo.QueryResult<GetTeacherSlugSuggestionQueryType, GetTeacherSlugSuggestionQueryVariablesType>;
export const GetTeachersPageableDocumentType = gql`
    query GetTeachersPageable($limit: Int, $offset: Int, $where: teachers_bool_exp!) {
  teachers(limit: $limit, offset: $offset, where: $where, order_by: {name: asc}) {
    ...TeacherFields
    confirmation_status
  }
  teachers_aggregate {
    aggregate {
      count
    }
  }
}
    ${TeacherFieldsFragmentDocType}`;

/**
 * __useGetTeachersPageableQuery__
 *
 * To run a query within a React component, call `useGetTeachersPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeachersPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeachersPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTeachersPageableQuery(baseOptions: Apollo.QueryHookOptions<GetTeachersPageableQueryType, GetTeachersPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeachersPageableQueryType, GetTeachersPageableQueryVariablesType>(GetTeachersPageableDocumentType, options);
      }
export function useGetTeachersPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetTeachersPageableQueryType, GetTeachersPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeachersPageableQueryType, GetTeachersPageableQueryVariablesType>(GetTeachersPageableDocumentType, options);
        }
export type GetTeachersPageableQueryHookResult = ReturnType<typeof useGetTeachersPageableQuery>;
export type GetTeachersPageableLazyQueryTypeHookResult = ReturnType<typeof useGetTeachersPageableLazyQueryType>;
export type GetTeachersPageableQueryResultType = Apollo.QueryResult<GetTeachersPageableQueryType, GetTeachersPageableQueryVariablesType>;
export const GetClassEventBookingsByClassEventPageableDocumentType = gql`
    query GetClassEventBookingsByClassEventPageable($limit: Int, $offset: Int, $teacherId: uuid!, $classEventId: uuid!) {
  class_event_bookings(
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
  ) {
    ...ClassEventBookingsFields
  }
  class_event_bookings_aggregate {
    aggregate {
      count
    }
  }
}
    ${ClassEventBookingsFieldsFragmentDocType}`;

/**
 * __useGetClassEventBookingsByClassEventPageableQuery__
 *
 * To run a query within a React component, call `useGetClassEventBookingsByClassEventPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassEventBookingsByClassEventPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassEventBookingsByClassEventPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      teacherId: // value for 'teacherId'
 *      classEventId: // value for 'classEventId'
 *   },
 * });
 */
export function useGetClassEventBookingsByClassEventPageableQuery(baseOptions: Apollo.QueryHookOptions<GetClassEventBookingsByClassEventPageableQueryType, GetClassEventBookingsByClassEventPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassEventBookingsByClassEventPageableQueryType, GetClassEventBookingsByClassEventPageableQueryVariablesType>(GetClassEventBookingsByClassEventPageableDocumentType, options);
      }
export function useGetClassEventBookingsByClassEventPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetClassEventBookingsByClassEventPageableQueryType, GetClassEventBookingsByClassEventPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassEventBookingsByClassEventPageableQueryType, GetClassEventBookingsByClassEventPageableQueryVariablesType>(GetClassEventBookingsByClassEventPageableDocumentType, options);
        }
export type GetClassEventBookingsByClassEventPageableQueryHookResult = ReturnType<typeof useGetClassEventBookingsByClassEventPageableQuery>;
export type GetClassEventBookingsByClassEventPageableLazyQueryTypeHookResult = ReturnType<typeof useGetClassEventBookingsByClassEventPageableLazyQueryType>;
export type GetClassEventBookingsByClassEventPageableQueryResultType = Apollo.QueryResult<GetClassEventBookingsByClassEventPageableQueryType, GetClassEventBookingsByClassEventPageableQueryVariablesType>;
export const GetUsersPageableDocumentType = gql`
    query GetUsersPageable($limit: Int, $offset: Int, $where: users_bool_exp!) {
  users(limit: $limit, offset: $offset, where: $where) {
    ...UserFields
  }
  users_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    ${UserFieldsFragmentDocType}`;

/**
 * __useGetUsersPageableQuery__
 *
 * To run a query within a React component, call `useGetUsersPageableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersPageableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersPageableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUsersPageableQuery(baseOptions: Apollo.QueryHookOptions<GetUsersPageableQueryType, GetUsersPageableQueryVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersPageableQueryType, GetUsersPageableQueryVariablesType>(GetUsersPageableDocumentType, options);
      }
export function useGetUsersPageableLazyQueryType(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersPageableQueryType, GetUsersPageableQueryVariablesType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersPageableQueryType, GetUsersPageableQueryVariablesType>(GetUsersPageableDocumentType, options);
        }
export type GetUsersPageableQueryHookResult = ReturnType<typeof useGetUsersPageableQuery>;
export type GetUsersPageableLazyQueryTypeHookResult = ReturnType<typeof useGetUsersPageableLazyQueryType>;
export type GetUsersPageableQueryResultType = Apollo.QueryResult<GetUsersPageableQueryType, GetUsersPageableQueryVariablesType>;
export const DeleteDocumentType = gql`
    mutation Delete($id: uuid!) {
  delete_recurring_patterns(where: {class_id: {_eq: $id}}) {
    affected_rows
  }
  delete_class_events(where: {class_id: {_eq: $id}}) {
    affected_rows
  }
  delete_classes_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteMutationFnType = Apollo.MutationFunction<DeleteMutationType, DeleteMutationVariablesType>;

/**
 * __useDeleteMutation__
 *
 * To run a mutation, you first call `useDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMutation, { data, loading, error }] = useDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMutationType, DeleteMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMutationType, DeleteMutationVariablesType>(DeleteDocumentType, options);
      }
export type DeleteMutationHookResult = ReturnType<typeof useDeleteMutation>;
export type DeleteMutationResultType = Apollo.MutationResult<DeleteMutationType>;
export type DeleteMutationOptionsType = Apollo.BaseMutationOptions<DeleteMutationType, DeleteMutationVariablesType>;
export const InsertDocumentType = gql`
    mutation Insert($userId: uuid!, $name: String!, $description: String!, $is_organization: Boolean!, $instagram_name: String, $signup_message: String, $type: teacher_type_enum!, $images: [teacher_images_insert_input!]!) {
  insert_teachers(
    objects: {name: $name, type: $type, description: $description, instagram_name: $instagram_name, signup_message: $signup_message, is_organization: $is_organization, user_id: $userId, images: {data: $images}}
  ) {
    affected_rows
  }
}
    `;
export type InsertMutationFnType = Apollo.MutationFunction<InsertMutationType, InsertMutationVariablesType>;

/**
 * __useInsertMutation__
 *
 * To run a mutation, you first call `useInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMutation, { data, loading, error }] = useInsertMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      is_organization: // value for 'is_organization'
 *      instagram_name: // value for 'instagram_name'
 *      signup_message: // value for 'signup_message'
 *      type: // value for 'type'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useInsertMutation(baseOptions?: Apollo.MutationHookOptions<InsertMutationType, InsertMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMutationType, InsertMutationVariablesType>(InsertDocumentType, options);
      }
export type InsertMutationHookResult = ReturnType<typeof useInsertMutation>;
export type InsertMutationResultType = Apollo.MutationResult<InsertMutationType>;
export type InsertMutationOptionsType = Apollo.BaseMutationOptions<InsertMutationType, InsertMutationVariablesType>;
export const DeleteTeacherDocumentType = gql`
    mutation DeleteTeacher($id: uuid!) {
  delete_user_roles(where: {user: {teacher_profile: {id: {_eq: $id}}}}) {
    affected_rows
  }
  delete_images(where: {teacher_image: {image_id: {_eq: $id}}}) {
    affected_rows
  }
  delete_teacher_images(where: {teacher_id: {_eq: $id}}) {
    affected_rows
  }
  delete_class_owners(where: {teacher_id: {_eq: $id}}) {
    affected_rows
  }
  delete_class_events(
    where: {class: {class_owners: {teacher_id: {_eq: $id}}, class_owners_aggregate: {count: {predicate: {_eq: 1}}}}}
  ) {
    affected_rows
  }
  delete_classes(
    where: {class_owners: {teacher_id: {_eq: $id}}, class_owners_aggregate: {count: {predicate: {_eq: 1}}}}
  ) {
    affected_rows
  }
  delete_teachers_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteTeacherMutationFnType = Apollo.MutationFunction<DeleteTeacherMutationType, DeleteTeacherMutationVariablesType>;

/**
 * __useDeleteTeacherMutation__
 *
 * To run a mutation, you first call `useDeleteTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeacherMutation, { data, loading, error }] = useDeleteTeacherMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeacherMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeacherMutationType, DeleteTeacherMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeacherMutationType, DeleteTeacherMutationVariablesType>(DeleteTeacherDocumentType, options);
      }
export type DeleteTeacherMutationHookResult = ReturnType<typeof useDeleteTeacherMutation>;
export type DeleteTeacherMutationResultType = Apollo.MutationResult<DeleteTeacherMutationType>;
export type DeleteTeacherMutationOptionsType = Apollo.BaseMutationOptions<DeleteTeacherMutationType, DeleteTeacherMutationVariablesType>;
export const UpdateUserRolesDocumentType = gql`
    mutation UpdateUserRoles($userId: uuid!, $userRoles: [user_roles_insert_input!]!) {
  delete_user_roles(where: {user_id: {_eq: $userId}}) {
    affected_rows
  }
  insert_user_roles(objects: $userRoles) {
    affected_rows
  }
}
    `;
export type UpdateUserRolesMutationFnType = Apollo.MutationFunction<UpdateUserRolesMutationType, UpdateUserRolesMutationVariablesType>;

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userRoles: // value for 'userRoles'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRolesMutationType, UpdateUserRolesMutationVariablesType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRolesMutationType, UpdateUserRolesMutationVariablesType>(UpdateUserRolesDocumentType, options);
      }
export type UpdateUserRolesMutationHookResult = ReturnType<typeof useUpdateUserRolesMutation>;
export type UpdateUserRolesMutationResultType = Apollo.MutationResult<UpdateUserRolesMutationType>;
export type UpdateUserRolesMutationOptionsType = Apollo.BaseMutationOptions<UpdateUserRolesMutationType, UpdateUserRolesMutationVariablesType>;